module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer015"
    }
  }, [_c('p', {
    staticClass: "PER_Top-extra-space"
  }, [_c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page1",
      "title": "1"
    }
  })]), _vm._v(" "), _c('h2', {
    staticClass: "COM_Title",
    attrs: {
      "id": "sigil_toc_id_20"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor072"
    }
  }), _vm._v("COMMENTARY ON 1 SAMUEL")]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Overview")]), _c('b', [_vm._v(":")]), _vm._v(" The reformers regard Samuel not only as a prophet but also as the last of the judges of Israel, thereby serving as a bridge between the era of the judges and that of the kings. According to these interpreters, the first part of 1 Samuel focuses on the desire of the Israelites to secure a king like the surrounding nations. Due to their lack of trust in God, the first king of Israel was a tyrant, while the second king, David, serves as a figure of the Messiah.")]), _vm._v(" "), _c('h5', {
    attrs: {
      "id": "sigil_toc_id_21"
    }
  }, [_c('span', {
    staticClass: "b-i"
  }, [_vm._v("Prolegomena: What This Book Is About")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("The Four Books of Kings, That Is, Samuel and Kings.")]), _vm._v(" "), _c('i', [_vm._v("Sebastian Münster:")]), _vm._v(" The four books of Kings are only two books in Hebrew, namely the book of Samuel and the book of Kings. Both of these books the Latin translators have divided into two books. We too will follow these translators, except that the first and second books we will call First and Second Samuel; the third and fourth books we will name First and Second Kings. "), _c('i', [_vm._v("The Temple of the Lord: 1 Samuel 1.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-439-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-439",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Book of Prophets.")]), _vm._v(" "), _c('i', [_vm._v("Lucas Osiander:")]), _vm._v(" The first book of Samuel, as it is called, teaches not only that the majority of this book was written by Samuel, as can be observed from 1 Chronicles 29, but also the deeds of this same prophet. For this Samuel was the last judge or governor of the people of Israel. Until that time the judges had ruled; afterward the Israelites asked to receive a king. For this reason, because the kings are described in the later parts of this book, we also call this book the First Book of Kings. . . . In Matthew 12, Jesus cites this book about David and the bread of the Presence. And Paul recounted the history of these books in Acts 13. The second book speaks especially clearly of Christ when it tells the promises to David. Many examples of divine sovereignty over against the impious are displayed, as are converse examples of the goodness of God’s mercy to the pious. From these examples we should learn to fear God, to trust in him with our whole heart and to love him from our soul. "), _c('i', [_vm._v("Annotations on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-438-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-438",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Samuel Did Not Write the Whole Book.")]), _vm._v(" "), _c('i', [_vm._v("Cardinal Cajetan:")]), _vm._v(" The title of both this book and the one that follows is Samuel, from the teachers of the Jews, who is initially discussed in this book. The book is believed to have been written by Samuel in the first part; however, it is clear that Samuel himself did not write about the events after his death. "), _c('i', [_vm._v("Commentary on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-437-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-437",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Template for God’s People.")]), _vm._v(" "), _c('i', [_vm._v("Geneva Bible:")]), _vm._v(" According to Deuteronomy 17:14, God ordained that when the Israelites should reside in the land of Canaan, he would appoint them a king. Consequently, this first book of Samuel narrates the state of this people under their "), _c('a', {
    attrs: {
      "id": "_idTextAnchor073"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor074"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor075"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor076"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor077"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor078"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor079"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor080"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor081"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor082"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor083"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor084"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor085"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor086"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor087"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor088"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor089"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor090"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor091"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor092"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor093"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor094"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor095"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor096"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor097"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor098"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor099"
    }
  }), _vm._v("fi"), _c('a', {
    attrs: {
      "id": "_idTextAnchor100"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor101"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor102"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor103"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor104"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor105"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor106"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor107"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor108"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor109"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor110"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor111"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor112"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor113"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor114"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor115"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor116"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor117"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor118"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor119"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor120"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor121"
    }
  }), _vm._v("rst "), _c('a', {
    attrs: {
      "id": "_idTextAnchor122"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor123"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor124"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor125"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor126"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor127"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor128"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor129"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor130"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor131"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor132"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor133"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor134"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor135"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor136"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor137"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor138"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor139"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor140"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor141"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor142"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor143"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor144"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor145"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor146"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor147"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor148"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor149"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor150"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor151"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor152"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor153"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor154"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor155"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor156"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor157"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor158"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor159"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor160"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor161"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor162"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor163"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor164"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor165"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor166"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor167"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor168"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor169"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor170"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor171"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor172"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor173"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor174"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor175"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor176"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor177"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor178"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor179"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor180"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor181"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor182"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor183"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor184"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor185"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor186"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor187"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor188"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor189"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor190"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor191"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor192"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor193"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor194"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor195"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor196"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor197"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor198"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor199"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor200"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor201"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor202"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor203"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor204"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor205"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor206"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor207"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor208"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor209"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor210"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor211"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor212"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor213"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor214"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor215"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor216"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor217"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor218"
    }
  }), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page2",
      "title": "2"
    }
  }), _vm._v("king, King Saul. However, contrary to God’s timing, the people were not content with the current government God had erected, and so demanded a king so that the Israelites might be like the other nations, which the Israelites believed to be safer since they had a king. The Israelites did not ask for a king so that they could better serve God under a godly person who represented Jesus Christ, the true deliverer. Therefore God gave them a tyrant and a hypocrite to rule over them so they might learn that a human king is not sufficient to defend them. Rather, only a ruler who was empowered and helped by God could do so. Therefore, God punished the ingratitude of his people, and he sent them continual wars both at home and abroad. And because Saul, who was not truly worthy of the office of king, did not acknowledge God’s mercy toward him but rather disposed of the Word of God and was not zealous for God’s glory, he was put down by the voice of God. In his place, David, the true figure of the Messiah, was placed on the throne. Indeed, David’s patience, modesty, constancy, persecution by open enemies, false friends and lying flatterers are left to the church, and to every member of the body of Christ, as a template for their vocations as God’s people. "), _c('i', [_vm._v("Argument of 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-436-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-436",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])])])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "_idContainer016"
    }
  }, [_c('p', {
    staticClass: "Basic-Paragraph"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor219"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor220"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor221"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor222"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor223"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor224"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor225"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor226"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor227"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor228"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor229"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor230"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor231"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor232"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor233"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor234"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor235"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor236"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor237"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor238"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor239"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor240"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor241"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor242"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor243"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor244"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor245"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor246"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor247"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor248"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor249"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor250"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor251"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor252"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor253"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor254"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor255"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor256"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor257"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor258"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor259"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor260"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor261"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor262"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor263"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor264"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor265"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor266"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor267"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor268"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor269"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor270"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor271"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor272"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor273"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor274"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor275"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor276"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor277"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor278"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor279"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor280"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor281"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor282"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor283"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor284"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor285"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor286"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor287"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor288"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor289"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor290"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor291"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor292"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor293"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor294"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor295"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor296"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor297"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor298"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor299"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor300"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor301"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor302"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor303"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor304"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor305"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor306"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor307"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor308"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor309"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor310"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor311"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor312"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor313"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor314"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor315"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor316"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor317"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor318"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor319"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor320"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor321"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor322"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor323"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor324"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor325"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor326"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor327"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor328"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor329"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor330"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor331"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor332"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor333"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor334"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor335"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor336"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor337"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor338"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor339"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor340"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor341"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor342"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor343"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor344"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor345"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor346"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor347"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor348"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor349"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor350"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor351"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor352"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor353"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor354"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor355"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor356"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor357"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor358"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor359"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor360"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor361"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor362"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor363"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor364"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor365"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor366"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor367"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor368"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor369"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor370"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor371"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor372"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor373"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor374"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor375"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor376"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor377"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor378"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor379"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor380"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor381"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor382"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor383"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor384"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor385"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor386"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor387"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor388"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor389"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor390"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor391"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor392"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor393"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor394"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor395"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor396"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor397"
    }
  })])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "_idContainer017"
    }
  }, [_c('p', {
    staticClass: "PER_Top-extra-space"
  }, [_c('span', {
    staticClass: "com-rorohiko-pagestaker-style"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor398"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor399"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor400"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor401"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor402"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor403"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor404"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor405"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor406"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor407"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor408"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor409"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor410"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor411"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor412"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor413"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor414"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor415"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor416"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor417"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor418"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor419"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor420"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor421"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor422"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor423"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor424"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor425"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor426"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor427"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor428"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor429"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor430"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor431"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor432"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor433"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor434"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor435"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor436"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor437"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor438"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor439"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor440"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor441"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor442"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor443"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor444"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor445"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor446"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor447"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor448"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor449"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor450"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor451"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor452"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor453"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor454"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor455"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor456"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor457"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor458"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor459"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor460"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor461"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor462"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor463"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor464"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor465"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor466"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor467"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor468"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor469"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor470"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor471"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor472"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor473"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor474"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor475"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor476"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor477"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor478"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor479"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor480"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor481"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor482"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor483"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor484"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor485"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor486"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor487"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor488"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor489"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor490"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor491"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor492"
    }
  })]), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page3",
      "title": "3"
    }
  })]), _vm._v(" "), _c('h2', {
    staticClass: "PER_ScriptureCenter",
    attrs: {
      "id": "sigil_toc_id_22"
    }
  }, [_c('span', {
    staticClass: "RH-marker"
  }, [_vm._v("1:1-28")]), _vm._v(" THE BIRTH AND DEDICATION OF SAMUEL")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("1")]), _c('i', [_vm._v("There was a certain man of Ramathaim-zophim of the hill country of Ephraim whose name was Elkanah the son of Jeroham, son of Elihu, son of Tohu, son of Zuph, an Ephrathite.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("2")]), _c('i', [_vm._v("He had two wives. The name of the one was Hannah, and the name of the other, Peninnah. And Peninnah had children, but Hannah had no children.")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("3")]), _c('i', [_vm._v("Now this man used to go up year by year from his city to worship and to sacrifice to the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("of hosts at Shiloh, where the two sons of Eli, Hophni and Phinehas, were priests of the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _c('i', [_vm._v(".")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("4")]), _c('i', [_vm._v("On the day when Elkanah sacrificed, he would give portions to Peninnah his wife and to all her sons and daughters.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("5")]), _c('i', [_vm._v("But to Hannah he gave a double portion, because he loved her, though the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("had closed her womb.")]), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("a")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("6")]), _c('i', [_vm._v("And her rival used to provoke her grievously to irritate her, because the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("had closed her womb.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("7")]), _c('i', [_vm._v("So it went on year by year. As often as she went up to the house of the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _c('i', [_vm._v(", she used to provoke her. Therefore Hannah wept and would not eat.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("8")]), _c('i', [_vm._v("And Elkanah, her husband, said to her, “Hannah, why do you weep? And why do you not eat? And why is your heart sad? Am I not more to you than ten sons?”")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("9")]), _c('i', [_vm._v("After they had eaten and drunk in Shiloh, Hannah rose. Now Eli the priest was sitting on the seat beside the doorpost of the temple of the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _c('i', [_vm._v(".")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("10")]), _c('i', [_vm._v("She was deeply distressed and prayed to the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("and wept bitterly.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("11")]), _c('i', [_vm._v("And she vowed a vow and said, “O")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("of hosts, if you will indeed look on the affliction of your servant and remember me and not forget your servant, but will give to your servant a son, then I will give him to the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("all the days of his life, and no razor shall touch his head.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("12")]), _c('i', [_vm._v("As she continued praying before the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _c('i', [_vm._v(", Eli observed her mouth.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("13")]), _c('i', [_vm._v("Hannah was speaking in her heart; only her lips moved, and her voice was not heard. Therefore Eli took her to be a drunken woman.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("14")]), _c('i', [_vm._v("And Eli said to her, “How long will you go on being drunk? Put your wine away from you.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("15")]), _c('i', [_vm._v("But Hannah answered, “No, my lord, I am a woman troubled in spirit. I have drunk neither wine nor strong drink, but I have been pouring out my soul before the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _c('i', [_vm._v(".")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("16")]), _c('i', [_vm._v("Do not regard your servant as a worthless woman, for all along I have been speaking out of my great anxiety and vexation.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("17")]), _c('i', [_vm._v("Then Eli answered, “Go in peace, and the God of Israel grant your petition that you have made to him.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("18")]), _c('i', [_vm._v("And she said, “Let your servant find favor in your eyes.” Then the woman went her way and ate, and her face was no longer sad.")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("19")]), _c('i', [_vm._v("They rose early in the morning and worshiped before the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _c('i', [_vm._v("; then they went back to their house at Ramah. And Elkanah knew Hannah his wife, and the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("remembered her.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("20")]), _c('i', [_vm._v("And in due time Hannah conceived and bore a son, and she called his name Samuel, for she said, “I have asked for him from the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _c('i', [_vm._v(".”")]), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("b")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("21")]), _c('i', [_vm._v("The man Elkanah and all his house went up to offer to the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("the yearly sacrifice and to pay his vow.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("22")]), _c('i', [_vm._v("But Hannah did not go up, for she said to her husband, “As soon as the child is weaned, I will bring him, so that he may appear in the presence of the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("and dwell there forever.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("23")]), _c('i', [_vm._v("Elkanah her husband said to her, “Do what seems best to you; wait until you have weaned him; only, may the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("establish his word.” So the woman remained and nursed her son until she weaned him.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("24")]), _c('i', [_vm._v("And when she had weaned him, she took him up with her, along with a three-year-old bull,")]), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("c")]), _vm._v(" "), _c('i', [_vm._v("an ephah")]), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("d")]), _vm._v(" "), _c('i', [_vm._v("of flour, and a skin of wine, and she brought him to the house of the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("at Shiloh. And the child was young.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("25")]), _c('i', [_vm._v("Then they slaughtered the bull, and they brought the child to Eli.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("26")]), _c('i', [_vm._v("And she said, “Oh, my lord! As you live, my lord, I am the woman who was standing here in your presence, praying to the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _c('i', [_vm._v(".")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("27")]), _c('i', [_vm._v("For this child I prayed, and the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("has granted me my petition that I made to him.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("28")]), _c('i', [_vm._v("Therefore I have lent him to the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _c('i', [_vm._v(". As long as he lives, he is lent to the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _c('i', [_vm._v(".”")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('i', [_vm._v("And he worshiped the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("there.")])]), _vm._v(" "), _c('p', {
    staticClass: "small"
  }, [_c('b', [_vm._v("a")]), _vm._v(" Syriac; the meaning of the Hebrew is uncertain. Septuagint "), _c('i', [_vm._v("And, although he loved Hannah, he would give Hannah only one portion, because the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("had closed her womb")]), _vm._v(" "), _c('b', [_vm._v("b")]), _vm._v(" "), _c('i', [_vm._v("Samuel")]), _vm._v(" sounds like the Hebrew for "), _c('i', [_vm._v("heard of God")]), _vm._v(" "), _c('b', [_vm._v("c")]), _vm._v(" Dead Sea Scroll, Septuagint, Syriac; Masoretic Text "), _c('i', [_vm._v("three bulls")]), _vm._v(" "), _c('b', [_vm._v("d")]), _vm._v(" An "), _c('i', [_vm._v("ephah")]), _vm._v(" was about 3/5 bushel or 22 liters"), _c('br'), _vm._v(" "), _c('br')]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('span', {
    staticClass: "com-rorohiko-pagestaker-style"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor493"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor494"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor495"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor496"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor497"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor498"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor499"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor500"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor501"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor502"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor503"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor504"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor505"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor506"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor507"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor508"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor509"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor510"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor511"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor512"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor513"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor514"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor515"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor516"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor517"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor518"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor519"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor520"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor521"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor522"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor523"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor524"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor525"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor526"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor527"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor528"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor529"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor530"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor531"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor532"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor533"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor534"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor535"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor536"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor537"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor538"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor539"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor540"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor541"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor542"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor543"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor544"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor545"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor546"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor547"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor548"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor549"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor550"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor551"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor552"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor553"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor554"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor555"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor556"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor557"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor558"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor559"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor560"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor561"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor562"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor563"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor564"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor565"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor566"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor567"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor568"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor569"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor570"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor571"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor572"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor573"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor574"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor575"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor576"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor577"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor578"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor579"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor580"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor581"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor582"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor583"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor584"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor585"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor586"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor587"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor588"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor589"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor590"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor591"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor592"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor593"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor594"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor595"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor596"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor597"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor598"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor599"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor600"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor601"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor602"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor603"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor604"
    }
  })]), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page4",
      "title": "4"
    }
  }), _c('b', [_vm._v("Overview:")]), _vm._v(" The reformers concentrate on Elkanah’s polygamy, a sensitive topic for some of the commentators on account of their association with rulers who sometimes aspired to having more than one wife. Both Bucer and Melanchthon, for instance, attended the marriage of Philip of Hesse (1504–1567) to a second wife in 1540, and Luther’s role in the bigamous union incited controversy."), _c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-435-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-435",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])])]), _vm._v(" Bugenhagen interprets Elkanah’s marriage to two women as a spiritual mystery indicating two responses to faith: hypocrisy and belief. Other interpreters criticize the cultural practice of polygamy among biblical patriarchs. Elkanah, however, is recognized as a just man who worships God faithfully. More importantly, Hannah is regarded as the ideal woman who trusted in God despite hardship. Her sincere prayer for a child is answered by God, but the reformers, opposed to the vows of parents who dedicated their children as oblates in medieval monasteries, argue that Hannah’s entrusting of little Samuel to Eli is not a perpetual vow.")]), _vm._v(" "), _c('h5', {
    attrs: {
      "id": "sigil_toc_id_23"
    }
  }, [_c('b', [_vm._v("1:1-2")]), _vm._v(" "), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("Polygamy")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Elkanah’s Two Wives.")]), _vm._v(" "), _c('i', [_vm._v("Johannes Bugenhagen:")]), _vm._v(" The mystery of these two wives is the same as Hagar and Sarah, about whom you read in Genesis and in the epistle to the Galatians. Furthermore, see how thoroughly this point is made in all of Scripture. These two women contrast our native hypocrisy and our faith, hypocrites and believers. Peninnah respected marriage, was not guilty of a bad reputation and ascended to the holy place, as was seen before God and before people. God is viewed as approving of this holy goodness when he gives her the honor of rewards, that is, children. Hannah, whose womb is closed, seems to be cast down. This is certainly a curse, just as the earth is cursed when planted seeds do not bear fruit. And yet a person cannot judge rightly about this case. For not only Peninnah but also the good man Eli was wrong when he mistook sadness and affliction for drunkenness. Hypocritical opinions have their wisdom, piety and righteousness not only when they concern others but also concerning oneself. These ideas abound in everyone and multiply in people: “God has given abundantly,” as if merits had been accepted. These carry the certainty of the Pharisee’s decree when he judged, “I am not like other people. Surely God does not love others! No, God hates all those who fall to the depths!”")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Through bad fruits such as these, God’s disciples can see this and know that these are the ones whom Scripture calls “men of blood,” that is, they want evil for others. While they are proud of their works and gifts to God, they cannot help but hate others. They have no compassion for anyone with sin. They scorn not only sin but also the cross where God was placed. And they think further that their scorn is a curse from the same God whom they themselves do not receive, as if God himself works against the faithful. This is the greatest pious temptation for their own pitiful selves.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("This is why Hannah was scorned: God had closed her womb. As it says in the psalm: “many are saying of my soul, there is no salvation for him in God.” And again, “God has forsaken him; pursue and seize him, for there is none to deliver him.” But by believing that it is proper to condescend, to impose the cross and daily to scatter the benefits of God while ascending into glory through the cross, then through glory these blind ones descend into death (even as the faith of the righteous blessedly ascends). And so their blasphemy never ends. “But many who are first will be last, and the last first,” and the greater shall serve the lesser: “I have loved "), _c('a', {
    attrs: {
      "id": "_idTextAnchor605"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor606"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor607"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor608"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor609"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor610"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor611"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor612"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor613"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor614"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor615"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor616"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor617"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor618"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor619"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor620"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor621"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor622"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor623"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor624"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor625"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor626"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor627"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor628"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor629"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor630"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor631"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor632"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor633"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor634"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor635"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor636"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor637"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor638"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor639"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor640"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor641"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor642"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor643"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor644"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor645"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor646"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor647"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor648"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor649"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor650"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor651"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor652"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor653"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor654"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor655"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor656"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor657"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor658"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor659"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor660"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor661"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor662"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor663"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor664"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor665"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor666"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor667"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor668"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor669"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor670"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor671"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor672"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor673"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor674"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor675"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor676"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor677"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor678"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor679"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor680"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor681"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor682"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor683"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor684"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor685"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor686"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor687"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor688"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor689"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor690"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor691"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor692"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor693"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor694"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor695"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor696"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor697"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor698"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor699"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor700"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor701"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor702"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor703"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor704"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor705"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor706"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor707"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor708"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor709"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor710"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor711"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor712"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor713"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor714"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor715"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor716"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor717"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor718"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor719"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor720"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor721"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor722"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor723"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor724"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor725"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor726"
    }
  }), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page5",
      "title": "5"
    }
  }), _vm._v("Jacob but Esau I have hated. I have laid waste his hill country and left his heritage to jackals of the desert.” Hannah declares all of this in her song of chapter 2. "), _c('i', [_vm._v("Commentary on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-434-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-434",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Polygamy Tolerated but Not Approved.")]), _vm._v(" "), _c('i', [_vm._v("Johannes Piscator:")]), _vm._v(" We have an example of polygamy in this holy man Elkanah, the father of Samuel. This raises the question of whether polygamy is allowed. If it is allowed, it appears to be approved here, given that many of the holy men in the Old Testament were polygamous: Abraham, Jacob, David, etc. For their polygamy never seem to be reproved or condemned. But, in fact, polygamy was not allowed. That’s because the whole notion of polygamy fights against the institution of marriage given by God, which was created and established for our first parents between a man and a woman. According to Genesis 2, Adam proclaimed that the man and woman shall unite and “become one flesh.” This is affirmed in Matthew 19:4-6. Let me respond to this question from a different angle. As for whether polygamy is allowed, it is important to note that the life of holy people is not a rule for us exactly, because holy people had their warts just like we do. But ultimately we are to imitate them in the acts they do that we recognize as conforming to the divine law. As for the other matter, although the polygamy carried about by the holy patriarchs before the law was not condemned, it is prohibited after the law was given, in accordance with Leviticus: “And you shall not take a woman as a rival wife to her sister, uncovering her nakedness while her sister is still alive.” Therefore, although God tolerated the polygamy of holy men, God did not approve it. "), _c('i', [_vm._v("Commentary on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-433-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-433",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Trouble with Polygamy.")]), _vm._v(" "), _c('i', [_vm._v("Andrew Willet:")]), _vm._v(" This presence of polygamy under the law in marrying two or more wives was not simply lawful or dispensed with, which is the opinion of many. . . . Such an interpretation cannot be, for our Savior says concerning this matter: “from the beginning it was not so.” So also the Prophet Malachi: “Did he not make them one, with a portion of the Spirit in their union? And what was the one God seeking? Godly offspring.” Therefore, the best interpretation is that polygamy was a human infirmity in the patriarchs in which they took for themselves two or more wives. And such marriages were not without great inconveniencies. There was continual competition between them, as between Sarah and Hagar, Leah and Rachel and here between these two wives of Elkanah.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("The first polygamist in the Bible was Lamech, of the cursed seed of Cain. Yet because at this time the temporal promises of the Jewish nation depended upon their carnal generation, it pleased God to wink at this infirmity and to tolerate it in the patriarchs. God did so until the Messiah came, when the church of God should no longer be tied to the people of the Jews, but spiritual children should be begotten unto God from all nations, even among the Gentiles. "), _c('i', [_vm._v("Harmony on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-432-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-432",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])])])])]), _vm._v(" "), _c('h5', {
    attrs: {
      "id": "sigil_toc_id_24"
    }
  }, [_c('b', [_vm._v("1:3-8")]), _vm._v(" "), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("Elkanah Goes to Worship Year After Year")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Going Up to Shiloh.")]), _vm._v(" "), _c('i', [_vm._v("Johannes Bugenhagen:")]), _vm._v(" And Elkanah went up according to the law of Deuteronomy 16. The Lord’s tabernacle had been in Shiloh since the time of Joshua, as is said in Joshua. Doubtlessly the ark was there too, for it had been moved under Eli’s authority, as you will see. The Lord speaks of Shiloh in Jeremiah: “Do not trust in the external worship of God even as God has commanded, unless faith is there, because trusting in anything as holy is most assuredly not allowed.” "), _c('i', [_vm._v("Commentary on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-431-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-431",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_c('span', {
    staticClass: "com-rorohiko-pagestaker-style"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor727"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor728"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor729"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor730"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor731"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor732"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor733"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor734"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor735"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor736"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor737"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor738"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor739"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor740"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor741"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor742"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor743"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor744"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor745"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor746"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor747"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor748"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor749"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor750"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor751"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor752"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor753"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor754"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor755"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor756"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor757"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor758"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor759"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor760"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor761"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor762"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor763"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor764"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor765"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor766"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor767"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor768"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor769"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor770"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor771"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor772"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor773"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor774"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor775"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor776"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor777"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor778"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor779"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor780"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor781"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor782"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor783"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor784"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor785"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor786"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor787"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor788"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor789"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor790"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor791"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor792"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor793"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor794"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor795"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor796"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor797"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor798"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor799"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor800"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor801"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor802"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor803"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor804"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor805"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor806"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor807"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor808"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor809"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor810"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor811"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor812"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor813"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor814"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor815"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor816"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor817"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor818"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor819"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor820"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor821"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor822"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor823"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor824"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor825"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor826"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor827"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor828"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor829"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor830"
    }
  })])]), _c('b', [_c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page6",
      "title": "6"
    }
  })]), _c('b', [_vm._v("Holy Worship.")]), _vm._v(" "), _c('i', [_vm._v("Lucas Osiander:")]), _vm._v(" Elkanah went up to the Lord’s tabernacle in order to worship God and to sacrifice to the Lord of hosts—as he is called, because all creatures serve him as if they were his soldiers. At that time the Lord of hosts had his holy tabernacle in Shiloh. For under the law the fathers strengthened their faith through sacrifices, which foreshadowed Christ’s death. And it is fitting for us to gather frequently and diligently to hear the Word of God and to strengthen our faith through the enjoyment of the Lord’s Supper. "), _c('i', [_vm._v("Annotations on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-430-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-430",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Recognizing the Mediator.")]), _vm._v(" "), _c('i', [_vm._v("Viktorin Strigel:")]), _vm._v(" Every year Elkanah took his family to Shiloh, where there was then a tabernacle, to hear the teaching concerning the law and the Messiah. And he prayed and gave thanks for all spiritual and material blessings. For it is explicitly said that he worshiped and gave sacrifices, so that it would be indicated that he does not placate God through ceremonies, unless first the foundation has been considered, that is, the Mediator has been recognized. Through the Mediator the remission of sins, reconciliation with God and the beginnings of moral obedience are received. "), _c('i', [_vm._v("Commentary on 1 Samuel.")]), _c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-429-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-429",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("The Feast and Eli’s Line.")]), _vm._v(" "), _c('i', [_vm._v("Giovanni Diodati:")]), _vm._v(" Here Elkanah went to the feast of the Passover with all his family [just like Jesus did with his family] in Luke 2:41. It is very likely that Elkanah observed the law so faithfully that he attended the feasts on all three solemn festivals in accordance with Exodus 23:17. There is no mention made of this Eli anywhere else. However, it appears based on 2 Samuel 8:17 and 1 Chronicles 24:3-4 that he was one of Ithamar’s posterity, who was Aaron’s younger brother. It also appears that for some unknown reason there had been an interruption in the succession of the priesthood in Eleazar, the firstborn in his line, who was afterward reestablished in the line of Zadok. "), _c('i', [_vm._v("Annotations on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-428-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-428",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Hannah’s Portion and Prayer.")]), _vm._v(" "), _c('i', [_vm._v("Johannes Bugenhagen:")]), _vm._v(" Elkanah gave Hannah “one part” because she was alone, not having children to whom more parts could be given. She had not taken the food; it had not pleased her to eat, so she ate little even though it says below, “after they had all eaten and drunk.” Then it says, “She was deeply distressed.” Here is the cross, even while hypocrites reign secure as if near to God. Also, one does not fight against enemies here, for the heaviest troubles that need to be fought are known to be those on the inside. But prayers are multiplied before God. "), _c('i', [_vm._v("Commentary on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-427-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-427",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Hannah’s Example of Faith and Love.")]), _vm._v(" "), _c('i', [_vm._v("Viktorin Strigel:")]), _vm._v(" Hannah is truly a mirror on which all pious and honest women should reflect. She does not harbor hatred or rage against God in the midst of her troubles. She is obedient to God, recognizing and deploring her peculiar sin and weakness, even as she asks God for help, knowing that barrenness and fertility are not accidents but both are the work of God. And what did her husband Elkanah do? He tolerated the foolish Peninnah and most gently consoled Hannah with his words: “Why do you weep? And why do you not eat? Am I not more to you than many sons?” It is as if he said, “Peninnah has the shell but you have the kernel. For as she has the fruit of my body, so you rest in my heart. You sweetly surround this better part and you do not need to desire more than this.” "), _c('i', [_vm._v("Commentary on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-426-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-426",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Pleasure Divided from Pain.")]), _vm._v(" "), _c('i', [_vm._v("Daniel Dyke:")]), _vm._v(" It is noted that Elkanah loved Hannah more than his other wife, promising no doubt a greater matter of comfort to himself in her than in the other. But what followed? He loved her, says the prophet, and "), _c('a', {
    attrs: {
      "id": "_idTextAnchor831"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor832"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor833"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor834"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor835"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor836"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor837"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor838"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor839"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor840"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor841"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor842"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor843"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor844"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor845"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor846"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor847"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor848"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor849"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor850"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor851"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor852"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor853"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor854"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor855"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor856"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor857"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor858"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor859"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor860"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor861"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor862"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor863"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor864"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor865"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor866"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor867"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor868"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor869"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor870"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor871"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor872"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor873"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor874"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor875"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor876"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor877"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor878"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor879"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor880"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor881"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor882"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor883"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor884"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor885"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor886"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor887"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor888"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor889"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor890"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor891"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor892"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor893"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor894"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor895"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor896"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor897"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor898"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor899"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor900"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor901"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor902"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor903"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor904"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor905"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor906"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor907"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor908"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor909"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor910"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor911"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor912"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor913"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor914"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor915"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor916"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor917"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor918"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor919"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor920"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor921"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor922"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor923"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor924"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor925"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor926"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor927"
    }
  }), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page7",
      "title": "7"
    }
  }), _vm._v("the Lord made her barren. Mark the connection of his loving her and God’s making her barren. So shall it be in all such earthly creatures, where we cleave inordinately and falsely promise joy to ourselves in their use. God in his just judgment shall make these barren, so that they shall not yield us a quarter of that comfort or benefit that we expected. The rich fool promised himself a little heaven in his riches: “Soul, you have ample goods laid up for many years; relax, eat, drink, be merry. . . .” But, alas, how soon did God give him unease? “Fool, this night your soul is required of you, and the things you have prepared, whose will they be?” Here is the reason for this deceit: We look only at the apparent and outward good of those things we desire or expect. In other words, we extract the sweet from the sour and the pleasure from the pain. But when we get what we want, we feel more of the sour than of the sweet. And hence it comes to pass that nothing pleases us so well in the expectation itself. Indeed, almost nothing that pleasures us when hoped for gives us more displeasure once acquired. "), _c('i', [_vm._v("The Mystery of Self-Deceiving.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-425-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-425",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])])])])]), _vm._v(" "), _c('h5', {
    attrs: {
      "id": "sigil_toc_id_25"
    }
  }, [_c('b', [_vm._v("1:9-11")]), _vm._v(" "), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("Hannah’s Vow and Prayer")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Hannah’s Vow.")]), _vm._v(" "), _c('i', [_vm._v("Johannes Bugenhagen:")]), _vm._v(" Here Hannah has nothing in her power, nothing in her free will, no presumptive claims, rather everything relating to the vow is committed to God; all things here are entirely in the hands of God. “If you give me a son, I will give him to you. If you do not give, I can give nothing to you. If you do not desire to give, you will not give. If you do desire it, you give it. And the one entrusted to me, I will give to you, so that he might minister in the tabernacle and serve the priests. Then if something else should be pleasing in your sight, I will have made sure that he does not remain in his ministry, for I do not presume to determine your calling through this vow. He will be yours. You will do as it has pleased you. A vow against your will is impious. If you give this and he is presented to you, you will make sure that the child whom you give has the mind to obey me in this. You will grant this to pious parents, so that the son does my will according to God. Yes indeed, this one whom God gives me will at the same time recognize the calling of God and honor the commandment about parents. If through later impiety the child comes to condemn God’s calling and parental orders, nevertheless I will be responsible to the vow for the child in my keeping while he is under my care. I truly vow nothing here that brings danger to the child’s conscience. So if he grasps it, it is already done alone as a free person who can change, which is very important. For I am making a vow to you, not against you.” "), _c('i', [_vm._v("Commentary on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-424-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-424",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Heart Like a Flower.")]), _vm._v(" "), _c('i', [_vm._v("Edward Reynolds:")]), _vm._v(" A godly heart is . . . like a flower. For flowers shut when the sun sets and the night comes, but open again when the sun returns and shines on them. If God withdraws his favor and sends a night of affliction, they shut up themselves as well as their thoughts in silence. But if he shines again and sheds abroad the light and sense of his love on them, then their heart and mouth are wide open toward heaven, in lifting up praises to God. Hannah prayed silently, so long as she was in bitterness of soul and of a sorrowful spirit. But as soon as God answered her prayers and filled her heart with joy in him, her mouth immediately opened into a song of thanksgiving. "), _c('i', [_vm._v("Seven Sermons on Fourteenth Chapter of Hosea.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-423-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-423",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Prayer as a Key.")]), _vm._v(" "), _c('i', [_vm._v("Lancelot Andrewes:")]), _vm._v(" Prayer may be compared to a key. An example is when Elisha opened the heavens by prayer when they were shut up. . . . Likewise, when God shuts up the wombs of women . . . so that they become barren, prayer is the key that opens them. By this key was the womb of Hannah opened so that she brought forth Samuel. "), _c('i', [_vm._v("Collection of Lectures.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-422-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-422",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_c('span', {
    staticClass: "com-rorohiko-pagestaker-style"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor928"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor929"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor930"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor931"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor932"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor933"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor934"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor935"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor936"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor937"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor938"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor939"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor940"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor941"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor942"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor943"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor944"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor945"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor946"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor947"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor948"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor949"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor950"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor951"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor952"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor953"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor954"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor955"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor956"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor957"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor958"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor959"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor960"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor961"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor962"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor963"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor964"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor965"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor966"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor967"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor968"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor969"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor970"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor971"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor972"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor973"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor974"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor975"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor976"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor977"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor978"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor979"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor980"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor981"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor982"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor983"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor984"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor985"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor986"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor987"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor988"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor989"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor990"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor991"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor992"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor993"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor994"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor995"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor996"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor997"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor998"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor999"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1000"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1001"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1002"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1003"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1004"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1005"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1006"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1007"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1008"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1009"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1010"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1011"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1012"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1013"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1014"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1015"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1016"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1017"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1018"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1019"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1020"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1021"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1022"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1023"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1024"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1025"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1026"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1027"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1028"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1029"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1030"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1031"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1032"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1033"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1034"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1035"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1036"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1037"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1038"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1039"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1040"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1041"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1042"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1043"
    }
  })])]), _c('b', [_c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page8",
      "title": "8"
    }
  })]), _c('b', [_vm._v("Spiritual Children.")]), _vm._v(" "), _c('i', [_vm._v("Lancelot Andrewes:")]), _vm._v(" Children whom God gives to parents upon a plentiful contrition and repentance usually prove to be excellent in all spiritual graces. The first example of this is Seth, who is not only the foundation of the church but of all humankind. . . . It also appeared in Hannah, who having bewailed her own case in the bitterness of her soul, received from the Lord a blessed seed who came to be called Samuel. He is the one who restored religion and settled the state of the kingdom. "), _c('i', [_vm._v("Collection of Lectures.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-421-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-421",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")])])])])]), _vm._v(" "), _c('h5', {
    attrs: {
      "id": "sigil_toc_id_26"
    }
  }, [_c('b', [_vm._v("1:12-20")]), _vm._v(" "), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("Eli’s Response to Hannah")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Comfort from Eli.")]), _vm._v(" "), _c('i', [_vm._v("Johannes Bugenhagen:")]), _vm._v(" Hannah received the word of consolation from the mouth of Eli as if from the mouth of God. Doubtless, if you prayed an invocation to God and a holy man responded, would you not be consoled by a sure word through this one as if from the Lord? Thus we believe that in former times God consoled the saints through holy people, and only rarely through special revelation. For this reason, Hannah was not more sorrowful. This is the nature of God’s consolation after the cross and hell. "), _c('i', [_vm._v("Commentary on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-420-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-420",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Eli’s Ministry.")]), _vm._v(" "), _c('i', [_vm._v("Viktorin Strigel:")]), _vm._v(" The priest Eli might be considered as a primary example of a faithful ministry, because he did not seek pleasure, useless leisure or sloth. Instead, “Sparta is your country, make the most of it.”"), _c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-419-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-419",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17")])])]), _vm._v(" He was offered all the work of his office and he took it. For that reason he sat in the forecourt of the temple, so that he might bring wanderers or erring people back, fortify the inexperienced, strengthen the weak, shed light on dark and intricate questions and loosen the bonds of those hopelessly wrapped up in doubts. Therefore, by this example of Eli, let us learn to avoid thoughtless judgments, which will require repentance. As the old saying says: “He who judges quickly shall soon repent.” "), _c('i', [_vm._v("Commentary on 1 Samuel")]), _vm._v("."), _c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-418-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-418",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18")])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("No Drinking Allowed.")]), _vm._v(" "), _c('i', [_vm._v("Johann Arndt:")]), _vm._v(" People were not to drink wine or strong drink when they went into the tabernacle. . . . This signifies that if a man wishes to go into the eternal tabernacle of God, that is, to eternal life, he must give up the pleasure and lusts of the flesh of this world and everything by which the flesh conquers the spirit, so that the flesh will not be stronger than the spirit and conquer it. The love of this world, pleasure and pride is a strong sweet wine by which the soul and the spirit are conquered. "), _c('i', [_vm._v("True Christianity.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-417-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-417",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("The Talk of Fools.")]), _vm._v(" "), _c('i', [_vm._v("John Dod:")]), _vm._v(" Those who are too conceited of themselves and of their own wits are here to be sharply reproved. These are the types who will brag and boast that they are not so simple, but they know well enough how to serve God and how to do the duties that pertain to them in their families. Although they have not lived in the world for long and are just recently married, yet they know sufficiently without teaching what belongs to the duty of a husband, of a father, of a master and of all other things a Christian man should know. By saying such things, these foolish men consider little what they speak against themselves and how far they discover their own nakedness. Hereby they make it apparent that they have in them no Christianity at all. For let’s ask ourselves this: Are they wiser than all the prophets and righteous people who lived in ancient times? They saw and acknowledged their great lack of the understanding of holy things. . . . How foully was Eli overtaken through ignorance in censuring and condemning good Hannah for drunkenness when she was pouring out her soul "), _c('a', {
    attrs: {
      "id": "_idTextAnchor1044"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1045"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1046"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1047"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1048"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1049"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1050"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1051"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1052"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1053"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1054"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1055"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1056"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1057"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1058"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1059"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1060"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1061"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1062"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1063"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1064"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1065"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1066"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1067"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1068"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1069"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1070"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1071"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1072"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1073"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1074"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1075"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1076"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1077"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1078"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1079"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1080"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1081"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1082"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1083"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1084"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1085"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1086"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1087"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1088"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1089"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1090"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1091"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1092"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1093"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1094"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1095"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1096"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1097"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1098"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1099"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1100"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1101"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1102"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1103"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1104"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1105"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1106"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1107"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1108"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1109"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1110"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1111"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1112"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1113"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1114"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1115"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1116"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1117"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1118"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1119"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1120"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1121"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1122"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1123"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1124"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1125"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1126"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1127"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1128"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1129"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1130"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1131"
    }
  }), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page9",
      "title": "9"
    }
  }), _vm._v("before the Lord because she moved her lips only? Although she uttered no words in his hearing, she spoke in her heart to God. And the like might be said of many indiscreet speeches and actions of the disciples of Christ before the resurrection, and till they had received the Spirit of understanding in a more plentiful measure. "), _c('i', [_vm._v("The Third Sermon of the Lord’s Supper.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-416-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-416",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20")])])])])]), _vm._v(" "), _c('h5', {
    attrs: {
      "id": "sigil_toc_id_27"
    }
  }, [_c('b', [_vm._v("1:21-28")]), _vm._v(" "), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("Hannah Prepares and Delivers Samuel to the Lord")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Vows Can Be Revoked.")]), _vm._v(" "), _c('i', [_vm._v("Martin Luther:")]), _vm._v(" Samuel, whose mother dedicated him to God, did not always observe the vow, but, as Samuel clearly indicated, become a ruler, traveled around the country, served the people and did not always remain in the temple as had been vowed. On the contrary, Samuel later lived in Ramah, and his example is a powerful argument against eternally binding monastic vows. "), _c('i', [_vm._v("An Answer to Several Questions on Monastic Vows.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-415-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-415",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Samuel Is Lent to the Lord.")]), _vm._v(" "), _c('i', [_vm._v("Johannes Bugenhagen:")]), _vm._v(" This vow is not a perpetual vow, as it says, “As long as he lives, he is lent to the L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")]), _vm._v(".” For because he was a Levite from Kohath, he has been given not by his mother’s vow but the law of God in Numbers 4 to minister from his thirtieth year to his fiftieth, at which time the law restores his freedom. This background also explains why Samuel will be described later as being in Ramah in possession of his father’s house and a judge in Israel for many years. "), _c('i', [_vm._v("Commentary on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-414-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-414",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Samuel’s Sacrifice as a Type of Christ’s.")]), _vm._v(" "), _c('i', [_vm._v("Lancelot Andrewes:")]), _vm._v(" Oblations were of two sorts according to Numbers 28:4, a “morning lamb” and an “evening lamb.” The presentation of Christ in the temple by his parents was the morning lamb; and the offering up of himself as a sacrifice in his passion was the evening lamb. In his oblation he was the author and beginning of our faith; in his passion, he was the finisher and accomplishment of our faith. For the application of this Scripture—that it may not seem strange but lawful and warrantable both by Scripture and by practice of Christ’s church—we are to know that it is lawful and usual to compare things spiritual . . . with things natural. "), _c('i', [_vm._v("Collection of Lectures.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-413-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-413",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Temporal Versus Spiritual Prayers.")]), _vm._v(" "), _c('i', [_vm._v("Andrew Willet:")]), _vm._v(" Some question whether it is lawful to pray for temporal and indifferent things, as here Hannah prays for a child and obtains one. . . . Temporal things are only to be prayed for in general, as we pray for them under the name of bread in the Lord’s Prayer. However, it appears by the examples of holy people in the Scripture that it is lawful to pray for temporal things, as Abraham prayed for Ishmael and Moses prayed for victory against Amalek. But there are two conditions required for temporal prayers: first, that we should pray for them transitorily, that is, not with as great a fervency and desire as for spiritual things; and second, that we must demonstrate how they will be used for God’s glory. But we must not think that we are heard for the merit of our prayer. God hears us in mercy, though prayer is appointed as the way and the means by which we walk. It is not the cause of granting our requests. "), _c('i', [_vm._v("Harmony on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-412-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-412",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Perpetual Nazirite.")]), _vm._v(" "), _c('i', [_vm._v("Lancelot Andrewes:")]), _vm._v(" If we ask why Hannah . . . gives something to God, the reason is because God has been offended by humankind and therefore must be appeased; and nothing more serves to appease wrath than a gift. . . . But if we will appease by a gift there must be an equality; we may not offer a thing under the value of the thing that was taken away. That is the reason why all the sacrifices of the law could not appease God. . . . The value of our obedience to God is such as cannot appease and satisfy his majesty, having "), _c('a', {
    attrs: {
      "id": "_idTextAnchor1132"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1133"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1134"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1135"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1136"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1137"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1138"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1139"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1140"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1141"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1142"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1143"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1144"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1145"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1146"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1147"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1148"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1149"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1150"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1151"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1152"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1153"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1154"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1155"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1156"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1157"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1158"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1159"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1160"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1161"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1162"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1163"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1164"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1165"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1166"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1167"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1168"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1169"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1170"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1171"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1172"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1173"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1174"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1175"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1176"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1177"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1178"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1179"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1180"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1181"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1182"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1183"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1184"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1185"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1186"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1187"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1188"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1189"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1190"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1191"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1192"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1193"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1194"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1195"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1196"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1197"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1198"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1199"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1200"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1201"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1202"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1203"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1204"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1205"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1206"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1207"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1208"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1209"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1210"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1211"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1212"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1213"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1214"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1215"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1216"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1217"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1218"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1219"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1220"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1221"
    }
  }), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page10",
      "title": "10"
    }
  }), _vm._v("been offended. . . . But if we can offer to God a thing of equal price to the obedience that we owe to God, then no doubt God will be appeased, especially if we offer a thing of a higher rate. . . . To offer Samuel as a Nazirite was not enough, for that continues but for certain days. . . . But Hannah gives her son to the Lord all his life, that is, forever. "), _c('i', [_vm._v("Collection of Lectures.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-411-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-411",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25")])])])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "_idContainer018"
    }
  }, [_c('p', {
    staticClass: "PER_Top-extra-space"
  }, [_c('span', {
    staticClass: "com-rorohiko-pagestaker-style"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor1222"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1223"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1224"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1225"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1226"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1227"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1228"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1229"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1230"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1231"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1232"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1233"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1234"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1235"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1236"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1237"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1238"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1239"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1240"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1241"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1242"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1243"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1244"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1245"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1246"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1247"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1248"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1249"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1250"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1251"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1252"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1253"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1254"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1255"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1256"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1257"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1258"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1259"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1260"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1261"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1262"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1263"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1264"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1265"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1266"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1267"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1268"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1269"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1270"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1271"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1272"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1273"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1274"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1275"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1276"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1277"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1278"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1279"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1280"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1281"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1282"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1283"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1284"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1285"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1286"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1287"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1288"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1289"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1290"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1291"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1292"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1293"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1294"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1295"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1296"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1297"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1298"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1299"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1300"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1301"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1302"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1303"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1304"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1305"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1306"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1307"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1308"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1309"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1310"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1311"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1312"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1313"
    }
  })]), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page11",
      "title": "11"
    }
  })]), _vm._v(" "), _c('h2', {
    staticClass: "PER_ScriptureCenter",
    attrs: {
      "id": "sigil_toc_id_28"
    }
  }, [_c('span', {
    staticClass: "RH-marker"
  }, [_vm._v("2:1-10")]), _vm._v(" THE PRAYER OF HANNAH")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("1")]), _c('i', [_vm._v("And Hannah prayed and said,")])]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "verse"
  }, [_c('i', [_vm._v("“My heart exults in the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _c('i', [_vm._v(";")])]), _vm._v(" "), _c('p', {
    staticClass: "verseindent"
  }, [_c('i', [_vm._v("my horn is exalted in the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _c('i', [_vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "verse"
  }, [_c('i', [_vm._v("My mouth derides my enemies,")])]), _vm._v(" "), _c('p', {
    staticClass: "verseindent"
  }, [_c('i', [_vm._v("because I rejoice in your salvation.")])]), _vm._v(" "), _c('p', {
    staticClass: "versefirst"
  }, [_c('i', [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("2")])]), _c('i', [_vm._v("“There is none holy like the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _c('i', [_vm._v(":")])]), _vm._v(" "), _c('p', {
    staticClass: "verseindent"
  }, [_c('i', [_vm._v("for there is none besides you;")])]), _vm._v(" "), _c('p', {
    staticClass: "verseindent"
  }, [_c('i', [_vm._v("there is no rock like our God.")])]), _vm._v(" "), _c('p', {
    staticClass: "verse"
  }, [_c('i', [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("3")])]), _c('i', [_vm._v("Talk no more so very proudly,")])]), _vm._v(" "), _c('p', {
    staticClass: "verseindent"
  }, [_c('i', [_vm._v("let not arrogance come from your mouth;")])]), _vm._v(" "), _c('p', {
    staticClass: "verse"
  }, [_c('i', [_vm._v("for the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("is a God of knowledge,")])]), _vm._v(" "), _c('p', {
    staticClass: "verseindent"
  }, [_c('i', [_vm._v("and by him actions are weighed.")])]), _vm._v(" "), _c('p', {
    staticClass: "verse"
  }, [_c('i', [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("4")])]), _c('i', [_vm._v("The bows of the mighty are broken,")])]), _vm._v(" "), _c('p', {
    staticClass: "verseindent"
  }, [_c('i', [_vm._v("but the feeble bind on strength.")])]), _vm._v(" "), _c('p', {
    staticClass: "verse"
  }, [_c('i', [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("5")])]), _c('i', [_vm._v("Those who were full have hired themselves out for bread,")])]), _vm._v(" "), _c('p', {
    staticClass: "verseindent"
  }, [_c('i', [_vm._v("but those who were hungry have ceased to hunger.")])]), _vm._v(" "), _c('p', {
    staticClass: "verse"
  }, [_c('i', [_vm._v("The barren has borne seven,")])]), _vm._v(" "), _c('p', {
    staticClass: "verseindent"
  }, [_c('i', [_vm._v("but she who has many children is forlorn.")])]), _vm._v(" "), _c('p', {
    staticClass: "verse"
  }, [_c('i', [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("6")])]), _c('i', [_vm._v("The")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("kills and brings to life;")])]), _vm._v(" "), _c('p', {
    staticClass: "verseindent"
  }, [_c('i', [_vm._v("he brings down to Sheol and raises up.")])]), _vm._v(" "), _c('p', {
    staticClass: "verse"
  }, [_c('i', [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("7")])]), _c('i', [_vm._v("The")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("makes poor and makes rich;")])]), _vm._v(" "), _c('p', {
    staticClass: "verseindent"
  }, [_c('i', [_vm._v("he brings low and he exalts.")])]), _vm._v(" "), _c('p', {
    staticClass: "verse"
  }, [_c('i', [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("8")])]), _c('i', [_vm._v("He raises up the poor from the dust;")])]), _vm._v(" "), _c('p', {
    staticClass: "verseindent"
  }, [_c('i', [_vm._v("he lifts the needy from the ash heap")])]), _vm._v(" "), _c('p', {
    staticClass: "verse"
  }, [_c('i', [_vm._v("to make them sit with princes")])]), _vm._v(" "), _c('p', {
    staticClass: "verseindent"
  }, [_c('i', [_vm._v("and inherit a seat of honor.")])]), _vm._v(" "), _c('p', {
    staticClass: "verse"
  }, [_c('i', [_vm._v("For the pillars of the earth are the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _c('i', [_vm._v("’s,")])]), _vm._v(" "), _c('p', {
    staticClass: "verseindent"
  }, [_c('i', [_vm._v("and on them he has set the world.")])]), _vm._v(" "), _c('p', {
    staticClass: "versefirst"
  }, [_c('i', [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("9")])]), _c('i', [_vm._v("“He will guard the feet of his faithful ones,")])]), _vm._v(" "), _c('p', {
    staticClass: "verseindent"
  }, [_c('i', [_vm._v("but the wicked shall be cut off in darkness,")])]), _vm._v(" "), _c('p', {
    staticClass: "verseindent"
  }, [_c('i', [_vm._v("for not by might shall a man prevail.")])]), _vm._v(" "), _c('p', {
    staticClass: "verse"
  }, [_c('i', [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("10")])]), _c('i', [_vm._v("The adversaries of the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("shall be broken to pieces;")])]), _vm._v(" "), _c('p', {
    staticClass: "verseindent"
  }, [_c('i', [_vm._v("against them he will thunder in heaven.")])]), _vm._v(" "), _c('p', {
    staticClass: "verse"
  }, [_c('i', [_vm._v("The")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("will judge the ends of the earth;")])]), _vm._v(" "), _c('p', {
    staticClass: "verseindent"
  }, [_c('i', [_vm._v("he will give strength to his king")])]), _vm._v(" "), _c('p', {
    staticClass: "verseindent"
  }, [_c('i', [_vm._v("and exalt the horn of his anointed.”")])])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Overview:")]), _vm._v(" Hannah’s prayer, according to the reformers, signifies much more than mere praise of God for the gift of a child. It foretells the reign of Christ, and also provides the basis for Mary’s prayer in Luke 1:46-55."), _c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-410-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-410",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])])]), _vm._v(" The commentators regard this as one of chief passages where the messianic king, Jesus Christ, is predicted in the Old Testament. The reformers, intent on safeguarding the sovereignty of God, dwell on Hannah’s words that the Lord both takes and restores life, which Strigel interprets as true conversion to God. The story of a barren yet faithful woman who ends up with a baby boy is a common one in the Bible, but the commentators see more spiritual significance in the story than first meets the eye.")]), _vm._v(" "), _c('h5', {
    attrs: {
      "id": "sigil_toc_id_29"
    }
  }, [_c('b', [_vm._v("2:1-5")]), _vm._v(" "), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("Overview of Hannah’s Prayer")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Hannah Sings of God’s Glory.")]), _vm._v(" "), _c('i', [_vm._v("Johannes Bugenhagen:")]), _vm._v(" From her experience, Hannah, full of the Spirit, sings against the glory of human hypocrisy and sings about God’s glory, through which God graciously makes the barren fruitful. This means that Gentiles and sinners acquire grace. This divine grace and glory has been declared and entered the world through the reign of Christ, whose strength God exalts against all of the world’s powers, knowledge, righteousness and especially all human hypocrisy. "), _c('i', [_vm._v("Commentary on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-409-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-409",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Hannah’s Faithful and Prophetic Prayer.")]), _vm._v(" "), _c('i', [_vm._v("Viktorin Strigel:")]), _vm._v(" Hannah conforms to the "), _c('a', {
    attrs: {
      "id": "_idTextAnchor1314"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1315"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1316"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1317"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1318"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1319"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1320"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1321"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1322"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1323"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1324"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1325"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1326"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1327"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1328"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1329"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1330"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1331"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1332"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1333"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1334"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1335"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1336"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1337"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1338"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1339"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1340"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1341"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1342"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1343"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1344"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1345"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1346"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1347"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1348"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1349"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1350"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1351"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1352"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1353"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1354"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1355"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1356"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1357"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1358"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1359"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1360"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1361"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1362"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1363"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1364"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1365"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1366"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1367"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1368"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1369"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1370"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1371"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1372"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1373"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1374"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1375"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1376"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1377"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1378"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1379"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1380"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1381"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1382"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1383"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1384"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1385"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1386"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1387"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1388"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1389"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1390"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1391"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1392"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1393"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1394"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1395"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1396"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1397"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1398"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1399"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1400"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1401"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1402"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1403"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1404"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1405"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1406"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1407"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1408"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1409"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1410"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1411"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1412"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1413"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1414"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1415"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1416"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1417"
    }
  }), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page12",
      "title": "12"
    }
  }), _vm._v("pattern given in James: “Is anyone among you suffering? Let him pray. Is anyone cheerful? Let him sing praise.” Just as she brought prayers and vows to God earlier, she then celebrated the goodness and mercy of God with the sweetest song. But Hannah’s song is so admirably worthy not only because it praises the source of the gift but also because it foretells the reign of Christ, which lasts even to the end of the earth. Further, she teaches faith in God alone to be such that one can be killed and made alive, taken down to hell and brought back. "), _c('i', [_vm._v("Commentary on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-408-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-408",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Giving All.")]), _vm._v(" "), _c('i', [_vm._v("Thomas Adams:")]), _vm._v(" God gave Samuel to Hannah, Hannah gave Samuel back again to God. In a similar way, return part of your riches to God, who gave all to you in the first place. "), _c('i', [_vm._v("Commentary on 2 Peter.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-407-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-407",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Prayer of All Creatures.")]), _vm._v(" "), _c('i', [_vm._v("Lancelot Andrewes:")]), _vm._v(" The want of so great a blessing as is the bearing of a child moved Hannah to break forth into this desire of prayer. Yet it is most certain that the Virgin Mary needed a Savior—for which she also confessed that her spirit rejoiced—more so than Hannah needed a son. And as Mary’s need was greater, so her prayer was stronger than Hannah’s prayer. For Hannah prayed alone; but as for Mary’s prayer, it was accompanied with the desire and prayer of all creatures. "), _c('i', [_vm._v("Collection of Lectures.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-406-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-406",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])])])])]), _vm._v(" "), _c('h5', {
    attrs: {
      "id": "sigil_toc_id_30"
    }
  }, [_c('b', [_vm._v("2:6-9")]), _vm._v(" "), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("Killing and Bringing to Life")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Taking and Giving Life.")]), _vm._v(" "), _c('i', [_vm._v("Hans Denck:")]), _vm._v(" The righteousness of God is God himself. Sin is what raises itself up against God; it is in truth nothing. The righteousness works through the Word that was from the beginning and is subsequently divided in two, law and gospel, on account of the twofold office that Christ as king of righteousness exercises, namely, to destroy the unbelievers and to bring to life the believers. Now, all believers were once unbelievers. Consequently, in becoming believers, they thus first had to die in order that they might thereafter no longer live for themselves, as unbelievers do, but for God through Christ that their walk might indeed no longer be on earth but in heaven, as Paul says. David also verifies this where he says: The Lord leads down into hell and up again. All this I believe (Lord, crush my unbelief) in truth, awaiting now whoever wishes to deny and overthrow it. "), _c('i', [_vm._v("Nuremberg Confession.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-405-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-405",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Law Versus Gospel.")]), _vm._v(" "), _c('i', [_vm._v("Johann Gerhard:")]), _vm._v(" God kills and makes alive, and he leads down to hell and brings back again. Specifically, God kills by contrition that he may make alive by consolation. And God leads down to hell by the hammer of the law that he may bring back from hell by the comfort of the gospel. "), _c('i', [_vm._v("The Conquest of Temptations.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-404-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-404",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("True Repentance Involves Dying and Rising.")]), _vm._v(" "), _c('i', [_vm._v("Viktorin Strigel:")]), _vm._v(" Hannah’s song describes true repentance, or conversion to God, in which there are two moves: dying and being made alive. Dying points to the heart’s recognizing God’s wrath against sin with true fear and suffering. Scripture describes this suffering: “Like a lion he breaks all my bones.” In these sufferings, which come from awareness of God’s wrath, there is mortification of the flesh, or of the old and corrupt nature. This suffering may be greater or smaller in various people, but contrition is necessary in all conversions, as it says in 2 Corinthians: “You were grieved into repenting . . . for godly grief produces a repentance that leads to salvation.” "), _c('i', [_vm._v("Commentary on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-403-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-403",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Studying at God’s School.")]), _vm._v(" "), _c('i', [_vm._v("Martin Luther:")]), _vm._v(" I have often seen excellent men horribly vexed by terrors, afflictions and the severest persecutions, so "), _c('a', {
    attrs: {
      "id": "_idTextAnchor1418"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1419"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1420"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1421"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1422"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1423"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1424"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1425"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1426"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1427"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1428"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1429"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1430"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1431"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1432"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1433"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1434"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1435"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1436"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1437"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1438"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1439"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1440"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1441"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1442"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1443"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1444"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1445"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1446"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1447"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1448"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1449"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1450"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1451"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1452"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1453"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1454"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1455"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1456"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1457"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1458"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1459"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1460"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1461"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1462"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1463"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1464"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1465"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1466"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1467"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1468"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1469"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1470"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1471"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1472"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1473"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1474"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1475"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1476"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1477"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1478"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1479"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1480"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1481"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1482"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1483"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1484"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1485"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1486"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1487"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1488"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1489"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1490"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1491"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1492"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1493"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1494"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1495"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1496"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1497"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1498"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1499"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1500"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1501"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1502"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1503"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1504"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1505"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1506"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1507"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1508"
    }
  }), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page13",
      "title": "13"
    }
  }), _vm._v("much so that they nearly experienced despair of heart. But these things must be learned so that we may be able to comfort such men and interpret the temptations as the special manner by which God is accustomed to wrestle with us in the form of a destroyer and that we may exhort them firmly to retain the promise, or lamp and spark, of the Word in the hope that the rescue will certainly follow. For God leads down to hell and brings back. Now you see his back parts, and God seems to be shunning you, but sometime later you will see his front parts and his face. This is what it means for him to love those whom he chastises. This love must be learned from experience, nor should chastisement be avoided and shunned. The story is told of a peasant who, when he heard this consolation from his pastor, that the afflictions and troubles by which God afflicts us are signs of his love, replied: “Ah, how I would like him to love others and not me!” "), _c('i', [_vm._v("Lectures on Genesis.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-402-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-402",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("All Is God’s Own.")]), _vm._v(" "), _c('i', [_vm._v("David Clarkson:")]), _vm._v(" God has the right to dispose of all as he wills, and does actually dispose of any things and persons as he thinks is good. He has "), _c('i', [_vm._v("jus praesenter disponendi")]), _vm._v(", “the right of present disposal,” which is properly dominion or property. He gives possession and ejects, puts in and throws out, lifts up and casts down, whom and when he will. . . . Why does God thus dispose of all? Because all is his own. "), _c('i', [_vm._v("Sermon on 1 Chronicles 29:11.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-401-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-401",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])])])])]), _vm._v(" "), _c('h5', {
    attrs: {
      "id": "sigil_toc_id_31"
    }
  }, [_c('b', [_vm._v("2:10")]), _vm._v(" "), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("God Blessed His Church")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Another Prediction About the Messiah.")]), _vm._v(" "), _c('i', [_vm._v("Cardinal Cajetan:")]), _vm._v(" According to the Hebrew, the passage states: “He will give strength to his king; he will raise the horn of his Messiah.” Before this time, however, no king had been instituted in Israel. Therefore, this passage speaks about the messianic king, for God gave him strength and elevated his power. In fact, in Hebrew the word "), _c('i', [_vm._v("Messiah")]), _vm._v(" means “anointed,” while in Greek the word is translated as "), _c('i', [_vm._v("Christ")]), _vm._v(". Now, it is evident that Christ will come at the time of judgment in strength and in great stature. And for this reason it is manifest that he will be a person who judges the ends of the earth according to the prophecy from the book of Job. And this is the fourth passage in which the Messiah is clearly predicted: first, during the time of Abraham; second, during the time of Jacob; third, during the time of Moses; and fourth, during the time of Samuel. Later the Messiah is predicted in the book of Job. "), _c('i', [_vm._v("Commentary on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-400-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-400",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("David, the Chosen One.")]), _vm._v(" "), _c('i', [_vm._v("John Calvin:")]), _vm._v(" Before a king had been established over the people, Hannah, the mother of Samuel, describing the happiness of the godly, already says in her song: “God will give strength to his king and exalt the horn of his Messiah.” By these words she means that God will bless his church. To this corresponds the prophecy that is added a little later: “The priest whom I shall raise up . . . will walk in the presence of my Christ.” And there is no doubt that our heavenly Father willed that we perceive in David and his descendants the living image of Christ. Accordingly David, wishing to urge the pious fear of God, commands them to “kiss the Son.” To this corresponds the saying of the Gospel: “He who does not honor the Son does not honor the Father.” Therefore, although the kingdom collapsed because of the revolt of the ten tribes, yet the covenant God made with David and his successors had to stand, just as he spoke through the prophets: “I will not tear away all the kingdom . . . for the sake of David my servant and for the sake of Jerusalem, which I have chosen . . . but to your son one tribe will remain.” This same promise is repeated a second and a third time. It is expressly stated: “I will . . . afflict David’s descendants, but not eternally.” Sometime later it is said: “For the sake of David his servant, God gave him a lamp in Jerusalem, to "), _c('a', {
    attrs: {
      "id": "_idTextAnchor1509"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1510"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1511"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1512"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1513"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1514"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1515"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1516"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1517"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1518"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1519"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1520"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1521"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1522"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1523"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1524"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1525"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1526"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1527"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1528"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1529"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1530"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1531"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1532"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1533"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1534"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1535"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1536"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1537"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1538"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1539"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1540"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1541"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1542"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1543"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1544"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1545"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1546"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1547"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1548"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1549"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1550"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1551"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1552"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1553"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1554"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1555"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1556"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1557"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1558"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1559"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1560"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1561"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1562"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1563"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1564"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1565"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1566"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1567"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1568"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1569"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1570"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1571"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1572"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1573"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1574"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1575"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1576"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1577"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1578"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1579"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1580"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1581"
    }
  }), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page14",
      "title": "14"
    }
  }), _vm._v("raise himself up a son and to protect Jerusalem.” Then, although affairs verged on ruin, it was again said: “The Lord was unwilling to destroy Judah, for the sake of David his servant, since he promised to give a lamp to him and to his sons forever.” To sum up: While all others were passed over, David alone was chosen as the one in whom God’s pleasure should rest. "), _c('i', [_vm._v("Institutes 2.6.2.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-399-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-399",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])])])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "_idContainer019"
    }
  }, [_c('p', {
    staticClass: "PER_Top-extra-space"
  }, [_c('span', {
    staticClass: "com-rorohiko-pagestaker-style"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor1582"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1583"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1584"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1585"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1586"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1587"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1588"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1589"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1590"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1591"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1592"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1593"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1594"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1595"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1596"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1597"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1598"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1599"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1600"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1601"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1602"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1603"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1604"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1605"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1606"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1607"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1608"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1609"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1610"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1611"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1612"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1613"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1614"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1615"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1616"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1617"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1618"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1619"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1620"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1621"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1622"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1623"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1624"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1625"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1626"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1627"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1628"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1629"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1630"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1631"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1632"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1633"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1634"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1635"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1636"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1637"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1638"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1639"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1640"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1641"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1642"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1643"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1644"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1645"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1646"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1647"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1648"
    }
  })]), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page15",
      "title": "15"
    }
  })]), _vm._v(" "), _c('h2', {
    staticClass: "PER_ScriptureCenter",
    attrs: {
      "id": "sigil_toc_id_32"
    }
  }, [_c('span', {
    staticClass: "RH-marker"
  }, [_vm._v("2:11-36")]), _vm._v(" REJECTION OF ELI’S WICKED SONS AND HIS HOUSEHOLD")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("11")]), _c('i', [_vm._v("Then Elkanah went home to Ramah. And the boy")]), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("a")]), _vm._v(" "), _c('i', [_vm._v("was ministering to the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("in the presence of Eli the priest.")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("12")]), _c('i', [_vm._v("Now the sons of Eli were worthless men. They did not know the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _c('i', [_vm._v(".")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("13")]), _c('i', [_vm._v("The custom of the priests with the people was that when any man offered sacrifice, the priest’s servant would come, while the meat was boiling, with a three-pronged fork in his hand,")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("14")]), _c('i', [_vm._v("and he would thrust it into the pan or kettle or cauldron or pot. All that the fork brought up the priest would take for himself. This is what they did at Shiloh to all the Israelites who came there.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("15")]), _c('i', [_vm._v("Moreover, before the fat was burned, the priest’s servant would come and say to the man who was sacrificing, “Give meat for the priest to roast, for he will not accept boiled meat from you but only raw.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("16")]), _c('i', [_vm._v("And if the man said to him, “Let them burn the fat first, and then take as much as you wish,” he would say, “No, you must give it now, and if not, I will take it by force.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("17")]), _c('i', [_vm._v("Thus the sin of the young men was very great in the sight of the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _c('i', [_vm._v(", for the men treated the offering of the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("with contempt.")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("18")]), _c('i', [_vm._v("Samuel was ministering before the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _c('i', [_vm._v(", a boy clothed with a linen ephod.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("19")]), _c('i', [_vm._v("And his mother used to make for him a little robe and take it to him each year when she went up with her husband to offer the yearly sacrifice.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("20")]), _c('i', [_vm._v("Then Eli would bless Elkanah and his wife, and say, “May the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("give you children by this woman for the petition she asked of the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _c('i', [_vm._v(".” So then they would return to their home.")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("21")]), _c('i', [_vm._v("Indeed the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("visited Hannah, and she conceived and bore three sons and two daughters. And the boy Samuel grew in the presence of the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _c('i', [_vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("22")]), _c('i', [_vm._v("Now Eli was very old, and he kept hearing all that his sons were doing to all Israel, and how they lay with the women who were serving at the entrance to the tent of meeting.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("23")]), _c('i', [_vm._v("And he said to them, “Why do you do such things? For I hear of your evil dealings from all these people.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("24")]), _c('i', [_vm._v("No, my sons; it is no good report that I hear the people of the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("spreading abroad.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("25")]), _c('i', [_vm._v("If someone sins against a man, God will mediate for him, but if someone sins against the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _c('i', [_vm._v(", who can intercede for him?” But they would not listen to the voice of their father, for it was the will of the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("to put them to death.")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("26")]), _c('i', [_vm._v("Now the boy Samuel continued to grow both in stature and in favor with the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("and also with man.")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("27")]), _c('i', [_vm._v("And there came a man of God to Eli and said to him, “Thus says the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _c('i', [_vm._v(", ‘Did I indeed reveal myself to the house of your father when they were in Egypt subject to the house of Pharaoh?")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("28")]), _c('i', [_vm._v("Did I choose him out of all the tribes of Israel to be my priest, to go up to my altar, to burn incense, to wear an ephod before me? I gave to the house of your father all my offerings by fire from the people of Israel.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("29")]), _c('i', [_vm._v("Why then do you scorn")]), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("b")]), _vm._v(" "), _c('i', [_vm._v("my sacrifices and my offerings that I commanded for my dwelling, and honor your sons above me by fattening yourselves on the choicest parts of every offering of my people Israel?’")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("30")]), _c('i', [_vm._v("Therefore the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _c('i', [_vm._v(", the God of Israel, declares: ‘I promised that your house and the house of your father should go in and out before me forever,’ but now the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("declares: ‘Far be it from me, for those who honor me I will honor, and those who despise me shall be lightly esteemed.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("31")]), _c('i', [_vm._v("Behold, the days are coming when I will cut off your strength and the strength of your father’s house, so that there will not be an old man in your house.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("32")]), _c('i', [_vm._v("Then in distress you will look with envious eye on all the prosperity that shall be bestowed on Israel, and there shall not be an old man in your house forever.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("33")]), _c('i', [_vm._v("The only one of you whom I shall not cut off from my altar shall be spared to weep his")]), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("c")]), _vm._v(" "), _c('i', [_vm._v("eyes out to grieve his heart, and all the descendants")]), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("d")]), _vm._v(" "), _c('i', [_vm._v("of your house shall die by the sword of men.")]), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("e")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("34")]), _c('i', [_vm._v("And this that shall come upon your two sons, Hophni and Phinehas, shall be the sign to you: both of them shall die on the same day.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("35")]), _c('i', [_vm._v("And I will raise up for myself a faithful priest, who shall do according to what is in my heart and in my mind. And I will build him a sure house, and he shall go in and out before my "), _c('a', {
    attrs: {
      "id": "_idTextAnchor1649"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1650"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1651"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1652"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1653"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1654"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1655"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1656"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1657"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1658"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1659"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1660"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1661"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1662"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1663"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1664"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1665"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1666"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1667"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1668"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1669"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1670"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1671"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1672"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1673"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1674"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1675"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1676"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1677"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1678"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1679"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1680"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1681"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1682"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1683"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1684"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1685"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1686"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1687"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1688"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1689"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1690"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1691"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1692"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1693"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1694"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1695"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1696"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1697"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1698"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1699"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1700"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1701"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1702"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1703"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1704"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1705"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1706"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1707"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1708"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1709"
    }
  })]), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page16",
      "title": "16"
    }
  }), _c('i', [_vm._v("anoi"), _c('a', {
    attrs: {
      "id": "_idTextAnchor1710"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1711"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1712"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1713"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1714"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1715"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1716"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1717"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1718"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1719"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1720"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1721"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1722"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1723"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1724"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1725"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1726"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1727"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1728"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1729"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1730"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1731"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1732"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1733"
    }
  }), _vm._v("nted forever.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("36")]), _c('i', [_vm._v("And everyone who is left in your house shall come to implore him for a piece of silver or a loaf of bread and shall say, “Please put me in one of the priests’ places, that I may eat a morsel of bread.”’”")])]), _vm._v(" "), _c('p', {
    staticClass: "small"
  }, [_c('b', [_vm._v("a")]), _vm._v(" Hebrew "), _c('i', [_vm._v("na’ar")]), _vm._v(" can be rendered "), _c('i', [_vm._v("boy")]), _vm._v(" (2:11, 18, 21, 26; 3:1, 8), "), _c('i', [_vm._v("servant")]), _vm._v(" (2:13, 15), or "), _c('i', [_vm._v("young man")]), _vm._v(" (2:17), depending on the context "), _c('b', [_vm._v("b")]), _vm._v(" Hebrew "), _c('i', [_vm._v("kick at")]), _vm._v(" "), _c('b', [_vm._v("c")]), _vm._v(" Septuagint; Hebrew "), _c('i', [_vm._v("your")]), _vm._v("; twice in this verse "), _c('b', [_vm._v("d")]), _vm._v(" Hebrew "), _c('i', [_vm._v("increase")]), _vm._v(" "), _c('b', [_vm._v("e")]), _vm._v(" Septuagint; Hebrew "), _c('i', [_vm._v("die as men"), _c('br'), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Overview:")]), _vm._v(" According to the interpreters, leadership of God’s people is a great responsibility, not to be taken lightly. Melanchthon exhorts us not to discredit the gospel by our bad behavior. The reformers believe that leaders, particularly members of the clergy, are to display exemplary lives in accordance with good doctrine. When God’s people see poor behavior in their leaders, they are drawn to imitate their bad example rather than seek the higher road to goodness and righteousness. Eli’s sons are evil leaders juxtaposed with Samuel’s godly leadership. Moreover, the reformers criticize Eli for being too lenient toward his sons, and the commentators use this passage to encourage parents to follow the wisdom of Proverbs by disciplining their children. When Eli tries to admonish his sons’ behavior, however, it is too late. According to the interpreters, Eli is unable to intercede with God on his sons’ behalf, and God rightly condemns his sons for their wicked behavior. Despite the free actions of Eli’s sons, the removal of Eli’s lineage from the priesthood is part of God’s sovereign plan, which prompts an explanation of the difference between conditional and unconditional promises.")]), _vm._v(" "), _c('h5', {
    attrs: {
      "id": "sigil_toc_id_33"
    }
  }, [_c('b', [_vm._v("2:11-17")]), _vm._v(" "), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("The")]), _vm._v(" "), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("Differences Between Godly and Ungodly Leaders")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Integrity Among Ministers.")]), _vm._v(" "), _c('i', [_vm._v("Philipp Melanchthon:")]), _vm._v(" We, who confess the gospel, are especially to consider how severely God is angered if we give the gospel an evil name. For such sin God cast aside the high priest Eli and his sons, as the text says, 1 Samuel 2:17, “Thus the sin of the young men was very great in the sight of the Lord; for they treated the offering of the Lord with contempt.” As God was angry with those who gave reason for speaking of the sacrifice, you should not give reason for, or support, blasphemy or contempt of the gospel. We must, therefore, be careful in doctrine and customs, so that we do not incur the anger of God with offensive doctrine or injurious examples. "), _c('i', [_vm._v("Theological Commonplaces (1555).")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-398-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-398",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Samuel’s Steadfastness Contrasts with Eli’s Sons.")]), _vm._v(" "), _c('i', [_vm._v("Viktorin Strigel:")]), _vm._v(" Samuel possessed great and amazing virtue, because he did not imitate the depraved example of Eli’s sons. For he very much shows examples of self-governance in both parts of valor. For they are especially strong who have close friendships at home and who attend closely to God. Therefore, when Samuel did not follow the impious and otherwise wicked sons of Eli, then his incorruptibility can rightly be described as Pyrrhus spoke of Fabricius (as stated in Eutropius’s history). Such is Samuel, who was as hard to separate from honesty as Saul was quick. For he was always true to himself, unchanging in all matters. "), _c('i', [_vm._v("Commentary on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-397-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-397",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("The Role of a Church Leader.")]), _vm._v(" "), _c('i', [_vm._v("Heinrich Bullinger:")]), _vm._v(" Let us consider how pastors are to lead the church of Christ and exemplify a holy life. The Lord said to his disciples in the Gospel: “You are the light of the world. A city on a hill cannot be hidden. Neither do people light a lamp and put it under a bowl. Instead they put it on its stand, and it gives light to everyone in the house. In the same way, let your light shine before men, that they may see your good deeds and praise your Father in "), _c('a', {
    attrs: {
      "id": "_idTextAnchor1734"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1735"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1736"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1737"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1738"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1739"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1740"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1741"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1742"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1743"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1744"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1745"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1746"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1747"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1748"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1749"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1750"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1751"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1752"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1753"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1754"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1755"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1756"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1757"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1758"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1759"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1760"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1761"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1762"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1763"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1764"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1765"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1766"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1767"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1768"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1769"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1770"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1771"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1772"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1773"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1774"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1775"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1776"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1777"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1778"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1779"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1780"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1781"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1782"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1783"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1784"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1785"
    }
  }), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page17",
      "title": "17"
    }
  }), _vm._v("hea"), _c('a', {
    attrs: {
      "id": "_idTextAnchor1786"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1787"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1788"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1789"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1790"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1791"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1792"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1793"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1794"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1795"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1796"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1797"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1798"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1799"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1800"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1801"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1802"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1803"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1804"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1805"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1806"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1807"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1808"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1809"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1810"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1811"
    }
  }), _vm._v("ven.” As such, pastors are to give light to their churches by means of a holy life and not just by means of doctrine. After seeing that the pastor’s life agrees with sound doctrine, the people of the church will be moved toward innocence of life. For the most part, an example of a holy and good person may be found in the study of the virtues; on the contrary, Scripture testifies in many ways how the corrupt sons of Eli, the chief leaders of religion, served as an example to corrupt the people. For Scripture says, “This sin of the young men was very great in the Lord’s sight, for they were treating the Lord’s offering with contempt.” For it is apparent that people begin to doubt the whole doctrine when they see the corrupt life of the ministers of the church. The people cry out, “If the pastor truly believed the things he teaches us, he would not lead such an immoral life.” In this way, the teachers are said to have overthrown in their evil life what they had constructed in their unsound doctrine. "), _c('i', [_vm._v("Decades 5.4.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-396-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-396",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("The Many Offenses of Eli’s Sons.")]), _vm._v(" "), _c('i', [_vm._v("Andrew Willet:")]), _vm._v(" The sin Eli’s sons committed against the offerings of the Lord was not of one sort but many. First, they were guilty of theft and robbery. For whereas only the breast and right shoulder belonged to the priest of the peace offerings, they took more and were not content with the ordinary portion brought up by their utensils. Second, they also committed sacrilege. For whereas the Lord was to be served first and the fat burned first, they exacted their fee and more, even before the Lord had gotten his due. Third, they did this with contemptuous hostility and violence, not staying to receive it at the offerer’s hand, but being their own carvers. Fourth, they were also guilty of the sin of wantonness. They took the flesh while it was yet raw, so that they might dress it to the priest’s liking. In short, the sin of the young men was very great: in respect to themselves . . . who, being priests, should have given a good example to others; in regard to God, against whom they were presumptuous; and in respect to the great hurt and inconvenience that arose from this, they caused the people to abhor the sacrifices of the Lord. "), _c('i', [_vm._v("Harmony on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-395-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-395",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])])])])]), _vm._v(" "), _c('h5', {
    attrs: {
      "id": "sigil_toc_id_34"
    }
  }, [_c('b', [_vm._v("2:18-21")]), _vm._v(" "), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("Samuel and His Ephod")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("The Ephod Linen.")]), _vm._v(" "), _c('i', [_vm._v("Johannes Bugenhagen:")]), _vm._v(" This was the ephod garment of the Levites, spoken of in Exodus 28, which covered over the priests’ lower body. But when it was put on Samuel, it signified his public ministry and his Levitical priesthood in the tabernacle. "), _c('i', [_vm._v("Commentary on 1 Samuel.")]), _c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-394-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-394",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Different Kinds of Ephods.")]), _vm._v(" "), _c('i', [_vm._v("Andrew Willet:")]), _vm._v(" There were two kinds of ephods belonging to the service of the tabernacle, one peculiar to the high priest wrought with gold and blue silk; and another of linen only, which was common to all the Levites and priests. . . . Of this sort was Samuel’s ephod. Yet there was also a third kind of ephod, which was a civil garment of white linen used in the time of celebration and joy. Such is the type of ephod David put on when he danced before the ark and about which the Preacher said, “Let your garments be always white.” "), _c('i', [_vm._v("Harmony on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-393-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-393",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])])])])]), _vm._v(" "), _c('h5', {
    attrs: {
      "id": "sigil_toc_id_35"
    }
  }, [_c('b', [_vm._v("2:22-26")]), _vm._v(" "), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("The Sins of the Sons")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Scattering the Wolves.")]), _vm._v(" "), _c('i', [_vm._v("Martin Bucer:")]), _vm._v(" Let us be admonished by those horrible punishments that were suffered by the priest Eli . . . and the whole people of Israel on account of their wicked indulgence and misguided compassion toward those against whom they should have treated severely—by God’s command, who alone is truly compassionate and merciful. We should not imagine that anyone—contrary to God’s teaching "), _c('a', {
    attrs: {
      "id": "_idTextAnchor1812"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1813"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1814"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1815"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1816"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1817"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1818"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1819"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1820"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1821"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1822"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1823"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1824"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1825"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1826"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1827"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1828"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1829"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1830"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1831"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1832"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1833"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1834"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1835"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1836"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1837"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1838"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1839"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1840"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1841"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1842"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1843"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1844"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1845"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1846"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1847"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1848"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1849"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1850"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1851"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1852"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1853"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1854"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1855"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1856"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1857"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1858"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1859"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1860"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1861"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1862"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1863"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1864"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1865"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1866"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1867"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1868"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1869"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1870"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1871"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1872"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1873"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1874"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1875"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1876"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1877"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1878"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1879"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1880"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1881"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1882"
    }
  }), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page18",
      "title": "18"
    }
  }), _vm._v("and to the church of God’s ruin—will be shown leniency or pardoned at all. Christian leniency and mercy must be shown to "), _c('i', [_vm._v("Christ’s")]), _vm._v(" sheep—by which they should be protected from wolves—not to wolves, so that they can scatter and destroy the sheep. "), _c('i', [_vm._v("Reign of Christ.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-392-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-392",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Parental Responsibility.")]), _vm._v(" "), _c('i', [_vm._v("Philipp Melanchthon:")]), _vm._v(" Also we need to teach parents their responsibility to instill in their children the fear of God, to teach and let them learn the Word of God. Thus we read in the Proverbs of Solomon: “For folly is bound up in the heart of a child, but the rod of discipline drives it far from him.” So Paul in Ephesians 6 says: “Fathers, do not provoke your children to anger, but bring them up in the discipline and instruction of the Lord.” Such is the example of Eli who according to 1 Samuel 2 was punished by God and deprived of his priestly office because he had not taken seriously the rearing of this children. Never have youth been more insolent than today—we see how little they obey, how little they respect their parents. On this account, undoubtedly, the world is full of plagues, war, rebellion and other evils. "), _c('i', [_vm._v("Instructions by the Visitors of Parish Pastors: On True Christian Prayer.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-391-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-391",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("God Will Punish Eli’s Corrupt Sons.")]), _vm._v(" "), _c('i', [_vm._v("Johannes Bugenhagen:")]), _vm._v(" A priest holds the office of mediation between God and people, to teach the people God’s Word and to make sacrifices. These all stumble wherever the Word of God is despised. For what good does it do to add piety to impiety? In the same way, these priests stretched what was written in the Lord’s law about the portions given to priests and the sacrifices of the law concerning the fat burned to the Lord as written in Leviticus. They did not come back to their senses when admonished by the people but rather used violence against those who questioned them. When their father rightly admonished them, they despised his great forbearance and earned God’s judgment, as it is written, “It was the will of the L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")]), _vm._v(" to put them to death.” This is an example of how human doctrines gather people against God’s Word while the glory of wealth and worldly opinions of justice are sought instead. Here are erring spirits, which little by little possess what they want by violent means. "), _c('i', [_vm._v("Commentary on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-390-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-390",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Scandalous Sacrifice.")]), _vm._v(" "), _c('i', [_vm._v("Robert Sanderson:")]), _vm._v(" In judging the cases of scandal, we are not so much to look at the event, what that is or may be, as we are at the cause from where it comes. . . . The first is when a person does something before another person that is in itself evil, unlawful and sinful. In which case, neither the intention of the one who does it nor the event, as to him who sees it done, is of any consideration. It does not matter whether the doer had an intention to draw the other into sin or not. Nor does it matter whether the other was induced to commit sin or not. The fact that the action itself is evil, and done before others, is sufficient to render the doer guilty of having given scandal, though he had neither any intention himself so to do, nor was any person actually scandalized by it. This is because whatsoever is in itself and in its own nature evil is also of itself, and in its own nature, scandalous, and of evil example. Thus did Hophni and Phinehas, the sons of Eli, give scandal by their wretched profaneness and greediness about the sacrifices of the Lord as well as their vile and shameless abusing of the women. "), _c('i', [_vm._v("The Case Determined.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-389-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-389",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Multiplying Sin.")]), _vm._v(" "), _c('i', [_vm._v("Thomas Adams:")]), _vm._v(" The sin of the clergy is like a sickness, which rising from the stomach into the head, drops down upon the lungs . . . until all the members of the body languish into corruption. Eli’s lewd sons acted intolerably when they sinned in the tabernacle. "), _c('a', {
    attrs: {
      "id": "_idTextAnchor1883"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1884"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1885"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1886"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1887"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1888"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1889"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1890"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1891"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1892"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1893"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1894"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1895"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1896"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1897"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1898"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1899"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1900"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1901"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1902"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1903"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1904"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1905"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1906"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1907"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1908"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1909"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1910"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1911"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1912"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1913"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1914"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1915"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1916"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1917"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1918"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1919"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1920"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1921"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1922"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1923"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1924"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1925"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1926"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1927"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1928"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1929"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1930"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1931"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1932"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1933"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1934"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1935"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1936"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1937"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1938"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1939"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1940"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1941"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1942"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1943"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1944"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1945"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1946"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1947"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1948"
    }
  }), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page19",
      "title": "19"
    }
  }), _vm._v("Although their sacrifices could do away the sins of others, no sacrifice could do away their own sin. Although many a soul was the cleaner for the blood of those beasts they shed, their own souls were the fouler by it. By one and the same service, they atoned for the people’s offenses and multiplied their own. "), _c('i', [_vm._v("The Temple.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-388-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-388",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Why We Must Read the Scriptures.")]), _vm._v(" "), _c('i', [_vm._v("John Jewel:")]), _vm._v(" Are you a father? Do you have children? Read the Scriptures and they will teach you. If you have sons, instruct them. Eli the prophet, by sparing his wanton children, cast away himself and his children: They were killed, the ark of God was taken and old Eli fell down and broke his neck. Of the Holy Scriptures."), _c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-387-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-387",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])])])]), _vm._v(" "), _c('h5', {
    attrs: {
      "id": "sigil_toc_id_36"
    }
  }, [_c('b', [_vm._v("2:27-36")]), _vm._v(" "), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("The Lord Rejects Eli’s Household")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("There Came a Man of God.")]), _vm._v(" "), _c('i', [_vm._v("Johannes Bugenhagen:")]), _vm._v(" Another prophet was sent by God. As Eli’s own words show, he was not ignorant of his sin of releasing his ungodly sons into the priesthood and letting this matter become a disgrace. Here the law or judgment of God is revealed clearly to him, which confounds his conscience. Love for his sons keeps him from coming to his senses, even though the priesthood should not be a private honor. But he heard the judgment of God again from Samuel when he said, “It is the L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")]), _vm._v(". Let him do what seems good to him.” "), _c('i', [_vm._v("Commentary on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-386-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-386",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Eli’s Three Errors.")]), _vm._v(" "), _c('i', [_vm._v("Viktorin Strigel:")]), _vm._v(" The prophet’s remembrance of the earlier blessings given to the Levites is followed by the most egregious accusations, in which three of Eli the priest’s crimes are brought up. The first is profaning the sacrifice. The second is being fawning and overindulgent to his children. The third is avarice. "), _c('i', [_vm._v("Commentary on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-385-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-385",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("But It Should Not Be So.")]), _vm._v(" "), _c('i', [_vm._v("Andrew Willet:")]), _vm._v(" Here arises a great doubt, given we know that God’s promises are most certain and that his decree is immutable. How, then, does the Lord make a promise and then go back on it? The answer is that some of God’s promises are absolute without any condition, as was the promise of the Messiah. However, others of God’s promises are given to us conditionally, especially the temporal promises made to the Israelites. These conditional promises, such as the priesthood being promised to the family of Eli, depended on the condition of their obedience. So now, life everlasting is promised to those who have faith and believe. But will some say: Does God’s election, therefore, depend on our works or belief? Not in any way. For God, as he has promised the reward—so also, to those whom he purposes to make heirs of his promise—he has likewise ordained the means to give them faith (and all other graces) to apprehend and lay hold of the promises. God’s promises, then, are only effectual to those who, by a lively faith, apprehend them. The rest, which by their disobedience fall off from God’s promises, do not work any alteration in the purpose of God, who has foreseen both their disobedience and that his promises did not belong to them. "), _c('i', [_vm._v("Harmony on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-384-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-384",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")])])])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "_idContainer020"
    }
  }, [_c('p', {
    staticClass: "PER_Top-extra-space"
  }, [_c('span', {
    staticClass: "com-rorohiko-pagestaker-style"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor1949"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1950"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1951"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1952"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1953"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1954"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1955"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1956"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1957"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1958"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1959"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1960"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1961"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1962"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1963"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1964"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1965"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1966"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1967"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1968"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1969"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1970"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1971"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1972"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1973"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1974"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1975"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1976"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1977"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1978"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1979"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1980"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1981"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1982"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1983"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1984"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1985"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1986"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1987"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1988"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1989"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1990"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1991"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1992"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1993"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1994"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1995"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1996"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1997"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1998"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1999"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2000"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2001"
    }
  })]), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page20",
      "title": "20"
    }
  })]), _vm._v(" "), _c('h2', {
    staticClass: "PER_ScriptureCenter",
    attrs: {
      "id": "sigil_toc_id_37"
    }
  }, [_c('span', {
    staticClass: "RH-marker"
  }, [_vm._v("3:1–4:1a")]), _vm._v(" SAMUEL’S CALLING")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("1")]), _c('i', [_vm._v("Now the boy Samuel was ministering to the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("in the presence of Eli. And the word of the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("was rare in those days; there was no frequent vision.")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("2")]), _c('i', [_vm._v("At that time Eli, whose eyesight had begun to grow dim so that he could not see, was lying down in his own place.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("3")]), _c('i', [_vm._v("The lamp of God had not yet gone out, and Samuel was lying down in the temple of the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _c('i', [_vm._v(", where the ark of God was.")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("4")]), _c('i', [_vm._v("Then the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("called Samuel, and he said, “Here I am!”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("5")]), _c('i', [_vm._v("and ran to Eli and said, “Here I am, for you called me.” But he said, “I did not call; lie down again.” So he went and lay down.")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("6")]), _c('i', [_vm._v("And the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("called again, “Samuel!” and Samuel arose and went to Eli and said, “Here I am, for you called me.” But he said, “I did not call, my son; lie down again.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("7")]), _c('i', [_vm._v("Now Samuel did not yet know the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _c('i', [_vm._v(", and the word of the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("had not yet been revealed to him.")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("8")]), _c('i', [_vm._v("And the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("called Samuel again the third time. And he arose and went to Eli and said, “Here I am, for you called me.” Then Eli perceived that the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("was calling the boy.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("9")]), _c('i', [_vm._v("Therefore Eli said to Samuel, “Go, lie down, and if he calls you, you shall say, ‘Speak,")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _c('i', [_vm._v(", for your servant hears.’” So Samuel went and lay down in his place.")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("10")]), _c('i', [_vm._v("And the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("came and stood, calling as at other times, “Samuel! Samuel!” And Samuel said, “Speak, for your servant hears.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("11")]), _c('i', [_vm._v("Then the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("said to Samuel, “Behold, I am about to do a thing in Israel at which the two ears of everyone who hears it will tingle.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("12")]), _c('i', [_vm._v("On that day I will fulfill against Eli all that I have spoken concerning his house, from beginning to end.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("13")]), _c('i', [_vm._v("And I declare to him that I am about to punish his house forever, for the iniquity that he knew, because his sons were blaspheming God,")]), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("a")]), _vm._v(" "), _c('i', [_vm._v("and he did not restrain them.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("14")]), _c('i', [_vm._v("Therefore I swear to the house of Eli that the iniquity of Eli’s house shall not be atoned for by sacrifice or offering forever.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("15")]), _c('i', [_vm._v("Samuel lay until morning; then he opened the doors of the house of the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _c('i', [_vm._v(". And Samuel was afraid to tell the vision to Eli.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("16")]), _c('i', [_vm._v("But Eli called Samuel and said, “Samuel, my son.” And he said, “Here I am.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("17")]), _c('i', [_vm._v("And Eli said, “What was it that he told you? Do not hide it from me. May God do so to you and more also if you hide anything from me of all that he told you.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("18")]), _c('i', [_vm._v("So Samuel told him everything and hid nothing from him. And he said, “It is the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _c('i', [_vm._v(". Let him do what seems good to him.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("19")]), _c('i', [_vm._v("And Samuel grew, and the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("was with him and let none of his words fall to the ground.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("20")]), _c('i', [_vm._v("And all Israel from Dan to Beersheba knew that Samuel was established as a prophet of the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _c('i', [_vm._v(".")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("21")]), _c('i', [_vm._v("And the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("appeared again at Shiloh, for the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("revealed himself to Samuel at Shiloh by the word of the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _c('i', [_vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    staticClass: "drop-cap"
  }, [_vm._v("4")]), _vm._v(" "), _c('i', [_vm._v("And the word of Samuel came to all Israel."), _c('br'), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('p', {
    staticClass: "small"
  }, [_c('b', [_vm._v("a")]), _vm._v(" Or "), _c('i', [_vm._v("blaspheming for themselves"), _c('br'), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Overview:")]), _vm._v(" There was a general sense among Reformation interpreters that in their day God was dismantling the church of old on account of its faithlessness and breathing new life into the church—not very different from the way God was ending Eli’s line and starting afresh with Samuel. Due to the godlessness on the part of Israelite leadership, God sends a spiritual famine in accordance with Scripture. As the last of the judges, Samuel is a true prophet of God, who begins to restore the Israelites to proper worship of God. Although Samuel does not initially understand God’s voice, God chooses him to lead God’s people into the truth. His first assignment is to deliver a divine word to his teacher Eli. The reformers commend Eli’s humility to Christian believers. "), _c('a', {
    attrs: {
      "id": "_idTextAnchor2002"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2003"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2004"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2005"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2006"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2007"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2008"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2009"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2010"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2011"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2012"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2013"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2014"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2015"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2016"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2017"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2018"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2019"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2020"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2021"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2022"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2023"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2024"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2025"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2026"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2027"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2028"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2029"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2030"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2031"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2032"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2033"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2034"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2035"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2036"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2037"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2038"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2039"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2040"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2041"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2042"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2043"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2044"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2045"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2046"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2047"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2048"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2049"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2050"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2051"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2052"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2053"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2054"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2055"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2056"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2057"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2058"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2059"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2060"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2061"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2062"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2063"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2064"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2065"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2066"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2067"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2068"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2069"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2070"
    }
  }), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page21",
      "title": "21"
    }
  }), _vm._v("Like Eli, Christians must always affirm and patiently accept the word of the Lord, regardless of the immediate pain it causes us or the difficulty that ensues. For the commentators, the beauty of this passage is that God gives partial revelation to Samuel and partial revelation to Eli, reminding us of Paul’s analogy of the church as one body with many members.")]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Called by God Alone.")]), _vm._v(" "), _c('i', [_vm._v("Viktorin Strigel:")]), _vm._v(" This particular chapter recounts the direct calling of Samuel to prophetic service. Samuel was not called by people or through the agency of people but by God. And Samuel was called in this way so that he could be an expounder of the law and a witness of the Messiah, who would govern the political realm. "), _c('i', [_vm._v("Commentary on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-383-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-383",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])])])])]), _vm._v(" "), _c('h5', {
    attrs: {
      "id": "sigil_toc_id_38"
    }
  }, [_c('b', [_vm._v("3:1")]), _vm._v(" "), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("The Scarcity of God’s Word in Those Days")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Eli Establishes Samuel as a Prophet.")]), _vm._v(" "), _c('i', [_vm._v("Lucas Osiander:")]), _vm._v(" Prophets and divine revelations were rare then. At that time the godlessness of the priests and the people was very great. As the Lord said in Amos: “I will send a famine on the land—not a famine of bread, nor a thirst for water, but for hearing the words of the Lord.” Because God’s people then deserved punishment, a prophet was raised up, namely Samuel. For when God punishes his people’s sins, he first sends someone to invite and call them to repentance, saying, “Come to your senses and escape punishment.” Already, therefore, Samuel is called to the office of prophet. . . . [He then replied to God’s call, saying]: “I am humbly ready to receive the word that you will tell me.” And so Eli, who was denied prophetic visions, nevertheless established Samuel in how he prepared him to hear the divine oracle. "), _c('i', [_vm._v("Annotations on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-382-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-382",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Neglected Word.")]), _vm._v(" "), _c('i', [_vm._v("Viktorin Strigel:")]), _vm._v(" At this time there were not many preachers or pastors. It was as if sacred Scripture was covered in mold or dust. The study of Scripture was neglected when Samuel came along, who roused and illuminated the study of it again. And just as the supreme good of any church is the preservation of the true doctrine of God, so the worst thing that can happen to a church is to have a famine, not of bread, but of the Word of God. Whenever the Word is lost or obscured, a horrible darkness concerning the benefits of Christ, concerning true prayer and concerning faith must inevitably follow. Therefore we give thanks to God because his Word desires to dwell among us abundantly with all wisdom. "), _c('i', [_vm._v("Commentary on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-381-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-381",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("There Was No Manifest Vision.")]), _vm._v(" "), _c('i', [_vm._v("Andrew Willet:")]), _vm._v(" God, for the sin of his people, brought a famine on them—“not a famine of bread, or a thirst for water”—just as he threatened by his prophet Amos: “They shall wander from sea to sea, and from north to east; they shall run to and fro, to seek the word of the Lord, but they shall not find it.” Although there might be some private and particular visions and revelations—as to Manoah in Judges 13—yet the public office of prophets was ceased and intermittent. For this is not to be understood of the written word—for they had the books of Moses—but of the word of prophecy. And if there were any such visions, they were dark, hidden and obscure. As the Septuagint reads, there was no “distinct vision,” that is, opened, unfolded and applied. Christ Jesus the Word of God, by whom the Lord spoke to Samuel in 1 Samuel 3:21 and to David in 2 Samuel 7:21, sparingly revealed and manifested himself to his servants the prophets. "), _c('i', [_vm._v("Harmony of 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-380-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-380",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])])])])]), _vm._v(" "), _c('h5', {
    attrs: {
      "id": "sigil_toc_id_39"
    }
  }, [_c('b', [_vm._v("3:2-18")]), _vm._v(" "), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("God’s Revelation")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("The Same Lord Empowering Everyone.")]), _vm._v(" "), _c('i', [_vm._v("Johannes Brenz:")]), _vm._v(" God provided the revelation in this way so Eli could recognize that what was first "), _c('a', {
    attrs: {
      "id": "_idTextAnchor2071"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2072"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2073"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2074"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2075"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2076"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2077"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2078"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2079"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2080"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2081"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2082"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2083"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2084"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2085"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2086"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2087"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2088"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2089"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2090"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2091"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2092"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2093"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2094"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2095"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2096"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2097"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2098"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2099"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2100"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2101"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2102"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2103"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2104"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2105"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2106"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2107"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2108"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2109"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2110"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2111"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2112"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2113"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2114"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2115"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2116"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2117"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2118"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2119"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2120"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2121"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2122"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2123"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2124"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2125"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2126"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2127"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2128"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2129"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2130"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2131"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2132"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2133"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2134"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2135"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2136"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2137"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2138"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2139"
    }
  }), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page22",
      "title": "22"
    }
  }), _vm._v("revealed to Samuel through a dream was truly divine. Thus after Eli heard Samuel describe the revelation, he was convinced by his own testimony that this was no mere dream but a certain pronouncement from the Lord. In this way Eli might recognize and be frightened by his own true unworthiness before the Lord, and thereby be revived. This passage shows us the wonderful plan of God that one person is not given all gifts but rather that individuals are given individual gifts. To Samuel was given the gift of hearing the voice of God, though he was not given the gift of recognizing it as God’s voice without being taught to know it by Eli. To Eli it was given that he might recognize the voice of God through his intellect, though it was not given him to hear the Lord himself. As Paul says, “Now there are varieties of gifts, but the same Spirit; and there are varieties of service, but the same Lord; and there are varieties of activities, but it is the same God who empowers them all in everyone.” "), _c('i', [_vm._v("Sermons on Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-379-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-379",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Listening Like Samuel.")]), _vm._v(" "), _c('i', [_vm._v("Johann Arndt:")]), _vm._v(" The Lord says, “Hear my voice and open unto me.” In a house in which there is the noise of this world, no sweet music can be heard. In a like manner, God cannot be heard in a worldly heart, for it is not opened toward God and does not let him in. Therefore such an earthly heart cannot taste the heavenly manna. When the tumult of this world is still in the heart, God comes and knocks and allows himself to be heard. Then you can say with the prophet Samuel: “Speak, Lord, for your servant hears.” "), _c('i', [_vm._v("True Christianity.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-378-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-378",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("How Samuel Did Not Know the Lord.")]), _vm._v(" "), _c('i', [_vm._v("Andrew Willet:")]), _vm._v(" Some read: “This is what Samuel did before he knew the Lord.” However, the passage is better interpreted as: “Samuel did not yet know the Lord,” as the Hebrew here signifies both "), _c('i', [_vm._v("not yet")]), _vm._v(" and "), _c('i', [_vm._v("before that")]), _vm._v(". At any rate, the first interpretation is more proper here, which makes the sense full without any other addition. But in the other reading something must be supplied. Now there is a twofold knowledge of God: ordinary and extraordinary. One is common to all servants of God, the other only to the prophets when the will of God is revealed concerning things to come: Samuel was not without the ordinary knowledge of God before, but the latter he had no experience of until now. As the next words shows, “The word of the Lord had not yet been revealed to him,” which the Jews interpret as prophecy. Therefore Eli gave him instruction and informed him that it was the Lord who spoke to him. "), _c('i', [_vm._v("Harmony on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-377-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-377",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Samuel Preaches Repentance to Eli.")]), _vm._v(" "), _c('i', [_vm._v("Viktorin Strigel:")]), _vm._v(" We can see how merciful and long-suffering our heavenly father is when we consider that Eli the priest was told to repent by two prophets. For in the previous chapter Eli heard the most fervent advice of the unnamed prophet. Now he is invited to repentance by the ministry of the prophet Samuel. But then consider Samuel’s great sorrow upon seeing his master and teacher’s unhappy end. "), _c('i', [_vm._v("Commentary on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-376-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-376",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("What Seems Good to God.")]), _vm._v(" "), _c('i', [_vm._v("Lancelot Andrewes:")]), _vm._v(" We must bear quietly the punishment laid on us, for out of affliction the godly gather a matter of thanks for having all taken from them. . . . The godly praise God for the cup of affliction as well as for the cup of salvation, and are as thankful to God for the benefits the Lord bestows on them by means of affliction against their will as for those that come to them by their will and good liking. And this is the perfection we are to strive toward. But if we do not at all reckon them as benefits, nevertheless we must say with Eli, “It is the Lord; let him do what seems good to him.” "), _c('i', [_vm._v("Collection of Lectures.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-375-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-375",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Eli Confesses His Sins.")]), _vm._v(" "), _c('i', [_vm._v("Lucas Osiander:")]), _vm._v(" When Eli responded, “It is the Lord. Let him do "), _c('a', {
    attrs: {
      "id": "_idTextAnchor2140"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2141"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2142"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2143"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2144"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2145"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2146"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2147"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2148"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2149"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2150"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2151"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2152"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2153"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2154"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2155"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2156"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2157"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2158"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2159"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2160"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2161"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2162"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2163"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2164"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2165"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2166"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2167"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2168"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2169"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2170"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2171"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2172"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2173"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2174"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2175"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2176"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2177"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2178"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2179"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2180"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2181"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2182"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2183"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2184"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2185"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2186"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2187"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2188"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2189"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2190"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2191"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2192"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2193"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2194"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2195"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2196"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2197"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2198"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2199"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2200"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2201"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2202"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2203"
    }
  }), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page23",
      "title": "23"
    }
  }), _vm._v("what seems good to him,” it was as if he were saying, “I recognize my sin and the righteous wrath of the Lord. And I understand that I and my posterity are no longer allowed to continue the sacrifices or serve as mediators as a punishment for our sins. I will bear this patiently, content in this one thing: that I know the Lord God seriously desires repentance and not that we are cast into eternal damnation.” Therefore, even if we are not able to escape from such physical punishment, we still should not doubt the mercy of God, which leads to eternal life. Instead, we should subject ourselves to the will of God with continual, humble and patient supplications. "), _c('i', [_vm._v("Annotations on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-374-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-374",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Not Eternal Condemnation.")]), _vm._v(" "), _c('i', [_vm._v("Thomas Jackson:")]), _vm._v(" Now when Samuel had delivered this fearful and reproving sentence to Eli, the latter replied no more than this: “It is the Lord. Let him do what seems him good to him.” Had this message been delivered by that “man of God” who brought the former prophecy of doom to this good old man, Eli—though he was a weak judge—he probably would have happily ignored it, for such did he do when the man of God spoke to him. At the least, he would have called the messenger’s prophecy into question. But because this latter and more terrible doom was delivered to him by a child—who was far removed from secular cunning and sophisms of corrupt priests or Levites, who could not even distinguish the voice of the Lord from the voice of his teacher until he was instructed by him and who depended on Eli completely as his foster father—his message was to Eli more authentic. In other words, Samuel’s message, both in its content and in its presentation, was freer from all suspicion of imposture.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Eli’s response is of the same alloy of Job’s reply to the sad news his servants brought to him. “The Lord,” says Job, “gave and has taken away; blessed be the name of the Lord.” Such is how he spoke after he had seen himself and his family utterly undone for worldly substance, deprived of all earthly contentment. Eli knew that this sentence against him was denounced as by oath. It was as certain and impossible to be reversed as if it had already happened. For this reason, I believe, the old man, Eli, did consider a more submissive answer to Samuel than he had vouchsafed to the man of God who was sent to him on the same errand. The humility and modesty of his answer persuades me that the fearful sentence denounced against him extended no further than to the irreversible deposition of him and his family from the legal or temporary priesthood to the poor and humble estate where his posterity after the disaster of his two sons were to live here on the earth. Nor have I any warrant from God’s Word to say, and Christian charity forbids me to think, that either Eli himself, his two lewd sons or his posterity were absolutely or irreversibly decreed from this time forward to everlasting damnation. "), _c('i', [_vm._v("A Treatise of the Son of God to His Everlasting Priesthood.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-373-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-373",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])])])])]), _vm._v(" "), _c('h5', {
    attrs: {
      "id": "sigil_toc_id_40"
    }
  }, [_c('b', [_vm._v("3:19-4:1a")]), _vm._v(" "), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("Samuel’s Calling to the Lord")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("The Word of God Reestablished Under Samuel.")]), _vm._v(" "), _c('i', [_vm._v("Johannes Bugenhagen:")]), _vm._v(" This describes the Lord’s first revelation to the young Samuel. It came at a time when the Lord had ceased to appear in Shiloh, for the reasons clearly explained in chapter two. Here you see an example of this: “You have hidden these things from the wise and understanding and revealed them to little children.” So Samuel grew before God and the people, for he had the word of God and became known by all of Israel as a faithful prophet. "), _c('i', [_vm._v("Commentary on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-372-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-372",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Samuel’s Calling.")]), _vm._v(" "), _c('i', [_vm._v("Andrew Willet:")]), _vm._v(" Three things are expressed whereby the excellence of Samuel’s gifts and the prerogative of his calling appear. First, the certainty of his predictions and prophecies all came to pass and none were spoken "), _c('a', {
    attrs: {
      "id": "_idTextAnchor2204"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2205"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2206"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2207"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2208"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2209"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2210"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2211"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2212"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2213"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2214"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2215"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2216"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2217"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2218"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2219"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2220"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2221"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2222"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2223"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2224"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2225"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2226"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2227"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2228"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2229"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2230"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2231"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2232"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2233"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2234"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2235"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2236"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2237"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2238"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2239"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2240"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2241"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2242"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2243"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2244"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2245"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2246"
    }
  }), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page24",
      "title": "24"
    }
  }), _vm._v("in vain. Samuel did not need any signs or miracles for the demonstrations of his calling, as the effect and accomplishment of his prophecies were a sufficient evidence. Second, Samuel was faithful, without any partiality or accepting of persons, in delivering the word of God to Israel—just as Moses is said to have been faithful in the Lord’s house. Finally, after the Lord had begun in this way to reveal himself to Samuel, God continued to do so, and he added further to reveal to Samuel his will and to appear to him. Samuel therefore was an honorable prophet, because in him the word of prophesying revived out of its previous decay. And therefore Scripture says, “No Passover like it had been kept in Israel since the days of Samuel the prophet,” since he restored the religion that had been greatly corrupted. "), _c('i', [_vm._v("Harmony on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-371-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-371",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")])])])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "_idContainer021"
    }
  }, [_c('p', {
    staticClass: "PER_Top-extra-space"
  }, [_c('span', {
    staticClass: "com-rorohiko-pagestaker-style"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor2247"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2248"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2249"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2250"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2251"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2252"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2253"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2254"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2255"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2256"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2257"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2258"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2259"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2260"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2261"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2262"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2263"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2264"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2265"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2266"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2267"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2268"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2269"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2270"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2271"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2272"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2273"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2274"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2275"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2276"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2277"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2278"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2279"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2280"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2281"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2282"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2283"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2284"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2285"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2286"
    }
  })]), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page25",
      "title": "25"
    }
  })]), _vm._v(" "), _c('h2', {
    staticClass: "PER_ScriptureCenter",
    attrs: {
      "id": "sigil_toc_id_41"
    }
  }, [_c('span', {
    staticClass: "RH-marker"
  }, [_vm._v("4:1b–7:2")]), _vm._v(" THE ARK CAPTURED AND RETURNED")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("1")]), _c('i', [_vm._v("Now Israel went out to battle against the Philistines. They encamped at Ebenezer, and the Philistines encamped at Aphek.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("2")]), _c('i', [_vm._v("The Philistines drew up in line against Israel, and when the battle spread, Israel was defeated before the Philistines, who killed about four thousand men on the field of battle.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("3")]), _c('i', [_vm._v("And when the people came to the camp, the elders of Israel said, “Why has the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("defeated us today before the Philistines? Let us bring the ark of the covenant of the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("here from Shiloh, that it")]), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("a")]), _vm._v(" "), _c('i', [_vm._v("may come among us and save us from the power of our enemies.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("4")]), _c('i', [_vm._v("So the people sent to Shiloh and brought from there the ark of the covenant of the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("of hosts, who is enthroned on the cherubim. And the two sons of Eli, Hophni and Phinehas, were there with the ark of the covenant of God.")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("5")]), _c('i', [_vm._v("As soon as the ark of the covenant of the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("came into the camp, all Israel gave a mighty shout, so that the earth resounded.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("6")]), _c('i', [_vm._v("And when the Philistines heard the noise of the shouting, they said, “What does this great shouting in the camp of the Hebrews mean?” And when they learned that the ark of the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("had come to the camp,")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("7")]), _c('i', [_vm._v("the Philistines were afraid, for they said, “A god has come into the camp.” And they said, “Woe to us! For nothing like this has happened before.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("8")]), _c('i', [_vm._v("Woe to us! Who can deliver us from the power of these mighty gods? These are the gods who struck the Egyptians with every sort of plague in the wilderness.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("9")]), _c('i', [_vm._v("Take courage, and be men, O Philistines, lest you become slaves to the Hebrews as they have been to you; be men and fight.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("10")]), _c('i', [_vm._v("So the Philistines fought, and Israel was defeated, and they fled, every man to his home. And there was a very great slaughter, for thirty thousand foot soldiers of Israel fell.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("11")]), _c('i', [_vm._v("And the ark of God was captured, and the two sons of Eli, Hophni and Phinehas, died.")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("12")]), _c('i', [_vm._v("A man of Benjamin ran from the battle line and came to Shiloh the same day, with his clothes torn and with dirt on his head.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("13")]), _c('i', [_vm._v("When he arrived, Eli was sitting on his seat by the road watching, for his heart trembled for the ark of God. And when the man came into the city and told the news, all the city cried out.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("14")]), _c('i', [_vm._v("When Eli heard the sound of the outcry, he said, “What is this uproar?” Then the man hurried and came and told Eli.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("15")]), _c('i', [_vm._v("Now Eli was ninety-eight years old and his eyes were set so that he could not see.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("16")]), _c('i', [_vm._v("And the man said to Eli, “I am he who has come from the battle; I fled from the battle today.” And he said, “How did it go, my son?”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("17")]), _c('i', [_vm._v("He who brought the news answered and said, “Israel has fled before the Philistines, and there has also been a great defeat among the people. Your two sons also, Hophni and Phinehas, are dead, and the ark of God has been captured.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("18")]), _c('i', [_vm._v("As soon as he mentioned the ark of God, Eli fell over backward from his seat by the side of the gate, and his neck was broken and he died, for the man was old and heavy. He had judged Israel forty years.")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("19")]), _c('i', [_vm._v("Now his daughter-in-law, the wife of Phinehas, was pregnant, about to give birth. And when she heard the news that the ark of God was captured, and that her father-in-law and her husband were dead, she bowed and gave birth, for her pains came upon her.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("20")]), _c('i', [_vm._v("And about the time of her death the women attending her said to her, “Do not be afraid, for you have borne a son.” But she did not answer or pay attention.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("21")]), _c('i', [_vm._v("And she named the child Ichabod, saying, “The glory has departed")]), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("b")]), _vm._v(" "), _c('i', [_vm._v("from Israel!” because the ark of God had been captured and because of her father-in-law and her husband.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("22")]), _c('i', [_vm._v("And she said, “The glory has departed from Israel, for the ark of God has been captured.”")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    staticClass: "drop-cap"
  }, [_vm._v("5")]), _vm._v(" "), _c('i', [_vm._v("When the Philistines captured the ark of God, they brought it from Ebenezer to Ashdod.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("2")]), _c('i', [_vm._v("Then the Philistines took the ark of God and brought it into the house of Dagon and set it up beside Dagon.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("3")]), _c('i', [_vm._v("And when the people of Ashdod rose early the next day, behold, Dagon had fallen face downward on the ground before the ark of the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _c('i', [_vm._v(". So they took Dagon and put him back in his place.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("4")]), _c('i', [_vm._v("But when they rose early on the next morning, behold, Dagon had fallen face downward on the ground before the "), _c('a', {
    attrs: {
      "id": "_idTextAnchor2287"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2288"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2289"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2290"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2291"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2292"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2293"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2294"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2295"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2296"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2297"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2298"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2299"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2300"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2301"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2302"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2303"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2304"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2305"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2306"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2307"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2308"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2309"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2310"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2311"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2312"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2313"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2314"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2315"
    }
  })]), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page26",
      "title": "26"
    }
  }), _c('i', [_vm._v("ark of the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _c('i', [_vm._v(", and the head of Dagon and both his hands were lying cut off on the threshold. Only the trunk of Dagon was left to him.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("5")]), _c('i', [_vm._v("This is why the priests of Dagon and all who enter the house of Dagon do not tread on the threshold of Dagon in Ashdod to this day.")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("6")]), _c('i', [_vm._v("The hand of the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("was heavy against the people of Ashdod, and he terrified and afflicted them with tumors, both Ashdod and its territory.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("7")]), _c('i', [_vm._v("And when the men of Ashdod saw how things were, they said, “The ark of the God of Israel must not remain with us, for his hand is hard against us and against Dagon our god.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("8")]), _c('i', [_vm._v("So they sent and gathered together all the lords of the Philistines and said, “What shall")]), _vm._v(" "), _c('i', [_vm._v("we do with the ark of the God of Israel?” They an­­­­swered,")]), _vm._v(" "), _c('i', [_vm._v("“Let the ark of the God of Israel be brought around to Gath.” So they brought the ark of the God of Israel there.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("9")]), _c('i', [_vm._v("But after they had brought it around, the hand of the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("was against the city, causing a very great panic, and he afflicted the men of the city, both young and old, so that tumors broke out on them.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("10")]), _c('i', [_vm._v("So they sent the ark of God to Ekron. But as soon as the ark of God came to Ekron, the people of Ekron cried out, “They have brought around to us the ark of the God of Israel to kill us and our people.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("11")]), _c('i', [_vm._v("They sent therefore and gathered together all the lords of the Philistines and said, “Send away the ark of the God of Israel, and let it return to its own place, that it may not kill us and our people.” For there was a deathly panic throughout the whole city. The hand of God was very heavy there.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("12")]), _c('i', [_vm._v("The men who did not die were struck with tumors, and the cry of the city went up to heaven.")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    staticClass: "drop-cap"
  }, [_vm._v("6")]), _vm._v(" "), _c('i', [_vm._v("The ark of the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("was in the country of the Philistines seven months.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("2")]), _c('i', [_vm._v("And the Philistines called for the priests and the diviners and said, “What shall we do with the ark of the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _c('i', [_vm._v("? Tell us with what we shall send it to its place.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("3")]), _c('i', [_vm._v("They said, “If you send away the ark of the God of Israel, do not send it empty, but by all means return him a guilt offering. Then you will be healed, and it will be known to you why his hand does not turn away from you.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("4")]), _c('i', [_vm._v("And they said, “What is the guilt offering that we shall return to him?” They answered, “Five golden tumors and five golden mice, according to the number of the lords of the Philistines, for the same plague was on all of you and on your lords.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("5")]), _c('i', [_vm._v("So you must make images of your tumors and images of your mice that ravage the land, and give glory to the God of Israel. Perhaps he will lighten his hand from off you and your gods and your land.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("6")]), _c('i', [_vm._v("Why should you harden your hearts as the Egyptians and Pharaoh hardened their hearts? After he had dealt severely with them, did they not send the people away, and they departed?")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("7")]), _c('i', [_vm._v("Now then, take and prepare a new cart and two milk cows on which there has never come a yoke, and yoke the cows to the cart, but take their calves home, away from them.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("8")]), _c('i', [_vm._v("And take the ark of the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("and place it on the cart and put in a box")]), _vm._v(" "), _c('i', [_vm._v("at its side the figures of gold, which you are returning")]), _vm._v(" "), _c('i', [_vm._v("to him as a guilt offering. Then send it off and let it go its way")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("9")]), _c('i', [_vm._v("and watch. If it goes up on the way to its own land, to Beth-shemesh, then it is he who has done us this great harm, but if not, then we shall know that it is not his hand that struck us; it happened to us by coincidence.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("10")]), _c('i', [_vm._v("The men did so, and took two milk cows and yoked them to the cart and shut up their calves at home.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("11")]), _c('i', [_vm._v("And they put the ark of the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("on the cart and the box with the golden mice and the images of their tumors.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("12")]), _c('i', [_vm._v("And the cows went straight in the direction of Beth-shemesh along one highway, lowing as they went. They turned neither to the right nor to the left, and the lords of the Philistines went after them as far as the border of Beth-shemesh.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("13")]), _c('i', [_vm._v("Now the people of Beth-shemesh were reaping their wheat harvest in the valley. And when they lifted up their eyes and saw the ark, they rejoiced to see it.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("14")]), _c('i', [_vm._v("The cart came into the field of Joshua of Beth-shemesh and stopped there. A great stone was there. And they split up the wood of the cart and offered the cows as a burnt offering to the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _c('i', [_vm._v(".")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("15")]), _c('i', [_vm._v("And the Levites took down the ark of the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("and the box that was beside it, in which were the golden figures, and set them upon the great stone. And the men of Beth-shemesh offered burnt offerings and sacrificed sacrifices on that day to the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _c('i', [_vm._v(".")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("16")]), _c('i', [_vm._v("And when the five lords of the Philistines saw it, they returned that day to Ekron.")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "com-rorohiko-pagestaker-style"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor2316"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2317"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2318"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2319"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2320"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2321"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2322"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2323"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2324"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2325"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2326"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2327"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2328"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2329"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2330"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2331"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2332"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2333"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2334"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2335"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2336"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2337"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2338"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2339"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2340"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2341"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2342"
    }
  })]), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page27",
      "title": "27"
    }
  }), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("17")]), _c('i', [_vm._v("These are the golden tumors that the Philistines returned as a guilt offering to the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _c('i', [_vm._v(": one for Ashdod, one for Gaza, one for Ashkelon, one for Gath, one for Ekron,")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("18")]), _c('i', [_vm._v("and the golden mice, according to the number of all the cities of the Philistines belonging to the five lords, both fortified cities and unwalled villages. The great stone beside which they set down the ark of the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("is a witness to this day in the field of Joshua of Beth-shemesh.")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("19")]), _c('i', [_vm._v("And he struck some of the men of Beth-shemesh, because they looked upon the ark of the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _c('i', [_vm._v(". He struck seventy men of them,")]), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("c")]), _vm._v(" "), _c('i', [_vm._v("and the people mourned because the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("had struck the people with a great blow.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("20")]), _c('i', [_vm._v("Then the men of Beth-shemesh said, “Who is able to stand before the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _c('i', [_vm._v(", this holy God? And to whom shall he go up away from us?”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("21")]), _c('i', [_vm._v("So they sent messengers to the inhabitants of Kiriath-jearim, saying, “The Philistines have returned the ark of the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _c('i', [_vm._v(". Come down and take it up to you.”")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    staticClass: "drop-cap"
  }, [_vm._v("7")]), _vm._v(" "), _c('i', [_vm._v("And the men of Kiriath-jearim came and took up the ark of the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("and brought it to the house of Abinadab on the hill. And they consecrated his son Eleazar to have charge of the ark of the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _c('i', [_vm._v(".")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("2")]), _c('i', [_vm._v("From the day that the ark was lodged at Kiriath-jearim, a long time passed, some twenty years, and all the house of Israel lamented after the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _c('i', [_vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "small"
  }, [_c('b', [_vm._v("a")]), _vm._v(" Or "), _c('i', [_vm._v("he")]), _vm._v(" "), _c('b', [_vm._v("b")]), _vm._v(" Or "), _c('i', [_vm._v("gone into exile")]), _vm._v("; also verse 22 "), _c('b', [_vm._v("c")]), _vm._v(" Most Hebrew manuscripts "), _c('i', [_vm._v("struck of the people seventy men, fifty thousand men"), _c('br'), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Overview:")]), _vm._v(" According to the commentators, God uses the war between the Israelites and the Philistines to take the lives of Eli and his sons as punishment for their sins. The interpreters are also agreed that taking the ark of the covenant to the battlefield is a foolish act with dire consequences. Nevertheless, when the Philistines place the Israelite ark, which signifies the presence of Yahweh, alongside their god Dagon, the Lord God guards his sanctity despite the godlessness of the Israelites. In fact, God punishes the Philistines, who ironically display more reverence toward the ark than the Israelites had, sending it back to Bethshemesh with materials for guilt offerings and burnt offerings. Although the men of Bethshemesh should have known better, the interpreters explain, they violate the law of God by opening the ark and not handling it lawfully. God, therefore, rightly takes the lives of the guilty men. In this same passage, God takes the lives of Hophni, Phinehas, Eli and Phinehas’s wife. Although it is a harsh concept for many of us today, the commentators take to heart Hannah’s earlier song that “the Lord kills . . . ; he brings down to Sheol” (1 Sam 2:6). The interpreters do not distinguish here between God’s role in the taking of human life and the giving of it.")]), _vm._v(" "), _c('h5', {
    attrs: {
      "id": "sigil_toc_id_42"
    }
  }, [_c('b', [_vm._v("4:1b-11")]), _vm._v(" "), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("The Priests Accompany the Ark into Battle")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Fighting Battles Without God’s Word.")]), _vm._v(" "), _c('i', [_vm._v("Johannes Bugenhagen:")]), _vm._v(" Whoever goes to war without the word of God and trusts in his own strength will fall, because victory is the Lord’s. The self-appointed masters Hophni and Phinehas show that they did not have this word of God. You will not remain standing against “the Philistines,” whether that means people of God or enemies of the faith, unless the spiritual word guards your heart. For there are some among us who have the word of God (like the Israelites), who then produce great speeches of human knowledge, pointing to the Scriptures and arguing against adversaries, saying that it is good to destroy whomever and to strive to win on the holy day, as if conducting worship would be a lie and hypocrisy, as if the sacraments were just another kind of communion, as if they were not a righteous work to share with all and that Scripture says so. However that may be, they do not know that faith happens in the heart. They do not know that the gospel is not letter but spirit, not doctrine but life. And while they themselves trust that the sacraments show only an external salvation (however otherwise beautiful), they crumble in the face of "), _c('a', {
    attrs: {
      "id": "_idTextAnchor2343"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2344"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2345"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2346"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2347"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2348"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2349"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2350"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2351"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2352"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2353"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2354"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2355"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2356"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2357"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2358"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2359"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2360"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2361"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2362"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2363"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2364"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2365"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2366"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2367"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2368"
    }
  }), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page28",
      "title": "28"
    }
  }), _vm._v("th"), _c('a', {
    attrs: {
      "id": "_idTextAnchor2369"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2370"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2371"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2372"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2373"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2374"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2375"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2376"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2377"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2378"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2379"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2380"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2381"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2382"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2383"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2384"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2385"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2386"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2387"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2388"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2389"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2390"
    }
  }), _vm._v("eir adversaries. This is what it means that the Israelites hoped for salvation from the ark, which was a sacrament according to the word of God. It had the propitiator who is Christ and the two cherubim, which are the two testaments of propitiation gazing on each other. But without the word of God, that is, without faith in their hearts, the ark was nothing but that death which they shamefully brought on themselves. "), _c('i', [_vm._v("Commentary on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-370-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-370",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Blaming God for Defeat.")]), _vm._v(" "), _c('i', [_vm._v("Viktorin Strigel:")]), _vm._v(" Just as Brutus exclaimed before meeting his end, “O Jupiter, the cause of all evils!” so the people of Israel disputed the reason for their loss in the battlefield. And just as Brutus was rightly punished for his monstrous scheming, first when he drove Caesar out of Cyprus and then when he killed him in the Senate out of ingratitude, so the people of Israel were rightly punished by God for their disobedience and ingratitude. Therefore, in our times of calamity, we ought to praise God’s righteousness and cry out with David, “Against you, you only, have I sinned and done what is evil in your sight.” And “You are righteous, O L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")]), _vm._v(", and your judgment is righteous.” "), _c('i', [_vm._v("Commentary on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-369-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-369",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])])])])]), _vm._v(" "), _c('h5', {
    attrs: {
      "id": "sigil_toc_id_43"
    }
  }, [_c('b', [_vm._v("4:12-22")]), _vm._v(" "), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("Death and Life")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Eli’s Death.")]), _vm._v(" "), _c('i', [_vm._v("Andrew Willet:")]), _vm._v(" The principal cause of Eli’s death was the justice of God in punishing, by this temporal judgment, Eli’s negligence in not correcting his sons. For, as he did not bow the necks of his sons to the yoke, so his neck, now bowed and broken, served as a just recompense. The subordinate cause of Eli’s death was the lamentable report of so many calamities, which all fell out together—Israel fleeing, his sons’ deaths and the ark’s capture, for which he grieved most of all. The messenger made no pause at all but uttered all his heavy news at once, as if it were on purpose to oppress and overload Eli with grief. However, if the messenger had taken time to tell the story by degrees, Eli’s grief might have been allayed. Finally, the instrumental cause of Eli’s death was his falling from his feet, which was not a low stool but a high throne, which was proper for a high priest and chief judge. So he fell high and, since he was also very old—almost one hundred years old—his body was fat and round, and he was not nimble enough to shift himself. What’s more, he was very dim-sighted and so could not see which way to help himself as he fell. "), _c('i', [_vm._v("Harmony on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-368-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-368",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("An Eli in Every Age.")]), _vm._v(" "), _c('i', [_vm._v("John Robinson:")]), _vm._v(" It is dangerous in the course of religion and godliness to fall forward by errors, preposterous zeal or another misguidance; yet not so much so as to fall backward by an unfaithful heart. The former may break his face thereby and lose his comfort in a great measure both with God and with people. But the latter is in danger utterly to break the neck of his conscience, as old Eli broke his neck bodily by falling backward from his seat and died. Are there not many Eli’s in all ages? "), _c('i', [_vm._v("Essays.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-367-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-367",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("The Birth of Ichabod.")]), _vm._v(" "), _c('i', [_vm._v("Lucas Osiander:")]), _vm._v(" The attending woman said to the wife of Phinehas, “Do not fear, get your soul back together, for you have borne a son. Recover your soul in hope, because when other mothers have given birth to their children they are often overwhelmed with great joy.” Truly, the new mother was by no means cheered up, because she did not respond to hearing the consolation of the child’s birth and she did not direct her mind to it, or in Hebrew, “she did not apply her heart to it.” That is, she did not sense any recovery. She named the newborn child Ichabod, saying, “Glory (that is, our glory, all glory, and the majesty of the people of Israel) has departed.” "), _c('i', [_vm._v("Annotations on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-366-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-366",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_c('span', {
    staticClass: "com-rorohiko-pagestaker-style"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor2391"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2392"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2393"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2394"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2395"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2396"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2397"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2398"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2399"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2400"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2401"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2402"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2403"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2404"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2405"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2406"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2407"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2408"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2409"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2410"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2411"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2412"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2413"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2414"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2415"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2416"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2417"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2418"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2419"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2420"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2421"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2422"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2423"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2424"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2425"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2426"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2427"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2428"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2429"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2430"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2431"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2432"
    }
  })])]), _c('b', [_c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page29",
      "title": "29"
    }
  })]), _c('b', [_vm._v("The Death of Phinehas’s Wife.")]), _vm._v(" "), _c('i', [_vm._v("Andrew Willet:")]), _vm._v(" Phinehas’s wife grieved more for the loss of the ark than in rejoicing that she had gained a son. She gave up the ghost based on her zeal and love of religion, which was absent in her husband. In fact, she did not even take into account the death of her husband and father-in-law, but was highly concerned about the capture of the ark and how its glory was lost. She therefore named her son Ichabod, which consists of two words: the first signifying “woe” or “where” . . . and the second, “glory.” The name Ichabod, then, means “Where is the glory?,” or “No glory.” Josephus thinks that she gave birth before her time, and that Ichabod was born at seven months. However, that is not likely, because the child lived. Nonetheless, here Samuel’s prophecy is fulfilled—that there would not be an old man left of Eli’s house. This translating of the glory of God to the Philistines prefigured the offering of grace to the Gentiles and the removing of the glory of religion from the Jews. "), _c('i', [_vm._v("Harmony on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-365-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-365",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])])])])]), _vm._v(" "), _c('h5', {
    attrs: {
      "id": "sigil_toc_id_44"
    }
  }, [_c('b', [_vm._v("5:1-12")]), _vm._v(" "), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("The L")]), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("ord Versus Dagon")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Trusting in False Gods.")]), _vm._v(" "), _c('i', [_vm._v("Johannes Bugenhagen:")]), _vm._v(" Just as the Israelites impiously trusted in the ark, despising the truly sacramental word of God, so the Gentiles impiously betrayed God too. They presumed to rule over God, standing the ark next to their god Dagon. But they were the ones who were themselves undone by God’s Scriptures and sacraments. They were terribly ignorant of God, not having even a crumb of the Spirit, which a disciple of Christ shows by his or her fruits. For these others stand next to their god, that is, next to their trust in works, traditions and human inventions, which they want to establish in this way, as if they already had God’s testimony for their impieties and idolatries. But this is against the first commandment: “You shall have no other gods before me.” "), _c('i', [_vm._v("Commentary on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-364-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-364",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("God’s Power Roused Against Enemies and Idols.")]), _vm._v(" "), _c('i', [_vm._v("Viktorin Strigel:")]), _vm._v(" While the triumphing, blasphemous enemies rise against the church and yell taunts against the God of Israel, God was then thought to be asleep or buried in his cups. But then he was roused, so that the Philistines were brought together to confess the thing itself, the infinite separation between the true and living God and the false and fabricated god known as Dagon. And so God is announced in his glory even without our prayers, even though Samuel and other pious people in Israel were doubtlessly making vows like this one: “Therefore arise, O Lord God, and sanctify your name, which they desecrate. Strengthen in us your kingdom, which they would destroy. Let your will be done, which they would suppress. Grant that your name not be trampled on because of our sin by those who do not seek to punish our sin but who desire only to destroy in us the knowledge of thy holy Word, of your name and of your work, so that they might dethrone you and rob you of a people that proclaims and confesses you and trusts in you. Amen.” "), _c('i', [_vm._v("Commentary on 1 Samuel.")]), _c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-363-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-363",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("God Is Not Mocked.")]), _vm._v(" "), _c('i', [_vm._v("Lucas Osiander:")]), _vm._v(" The Philistines set the ark beside Dagon, evidently as if in triumph about taking captive the God of Israel, whose captured ark was taken into their idol’s temple like spoils of war. For it was the custom to be arrogant in such victories, especially when enemies conquered God’s people. Then the true God and his religion was mocked. But God did not let a day go by without avenging their insults against him. Then “Dagon had fallen face downward on the ground before the ark of the L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")]), _vm._v(",” as if adoring the ark in veneration. For when an act of true religion is seen, then God begins to bring a great number people to himself. Quite sensibly, then, from this miracle the Philistines recognized the Israelite religion as truth and their idol Dagon "), _c('a', {
    attrs: {
      "id": "_idTextAnchor2433"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2434"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2435"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2436"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2437"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2438"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2439"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2440"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2441"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2442"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2443"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2444"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2445"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2446"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2447"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2448"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2449"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2450"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2451"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2452"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2453"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2454"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2455"
    }
  }), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page30",
      "title": "30"
    }
  }), _vm._v("as vanity. But with blinded minds, they did not totally comprehend it. "), _c('i', [_vm._v("Annotations on 1 Samuel.")]), _c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-362-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-362",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("The Philistine God Is Merely a Fish.")]), _vm._v(" "), _c('i', [_vm._v("Cardinal Cajetan:")]), _vm._v(" Consider, prudent reader, that here for the second time Dagon fell on its face on the ground before the ark of the covenant, and that its head and hands were cut off on the threshold. And so understand that this text does not say that Dagon’s trunk remained in its place . . . but it says that nothing remained in the idol’s place except "), _c('i', [_vm._v("dāg")]), _vm._v(", that is, the form of a fish—for the Hebrews, Dagon sounds like “fish.” And they say that this idol was an image of a man mixed with a fish, so that its head and hands were human, but the rest of its body was of a fish. And this fits very well with the letter of the Hebrew, which clearly states: only Dagon remained left over. For with its human members severed off, only a fish remained, prostrate before the ark of God. "), _c('i', [_vm._v("Commentary on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-361-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-361",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Unfit Companions.")]), _vm._v(" "), _c('i', [_vm._v("Charles Drelincourt:")]), _vm._v(" Just as the Lord’s ark and Dagon cannot dwell together under one roof, so the love of God and the love of the world can never subsist together. Therefore St. John advises us, “Do not love the world or the things in the world. If anyone loves the world, the love of the Father is not in him.” "), _c('i', [_vm._v("Christian Defense Against the Fears of Death.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-360-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-360",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])])])])]), _vm._v(" "), _c('h5', {
    attrs: {
      "id": "sigil_toc_id_45"
    }
  }, [_c('b', [_vm._v("6:1-12")]), _vm._v(" "), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("The Philistines")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("No Peace of Conscience Without God.")]), _vm._v(" "), _c('i', [_vm._v("Viktorin Strigel:")]), _vm._v(" Whenever humans and reason dominate, the word of God is removed from their midst and from any collective glory. Then the true priesthood falls and is extinguished, the cause of which is the wrath of God. But the victors never have peace in the consciences after this. For wherever the word of God is corrupted, pestilence and destruction are driven on consciences, just as the ark did to the Philistines. At length they had to confess their own shamefulness, that they had adulterated God’s word, the ark. So they got themselves together in order to return it unblemished. This is what the golden rings and mice signify: they are arcane signs for the pains of conscience, which are ultimately revealed through the word of God. As Paul says, “They will not get very far, for their folly will be plain to all.” "), _c('i', [_vm._v("Commentary on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-359-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-359",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("The Reverence of the Philistines.")]), _vm._v(" "), _c('i', [_vm._v("Andrew Willet:")]), _vm._v(" The Philistines were punished for their gross rudeness in profaning the ark and for consecrating it as one of their chief spoils to their idol, thereby making the great God inferior to their abominable invention. This breach of the natural and moral law did not escape unpunished. However, as for the ceremonial law—which prohibited the Israelites from coming near the ark or gazing on it—it was given only to the Israelites and so the heathen were ignorant of it. In this we see that the Lord requires a stricter obedience at the hands of his own people than of uninformed foreigners. What’s more, the Lord accepts this kind of reverence, which the Philistines out of their simple knowledge yielded to the ark—not allowing it to go empty but bestowing on it jewels of gold. They also used choice cows that were never before hitched to the yoke in addition to providing a new cart, which befits the holiness of the ark. The Philistines thereby expressed their reverence for the ark in this regard, by actually following the prescript of Moses’ law. "), _c('i', [_vm._v("Harmony on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-358-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-358",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Human Advice.")]), _vm._v(" "), _c('i', [_vm._v("Giovanni Diodati:")]), _vm._v(" This first part of the Philistines’ answer is naturally grounded on the ordinary means of appeasing God’s wrath by offerings. . . . It was likely consid"), _c('a', {
    attrs: {
      "id": "_idTextAnchor2456"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2457"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2458"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2459"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2460"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2461"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2462"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2463"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2464"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2465"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2466"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2467"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2468"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2469"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2470"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2471"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2472"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2473"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2474"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2475"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2476"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2477"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2478"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2479"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2480"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2481"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2482"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2483"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2484"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2485"
    }
  }), _vm._v("ered a trespass-offering, for it was a kind of trespass—though committed through ignorance—by which it was believed that God would be appeased and that the people would know that his wrath had been the cause of the people’s evils. . . . At the same time, the specification of the offerings—which is really absurd and ridiculous to think the Deity wants, for instance, images of mice—seems to be suggested by the devil in contempt of God. Who would accept this as a memorial that he had overcome his enemies by such poor and contemptible means—unless even in those days it was customary to consecrate a resemblance of those parts of the body in which they were healed, or of the annoyances which they were freed from, to that Deity which they were devoted to or from which they acknowledged the said deliverance? But because God’s law decreed nothing of the sort, it was truly an idolatrous superstition. "), _c('i', [_vm._v("Annotations on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-357-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-357",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")])])])])]), _vm._v(" "), _c('h5', {
    attrs: {
      "id": "sigil_toc_id_46"
    }
  }, [_c('b', [_vm._v("6:13-18")]), _vm._v(" "), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("The Israelites")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("God Alone Brought the Ark Back to Israel.")]), _vm._v(" "), _c('i', [_vm._v("Viktorin Strigel:")]), _vm._v(" God restored the ark of Israel by sending illustrious miracles, so that he might show that his church is gathered and protected not by human decisions or strength but by divine power. Yet though they had not set this miracle in motion, the Israelites with their meager human counsels would still move away from the form of government that God had instituted, as it says in chapter eight below. "), _c('i', [_vm._v("Commentary on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-356-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-356",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Continuance of the Ark.")]), _vm._v(" "), _c('i', [_vm._v("Andrew Willet:")]), _vm._v(" Here we may see the miserable state of Israel at this time—that they were deprived of that visible sign of God’s presence among them, namely, the ark, where the two tables of commandments dwelled. During this time they seemed to be forlorn and forsaken of God. Indeed, such times may sometimes fall out in the church of God: For a time, the Lord may allow sinners to be deprived of the true use of God’s Word and the sacraments. The Philistines held the ark for awhile—thinking that in time plagues would lessen. Afterward they purposed to keep the ark in enslavement and captivity still. At this time the ark sojourned among the Philistines without any profit to them at all. In the same way, a long time passed among the unrighteous Gentiles before truth was revealed to them, as the apostle says, since the time had not yet come for the Jews to be utterly dispossessed of the ark. But now we see that the ark of the gospel has been transferred to the believing Gentiles, and it has continued among them for hundreds of years, working in them faith and obedience to the truth. "), _c('i', [_vm._v("Harmony on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-355-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-355",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")])])])])]), _vm._v(" "), _c('h5', {
    attrs: {
      "id": "sigil_toc_id_47"
    }
  }, [_c('b', [_vm._v("6:19–7:2")]), _vm._v(" "), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("God’s Judgment for Looking at the Ark")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Unholy Curiosity.")]), _vm._v(" "), _c('i', [_vm._v("Johannes Bugenhagen:")]), _vm._v(" We have spoken above about looking at the ark out of curiosity. The law prohibits this under the penalty of death: no one should look at the ark, no one should come close to it and no one should look at it in the holy of holies. This is your death and you will be unable to avoid meeting it. You will be blinded by this inaccessible light, where you will have wanted to measure what is from God by your reason and wisdom. God reveals them to be small and foolish, whoever lets go of God in favor of their own works and judgment. For he hides this from the wise and the intelligent, as it says in Romans, “Oh, the depth of the riches and wisdom and knowledge of God!” and in Ecclesiasticus, “Seek not the things that are too high for you.” See this example of people’s conventional wisdom, how they push down the divine things that are seen as troublesome. They ask for kindness, but do not know even if they might be counted among the people of God. "), _c('i', [_vm._v("Commentary on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-354-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-354",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_c('span', {
    staticClass: "com-rorohiko-pagestaker-style"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor2486"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2487"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2488"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2489"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2490"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2491"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2492"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2493"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2494"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2495"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2496"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2497"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2498"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2499"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2500"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2501"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2502"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2503"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2504"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2505"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2506"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2507"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2508"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2509"
    }
  })])]), _c('b', [_c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page3132",
      "title": "3132"
    }
  })]), _c('b', [_vm._v("Causal but Not Casual.")]), _vm._v(" "), _c('i', [_vm._v("Lancelot Andrewes:")]), _vm._v(" The sickness and mortality of people is causal and not casual. For nothing is more contrary to judgment than chance or fortune. Just as a sparrow cannot fall on the ground without God’s providence—such is God’s care for them. . . . It is a senseless thing to think that sickness can befall a person by chance. Therefore the Philistines, being plagued by God, would boldly test whether that disease came of God’s hand or by chance. . . . But the very name "), _c('i', [_vm._v("plague")]), _vm._v(" signifies “judgment,” which shows that it is no casual thing. "), _c('i', [_vm._v("Collection of Lectures.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-353-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-353",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Smiting Bethshemesh.")]), _vm._v(" "), _c('i', [_vm._v("Andrew Willet:")]), _vm._v(" The Bethshemites were offensive in several ways. First, they did not receive the ark with great reverence and devotion when they saw it coming. Instead, they entertained it, as apparently they thought best, with shouting and signs of joy, as was common during the time of harvest. Second, they sacrificed female cows, namely, the two cows that drew the cart. However, according to the law, only bulls were to be offered. (Some also think that the Bethshemites themselves offered sacrifice rather than consulting with priests or the prophet Samuel. But that is not likely. . . .) Finally, the main reason why the Lord killed the Bethshemites was because “they looked on the ark of the Lord,” which was contrary to Numbers 5:20. . . . Josephus thinks that they also handled it irreverently with their hands. However, the fact that they looked on the ark without being priests was sufficient reason to procure God’s judgment. It is, of course, possible that the priests may have offended God by not approaching and drawing near with sufficient reverence. Nonetheless, it seems that by the number of them that were killed, most of them were of the common sort rather than priests. "), _c('i', [_vm._v("Harmony on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-352-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-352",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Unusual Circumstance.")]), _vm._v(" "), _c('i', [_vm._v("Giovanni Diodati:")]), _vm._v(" Kiriath-jearim was not a city that belonged to the priests as Bethshemesh was. As such, it was unlawful for anyone other than priests to touch the ark. It is therefore to be imagined that all this was done by the ministry of some priests who were sent for from some other place—unless there was some great toleration from God in such an extraordinary case as this was. "), _c('i', [_vm._v("Annotation on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-351-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-351",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20")])])])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "_idContainer022"
    }
  }, [_c('p', {
    staticClass: "PER_Top-extra-space"
  }, [_c('span', {
    staticClass: "com-rorohiko-pagestaker-style"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor2510"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2511"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2512"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2513"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2514"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2515"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2516"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2517"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2518"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2519"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2520"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2521"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2522"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2523"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2524"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2525"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2526"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2527"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2528"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2529"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2530"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2531"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2532"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2533"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2534"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2535"
    }
  })]), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page33",
      "title": "33"
    }
  })]), _vm._v(" "), _c('h2', {
    staticClass: "PER_ScriptureCenter",
    attrs: {
      "id": "sigil_toc_id_48"
    }
  }, [_c('span', {
    staticClass: "RH-marker"
  }, [_vm._v("7:3–8:22")]), _vm._v(" SAMUEL JUDGES WHILE ISRAEL DEMANDS A KING")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("3")]), _c('i', [_vm._v("And Samuel said to all the house of Israel, “If you are returning to the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("with all your heart, then put away the foreign gods and the Ashtaroth from among you and direct your heart to the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("and serve him only, and he will deliver you out of the hand of the Philistines.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("4")]), _c('i', [_vm._v("So the people of Israel put away the Baals and the Ashtaroth, and they served the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("only.")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("5")]), _c('i', [_vm._v("Then Samuel said, “Gather all Israel at Mizpah, and I will pray to the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("for you.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("6")]), _c('i', [_vm._v("So they gathered at Mizpah and drew water and poured it out before the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("and fasted on that day and said there, “We have sinned against the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _c('i', [_vm._v(".” And Samuel judged the people of Israel at Mizpah.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("7")]), _c('i', [_vm._v("Now when the Philistines heard that the people of Israel had gathered at Mizpah, the lords of the Philistines went up against Israel. And when the people of Israel heard of it, they were afraid of the Philistines.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("8")]), _c('i', [_vm._v("And the people of Israel said to Samuel, “Do not cease to cry out to the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("our God for us, that he may save us from the hand of the Philistines.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("9")]), _c('i', [_vm._v("So Samuel took a nursing lamb and offered it as a whole burnt offering to the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _c('i', [_vm._v(". And Samuel cried out to the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("for Israel, and the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("answered him.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("10")]), _c('i', [_vm._v("As Samuel was offering up the burnt offering, the Philistines drew near to attack Israel. But the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("thundered with a mighty sound that day against the Philistines and threw them into confusion, and they were defeated before Israel.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("11")]), _c('i', [_vm._v("And the men of Israel went out from Mizpah and pursued the Philistines and struck them, as far as below Beth-car.")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("12")]), _c('i', [_vm._v("Then Samuel took a stone and set it up between Mizpah and Shen")]), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("a")]), _vm._v(" "), _c('i', [_vm._v("and called its name Ebenezer;")]), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("b")]), _vm._v(" "), _c('i', [_vm._v("for he said, “Till now the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("has helped us.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("13")]), _c('i', [_vm._v("So the Philistines were subdued and did not again enter the territory of Israel. And the hand of the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("was against the Philistines all the days of Samuel.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("14")]), _c('i', [_vm._v("The cities that the Philistines had taken from Israel were restored to Israel, from Ekron to Gath, and Israel delivered their territory from the hand of the Philistines. There was peace also between Israel and the Amorites.")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("15")]), _c('i', [_vm._v("Samuel judged Israel all the days of his life.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("16")]), _c('i', [_vm._v("And he went on a circuit year by year to Bethel, Gilgal, and Mizpah. And he judged Israel in all these places.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("17")]), _c('i', [_vm._v("Then he would return to Ramah, for his home was there, and there also he judged Israel. And he built there an altar to the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _c('i', [_vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    staticClass: "drop-cap"
  }, [_vm._v("8")]), _vm._v(" "), _c('i', [_vm._v("When Samuel became old, he made his sons judges over Israel.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("2")]), _c('i', [_vm._v("The name of his firstborn son was Joel, and the name of his second, Abijah; they were judges in Beersheba.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("3")]), _c('i', [_vm._v("Yet his sons did not walk in his ways but turned aside after gain. They took bribes and perverted justice.")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("4")]), _c('i', [_vm._v("Then all the elders of Israel gathered together and came to Samuel at Ramah")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("5")]), _c('i', [_vm._v("and said to him, “Behold, you are old and your sons do not walk in your ways.Now appoint for us a king to judge us like all the nations.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("6")]), _c('i', [_vm._v("But the thing displeased Samuel when they said, “Give us a king to judge us.” And Samuel prayed to the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _c('i', [_vm._v(".")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("7")]), _c('i', [_vm._v("And the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("said to Samuel, “Obey the voice of the people in all that they say to you, for they have not rejected you, but they have rejected me from being king over them.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("8")]), _c('i', [_vm._v("According to all the deeds that they have done, from the day I brought them up out of Egypt even to this day, forsaking me and serving other gods, so they are also doing to you.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("9")]), _c('i', [_vm._v("Now then, obey their voice; only you shall solemnly warn them and show them the ways of the king who shall reign over them.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("10")]), _c('i', [_vm._v("So Samuel told all the words of the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("to the people who were asking for a king from him.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("11")]), _c('i', [_vm._v("He said, “These will be the ways of the king who will reign over you: he will take your sons and appoint them to his chariots and to be his horsemen and to run before his chariots.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("12")]), _c('i', [_vm._v("And he will appoint for himself commanders of thousands and commanders of fifties, and some to plow his ground and to reap his harvest, and to make his implements of war and the equipment of his chariots.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("13")]), _c('i', [_vm._v("He will take your daughters to be perfumers and cooks and bakers.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("14")]), _c('i', [_vm._v("He will take the best of your "), _c('a', {
    attrs: {
      "id": "_idTextAnchor2536"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2537"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2538"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2539"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2540"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2541"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2542"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2543"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2544"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2545"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2546"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2547"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2548"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2549"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2550"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2551"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2552"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2553"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2554"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2555"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2556"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2557"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2558"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2559"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2560"
    }
  })]), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page34",
      "title": "34"
    }
  }), _c('i', [_vm._v("fi"), _c('a', {
    attrs: {
      "id": "_idTextAnchor2561"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2562"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2563"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2564"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2565"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2566"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2567"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2568"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2569"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2570"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2571"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2572"
    }
  }), _vm._v("elds and vineyards and olive orchards and give them to his servants.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("15")]), _c('i', [_vm._v("He will take the tenth of your grain and of your vineyards and give it to his officers and to his servants.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("16")]), _c('i', [_vm._v("He will take your male servants and female servants and the best of your young men")]), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("c")]), _vm._v(" "), _c('i', [_vm._v("and your donkeys, and put them to his work.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("17")]), _c('i', [_vm._v("He will take the tenth of your flocks, and you shall be his slaves.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("18")]), _c('i', [_vm._v("And in that day you will cry out because of your king, whom you have chosen for yourselves, but the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("will not answer you in that day.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("19")]), _c('i', [_vm._v("But the people refused to obey the voice of Samuel. And they said, “No! But there shall be a king over us,")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("20")]), _c('i', [_vm._v("that we also may be like all the nations, and that our king may judge us and go out before us and fight our battles.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("21")]), _c('i', [_vm._v("And when Samuel had heard all the words of the people, he repeated them in the ears of the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _c('i', [_vm._v(".")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("22")]), _c('i', [_vm._v("And the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("said to Samuel, “Obey their voice and make them a king.” Samuel then said to the men of Israel, “Go every man to his city.”")])]), _vm._v(" "), _c('p', {
    staticClass: "small"
  }, [_c('b', [_vm._v("a")]), _vm._v(" Hebrew; Septuagint, Syriac "), _c('i', [_vm._v("Jeshanah")]), _vm._v(" "), _c('b', [_vm._v("b")]), _vm._v(" "), _c('i', [_vm._v("Ebenezer")]), _vm._v(" means "), _c('i', [_vm._v("stone of help")]), _vm._v(" "), _c('b', [_vm._v("c")]), _vm._v(" Septuagint "), _c('i', [_vm._v("cattle"), _c('br'), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Overview:")]), _vm._v(" In these two chapters, we witness the transition from judgeship to kingship in Israel. The reformers regard Samuel as a true prophet of God who leads the Israelites toward repentance and restores them to proper worship of God. In particular, the Lutheran interpreters note the concept of conversion in the leadership of Samuel. Because of Samuel’s godly leadership, the Israelites defeat the Philistines since faith proves the best of all weapons. Despite this victory, the reformers recognize the impiety of the Israelites for wanting a king like the rest of the nations rather than trusting in God as their king. The commentators interpret this desire as undue trust in worldly things such as power and comfort, while also seeing God’s hand in providing an earthly king whose descendants will lead to the King of kings, Jesus Christ. Some of the commentators, astute readers of the Old Testament and of the interpretive tradition before them, draw a parallel between this passage, about the role of a king, and the duties of a king set out in Deuteronomy 17.")]), _vm._v(" "), _c('h5', {
    attrs: {
      "id": "sigil_toc_id_49"
    }
  }, [_c('b', [_vm._v("7:3-17")]), _vm._v(" "), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("Victory by Humility")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Returning to God’s Word and to Faith.")]), _vm._v(" "), _c('i', [_vm._v("Johannes Bugenhagen:")]), _vm._v(" Under Samuel, the people truly turn back to God, are liberated by God, receive peace and triumph over their enemies, because in Samuel they have the word of God. “Since we have been justified by faith, we have peace,” and we put the kingdom of Satan and antichrist under foot. “Therefore,” as Christ says, “pray earnestly to the Lord of the harvest to send out laborers into his harvest.” For the wrath of God comes with the removal of God’s word, as in Isaiah 3:8 and Amos 8:11. "), _c('i', [_vm._v("Commentary on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-350-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-350",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Contrition, Faith and the New Obedience.")]), _vm._v(" "), _c('i', [_vm._v("Viktorin Strigel:")]), _vm._v(" This chapter shows extraordinary examples of true conversion to God, which is grasped through contrition, faith and the new obedience. The signs of contrition are true confession of sin, tears and fasting. The fruits of faith are prayers of invocation and the rejection of idols, for “how shall they call on him unless they believe?” After this conversion follows the clearest victory, which freed the people of Israel from a sad servitude. For no one can have strength of weapons without true repentance and invocation. How else can we be free from the many fighting Turks and other enemies of the church? Not by weapons alone, but also by crying out to God for conversion. That is our help in tribulation, for human salvation is vanity. "), _c('i', [_vm._v("Commentary on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-349-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-349",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Meaningful Offerings.")]), _vm._v(" "), _c('i', [_vm._v("Lancelot Andrewes:")]), _vm._v(" As Samuel not only prayed to God for the "), _c('a', {
    attrs: {
      "id": "_idTextAnchor2573"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2574"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2575"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2576"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2577"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2578"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2579"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2580"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2581"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2582"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2583"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2584"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2585"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2586"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2587"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2588"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2589"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2590"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2591"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2592"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2593"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2594"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2595"
    }
  }), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page35",
      "title": "35"
    }
  }), _vm._v("people but also sacrificed a suckling lamb and offered it up to God for them . . . so Christ, our intercessor to God, not only prayed but also made an offering on our behalf. He made an offering in the morning when he was presented to God his Father to yield obedience to the law; and he made an offering in the evening when he died. Not only was Christ the ear and firstfruit of the corn, but he also became the vine in his death by shedding his blood. And he not only prayed but also gave meaning to our prayers. In this way, not only did he make an offering for us, but he also gives meaning to our offerings. "), _c('i', [_vm._v("Collection of Lectures.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-348-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-348",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Erecting a Stone.")]), _vm._v(" "), _c('i', [_vm._v("Lucas Osiander:")]), _vm._v(" Samuel took a stone and called the name of the place Ebenezer, that is, a stone of help. This stone was erected as a sure testimony and memorial to divine goodness and power, which helped the people subdue their enemies. So Samuel said, “Till now the L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")]), _vm._v(" has helped us against the Philistines,” that is, let us preserve the memory of such great kindness with grateful souls and pass it on to those who come after us. We therefore truly erect such an image of God whenever we preach and sing the same glory, both privately and publicly. "), _c('i', [_vm._v("Annotations on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-347-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-347",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Greatness of the Victory.")]), _vm._v(" "), _c('i', [_vm._v("Andrew Willet:")]), _vm._v(" Three things set forth and commend the greatness of this victory. First, the people were unprepared and unarmed since they gathered together in common prayer and supplication, while their enemies came on them hastily and all of a sudden. Second, they used no carnal weapons or outward defense. Instead, Samuel only offered a sacrifice and prayed for them. Finally, God humbled the Philistines from heaven. The earth trembled under them, and they fell. The thunder astonished them and the lightning blasted them. This victory is like that which God gave to Barak and Deborah against Sisera (Judg 5) and that which God gave to Joshua when the Lord cast down stones on his enemies (Josh 10:10-11). "), _c('i', [_vm._v("Harmony on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-346-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-346",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])])])])]), _vm._v(" "), _c('h5', {
    attrs: {
      "id": "sigil_toc_id_50"
    }
  }, [_c('b', [_vm._v("8:1-9")]), _vm._v(" "), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("Asking for a King")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("The People’s Request.")]), _vm._v(" "), _c('i', [_vm._v("Johannes Bugenhagen:")]), _vm._v(" Recognizing the occasion provided by the sins of Samuel’s sons, the people impiously asked for a king who might defend them according to the customs of the Gentiles. They did not look to God, who had thus far been a king to them and fought for them, as Moses had said, “The L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")]), _vm._v(" will fight for you, and you have only to be silent.” God did this for them through the judges Moses, Aaron, Joshua, Eleazar and other successors described in the book of Judges. Through them the people were saved from their enemies until the time of Eli, when God served the people without regard to Eli’s impiety and the people’s idolatry. Then the rejected sons of Eli gave way to the greater Samuel. So it was already a great impiety to ask Samuel for a king while he was still living and not to expect that a judge would be given as usual to replace his impious sons, just as Samuel had been given to them instead of Eli’s sons. This is clearly a rejection of God and trusting in humans, in whom there is no salvation, as it says in the Psalms. "), _c('i', [_vm._v("Commentary on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-345-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-345",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Distrust and Audacity.")]), _vm._v(" "), _c('i', [_vm._v("Viktorin Strigel:")]), _vm._v(" Someone might ask how the people sinned in asking for a new form of government, when it seems wise to have deliberated on fixed leadership. Here is my simple reply. Two great sins are most severely punished, distrust and the audacity to set up new political forms according to human ideas rather than divine ones. For God wants to gather, protect and serve the church through the son, who is the head of the church. They do not need human protection, and God wants them to expect divine assistance, just "), _c('a', {
    attrs: {
      "id": "_idTextAnchor2596"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2597"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2598"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2599"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2600"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2601"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2602"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2603"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2604"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2605"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2606"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2607"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2608"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2609"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2610"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2611"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2612"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2613"
    }
  }), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page36",
      "title": "36"
    }
  }), _vm._v("as they expected deliverance from Egypt after more than eighty years. The elders rejected this faith, thinking of human assistance. The other trespass is the audacity to constitute a new political form without God’s establishment. For God does not want the teaching, worship or laws that have been handed down to change. God does not want to change the political forms, because such changes also shake the laws and doctrines and because legal restraints often make kings feel ill. Many also bend religion to serve their own desires, as when the kings of Samaria established new forms of worship during their reigns. "), _c('i', [_vm._v("Commentary on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-344-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-344",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("New Mediator.")]), _vm._v(" "), _c('i', [_vm._v("Lancelot Andrewes:")]), _vm._v(" Now, there is great disagreement between God and humankind by reason of sin, which has made a separation. And therefore we are to inquire who shall be the mediator between the two. It is certain Samuel, while he lived, stood between God and the people as a mediator to appease God by sacrifice. But his role as mediator has come to an end. Therefore we must look for a more perfect Mediator—such a one as Samuel himself needed. Now, the Mediator who stands between God and us is not Samuel the priest—but Christ. "), _c('i', [_vm._v("Collection of Lectures.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-343-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-343",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Did the People Cast Off the Lord’s Government?")]), _vm._v(" "), _c('i', [_vm._v("Andrew Willet:")]), _vm._v(" It is not quite true to say that the government under kings is a shaking off of the Lord’s yoke. For the Lord is with kings and he rules his people through them: They are the ordinance of God. Wisdom says, “By me kings reign.” Indeed, the Lord blessed the governments of David, Jehoshaphat, Hezekiah and Josiah. Yet the people . . . rejected the Lord’s government because they disliked the form of administration the Lord had set on them. They desired change and innovation without any direction from God. But it will be further questioned: Did God also reign together with bad kings? Yes. Even the authority of wicked kings is of God, which they abuse to tyranny. And for their evil and abuse of the government they shall give account to God. But although the people are evil who govern, yet the authority they possess is lawful and good. For even under tyrants there are many good things, such as the enacting of political laws, the administration of justice and the punishment of lawbreakers. "), _c('i', [_vm._v("Harmony on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-342-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-342",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Obeying Authorities, Obeying God.")]), _vm._v(" "), _c('i', [_vm._v("John Davenant:")]), _vm._v(" Work and its reward are related. Therefore, equity demands that for whom the work is done, from him the reward should be expected. It will seem scarcely credible that those who discharged the basest offices among people here on earth should be said on that very account to serve Christ himself, who sits in the heavens most glorious and by no means needing human service. But the reason is manifest . . . , namely, that whatever duties are performed by people according to the direction and at the command of Christ, and on account of the appointment and for the glory of Christ, they are judged to be offered and rendered to Christ himself. For “he serves God who for the sake of God serves people,” as Jerome has rightly observed. . . . Christ himself shows this: “As you have done it to the least of these, you have done it to me; As you did not do it to one of the least of these, you did not do it to me.”")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Jesus speaks in this place about almsgiving, as far as they are done or denied to people. But it ought to be extended to all the works of obedience commanded by God. For when these are rendered to people they are rendered to God, who commanded them to be done; when denied to people, they are deemed as denied to God himself. And this is right. For if the one who is commanded by God to obey people refuses to yield to human authority, this person would—if he had the power—also shake off the divine government.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("There are three corollaries to this. First, no service is dishonorable in which people conduct "), _c('a', {
    attrs: {
      "id": "_idTextAnchor2614"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2615"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2616"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2617"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2618"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2619"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2620"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2621"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2622"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2623"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2624"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2625"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2626"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2627"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2628"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2629"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2630"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2631"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2632"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2633"
    }
  }), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page37",
      "title": "37"
    }
  }), _vm._v("themselves well and faithfully: For such people and actions serve Christ himself, which is the height of dignity and honor. Second, no honor or authority screens a wicked person from dishonor and disgrace: For they who are of that character serve the devil, which is the abyss of infamy and misery. Third, those who, being placed under the rule of others, are unwilling to serve are rebels not only against people but also against God and Christ. Hence that reproof of God himself against the Israelites wishing to shake off the government of Samuel: “They have not rejected you, but they have rejected me.” "), _c('i', [_vm._v("Exposition of Colossians.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-341-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-341",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])])])])]), _vm._v(" "), _c('h5', {
    attrs: {
      "id": "sigil_toc_id_51"
    }
  }, [_c('b', [_vm._v("8:10-22")]), _vm._v(" "), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("The King’s Duties")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("No Divine Sanction to Abuse Authority.")]), _vm._v(" "), _c('i', [_vm._v("Philipp Melanchthon:")]), _vm._v(" Because there are some God-fearing rulers, this doctrine about property is emphasized so they may remember that the goods of the subjects are not to be appropriated by the master unless the common necessity of the country requires this. But some will quote the passage from 1 Samuel 8:11, “These will be the ways of the king who will reign over you; he will take your sons, your best fields. . . .” These words do not empower the sovereign power to do anything more than to requisition things for the common protection of the land. "), _c('i', [_vm._v("Theological Commonplaces (1555).")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-340-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-340",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("The Rule of Kings.")]), _vm._v(" "), _c('i', [_vm._v("Johannes Bugenhagen:")]), _vm._v(" It is not that this legal system before God will necessarily be as Samuel describes, because the law says of a king, “His heart may not be lifted up above his brothers.” Rather, it will not be otherwise but that the people will want to have a king according to the customs of the Gentiles. When the Lord truly gives assent to a king, he gives assent to that which kingly majesty requires before the world, how the king’s heart shall be directed according to Deuteronomy 17. As long as they all give their assent to this good, then the monarchy will have turned back to God through Christ. "), _c('i', [_vm._v("Commentary on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-339-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-339",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Kings, Taxes and Justice.")]), _vm._v(" "), _c('i', [_vm._v("Viktorin Strigel:")]), _vm._v(" Here some say that this describes a tyrant, not a king, and that it does not speak of a condition of servitude sanctioned by God. But the text calls this the rule of kings and speaks of the tax burden caused by their establishment. It does not authorize the power to establish severe servitude against divine law, because Deuteronomy 17 commands that a king shall study the law and follow it in all governance. This differentiation between dominion according to the holy law punishes Ahab, who wanted to elevate himself when he stole away Naboth’s vineyard against his will. Therefore such a great threat from Samuel about taxes was perceptive; that is, kings will raise themselves up greatly by way of private means, with as much legitimate tax as is fitting. This is just, because the benefit of defending the community clearly pertains to the individual, even as individuals need to unite with others. Romans 13 teaches that it is right to pay taxes. Therefore return what is determined, as the Baptist says, “Do not extort money from anyone by threats or by false accusation, and be content with your wages.” Do not be endlessly greedy, or invoke taxes as a pretext for all kinds of plundering. This is the true and simple meaning of Samuel to the assembly. "), _c('i', [_vm._v("Commentary on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-338-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-338",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")])])])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "_idContainer023"
    }
  }, [_c('p', {
    staticClass: "PER_Top-extra-space"
  }, [_c('span', {
    staticClass: "com-rorohiko-pagestaker-style"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor2634"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2635"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2636"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2637"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2638"
    }
  })]), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page38",
      "title": "38"
    }
  })]), _vm._v(" "), _c('h2', {
    staticClass: "PER_ScriptureCenter",
    attrs: {
      "id": "sigil_toc_id_52"
    }
  }, [_c('span', {
    staticClass: "RH-marker"
  }, [_vm._v("9:1–10:27")]), _vm._v(" SAUL CHOSEN AS KING")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("1")]), _c('i', [_vm._v("There was a man of Benjamin whose name was Kish, the son of Abiel, son of Zeror, son of Becorath, son of Aphiah, a Benjaminite, a man of wealth.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("2")]), _c('i', [_vm._v("And he had a son whose name was Saul, a handsome young man. There was not a man among the people of Israel more handsome than he. From his shoulders upward he was taller than any of the people.")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("3")]), _c('i', [_vm._v("Now the donkeys of Kish, Saul’s father, were lost. So Kish said to Saul his son, “Take one of the young men with you, and arise, go and look for the donkeys.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("4")]), _c('i', [_vm._v("And he passed through the hill country of Ephraim and passed through the land of Shalishah, but they did not find them. And they passed through the land of Shaalim, but they were not there. Then they passed through the land of Benjamin, but did not find them.")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("5")]), _c('i', [_vm._v("When they came to the land of Zuph, Saul said to his servant")]), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("a")]), _vm._v(" "), _c('i', [_vm._v("who was with him, “Come, let us go back, lest my father cease to care about the donkeys and become anxious about us.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("6")]), _c('i', [_vm._v("But he said to him, “Behold, there is a man of God in this city, and he is a man who is held in honor; all that he says comes true. So now let us go there. Perhaps he can tell us the way we should go.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("7")]), _c('i', [_vm._v("Then Saul said to his servant, “But if we go, what can we bring the man? For the bread in our sacks is gone, and there is no present to bring to the man of God. What do we have?”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("8")]), _c('i', [_vm._v("The servant answered Saul again, “Here, I have with me a quarter of a shekel")]), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("b")]), _vm._v(" "), _c('i', [_vm._v("of silver, and I will give it to the man of God to tell us our way.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("9")]), _c('i', [_vm._v("(Formerly in Israel, when a man went to inquire of God, he said, “Come, let us go to the seer,” for today’s “prophet” was formerly called a seer.)")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("10")]), _c('i', [_vm._v("And Saul said to his servant, “Well said; come, let us go.” So they went to the city where the man of God was.")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("11")]), _c('i', [_vm._v("As they went up the hill to the city, they met young women coming out to draw water and said to them, “Is the seer here?”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("12")]), _c('i', [_vm._v("They answered, “He is; behold, he is just ahead of you. Hurry. He has come just now to the city, because the people have a sacrifice today on the high place.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("13")]), _c('i', [_vm._v("As soon as you enter the city you will find him, before he goes up to the high place to eat. For the people will not eat till he comes, since he must bless the sacrifice; afterward those who are invited will eat. Now go up, for you will meet him immediately.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("14")]), _c('i', [_vm._v("So they went up to the city. As they were entering the city, they saw Samuel coming out toward them on his way up to the high place.")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("15")]), _c('i', [_vm._v("Now the day before Saul came, the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("had revealed to Samuel:")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("16")]), _c('i', [_vm._v("“Tomorrow about this time I will send to you a man from the land of Benjamin, and you shall anoint him to be prince")]), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("c")]), _vm._v(" "), _c('i', [_vm._v("over my people Israel. He shall save my people from the hand of the Philistines. For I have seen")]), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("d")]), _vm._v(" "), _c('i', [_vm._v("my people, because their cry has come to me.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("17")]), _c('i', [_vm._v("When Samuel saw Saul, the L")]), _c('span', {
    staticClass: "small-caps_i"
  }, [_vm._v("ord")]), _vm._v(" "), _c('i', [_vm._v("told him, “Here is the man of whom I spoke to you! He it is who shall restrain my people.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("18")]), _c('i', [_vm._v("Then Saul approached Samuel in the gate and said, “Tell me where is the house of the seer?”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("19")]), _c('i', [_vm._v("Samuel answered Saul, “I am the seer. Go up before me to the high place, for today you shall eat with me, and in the morning I will let you go and will tell you all that is on your mind.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("20")]), _c('i', [_vm._v("As for your donkeys that were lost three days ago, do not set your mind on them, for they have been found. And for whom is all that is desirable in Israel? Is it not for you and for all your father’s house?”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("21")]), _c('i', [_vm._v("Saul answered, “Am I not a Benjaminite, from the least of the tribes of Israel? And is not my clan the humblest of all the clans of the tribe of Benjamin? Why then have you spoken to me in this way?”")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("22")]), _c('i', [_vm._v("Then Samuel took Saul and his young man and brought them into the hall and gave them a place at the head of those who had been invited, who were about thirty persons.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("23")]), _c('i', [_vm._v("And Samuel said to the cook, “Bring the portion I gave you, of which I said to you, ‘Put it aside.’”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("24")]), _c('i', [_vm._v("So the cook took up the leg and what was on it and set them before Saul. And Samuel said, “See, what was kept is set before you. Eat, because it was kept for you until the hour appointed, that you might eat with the guests.”")]), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("e")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('i', [_vm._v("So Saul ate with Samuel that day.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("25")]), _c('i', [_vm._v("And when they came down from the high place into the city, a bed was spread for Saul")]), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("f")]), _vm._v(" "), _c('i', [_vm._v("on the roof, and he lay down "), _c('a', {
    attrs: {
      "id": "_idTextAnchor2639"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2640"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2641"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2642"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2643"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2644"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2645"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2646"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2647"
    }
  })]), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page39",
      "title": "39"
    }
  }), _c('i', [_vm._v("to sleep.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("26")]), _c('i', [_vm._v("Then at the break of dawn")]), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("g")]), _vm._v(" "), _c('i', [_vm._v("Samuel called to Saul on the roof, “Up, that I may send you on your way.” So Saul arose, and both he and Samuel went out into the street.")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("27")]), _c('i', [_vm._v("As they were going down to the outskirts of the city, Samuel said to Saul, “Tell the servant to pass on before us, and when he has passed on, stop here yourself for a while, that I may make known to you the word of God.”")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    staticClass: "drop-cap"
  }, [_vm._v("10")]), _vm._v(" "), _c('i', [_vm._v("Then Samuel took a flask of oil and poured it on his head and kissed him and said, “Has not the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("anointed you to be prince")]), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("h")]), _vm._v(" "), _c('i', [_vm._v("over his people Israel? And you shall reign over the people of the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("and you will save them from the hand of their surrounding enemies. And this shall be the sign to you that the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("has anointed you to be prince")]), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("i")]), _vm._v(" "), _c('i', [_vm._v("over his heritage.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("2")]), _c('i', [_vm._v("When you depart from me today, you will meet two men by Rachel’s tomb in the territory of Benjamin at Zelzah, and they will say to you, ‘The donkeys that you went to seek are found, and now your father has ceased to care about the donkeys and is anxious about you, saying, “What shall I do about my son?”’")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("3")]), _c('i', [_vm._v("Then you shall go on from there farther and come to the oak of Tabor. Three men going up to God at Bethel will meet you there, one carrying three young goats, another carrying three loaves of bread, and another carrying a skin of wine.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("4")]), _c('i', [_vm._v("And they will greet you and give you two loaves of bread, which you shall accept from their hand.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("5")]), _c('i', [_vm._v("After that you shall come to Gibeath-elohim,")]), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("j")]), _vm._v(" "), _c('i', [_vm._v("where there is a garrison of the Philistines. And there, as soon as you come to the city, you will meet a group of prophets coming down from the high place with harp, tambourine, flute, and lyre before them, prophesying.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("6")]), _c('i', [_vm._v("Then the Spirit of the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("will rush upon you, and you will prophesy with them and be turned into another man.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("7")]), _c('i', [_vm._v("Now when these signs meet you, do what your hand finds to do,for God is with you.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("8")]), _c('i', [_vm._v("Then go down before me to Gilgal. And behold, I am coming down to you to offer burnt offerings and to sacrifice peace offerings. Seven days you shall wait, until I come to you and show you what you shall do.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("9")]), _c('i', [_vm._v("When he turned his back to leave Samuel, God gave him another heart. And all these signs came to pass that day.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("10")]), _c('i', [_vm._v("When they came to Gibeah,")]), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("k")]), _vm._v(" "), _c('i', [_vm._v("behold, a group of prophets met him, and the Spirit of God rushed upon him, and he prophesied among them.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("11")]), _c('i', [_vm._v("And when all who knew him previously saw how he prophesied with the prophets, the people said to one another, “What has come over the son of Kish? Is Saul also among the prophets?”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("12")]), _c('i', [_vm._v("And a man of the place answered, “And who is their father?” Therefore it became a proverb, “Is Saul also among the prophets?”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("13")]), _c('i', [_vm._v("When he had finished prophesying, he came to the high place.")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("14")]), _c('i', [_vm._v("Saul’s uncle said to him and to his servant, “Where did you go?” And he said, “To seek the donkeys. And when we saw they were not to be found, we went to Samuel.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("15")]), _c('i', [_vm._v("And Saul’s uncle said, “Please tell me what Samuel said to you.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("16")]), _c('i', [_vm._v("And Saul said to his uncle, “He told us plainly that the donkeys had been found.” But about the matter of the kingdom, of which Samuel had spoken, he did not tell him anything.")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("17")]), _c('i', [_vm._v("Now Samuel called the people together to the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("at Mizpah.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("18")]), _c('i', [_vm._v("And he said to the people of Israel, “Thus says the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _c('i', [_vm._v(", the God of Israel, ‘I brought up Israel out of Egypt, and I delivered you from the hand of the Egyptians and from the hand of all the kingdoms that were oppressing you.’")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("19")]), _c('i', [_vm._v("But today you have rejected your God, who saves you from all your calamities and your distresses, and you have said to him, ‘Set a king over us.’ Now therefore present yourselves before the L")]), _c('span', {
    staticClass: "small-caps_i"
  }, [_vm._v("ord")]), _vm._v(" "), _c('i', [_vm._v("by your tribes and by your thousands.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("20")]), _c('i', [_vm._v("Then Samuel brought all the tribes of Israel near, and the tribe of Benjamin was taken by lot.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("21")]), _c('i', [_vm._v("He brought the tribe of Benjamin near by its clans, and the clan of the Matrites was taken by lot;")]), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("l")]), _vm._v(" "), _c('i', [_vm._v("and Saul the son of Kish was taken by lot. But when they sought him, he could not be found.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("22")]), _c('i', [_vm._v("So they inquired again of the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _c('i', [_vm._v(", “Is there a man still to come?” and the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("said, “Behold, he has hidden himself among the baggage.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("23")]), _c('i', [_vm._v("Then they ran and took him from there. And when he stood among the people, he was taller than any of the people from his shoulders upward.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("24")]), _c('i', [_vm._v("And Samuel said to all the people, “Do you see him whom the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("has chosen? There is none like him among all the people.” And all the people shouted, “Long live the king!”")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "com-rorohiko-pagestaker-style"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor2648"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2649"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2650"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2651"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2652"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2653"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2654"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2655"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2656"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2657"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2658"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2659"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2660"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2661"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2662"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2663"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2664"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2665"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2666"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2667"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2668"
    }
  })]), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page40",
      "title": "40"
    }
  }), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("25")]), _c('i', [_vm._v("Then Samuel told the people the rights and duties of the kingship, and he wrote them in a book and laid it up before the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _c('i', [_vm._v(". Then Samuel sent all the people away, each one to his home.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("26")]), _c('i', [_vm._v("Saul also went to his home at Gibeah, and with him went men of valor whose hearts God had touched.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("27")]), _c('i', [_vm._v("But some worthless fellows said, “How can this man save us?” And they despised him and brought him no present. But he held his peace.")])]), _vm._v(" "), _c('p', {
    staticClass: "small"
  }, [_c('b', [_vm._v("a")]), _vm._v(" Hebrew "), _c('i', [_vm._v("young man")]), _vm._v("; also verses 7, 8, 10, 27 "), _c('b', [_vm._v("b")]), _vm._v(" A "), _c('i', [_vm._v("shekel")]), _vm._v(" was about 2/5 ounce or 11 grams "), _c('b', [_vm._v("c")]), _vm._v(" Or "), _c('i', [_vm._v("leader")]), _vm._v(" "), _c('b', [_vm._v("d")]), _vm._v(" Septuagint adds "), _c('i', [_vm._v("the affliction of")]), _vm._v(" "), _c('b', [_vm._v("e")]), _vm._v(" Hebrew "), _c('i', [_vm._v("appointed, saying, ‘I have invited the people’")]), _vm._v(" "), _c('b', [_vm._v("f")]), _vm._v(" Septuagint; Hebrew "), _c('i', [_vm._v("and he spoke with Saul")]), _vm._v(" "), _c('b', [_vm._v("g")]), _vm._v(" Septuagint; Hebrew "), _c('i', [_vm._v("And they arose early and at the break of dawn")]), _vm._v(" "), _c('b', [_vm._v("h")]), _vm._v(" Or "), _c('i', [_vm._v("leader")]), _vm._v(" "), _c('b', [_vm._v("i")]), _vm._v(" Septuagint; Hebrew lacks "), _c('i', [_vm._v("over his people Israel? And you shall…. to be prince")]), _vm._v(" "), _c('b', [_vm._v("j")]), _vm._v(" "), _c('i', [_vm._v("Gibeath-elohim")]), _vm._v(" means "), _c('i', [_vm._v("the hill of God")]), _vm._v(" "), _c('b', [_vm._v("k")]), _vm._v(" "), _c('i', [_vm._v("Gibeah")]), _vm._v(" means "), _c('i', [_vm._v("the hill")]), _vm._v(" "), _c('b', [_vm._v("l")]), _vm._v(" Septuagint adds "), _c('i', [_vm._v("finally he brought the family of the Matrites near, man by man"), _c('br'), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Overview:")]), _vm._v(" For the commentators here, both human and divine forces are at work in the choosing of Israel’s first king, Saul. God chooses the person he wants to rule the Israelites by orchestrating several seemingly unrelated events. Indeed, the reformers recognize God’s providence in Saul’s life in the very manner he is selected king through the circumstance of his father’s straying donkeys. At the same time, the reformers note Saul’s humble beginnings from the smallest tribe of Israel, Benjamin, and they cite his lack of confidence and leadership. Saul’s anointing by Samuel, however, temporarily invigorates him. As the commentators explain, anointings in the Old Testament impart supernatural gifts, and Saul becomes a new man who is regarded as a prophet on account of his changed behavior and new leadership gifts. Despite Saul’s reluctance to be Israel’s king, God’s plan cannot be thwarted.")]), _vm._v(" "), _c('h5', {
    attrs: {
      "id": "sigil_toc_id_53"
    }
  }, [_c('b', [_vm._v("9:1-20")]), _vm._v(" "), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("God’s Providence in")]), _vm._v(" "), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("Saul’s Life")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Benjamin’s Weakness and Saul’s Great Stature.")]), _vm._v(" "), _c('i', [_vm._v("Lucas Osiander:")]), _vm._v(" This ninth chapter now tells how Saul will rise up and where he had his beginnings. His ancestor Aphiah was of the tribe of Benjamin. On the diminishment of that tribe at that time when the king of Israel was chosen from it, see Judges 21. For we are reminded that God chooses what is low and despised and lifts them up on high. But Saul’s father Kish was valiant and strong; he was a brave hero. His son was called Saul, excellent and good; that is, he was an extraordinary character, even commended with a gifted soul. No man in Israel was his better. That is, he had no equal or comparison in terms of his body and his majestic form, because “from his shoulders upward he was taller than any of the people.” For although the soul’s strength is preferable to physical form, nevertheless his extraordinary height was a gift of God and was accompanied by a certain honor from the people. "), _c('i', [_vm._v("Annotations on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-337-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-337",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("God’s Promises Happen over Time.")]), _vm._v(" "), _c('i', [_vm._v("Viktorin Strigel:")]), _vm._v(" The beginning recites Saul’s genealogy, so that the reader knows from which tribe the people of Israel’s first king was chosen. For although kingship had been promised to the tribe of Judah in Genesis 49 and Deuteronomy 33, yet God did not choose a king according to that first counsel from the tribe of Judah but from the tribe of Benjamin. Thus is grasped the rule of all promises to the flesh: they cannot be seized by our plans without divine calling, just as Abraham was promised land, even though he never possessed it. And the ancestors in Egypt knew they had been promised the land of Canaan, but they did not occupy it either; still they awaited the call. Even so, it was promised that David would be king, but he could not take it during Saul’s lifetime. "), _c('i', [_vm._v("Commentary on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-336-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-336",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Done by Providence.")]), _vm._v(" "), _c('i', [_vm._v("Huldrych Zwingli:")]), _vm._v(" The straying donkeys, in search of which Saul had "), _c('a', {
    attrs: {
      "id": "_idTextAnchor2669"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2670"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2671"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2672"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2673"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2674"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2675"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2676"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2677"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2678"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2679"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2680"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2681"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2682"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2683"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2684"
    }
  }), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page41",
      "title": "41"
    }
  }), _vm._v("left his father’s house, show clearly enough that they went astray at the ordination of God, since the son sought donkeys and found a kingdom that he had not sought, and the father got not only the donkeys he was concerned about but also a king for a son, which he had never anticipated. . . . In this we see that everywhere the things we "), _c('i', [_vm._v("say")]), _vm._v(" occur by accident are done and regulated by providence. "), _c('i', [_vm._v("On the Providence of God.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-335-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-335",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Arranged by God.")]), _vm._v(" "), _c('i', [_vm._v("Johannes Bugenhagen:")]), _vm._v(" In this story you see that things like luck, prudence, industry and study are human causes. With God there is providence. For what great fortune could have seen that Saul would be anointed king when he was looking for donkeys and then rushing to consult a seer, so that through these things God would call and anoint him? Therefore all the spontaneous things we do like this or somehow feel compelled to do get put in motion or pushed along by God. Whether it is for God’s mercy or judgment, these things are not active in themselves as we want or determine them to be. In the end, they have been arranged by God in ways we have not known or could not have known. "), _c('i', [_vm._v("Commentary on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-334-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-334",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])])])])]), _vm._v(" "), _c('h5', {
    attrs: {
      "id": "sigil_toc_id_54"
    }
  }, [_c('b', [_vm._v("9:21-27")]), _vm._v(" "), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("Saul’s Refusal and Samuel’s Teaching")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Samuel Teaches Saul Servant Leadership.")]), _vm._v(" "), _c('i', [_vm._v("Viktorin Strigel:")]), _vm._v(" In this conversation with Saul, Samuel undoubtedly greatly admonished the future king about the office of pious governance, which is no different from being a good parent. See how he exhorts him to follow the law of all government, as Deuteronomy 17 most gravely teaches. For kingly authorities have been established from heaven, so that they defend laws, peace, and discipline and well preserve responsible public human society. This is just as Paul says in Romans 13: The magistrate is “God’s servant for your good.” Daniel also gave this direction to the king of the Chaldeans: “Break off your sins by practicing righteousness, and your iniquities by showing mercy to the oppressed.” To this end, princes surely need to know and consider that dominion should not resemble piracy, as it finally does among all those who inflict harm on others. In short, Samuel encouraged the future king to think about how his kingship came directly from God for the benefit of all humankind. "), _c('i', [_vm._v("Commentary on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-333-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-333",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Of Saul’s Refusal of the Kingdom.")]), _vm._v(" "), _c('i', [_vm._v("Andrew Willet:")]), _vm._v(" Saul excuses himself by three arguments. First, his tribe was the smallest in Israel, since it had not yet recovered from the loss and slaughter it had received in the battle with Israel in Judges 20. Second, his father’s house was of small account in the tribe. And third, he himself was the least in his father’s house. In fact, some think Saul was stalling and that he was full of hypocrisy, attributes that later manifested themselves during his reign as king. But I rather agree with those who think that Saul modestly refused the kingdom at this time and that he really tried to excuse himself from the honor of being king. This is clear from Saul’s different responses to Samuel, such as, “Why . . . have you spoken to me in this way?” Although it is clear that Saul later played the hypocrite, yet here he had another heart and he spoke from simplicity and humility. "), _c('i', [_vm._v("Harmony on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-332-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-332",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])])])])]), _vm._v(" "), _c('h5', {
    attrs: {
      "id": "sigil_toc_id_55"
    }
  }, [_c('b', [_vm._v("10:1")]), _vm._v(" "), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("The Anointing")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("God’s Royal Priesthood.")]), _vm._v(" "), _c('i', [_vm._v("Johannes Bugenhagen:")]), _vm._v(" The godly anointing used among the people of Israel looked toward Christ’s anointing, the anointing of the Lord, as it says in Isaiah, “The Spirit of the Lord God is upon me, because the L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")]), _vm._v(" has anointed me.” And in the psalm, “You have loved righteousness and hated wickedness. Therefore God, your God, has anointed you with the oil of gladness beyond your companions.” For "), _c('a', {
    attrs: {
      "id": "_idTextAnchor2685"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2686"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2687"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2688"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2689"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2690"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2691"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2692"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2693"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2694"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2695"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2696"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2697"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2698"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2699"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2700"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2701"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2702"
    }
  }), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page42",
      "title": "42"
    }
  }), _vm._v("Christ is the priest and king who puts an end to priesthood and royal dignity in Israel, for he is the true and eternal reality of all those figures who had come before. And through this one, all Christians are Christ’s: that is, priests and kings just as Abraham, Isaac and Jacob had been, of whom the psalm speaks, “Touch not my anointed ones, do my prophets no harm!” In that way, God’s external institution is not a human invention but has signified a spiritual and internal anointing. For this reason, what the gospel has publicly proclaimed in the world is not the work God instituted for a time being. This does not permit us to act or speak in this way: “God instituted this and wanted it to signify thus; so therefore whatever similar things we have instituted deserve the same significance.” For ours is a time of ungodliness, and we make human and divine signs equal, without any word of God. But 1 John 2 speaks of Christian anointing, how they are those who have had the oil of righteousness, just like Abraham, Isaac and Jacob. The psalm says, “the oil of gladness,” which is the Holy Spirit in your heart. But this impious argument is made against us: “The thing you admire is not in the words themselves. Those whom God commanded to anoint priests or kings were themselves anointed to be priests or kings before God. Therefore those whom we anoint as priests or kings without God’s command are truly ordained priests or kings before God.” Who told this to you, that from your hearts you have decided that God will definitely accept your word on this, whether it is true or false? The Lord commanded this anointing and Samuel said, “The L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")]), _vm._v(" has anointed you.” "), _c('i', [_vm._v("Commentary on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-331-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-331",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Grounded on the Holy Spirit.")]), _vm._v(" "), _c('i', [_vm._v("Giovanni Diodati:")]), _vm._v(" Ordinary ceremonies of anointing of the Old Testament were grounded on the communication of the gifts of the Holy Spirit and were figured by the oil. Now it is not said that it was anything other than the ordinary oil used by a priest, whereas it is likely that the horn of oil by which David was anointed was afterward kept in the tabernacle. Afterward other kings, when occasion served, were anointed with the same oil, as is the case in 1 Kings 1:39. "), _c('i', [_vm._v("Annotations on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-330-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-330",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("The Gifts of the Holy Spirit.")]), _vm._v(" "), _c('i', [_vm._v("Andrew Willet:")]), _vm._v(" This anointing in the Old Testament signified the gifts of the Holy Spirit that were necessary for those who would rule. This was a type and figure of the spiritual anointing of the Messiah—to be our Priest, Prophet and King. However, this ceremony was not necessary to continue in the New Testament. The Jews think Saul was not anointed in the same way that David and Solomon were anointed. They believe that David’s and Solomon’s anointing oil came from the tabernacle, but that Saul’s did not. And they also believe that the oil poured over David and Solomon came from a horn, while the oil poured over Saul came from a vial—the same way Jehu was anointed. This type of anointing, coming as it did from a brittle vessel like a vial—regardless of whether it was made of glass or of earth—signified the unstableness and short continuance of Saul’s and Jehu’s two kingdoms. By contrast, the oil coming from a horn indicated the firm and durable state of the kingdoms of David and Solomon. "), _c('i', [_vm._v("Harmony on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-329-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-329",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])])])])]), _vm._v(" "), _c('h5', {
    attrs: {
      "id": "sigil_toc_id_56"
    }
  }, [_c('b', [_vm._v("10:2-9")]), _vm._v(" "), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("A Sign, the Spirit and a Command")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Faith Before Works.")]), _vm._v(" "), _c('i', [_vm._v("Martin Luther:")]), _vm._v(" Here Samuel does not set forth one single work, but he sends a man, changed by the Spirit, as into a forest of works. Because he has become another man, therefore, other works follow. Our opponents do not understand this theology, but turn it upside down. They prescribe and teach that people should do works until they are changed and become different. But a man or person must first be changed. . . . Afterward, everything will be made "), _c('a', {
    attrs: {
      "id": "_idTextAnchor2703"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2704"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2705"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2706"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2707"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2708"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2709"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2710"
    }
  }), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page43",
      "title": "43"
    }
  }), _vm._v("right. . . . Everything now pleases God because the person pleases God, not for their own sake but for the sake of the sacrifice of Christ and the mercy which faith grasps. "), _c('i', [_vm._v("Comments on Psalm 51.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-328-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-328",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Signs and Sacraments from God.")]), _vm._v(" "), _c('i', [_vm._v("Johannes Bugenhagen:")]), _vm._v(" Samuel said, “And this shall be the sign to you.” This reality was new and hardly believable to Saul. Therefore it was confirmed by many foretold signs from God, so that he would believe the word of God. In the same way the external sacraments are confirmed to us. "), _c('i', [_vm._v("Commentary on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-327-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-327",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("How the Spirit of God Came On Saul.")]), _vm._v(" "), _c('i', [_vm._v("Andrew Willet:")]), _vm._v(" The spirit of God is taken here as (1) the gift of prophesying, (2) the ability to achieve and prosper in an undertaking or (3) the gift of sanctification. Saul was endued with the spirit of God in the first two ways. First, he received a temporary gift of prophesying that confirmed him in his calling, just as the seventy elders prophesied temporarily in Numbers 11:25. Second, he was also furnished with gifts fit for that calling, as courage and generosity were necessary for the office of a king. However, as for the third sense, he was far off from true inward sanctification, as his latter actions demonstrated. He became another man in these two respects: first, because he should now show himself a prophet—singing divine songs and hymns among the prophets as though he had from his youth been trained up among them. And, second, that he should now put on a princely mind and meditate on matters belonging to the kingdom—whereas he was before but conversant only with his cattle. Yet this was but a civil kind of change in him. There was no inward renewal; nor did he become a regenerated man who was born of the Spirit. "), _c('i', [_vm._v("Harmony on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-326-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-326",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Leaving Certainty for Uncertainty.")]), _vm._v(" "), _c('i', [_vm._v("Daniel Dyke:")]), _vm._v(" [One of the many manifestations of] deceit is when we are occupied in thinking of some good thing to come to make us neglect our present duty. Here we should remember that saying of Samuel to Saul, “ . . . Do what your hand finds to do, for God is with you.” It is a folly to leave certainties for uncertainties. If you will lay hold of the present occasion, you may do so. But as for that which is to come, you are wholly uncertain. You do not know whether there will ever be any occasion of good for you to lay hold of or not. "), _c('i', [_vm._v("The Mystery of Self-Deceiving.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-325-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-325",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")])])])])]), _vm._v(" "), _c('h5', {
    attrs: {
      "id": "sigil_toc_id_57"
    }
  }, [_c('b', [_vm._v("10:10-16")]), _vm._v(" "), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("Saul Among the Prophets")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("“Is Saul Also Among the Prophets?”")]), _vm._v(" "), _c('i', [_vm._v("Johannes Bugenhagen:")]), _vm._v(" This proverb, that Saul is among the prophets, means that many can be made suitable, even those who do not seemingly belong: "), _c('i', [_vm._v("Nos poma natamus")]), _vm._v(". To condemn the gifts of God because of a person’s outward appearance is truly the foolishness of human wisdom. Christ addressed this when he said, “No prophet is acceptable in his hometown.” This point condemns anyone who makes the mistake of marveling about another person, just as they so greatly seized on the son of Kish when they said, “Who is their father?” as if he needed to be from the prophets. So it is shown that prophets are not made by parents or from the flesh but by the gift of God, who gives it to anyone he desires, including those not accustomed to titles great or small or respectable. This is not a work of the flesh but of the will of God. "), _c('i', [_vm._v("Commentary on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-324-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-324",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Who Is Their Father?")]), _vm._v(" "), _c('i', [_vm._v("Andrew Willet:")]), _vm._v(" Many marveled at this sudden change in Saul, whom they had known to be a valiant and courageous man before—but no prophet. . . . Nevertheless, we should not marvel that Saul prophesies, even though he does not have a prophet for a father. For the gift of prophecy is not hereditary. True prophets are not "), _c('a', {
    attrs: {
      "id": "_idTextAnchor2711"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2712"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2713"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2714"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2715"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2716"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2717"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2718"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2719"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2720"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2721"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2722"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2723"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2724"
    }
  }), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page44",
      "title": "44"
    }
  }), _vm._v("such because their fathers were prophets. Rather, it is the Spirit of God who is their father. The Spirit of God is their instructor. Prophets are not so much taught by people as taught by the spirit of God, who works freely and who accepts no person’s worth. For the Spirit of God can raise up prophets even from among the most wretched and abject of people. "), _c('i', [_vm._v("Harmony on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-323-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-323",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")])])])])]), _vm._v(" "), _c('h5', {
    attrs: {
      "id": "sigil_toc_id_58"
    }
  }, [_c('b', [_vm._v("10:17-24")]), _vm._v(" "), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("The Selection and Hiding of Saul")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Casting Lots and Trusting God.")]), _vm._v(" "), _c('i', [_vm._v("Johannes Bugenhagen:")]), _vm._v(" Proverbs says, “The lot is cast into the lap, but its every decision is from the L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")]), _vm._v(".” It is not necessary to ask whether casting lots may be allowed. It is allowed if you will have faithfully and modestly gathered together to cast lots from God, committing prayers to God for safekeeping in all things, so that this sign shows you the important thing it wants to show. You read that the apostles did exactly this in Acts 1. This is not tempting God but seeking God’s own will in matters in which you do not know everything that should be done, especially what is right to do for the glory of God and the salvation of your neighbors. The fear of God does this for those who do not at all dare to trust human advice. It is rightly translated “casting lots” in Latin, because in Hebrew it shows an external sign by which God indicates whom he has chosen. But why did Samuel do this? I reply: He did not do this for himself but for the people, so that the people know who had been chosen to be king by God, so as to prevent what had been done earlier with Aaron and the priests in Numbers 16. Therefore among ministers of the Word it is most important to know that which should be taught in order to be an apostle of God; otherwise, how will you believe? "), _c('i', [_vm._v("Commentary on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-322-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-322",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Hiding the Baggage Within.")]), _vm._v(" "), _c('i', [_vm._v("Daniel Dyke:")]), _vm._v(" There are not so many, nor so cunning, devices for the hiding of natural infirmities of the body—such as the crookedness of the legs or back or the lack of a tooth or an eye—as there are for the unnatural deformities of the soul. But once their desires are granted, they show themselves. Then the waters, which were previously stopped and damned up, run over and rage furiously. . . . And this is surely like it was when Saul hid himself in the baggage when he was to be chosen king. In the same way, the wicked—when they look either by election or other means to get this or that—they very soon hide in themselves their filthy stuff and baggage within. "), _c('i', [_vm._v("The Mystery of Self-Deceiving.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-321-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-321",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Hiding Does Not Foil Providence.")]), _vm._v(" "), _c('i', [_vm._v("Thomas Adams:")]), _vm._v(" Saul is appointed to the kingdom of Israel by God and anointed by the prophet Samuel; yet still he must be designated by lot. Was this to leave behind certainty and put it to chance? No, for of all the tribes in Israel, Benjamin is taken; of all the families of Benjamin, Matri is taken; of all the kindred of Matri, the house of Kish is taken; of all the house of Kish, Saul is chosen to be king. Saul had hidden himself, but he could not hope that his being hidden should foil the purpose of God. He who designed his name among the thousands of Israel (he might well think) could easily find Saul in a tent, and bring him forth to honor. "), _c('i', [_vm._v("Commentary on 2 Peter.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-320-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-320",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18")])])])])]), _vm._v(" "), _c('h5', {
    attrs: {
      "id": "sigil_toc_id_59"
    }
  }, [_c('b', [_vm._v("10:25-27")]), _vm._v(" "), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("The Good and the Bad")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Only the Holy Spirit Works Faith.")]), _vm._v(" "), _c('i', [_vm._v("Johannes Bugenhagen:")]), _vm._v(" The text speaks of “those whose hearts God had touched.” This is the nature of God’s word and activity, that it is not received or accepted unless God’s Spirit touches the heart. You see this in 1 Esdras 1, which speaks of the return from the Babylonian Captivity. . . . Those who had previously sinned by asking for a king now most grievously sin again by despising the one whom God had chosen with clear signs. They did not look to God’s will but to human "), _c('a', {
    attrs: {
      "id": "_idTextAnchor2725"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2726"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2727"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2728"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2729"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2730"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2731"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2732"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2733"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2734"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2735"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2736"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2737"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2738"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2739"
    }
  }), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page45",
      "title": "45"
    }
  }), _vm._v("appearances, just as the flesh always does. It has nothing to do with the spirit of faith but with trying to have all kinds of things without wisdom or righteousness. "), _c('i', [_vm._v("Commentary on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-319-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-319",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("The Human Heart Is Not Able to Rest in God Alone.")]), _vm._v(" "), _c('i', [_vm._v("Viktorin Strigel:")]), _vm._v(" Samuel finds fault with the ungrateful people, and he exposes their audacity and mistrust. For the God who so far had defended the church by the power of his hand, preserved and freed it was also repeatedly able to carry them without human assistance by his help and deliverance. But so great is the mistrust of the human heart that it is not able to rest in God alone. Therefore all people seek help from visible sources while they can. Then when these sources lead to ruin, they shatter many souls and do not permit any consolation. This shows the anguish of confiding only in visible things instead of God. It is permitted to use things ordained by God, as David used them for his army. But faith in things without faith in God scorns the divine voice, “Cursed is the man who trusts in man and makes flesh his strength, whose heart turns away from the L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")]), _vm._v(".” "), _c('i', [_vm._v("Commentary on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-318-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-318",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Victory by Leniency.")]), _vm._v(" "), _c('i', [_vm._v("Andrew Willet:")]), _vm._v(" These “worthless fellows” were men of Belial, that is, men without a yoke who refused to submit themselves to Saul’s government. They thought that because he was of low parentage and of no power, he was not a likely man to save the people. Therefore they did not come to show their respects to the king, nor bring him presents as others did. For by such gifts of acknowledgment, subjects express their loyal affection to the magistrate. But Saul held his peace and winked at this fault to avoid sedition and to win them by leniency. "), _c('i', [_vm._v("Harmony on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-317-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-317",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21")])])])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "_idContainer024"
    }
  }, [_c('p', {
    staticClass: "PER_Top-extra-space"
  }, [_c('span', {
    staticClass: "com-rorohiko-pagestaker-style"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor2740"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2741"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2742"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2743"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2744"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2745"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2746"
    }
  })]), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page46",
      "title": "46"
    }
  })]), _vm._v(" "), _c('h2', {
    staticClass: "PER_ScriptureCenter",
    attrs: {
      "id": "sigil_toc_id_60"
    }
  }, [_c('span', {
    staticClass: "RH-marker"
  }, [_vm._v("11:1-15")]), _vm._v(" BATTLE AGAINST THE AMMONITES")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("1")]), _c('i', [_vm._v("Then Nahash the Ammonite went up and besieged Jabesh-gilead, and all the men of Jabesh said to Nahash, “Make a treaty with us, and we will serve you.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("2")]), _c('i', [_vm._v("But Nahash the Ammonite said to them, “On this condition I will make a treaty with you, that I gouge out all your right eyes, and thus bring disgrace on all Israel.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("3")]), _c('i', [_vm._v("The elders of Jabesh said to him, “Give us seven days’ respite that we may send messengers through all the territory of Israel. Then, if there is no one to save us, we will give ourselves up to you.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("4")]), _c('i', [_vm._v("When the messengers came to Gibeah of Saul, they reported the matter in the ears of the people, and all the people wept aloud.")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("5")]), _c('i', [_vm._v("Now, behold, Saul was coming from the field behind the oxen. And Saul said, “What is wrong with the people, that they are weeping?” So they told him the news of the men of Jabesh.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("6")]), _c('i', [_vm._v("And the Spirit of God rushed upon Saul when he heard these words, and his anger was greatly kindled.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("7")]), _c('i', [_vm._v("He took a yoke of oxen and cut them in pieces and sent them throughout all the territory of Israel by the hand of the messengers, saying, “Whoever does not come out after Saul and Samuel, so shall it be done to his oxen!” Then the dread of the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("fell upon the people, and they came out as one man.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("8")]), _c('i', [_vm._v("When he mustered them at Bezek, the people of Israel were three hundred thousand, and the men of Judah thirty thousand.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("9")]), _c('i', [_vm._v("And they said to the messengers who had come, “Thus shall you say to the men of Jabesh-gilead: ‘Tomorrow, by the time the sun is hot, you shall have salvation.’” When the messengers came and told the men of Jabesh, they were glad.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("10")]), _c('i', [_vm._v("Therefore the men of Jabesh said, “Tomorrow we will give ourselves up to you, and you may do to us whatever seems good to you.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("11")]), _c('i', [_vm._v("And the next day Saul put the people in three companies. And they came into the midst of the camp in the morning watch and struck down the Ammonites until the heat of the day. And those who survived were scattered, so that no two of them were left together.")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("12")]), _c('i', [_vm._v("Then the people said to Samuel, “Who is it that said, ‘Shall Saul reign over us?’ Bring the men, that we may put them to death.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("13")]), _c('i', [_vm._v("But Saul said, “Not a man shall be put to death this day, for today the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("has worked salvation in Israel.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("14")]), _c('i', [_vm._v("Then Samuel said to the people, “Come, let us go to Gilgal and there renew the kingdom.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("15")]), _c('i', [_vm._v("So all the people went to Gilgal, and there they made Saul king before the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("in Gilgal. There they sacrificed peace offerings before the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _c('i', [_vm._v(", and there Saul and all the men of Israel rejoiced greatly."), _c('br'), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Overview:")]), _vm._v(" The reformers recognize this passage as narrating Saul’s first assignment as king of Israel. Several commentators dwell on issues related to authority and governance. For example, Luther interprets this passage in light of the Peasants’ Revolt of 1524–1525, juxtaposing the divinely sanctioned leadership of Saul with that of renegade theologian Thomas Müntzer, who played an active role in the German revolt. Luther raises, but does not answer, a larger question related to authority: How do we determine legitimate leadership? Other commentators emphasize that the Holy Spirit empowers Saul to gain victory over the Ammonites, though they disagree on the personal and spiritual motives of Saul when it comes to his actions surrounding the battle. While some of the reformers comment positively on Saul’s refusal to kill those Israelites opposed to his leadership, others are tempted to interpret all of Saul’s actions in light of his overall failure as a godly king. As the story of Saul unfolds, however, the commentators become increasingly critical of his character and leadership, finding little to salvage from his reign as king of Israel.")]), _vm._v(" "), _c('h5', {
    attrs: {
      "id": "sigil_toc_id_61"
    }
  }, [_c('span', {
    staticClass: "com-rorohiko-pagestaker-style"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor2747"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2748"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2749"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2750"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2751"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2752"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2753"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2754"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2755"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2756"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2757"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2758"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2759"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2760"
    }
  })]), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page47",
      "title": "47"
    }
  }), _c('b', [_vm._v("11:1-11")]), _vm._v(" "), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("Saul’s New Rule")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("The Honor of Agriculture.")]), _vm._v(" "), _c('i', [_vm._v("Lucas Osiander:")]), _vm._v(" Even though he had been chosen as king, still he was not ashamed to continue farming, just like the old Romans formerly were not ashamed of rural matters. Some of them were called from the plow to the office of dictator."), _c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-316-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-316",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])])]), _vm._v(" Agriculture is an honest way of life—the least shameful way of life for a free person. "), _c('i', [_vm._v("Annotations on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-315-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-315",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Reading the Bible Carefully.")]), _vm._v(" "), _c('i', [_vm._v("Martin Luther:")]), _vm._v(" I have often warned that much good sense is needed when passing judgment on the works of the saints. When the Spirit had come on Saul, he cut oxen to pieces and threatened that the same thing would happen to the sheep of those who would not follow him and Samuel to war. Success followed the impulse, which was both heroic and from the Holy Spirit. After Thomas Müntzer had aroused the peasants to take up arms, he was also sure of victory in what seemed to him a just cause. But he perished, and rightly so; for his actions came from his own spirit, not from the Spirit of God. Nor could he get any support from the examples of the Old Testament saints, the examples on which he was nevertheless relying. "), _c('i', [_vm._v("Lectures on Genesis.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-314-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-314",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Beneficial Authority Is a Gift of God.")]), _vm._v(" "), _c('i', [_vm._v("Viktorin Strigel:")]), _vm._v(" Authority should not be matched up to our efforts. It is rather an exceptional and singular gift of God, as when the young Alexander the Great was followed by a large army such that no other leader will be followed in the same way. Similarly, Julius Caesar was such an authority that he could make a fleeing army stand put. Thus in this place the Lord bedecks the new king with authority, inclining the souls of the people to him. For it is a mistake to make an unwilling hound go hunting. But having been put under a clear, guiding and auspicious sequence of events about their government, the people can endure great things. Therefore whoever wants to enter into matters of government should ask God for wisdom beyond what the eye sees and the ear hears, as Solomon did.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Three benefits accompanied the state of being a king. First, any kind of pious king delighted in doing good for the preservation of doctrine, just as David, Solomon, Jehoshaphat, Hezekiah and Josiah cherished the study of doctrine and true worship. Second, through the king’s victories God gave illustrious testimony of his presence among the people, making himself visible, giving witness to doctrine and the church, and sending prophets to the kings. The third benefit about the kingly station was that he did whatever was good for the strengthening of the state. These benefits were great and singular works of God to those who acknowledged them, just as Scripture says, “Unless the Lord watches over the city, the watchman stays awake in vain.” And so that these highest goods relate to our states, let us pray most ardently for this and—wherever it is given—acknowledge this to be the work of God, celebrate God as the gracious author and custodian of this and remain diligent for him. "), _c('i', [_vm._v("Commentary on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-313-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-313",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("What Spirit of God Came to Saul?")]), _vm._v(" "), _c('i', [_vm._v("Andrew Willet:")]), _vm._v(" It is best to understand this passage as indicating that the spirit of fortitude came on Saul. This is similar to the way the spirit of God came on Sampson in Judges 14:5, when he tore apart the lion. It was, then, a heroic spirit that he received: the spirit of strength and courage. . . . It was not the spirit of sanctification or regeneration. By this it is evident that a person, even in civil actions, has need of the direction of God’s Spirit to bring him or her to a good end. This is as before: “Saul also went to his home at Gibeah, and with "), _c('a', {
    attrs: {
      "id": "_idTextAnchor2761"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2762"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2763"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2764"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2765"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2766"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2767"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2768"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2769"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2770"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2771"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2772"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2773"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2774"
    }
  }), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page48",
      "title": "48"
    }
  }), _vm._v("him went men of valor whose hearts God had touched.” People do not have any free will of themselves in moral actions to do that which is good and pleasing in the sight of God, unless such a person is drawn and guided by the Spirit of God. "), _c('i', [_vm._v("Harmony on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-312-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-312",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Waiting for Public Installation.")]), _vm._v(" "), _c('i', [_vm._v("Dutch Annotations:")]), _vm._v(" Even though Saul was privately anointed king over Israel by Samuel and he accepted the greatest part of the position, he did not as yet begin to execute that office in public. Instead, he lived a retired life until he was publicly installed by all the people. . . . Then the Spirit of the Lord came on him; that is, then God immediately, by the power of his Spirit, gave Saul the gifts of strength and courage to oppose the Ammonites. . . . And he took a couple of oxen, and hewed them in pieces. . . . He did this so that the Israelites would see the pieces of the oxen and remember what damage would befall them if they refused to follow Saul in this expedition. "), _c('i', [_vm._v("Annotations on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-311-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-311",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])])])])]), _vm._v(" "), _c('h5', {
    attrs: {
      "id": "sigil_toc_id_62"
    }
  }, [_c('b', [_vm._v("11:12-15")]), _vm._v(" "), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("Saul’s Appearance of Grandeur")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Forgiveness for the Sake of Public Tranquility.")]), _vm._v(" "), _c('i', [_vm._v("Viktorin Strigel:")]), _vm._v(" Saul’s dissimilation is praiseworthy, as he had not yet been confirmed as king. Rather, he is long and greatly honored for this moderation in victory, which he achieved as an unjustly forgotten person. Whoever thus conquers his soul at the height of its power over all things is comparable to one who finds the greatest way of life. It is like when David returned to Jerusalem after the war of sedition in 2 Samuel 19 and he swore that no one would be destroyed. These examples remind us that we should forgive anyone their most bitter wrongs and pardon private offenses for the sake of public tranquility. "), _c('i', [_vm._v("Commentary on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-310-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-310",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Evil Deeds Beget Evil Deeds.")]), _vm._v(" "), _c('i', [_vm._v("Thomas Adams:")]), _vm._v(" Saul was pious and began his reign with God, but the end of his reign was bloody. The further he went, the worse he was till even the night before he died, he consulted with a witch and ended his reign with the devil. "), _c('i', [_vm._v("Commentary on 2 Peter.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-309-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-309",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Superficially Infused.")]), _vm._v(" "), _c('i', [_vm._v("Andrew Willet:")]), _vm._v(" Saul here shows his piety, humanity and wisdom. He shows the first by not seeking private revenge, and the second by bearing with the people’s scruples and doubtfulness, since they had not yet received him as their king. Saul demonstrates his wisdom by seeking to win them with leniency. Such qualities are also seen in David (2 Sam 19:25) in pardoning Shimei and granting him his life. Saul gives this reason: “For today the Lord has worked salvation in Israel.” Saul would not have the joy of that day obscured and polluted with the shedding of blood. For, as God had shown the people mercy in sending them such a joyful deliverance, so he thought it fit that a similar mercy should be showed to others. Rabbi Ben Gerson thinks that Saul did not pardon these men but only delayed their punishment. But that is not likely. For until now Saul had proved himself to be an innocent man and a good prince. But afterward Saul forgot his own rule when he tried to kill Jonathon for unknowingly breaking Saul’s rash vow. . . . This mutability in Saul and his changeable nature—in falling from clemency to cruelty, from piety to profanity, from being a good governor to becoming a tyrant—shows that these virtues were not thoroughly grounded in him but were only superficially infused. "), _c('i', [_vm._v("Harmony on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-308-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-308",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])])])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "_idContainer025"
    }
  }, [_c('p', {
    staticClass: "PER_Top-extra-space"
  }, [_c('span', {
    staticClass: "com-rorohiko-pagestaker-style"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor2775"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2776"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2777"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2778"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2779"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2780"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2781"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2782"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2783"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2784"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2785"
    }
  })]), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page49",
      "title": "49"
    }
  })]), _vm._v(" "), _c('h2', {
    staticClass: "PER_ScriptureCenter",
    attrs: {
      "id": "sigil_toc_id_63"
    }
  }, [_c('span', {
    staticClass: "RH-marker"
  }, [_vm._v("12:1-25")]), _vm._v(" SAMUEL GIVES A FAREWELL ADDRESS")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("1")]), _c('i', [_vm._v("And Samuel said to all Israel, “Behold, I have obeyed your voice in all that you have said to me and have made a king over you.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("2")]), _c('i', [_vm._v("And now, behold, the king walks before you, and I am old and gray; and behold, my sons are with you. I have walked before you from my youth until this day.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("3")]), _c('i', [_vm._v("Here I am; testify against me before the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("and before his anointed. Whose ox have I taken? Or whose donkey have I taken? Or whom have I defrauded? Whom have I oppressed? Or from whose hand have I taken a bribe to blind my eyes with it? Testify against me")]), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("a")]), _vm._v(" "), _c('i', [_vm._v("and I will restore it to you.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("4")]), _c('i', [_vm._v("They said, “You have not defrauded us or oppressed us or taken anything from any man’s hand.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("5")]), _c('i', [_vm._v("And he said to them, “The")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("is witness against you, and his anointed is witness this day, that you have not found anything in my hand.” And they said, “He is witness.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("6")]), _c('i', [_vm._v("And Samuel said to the people, “The")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("is witness,")]), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("b")]), _vm._v(" "), _c('i', [_vm._v("who appointed Moses and Aaron and brought your fathers up out of the land of Egypt.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("7")]), _c('i', [_vm._v("Now therefore stand still that I may plead with you before the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("concerning all the righteous deeds of the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("that he performed for you and for your fathers.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("8")]), _c('i', [_vm._v("When Jacob went into Egypt, and the Egyptians oppressed them,")]), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("c")]), _vm._v(" "), _c('i', [_vm._v("then your fathers cried out to the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("and the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("sent Moses and Aaron, who brought your fathers out of Egypt and made them dwell in this place.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("9")]), _c('i', [_vm._v("But they forgot the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("their God. And he sold them into the hand of Sisera, commander of the army of Hazor,")]), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("d")]), _vm._v(" "), _c('i', [_vm._v("and into the hand of the Philistines, and into the hand of the king of Moab. And they fought against them.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("10")]), _c('i', [_vm._v("And they cried out to the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("and said, ‘We have sinned, because we have forsaken the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("and have served the Baals and the Ashtaroth. But now deliver us out of the hand of our enemies, that we may serve you.’")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("11")]), _c('i', [_vm._v("And the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("sent Jerubbaal and Barak")]), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("e")]), _vm._v(" "), _c('i', [_vm._v("and Jephthah and Samuel and delivered you out of the hand of your enemies on every side, and you lived in safety.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("12")]), _c('i', [_vm._v("And when you saw that Nahash the king of the Ammonites came against you, you said to me, ‘No, but a king shall reign over us,’ when the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("your God was your king.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("13")]), _c('i', [_vm._v("And now behold the king whom you have chosen, for whom you have asked; behold, the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("has set a king over you.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("14")]), _c('i', [_vm._v("If you will fear the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("and serve him and obey his voice and not rebel against the commandment of the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _c('i', [_vm._v(", and if both you and the king who reigns over you will follow the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("your God, it will be well.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("15")]), _c('i', [_vm._v("But if you will not obey the voice of the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _c('i', [_vm._v(", but rebel against the commandment of the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _c('i', [_vm._v(", then the hand of the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("will be against you and your king.")]), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("f")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("16")]), _c('i', [_vm._v("Now therefore stand still and see this great thing that the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("will do before your eyes.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("17")]), _c('i', [_vm._v("Is it not wheat harvest today? I will call upon the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _c('i', [_vm._v(", that he may send thunder and rain. And you shall know and see that your wickedness is great, which you have done in the sight of the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _c('i', [_vm._v(", in asking for yourselves a king.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("18")]), _c('i', [_vm._v("So Samuel called upon the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _c('i', [_vm._v(", and the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("sent thunder and rain that day, and all the people greatly feared the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("and Samuel.")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("19")]), _c('i', [_vm._v("And all the people said to Samuel, “Pray for your servants to the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("your God, that we may not die, for we have added to all our sins this evil, to ask for ourselves a king.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("20")]), _c('i', [_vm._v("And Samuel said to the people, “Do not be afraid; you have done all this evil. Yet do not turn aside from following the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _c('i', [_vm._v(", but serve the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("with all your heart.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("21")]), _c('i', [_vm._v("And do not turn aside after empty things that cannot profit or deliver, for they are empty.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("22")]), _c('i', [_vm._v("For the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("will not forsake his people, for his great name’s sake, because it has pleased the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("to make you a people for himself.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("23")]), _c('i', [_vm._v("Moreover, as for me, far be it from me that I should sin against the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("by ceasing to pray for you, and I will instruct you in the good and the right way.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("24")]), _c('i', [_vm._v("Only fear the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("and serve him faithfully with all your heart. For consider what great things he has done for you.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("25")]), _c('i', [_vm._v("But if you still do wickedly, you shall be swept away, both you and your king.”")])]), _vm._v(" "), _c('p', {
    staticClass: "small"
  }, [_c('b', [_vm._v("a")]), _vm._v(" Septuagint; Hebrew lacks "), _c('i', [_vm._v("Testify against me")]), _vm._v(" "), _c('b', [_vm._v("b")]), _vm._v(" Septuagint; Hebrew lacks "), _c('i', [_vm._v("is witness")]), _vm._v(" "), _c('b', [_vm._v("c")]), _vm._v(" Septuagint; Hebrew lacks "), _c('i', [_vm._v("and the Egyptians oppressed them")]), _vm._v(" "), _c('b', [_vm._v("d")]), _vm._v(" Septuagint "), _c('i', [_vm._v("the army of Jabin king of Hazor")]), _vm._v(" "), _c('b', [_vm._v("e")]), _vm._v(" Septuagint, Syriac; Hebrew "), _c('i', [_vm._v("Bedan")]), _vm._v(" "), _c('b', [_vm._v("f")]), _vm._v(" Septuagint; Hebrew "), _c('i', [_vm._v("fathers"), _c('br'), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('span', {
    staticClass: "com-rorohiko-pagestaker-style"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor2786"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2787"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2788"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2789"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2790"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2791"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2792"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2793"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2794"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2795"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2796"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2797"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2798"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2799"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2800"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2801"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2802"
    }
  })]), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page50",
      "title": "50"
    }
  }), _c('b', [_vm._v("Overview:")]), _vm._v(" The interpreters here recognize the godly leadership of Samuel over the people of Israel but see different themes within that larger unity. In terms of the speech Samuel gives, some regard it as a sermon that aims to bring about conversion, while other commentators focus on issues related to integrity or the duties of government officials. The reformers interpret the violent weather that accompanied Samuel’s speech as divine proof of God’s displeasure at the people’s request for a king. Like the biblical authors themselves, the reformers readily adduce God’s finger in physical occurrences such as weather. Samuel is not only a judge of the people but also their priest and mediator; the reformers emphasize the burden he carries as the people’s priest to pray for the people.")]), _vm._v(" "), _c('h5', {
    attrs: {
      "id": "sigil_toc_id_64"
    }
  }, [_c('b', [_vm._v("12:1-15")]), _vm._v(" "), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("One’s Clear Conscience and Good Leadership")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Samuel Conquers Hardened Hearts.")]), _vm._v(" "), _c('i', [_vm._v("Johannes Bugenhagen:")]), _vm._v(" Because the people were often reminded by God’s Word that they had sinned by asking for a king and by not wanting to acknowledge sins, Samuel confronted their sins with this biting address about God’s clearly extensive works; he does by retelling the whole story in only a few words. . . . By telling this history, Samuel declares that God had ruled the people to this point and that the people had confidently lived under God. The prophets had already promised this grace to all who believe in Christ, so that they might have confidence in spirit. That means they might have an untroubled conscience before God and have the peace of God in their hearts through the one reigning there, as in Jeremiah 23 and Isaiah 32. . . . Samuel showed how for so long God had been a king and continuously raised up good leaders in those days. He did this so that the people would acknowledge what they had done. And by a clear miracle of God, Samuel conquered their hardened hearts. He led them to confess the sin, and they judged his wisdom to be real, useful, necessary and salutary. "), _c('i', [_vm._v("Commentary on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-307-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-307",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("The Glorious Testimony of a Good Conscience.")]), _vm._v(" "), _c('i', [_vm._v("Viktorin Strigel:")]), _vm._v(" The approval of a good conscience and the testimony of others to the honest fact of that judgment are truly glorious things. But much is meant by the true approval of our consciences. For when the conscience judges truly, it recognizes its infirmities, fears God and also faithfully obeys God’s call. It then carries the one who is called not by personal striving but by recognizing oneself as being supported by God. Samuel glories in this, that he has the true testimony of conscience. He knows that he did not steal leadership but obeyed the call. He did not mix up personal gain with the happy burden of having authority from God. This glory, that is, this good testimony of the conscience, is rightly desired, because God wants us to live with a good conscience. "), _c('i', [_vm._v("Commentary on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-306-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-306",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Samuel and Moses’ Example.")]), _vm._v(" "), _c('i', [_vm._v("Johannes Aepinus:")]), _vm._v(" These two godly men, Moses and Samuel, teach us by their example that magistrates ought not to take or receive any manner of gifts from people who stand before them in judgment. Their example also teaches us that magistrates are bound to obey the precepts and commandments of God without any manner of denial or grudge. "), _c('i', [_vm._v("Exposition on Psalm 15.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-305-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-305",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Who Samuel Meant for His Anointed.")]), _vm._v(" "), _c('i', [_vm._v("Andrew Willet:")]), _vm._v(" Some think that under the type of Saul the anointed king, Samuel understands the Messiah, the anointed of God, whom the Lord had appointed to be judge of the world and before whom we must give account of all our doings. But it is evident that Samuel means something different. Verse 5 states, “His anointed is witness this day.” Samuel’s use of “this day” refers to Saul, in whose hearing he made this statement. In the same sense, David later calls Saul the Lord’s anointed (1 Sam 24:10). Now Samuel makes special mention of Saul in two regards. First, in respect of himself, "), _c('a', {
    attrs: {
      "id": "_idTextAnchor2803"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2804"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2805"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2806"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2807"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2808"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2809"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2810"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2811"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2812"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2813"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2814"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2815"
    }
  }), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page51",
      "title": "51"
    }
  }), _vm._v("he provides Saul a pattern on how to govern the people uprightly and justly without oppression. Second, in respect of the people, that they might see what difference there was (as they latter discovered) between the upright government that they had enjoyed under their judges, and the hard service they would feel under some of their kings—as Samuel had foretold them before. Finally, Samuel also means to preserve his own name, which is lawful to preserve, lest in time the people wrongly accuse him and speak ill of him after he is gone. "), _c('i', [_vm._v("Harmony on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-304-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-304",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])])])])]), _vm._v(" "), _c('h5', {
    attrs: {
      "id": "sigil_toc_id_65"
    }
  }, [_c('b', [_vm._v("12:16-18")]), _vm._v(" "), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("God and Thunder")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("The Lord Sent Thunder and Rain.")]), _vm._v(" "), _c('i', [_vm._v("Viktorin Strigel:")]), _vm._v(" This thunder and rain is like the terrifying crashes that accompanied the giving of the law on Mount Sinai. Thus the gathering, where Samuel was exhorting the people to repent, was confirmed and sealed by a divine sign. For the gathering of repentant people in the church is not an empty sound, but a sound that strikes the heart with a sense of God’s wrath and prepares it to accept the seed of the gospel. "), _c('i', [_vm._v("Commentary on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-303-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-303",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Why Samuel Called for Thunder.")]), _vm._v(" "), _c('i', [_vm._v("Andrew Willet:")]), _vm._v(" Here the Lord showed his power. And the people saw their foolishness in not being content with having such a mighty God for their protector who could fight for them with thunder and rain against their enemies, as he did for Israel against the host of Pharaoh and against the Philistines. And besides, it appeared that they had little reason to be wary of Samuel’s government, who by prayer could fetch down rain and thunder from heaven. In these two signs the Lord showed his mercy and judgment: The rain is, for the most part, a sign of his mercy, while the thunder and lightning are signs of his judgment. And as the rain mitigates the heat and the raging of the lightning . . . so the Lord’s judgments are tempered with mercy. "), _c('i', [_vm._v("Harmony on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-302-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-302",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])])])])]), _vm._v(" "), _c('h5', {
    attrs: {
      "id": "sigil_toc_id_66"
    }
  }, [_c('b', [_vm._v("12:19-25")]), _vm._v(" "), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("Samuel as Priest and Intercessor")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("The Duties of a Priest.")]), _vm._v(" "), _c('i', [_vm._v("Martin Luther:")]), _vm._v(" The duty of a priest is twofold: in the first place, to turn to God and pray for himself and for his people; in the second place, to turn from God to people by means of doctrine and the Word. Thus Samuel states in 1 Samuel 12:23: “Far be it from me not to pray for you and not to lead you to the good and the right way.” He acknowledges that this is essential to his office. "), _c('i', [_vm._v("Lectures on Genesis.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-301-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-301",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Gospel Follows Confession.")]), _vm._v(" "), _c('i', [_vm._v("Johannes Bugenhagen:")]), _vm._v(" “Do not be afraid.” The law was proclaimed up to this point. Here now the gospel follows the recognition of sin. Now the triumphant Samuel does not cease to pray or instruct those who are in the office of priest. This is for “his great name’s sake.” God does not bless us on account of our merits or demerits, but on account of two things Scripture insists upon: mercy and truth. "), _c('i', [_vm._v("Commentary on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-300-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-300",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Praying for the Church.")]), _vm._v(" "), _c('i', [_vm._v("Viktorin Strigel:")]), _vm._v(" The office of priest contains two main roles. The first is to teach. The second is to pray for the church. Samuel shows himself to have been most faithful in each of the two. In the same way, all pious people are priests, whether—according to their calling—they are teaching in the temple, in a school or in their homes. And they pray for the church, which is not only a place of speaking or Scriptures but a place where many great prayers are boldly offered. "), _c('i', [_vm._v("Commentary on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-299-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-299",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Continual Prayer.")]), _vm._v(" "), _c('i', [_vm._v("John Davenant:")]), _vm._v(" Persistence in prayer is commanded in Scripture: “We ought always to pray and not to lose heart,” "), _c('a', {
    attrs: {
      "id": "_idTextAnchor2816"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2817"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2818"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2819"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2820"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2821"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2822"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2823"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2824"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2825"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2826"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2827"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2828"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2829"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2830"
    }
  }), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page52",
      "title": "52"
    }
  }), _vm._v("“pray without ceasing” and “The prayer of a righteous person has great power as it is working.” But it may be said: How is it possible that Paul should never cease from prayer, when the weakness of human nature will not sustain continual praying? Indeed, some who have feigned to be part of the church have made constant prayer the pretext of indolence and sluggishness, and are reckoned among heretics in Theodoret and Augustine. I answer: We are said not to cease from prayer or not to leave off praying for anything when we have a fixed desire of that thing in our heart. As Augustine says regarding Psalm 37: “Your desire is your prayer; if there is a continual desire, there is continual prayer.” Second, we are said not to faint, or not to cease from praying, when we exercise it in its proper time and place. For it is idleness in a person, and he ceases from his work when he does not perform what he can and ought to do. In either respect, therefore, Paul said truly, “We have not ceased to pray for you.” For there was both a perpetual desire in his mind (at least as to the habit) of promoting their good; and that also, as much as in him lay, he did promote by his prayers as often as opportunity of praying offered itself to him. Observe, then, not only is the duty of the pastor to teach his flock and to commend them to God in public prayers, but also in his private prayer he ought never to be unmindful of the people committed to his care. Thus Samuel was actuated toward the people of God, “Moreover, as for me, far be it from me that I should sin against the Lord by ceasing to pray for you.” "), _c('i', [_vm._v("Exposition of Colossians.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-298-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-298",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Praying Without Ceasing.")]), _vm._v(" "), _c('i', [_vm._v("John Dod:")]), _vm._v(" God commands us to pray one for another. Now if those who are not connected to us in any way are to be recommended to God in our prayers, how much more so those whom God has more specially united to us either by nature or by duty and service! Indeed, Christ Jesus directly commands us to pray for our enemies. And if that is a bound duty, how much more is it to pray for our friends, especially if they also are God’s friends? For by our prayers they may be helped a great deal and endangered without them. The prophet Samuel understood that this was a duty when he accounted the neglect of it to be a sin against God. . . . For when the people were frightened and humbled, both by the words of Samuel and by the miraculous work of God in sending extraordinary thunder and rain in the time of the wheat harvest, they came to Samuel saying: “Pray for your servants to the Lord your God, that we might not die.” And his answer was, “ . . . as for me, far be it from me that I should sin against the Lord by ceasing to pray for you.” "), _c('i', [_vm._v("The Fourth Sermon on the Lord’s Supper.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-297-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-297",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])])])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "_idContainer026"
    }
  }, [_c('p', {
    staticClass: "PER_Top-extra-space"
  }, [_c('span', {
    staticClass: "com-rorohiko-pagestaker-style"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor2831"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2832"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2833"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2834"
    }
  })]), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page53",
      "title": "53"
    }
  })]), _vm._v(" "), _c('h2', {
    staticClass: "PER_ScriptureCenter",
    attrs: {
      "id": "sigil_toc_id_67"
    }
  }, [_c('span', {
    staticClass: "RH-marker"
  }, [_vm._v("13:1–14:52")]), _vm._v(" SAUL GOES TO BATTLE AGAINST THE PHILISTINES")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("1")]), _c('i', [_vm._v("Saul lived for one year and then became king, and when he had reigned for two years over Israel,")]), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("a")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("2")]), _c('i', [_vm._v("Saul chose three thousand men of Israel. Two thousand were with Saul in Michmash and the hill country of Bethel, and a thousand were with Jonathan in Gibeah of Benjamin. The rest of the people he sent home, every man to his tent.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("3")]), _c('i', [_vm._v("Jonathan defeated the garrison of the Philistines that was at Geba, and the Philistines heard of it. And Saul blew the trumpet throughout all the land, saying, “Let the Hebrews hear.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("4")]), _c('i', [_vm._v("And all Israel heard it said that Saul had defeated the garrison of the Philistines, and also that Israel had become a stench to the Philistines. And the people were called out to join Saul at Gilgal.")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("5")]), _c('i', [_vm._v("And the Philistines mustered to fight with Israel, thirty thousand chariots and six thousand horsemen and troops like the sand on the seashore in multitude. They came up and encamped in Michmash, to the east of Beth-aven.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("6")]), _c('i', [_vm._v("When the men of Israel saw that they were in trouble (for the people were hard pressed), the people hid themselves in caves and in holes and in rocks and in tombs and in cisterns,")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("7")]), _c('i', [_vm._v("and some Hebrews crossed the fords of the Jordan to the land of Gad and Gilead. Saul was still at Gilgal, and all the people followed him trembling.")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("8")]), _c('i', [_vm._v("He waited seven days, the time appointed by Samuel. But Samuel did not come to Gilgal, and the people were scattering from him.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("9")]), _c('i', [_vm._v("So Saul said, “Bring the burnt offering here to me, and the peace offerings.” And he offered the burnt offering.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("10")]), _c('i', [_vm._v("As soon as he had finished offering the burnt offering, behold, Samuel came. And Saul went out to meet him and greet him.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("11")]), _c('i', [_vm._v("Samuel said, “What have you done?” And Saul said, “When I saw that the people were scattering from me, and that you did not come within the days appointed, and that the Philistines had mustered at Michmash,")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("12")]), _c('i', [_vm._v("I said, ‘Now the Philistines will come down against me at Gilgal, and I have not sought the favor of the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _c('i', [_vm._v(".’ So I forced myself, and offered the burnt offering.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("13")]), _c('i', [_vm._v("And Samuel said to Saul, “You have done foolishly. You have not kept the command of the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("your God, with which he commanded you. For then the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("would have established your kingdom over Israel forever.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("14")]), _c('i', [_vm._v("But now your kingdom shall not continue. The")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("has sought out a man after his own heart, and the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("has commanded him to be prince")]), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("b")]), _vm._v(" "), _c('i', [_vm._v("over his people, because you have not kept what the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("commanded you.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("15")]), _c('i', [_vm._v("And Samuel arose and went up from Gilgal. The rest of the people went up after Saul to meet the army; they went up from Gilgal")]), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("c")]), _vm._v(" "), _c('i', [_vm._v("to Gibeah of Benjamin.")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('i', [_vm._v("And Saul numbered the people who were present with him, about six hundred men.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("16")]), _c('i', [_vm._v("And Saul and Jonathan his son and the people who were present with them stayed in Geba of Benjamin, but the Philistines encamped in Michmash.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("17")]), _c('i', [_vm._v("And raiders came out of the camp of the Philistines in three companies. One company turned toward Ophrah, to the land of Shual;")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("18")]), _c('i', [_vm._v("another company turned toward Beth-horon; and another company turned toward the border that looks down on the Valley of Zeboim toward the wilderness.")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("19")]), _c('i', [_vm._v("Now there was no blacksmith to be found throughout all the land of Israel, for the Philistines said, “Lest the Hebrews make themselves swords or spears.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("20")]), _c('i', [_vm._v("But every one of the Israelites went down to the Philistines to sharpen his plowshare, his mattock, his axe, or his sickle,")]), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("d")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("21")]), _c('i', [_vm._v("and the charge was two-thirds of a shekel")]), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("e")]), _vm._v(" "), _c('i', [_vm._v("for the plowshares and for the mattocks, and a third of a shekel")]), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("f")]), _vm._v(" "), _c('i', [_vm._v("for sharpening the axes and for setting the goads.")]), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("g")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("22")]), _c('i', [_vm._v("So on the day of the battle there was neither sword nor spear found in the hand of any of the people with Saul and Jonathan, but Saul and Jonathan his son had them.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("23")]), _c('i', [_vm._v("And the garrison of the Philistines went out to the pass of Michmash.")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    staticClass: "drop-cap"
  }, [_vm._v("14")]), _vm._v(" "), _c('i', [_vm._v("One day Jonathan the son of Saul said to the young man who carried his armor, “Come, let us go over to the Philistine garrison on the other side.” But he did not tell his father.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("2")]), _c('i', [_vm._v("Saul was staying in the outskirts of Gibeah in the pomegranate cave")]), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("h")]), _vm._v(" "), _c('i', [_vm._v("at Migron. The people who were with him were about six "), _c('a', {
    attrs: {
      "id": "_idTextAnchor2835"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2836"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2837"
    }
  })]), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page54",
      "title": "54"
    }
  }), _c('i', [_vm._v("hundred men,")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("3")]), _c('i', [_vm._v("including Ahijah the son of Ahitub, Ichabod’s brother, son of Phinehas, son of Eli, the priest of the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("in Shiloh, wearing an ephod. And the people did not know that Jonathan had gone.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("4")]), _c('i', [_vm._v("Within the passes, by which Jonathan sought to go over to the Philistine garrison, there was a rocky crag on the one side and a rocky crag on the other side. The name of the one was Bozez, and the name of the other Seneh.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("5")]), _c('i', [_vm._v("The one crag rose on the north in front of Michmash, and the other on the south in front of Geba.")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("6")]), _c('i', [_vm._v("Jonathan said to the young man who carried his armor, “Come, let us go over to the garrison of these uncircumcised. It may be that the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("will work for us, for nothing can hinder the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("from saving by many or by few.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("7")]), _c('i', [_vm._v("And his armor-bearer said to him, “Do all that is in your heart. Do as you wish.")]), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("i")]), _vm._v(" "), _c('i', [_vm._v("Behold, I am with you heart and soul.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("8")]), _c('i', [_vm._v("Then Jonathan said, “Behold, we will cross over to the men, and we will show ourselves to them.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("9")]), _c('i', [_vm._v("If they say to us, ‘Wait until we come to you,’ then we will stand still in our place, and we will not go up to them.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("10")]), _c('i', [_vm._v("But if they say, ‘Come up to us,’ then we will go up, for the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("has given them into our hand. And this shall be the sign to us.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("11")]), _c('i', [_vm._v("So both of them showed themselves to the garrison of the Philistines. And the Philistines said, “Look, Hebrews are coming out of the holes where they have hidden themselves.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("12")]), _c('i', [_vm._v("And the men of the garrison hailed Jonathan and his armor-bearer and said, “Come up to us, and we will show you a thing.” And Jonathan said to his armor-bearer, “Come up after me, for the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("has given them into the hand of Israel.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("13")]), _c('i', [_vm._v("Then Jonathan climbed up on his hands and feet, and his armor-bearer after him. And they fell before Jonathan, and his armor-bearer killed them after him.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("14")]), _c('i', [_vm._v("And that first strike, which Jonathan and his armor-bearer made, killed about twenty men within as it were half a furrow’s length in an acre")]), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("j")]), _vm._v(" "), _c('i', [_vm._v("of land.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("15")]), _c('i', [_vm._v("And there was a panic in the camp, in the field, and among all the people. The garrison and even the raiders trembled, the earth quaked, and it became a very great panic.")]), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("k")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("16")]), _c('i', [_vm._v("And the watchmen of Saul in Gibeah of Benjamin looked, and behold, the multitude was dispersing here and there.")]), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("l")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("17")]), _c('i', [_vm._v("Then Saul said to the people who were with him, “Count and see who has gone from us.” And when they had counted, behold, Jonathan and his armor-bearer were not there.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("18")]), _c('i', [_vm._v("So Saul said to Ahijah, “Bring the ark of God here.” For the ark of God went at that time with the people")]), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("m")]), _vm._v(" "), _c('i', [_vm._v("of Israel.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("19")]), _c('i', [_vm._v("Now while Saul was talking to the priest, the tumult in the camp of the Philistines increased more and more. So Saul said to the priest, “Withdraw your hand.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("20")]), _c('i', [_vm._v("Then Saul and all the people who were with him rallied and went into the battle. And behold, every Philistine’s sword was against his fellow, and there was very great confusion.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("21")]), _c('i', [_vm._v("Now the Hebrews who had been with the Philistines before that time and who had gone up with them into the camp, even they also turned to be with the Israelites who were with Saul and Jonathan.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("22")]), _c('i', [_vm._v("Likewise, when all the men of Israel who had hidden themselves in the hill country of Ephraim heard that the Philistines were fleeing, they too followed hard after them in the battle.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("23")]), _c('i', [_vm._v("So the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("saved Israel that day. And the battle passed beyond Beth-aven.")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("24")]), _c('i', [_vm._v("And the men of Israel had been hard pressed that day, so Saul had laid an oath on the people, saying, “Cursed be the man who eats food until it is evening and I am avenged on my enemies.” So none of the people had tasted food.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("25")]), _c('i', [_vm._v("Now when all the people")]), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("n")]), _vm._v(" "), _c('i', [_vm._v("came to the forest, behold, there was honey on the ground.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("26")]), _c('i', [_vm._v("And when the people entered the forest, behold, the honey was dropping, but no one put his hand to his mouth, for the people feared the oath.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("27")]), _c('i', [_vm._v("But Jonathan had not heard his father charge the people with the oath,so he put out the tip of the staff that was in his hand and dipped it in the honeycomb and put his hand to his mouth, and his eyes became bright.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("28")]), _c('i', [_vm._v("Then one of the people said, “Your father strictly charged the people with an oath, saying, ‘Cursed be the man who eats food this day.’” And the people were faint.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("29")]), _c('i', [_vm._v("Then Jonathan said, “My father has troubled the land. See how my eyes have become bright because I tasted a little of this honey.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("30")]), _c('i', [_vm._v("How much better if the people had eaten freely today of the spoil of their enemies that they found. For now the defeat among the Philistines has not been great.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("31")]), _c('i', [_vm._v("They struck down the Philistines that day from Michmash to Aijalon. And the people were very faint.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("32")]), _c('i', [_vm._v("The people pounced on the spoil and took sheep and oxen and calves and slaughtered them on the ground. "), _c('a', {
    attrs: {
      "id": "_idTextAnchor2838"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2839"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2840"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2841"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2842"
    }
  })]), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page55",
      "title": "55"
    }
  }), _c('i', [_vm._v("And the people ate them with the blood.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("33")]), _c('i', [_vm._v("Then they told Saul, “Behold, the people are sinning against the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("by eating with the blood.” And he said, “You have dealt treacherously; roll a great stone to me here.”")]), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("o")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("34")]), _c('i', [_vm._v("And Saul said, “Disperse yourselves among the people and say to them, ‘Let every man bring his ox or his sheep and slaughter them here and eat, and do not sin against the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("by eating with the blood.’” So every one of the people brought his ox with him that night and they slaughtered them there.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("35")]), _c('i', [_vm._v("And Saul built an altar to the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _c('i', [_vm._v("; it was the first altar that he built to the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _c('i', [_vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("36")]), _c('i', [_vm._v("Then Saul said, “Let us go down after the Philistines by night and plunder them until the morning light; let us not leave a man of them.” And they said, “Do whatever seems good to you.” But the priest said, “Let us draw near to God here.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("37")]), _c('i', [_vm._v("And Saul inquired of God, “Shall I go down after the Philistines? Will you give them into the hand of Israel?” But he did not answer him that day.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("38")]), _c('i', [_vm._v("And Saul said, “Come here, all you leaders of the people, and know and see how this sin has arisen today.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("39")]), _c('i', [_vm._v("For as the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("lives who saves Israel, though it be in Jonathan my son, he shall surely die.” But there was not a man among all the people who answered him.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("40")]), _c('i', [_vm._v("Then he said to all Israel, “You shall be on one side, and I and Jonathan my son will be on the other side.” And the people said to Saul, “Do what seems good to you.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("41")]), _c('i', [_vm._v("Therefore Saul said, “O")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("God of Israel, why have you not answered your servant this day? If this guilt is in me or in Jonathan my son, O")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _c('i', [_vm._v(", God of Israel, give Urim. But if this guilt is in your people Israel, give Thummim.”")]), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("p")]), _vm._v(" "), _c('i', [_vm._v("And Jonathan and Saul were taken, but the people escaped.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("42")]), _c('i', [_vm._v("Then Saul said, “Cast the lot between me and my son Jonathan.” And Jonathan was taken.")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("43")]), _c('i', [_vm._v("Then Saul said to Jonathan, “Tell me what you have done.” And Jonathan told him, “I tasted a little honey with the tip of the staff that was in my hand. Here I am; I will die.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("44")]), _c('i', [_vm._v("And Saul said, “God do so to me and more also; you shall surely die, Jonathan.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("45")]), _c('i', [_vm._v("Then the people said to Saul, “Shall Jonathan die, who has worked this great salvation in Israel? Far from it! As the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("lives, there shall not one hair of his head fall to the ground, for he has worked with God this day.” So the people ransomed Jonathan, so that he did not die.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("46")]), _c('i', [_vm._v("Then Saul went up from pursuing the Philistines, and the Philistines went to their own place.")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("47")]), _c('i', [_vm._v("When Saul had taken the kingship over Israel, he fought against all his enemies on every side, against Moab, against the Ammonites, against Edom, against the kings of Zobah, and against the Philistines. Wherever he turned he routed them.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("48")]), _c('i', [_vm._v("And he did valiantly and struck the Amalekites and delivered Israel out of the hands of those who plundered them.")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("49")]), _c('i', [_vm._v("Now the sons of Saul were Jonathan, Ishvi, and Malchi-shua. And the names of his two daughters were these: the name of the firstborn was Merab, and the name of the younger Michal.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("50")]), _c('i', [_vm._v("And the name of Saul’s wife was Ahinoam the daughter of Ahimaaz. And the name of the commander of his army was Abner the son of Ner, Saul’s uncle.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("51")]), _c('i', [_vm._v("Kish was the father of Saul, and Ner the father of Abner was the son of Abiel.")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("52")]), _c('i', [_vm._v("There was hard fighting against the Philistines all the days of Saul. And when Saul saw any strong man, or any valiant man, he attached him to himself.")])]), _vm._v(" "), _c('p', {
    staticClass: "small"
  }, [_c('b', [_vm._v("a")]), _vm._v(" Hebrew "), _c('i', [_vm._v("Saul was one year old when he became king, and he reigned two years over Israel")]), _vm._v(" (see 1 Samuel 10:6); some Greek manuscripts give Saul’s age when he began to reign as thirty years "), _c('b', [_vm._v("b")]), _vm._v(" Or "), _c('i', [_vm._v("leader")]), _vm._v(" "), _c('b', [_vm._v("c")]), _vm._v(" Septuagint; Hebrew lacks "), _c('i', [_vm._v("The rest of the people… from Gilgal")]), _vm._v(" "), _c('b', [_vm._v("d")]), _vm._v(" Septuagint; Hebrew "), _c('i', [_vm._v("plowshare")]), _vm._v(" "), _c('b', [_vm._v("e")]), _vm._v(" Hebrew "), _c('i', [_vm._v("was a pim")]), _vm._v(" "), _c('b', [_vm._v("f")]), _vm._v(" A "), _c('i', [_vm._v("shekel")]), _vm._v(" was about 2/5 ounce or 11 grams "), _c('b', [_vm._v("g")]), _vm._v(" The meaning of the Hebrew verse is uncertain "), _c('b', [_vm._v("h")]), _vm._v(" Or "), _c('i', [_vm._v("under the pomegranate")]), _vm._v(" [tree] "), _c('b', [_vm._v("i")]), _vm._v(" Septuagint "), _c('i', [_vm._v("Do all that your mind inclines to")]), _vm._v(" "), _c('b', [_vm._v("j")]), _vm._v(" Hebrew "), _c('i', [_vm._v("a yoke")]), _vm._v(" "), _c('b', [_vm._v("k")]), _vm._v(" Or "), _c('i', [_vm._v("became a panic from God")]), _vm._v(" "), _c('b', [_vm._v("l")]), _vm._v(" Septuagint; Hebrew "), _c('i', [_vm._v("they went here and there")]), _vm._v(" "), _c('b', [_vm._v("m")]), _vm._v(" Hebrew; Septuagint "), _c('i', [_vm._v("“Bring the ephod.” For at that time he wore the ephod before the people")]), _vm._v(" "), _c('b', [_vm._v("n")]), _vm._v(" Hebrew "), _c('i', [_vm._v("land")]), _vm._v(" "), _c('b', [_vm._v("o")]), _vm._v(" Septuagint; Hebrew "), _c('i', [_vm._v("this day")]), _vm._v(" "), _c('b', [_vm._v("p")]), _vm._v(" Vulgate and Septuagint; Hebrew "), _c('i', [_vm._v("Therefore Saul said to the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _c('i', [_vm._v(", the God of Israel, “Give Thummim.”"), _c('br'), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Overview:")]), _vm._v(" The reformers see the beginnings of Saul’s eventual downfall in this section of the biblical narrative. They do not agree, however, as to the exact cause, and they offer various reasons why Saul does not prove to be a godly king. While most commentators focus on Saul’s shortcomings, some "), _c('a', {
    attrs: {
      "id": "_idTextAnchor2843"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2844"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2845"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2846"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2847"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2848"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2849"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2850"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2851"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2852"
    }
  }), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page56",
      "title": "56"
    }
  }), _vm._v("also apply lessons from his life to our own, exhorting us to become people who are sincere and without hypocrisy. Jonathan, however, is the real hero in this section. The reformers recognize the juxtaposition the biblical authors make between Jonathan and Saul. Sensitive to the misuse of vows before and during their time period in the Catholic Church, the reformers interpret Jonathan’s breaking of Saul’s vow as more an example of a rash decision on Saul’s part than a faulty action on Jonathan’s.")]), _vm._v(" "), _c('h5', {
    attrs: {
      "id": "sigil_toc_id_68"
    }
  }, [_c('b', [_vm._v("13:1-7")]), _vm._v(" "), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("The Beginning of Saul’s Kingdom")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("The Character Not the Chronology of Saul’s Reign.")]), _vm._v(" "), _c('i', [_vm._v("Cardinal Cajetan:")]), _vm._v(" According to the Hebrew the words are: “Saul, a one-year-old son, in his reign.”"), _c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-296-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-296",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])])]), _vm._v(" That is, according to the image of a one-year-old son Saul ruled innocently. Accordingly it describes the character of his reign and says nothing about the beginning of his reign.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("“And for two years he reigned over Israel.” Immediately the question concerning the truth of these words occurs. For it is evident that Saul waged so many wars, which are narrated below, thus witnessing to the fact that his reign included many more years. And the apostle Paul in Acts 13 clearly says that Saul reigned forty years. Although Josephus, at the end of book six of the "), _c('i', [_vm._v("Antiquities")]), _vm._v(", says that Saul reigned twenty years—eighteen while Samuel was alive and two after Samuel’s death. The solution is that in this passage the years of Saul’s reign are not calculated absolutely, but, as it was said before, the years are calculated by the character of his reign. "), _c('i', [_vm._v("Commentary on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-295-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-295",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Saul Is a Supreme Example of Self-Deception.")]), _vm._v(" "), _c('i', [_vm._v("Johannes Bugenhagen:")]), _vm._v(" Thus far we have seen the gifts of God in Saul, and no one would have any reason to suspect any evil of him. But a person’s heart is deep and inscrutable, even to himself. Real and unavoidable afflictions reveal this. Therefore what follows reveals Saul’s hypocrisy and impiety. He looks after himself, not trusting in God and becoming a person of blood against his neighbors. All who do this are hypocrites, imposing human judgments under the form of holiness to suit the occasion. We can see this all the way to Saul’s death. He is someone who rules and administers without faith. He has gifts from God but misuses them, which is to say, he does not have faith in God and does not fear God. You will not find anything in Saul’s story that smacks of faith in God. One sees nothing but sheer mistrust, thoughtlessness, hypocrisy, and ambition, even though the king should be the best in all things. You will not easily find another example that uncovers the hypocrisy of the human heart. "), _c('i', [_vm._v("Commentary on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-294-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-294",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Reign of Tyranny.")]), _vm._v(" "), _c('i', [_vm._v("Daniel Dyke:")]), _vm._v(" What a humble man was Saul before he was king, and in the first beginning of the kingdom! But afterward, being confirmed in his kingdom, what a tyrant did he prove to be? Therefore, it is said that Saul reigned but two years, because after the two first years, though he held the government still in his hands, his deceitful heart was discovered, and he no longer reigned but tyrannized. "), _c('i', [_vm._v("The Mystery of Self-Deceiving.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-293-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-293",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])])])])]), _vm._v(" "), _c('h5', {
    attrs: {
      "id": "sigil_toc_id_69"
    }
  }, [_c('b', [_vm._v("13:8-23")]), _vm._v(" "), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("Saul’s Unlawful Sacrifice")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Saul’s Temptation.")]), _vm._v(" "), _c('i', [_vm._v("Johannes Bugenhagen:")]), _vm._v(" Saul’s temptation is described. The people were scattering, and Saul did not expect Samuel to arrive. Mistrust disguised as necessity compelled Saul to sacrifice, against the word of God. Hypocrisy does not believe the word of God but takes refuge in works and despairs. And then even the attempt to placate God is itself a way of dishonoring God, as you will see in chapter 15. Anyone who fears the seeming necessity of the moment more than they fear the Lord always acts foolishly. Such "), _c('a', {
    attrs: {
      "id": "_idTextAnchor2853"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2854"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2855"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2856"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2857"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2858"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2859"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2860"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2861"
    }
  }), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page57",
      "title": "57"
    }
  }), _vm._v("are all the works and even worship of those who do not receive the word of God, “for whatever does not proceed from faith is sin.” For this reason, God rejects Saul because Saul had rejected God. But Saul does not see this judgment in the world, for he reigned among the people for forty years, as Paul says. "), _c('i', [_vm._v("Commentary on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-292-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-292",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Saul’s Reign Serves as a Warning.")]), _vm._v(" "), _c('i', [_vm._v("Heinrich Bullinger:")]), _vm._v(" Saul, the first king of Israel, was very fortunate and victorious as long as he followed the word of God in all things. However, once he gave place to his own good intentions, being rejected by God, he heard Samuel essentially announce to him: “You have refused and rejected the word of the Lord; therefore, the Lord has also rejected you from being king over Israel.” I will not explain here the amount of evil he was involved in from that time. For, as he himself was horribly agitated by an evil spirit, so he did not cease to agitate and torment his kingdom until he had brought them all into great danger when he and his soldiers were crudely taken down by the pagan nations, leaving behind an eternal and shameful legacy. "), _c('i', [_vm._v("Decades 3.1.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-291-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-291",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Where Saul Offended.")]), _vm._v(" "), _c('i', [_vm._v("Andrew Willet:")]), _vm._v(" Some think Saul’s sin at this time was distrust in God’s help and assistance, because the people fell away from him—as though the Lord could not save as well with few as with many. It is similar to the plight of Moses when he was not allowed to go into the land of Canaan because he doubted God’s power and did not believe him when he struck the rock. But there was another special sin with which Samuel charged Saul, namely, that he had broken the commandment of God. Or it may be thought that Saul had an evil opinion of Samuel—that Samuel failed in his promise and that he forgot the time he had appointed for Saul. . . . Some think Saul broke Samuel’s charge in that he did not stay for him a full seven days, but in the beginning of the seventh day he offered sacrifice. For as soon as he had made an end of sacrificing, Samuel came. But it seems that this was not the greatest matter: For whereas Saul exonerated himself by claiming that Samuel had not come at the day set, Samuel answered nothing and only charged him with the breach of God’s commandment. Therefore there were two parts of Samuel’s charges: first, that he should wait for Samuel for seven days; second, that he should attempt nothing before Samuel came: “Seven days you shall wait, until I come to you and show you what you shall do.” Saul offended more in the second than in the first. That is, he presumed of himself, without direction from the prophet Samuel, to command sacrifice to be offered—thinking that God would be pleased with the external act of sacrificing, which apparently was not made in faith or obedience. "), _c('i', [_vm._v("Harmony on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-290-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-290",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Taking Before Punishing.")]), _vm._v(" "), _c('i', [_vm._v("Lancelot Andrewes:")]), _vm._v(" Just as when Saul had lost his spirit the kingdom did not last long without him, so if our talents are once taken away, we may perceive that God will lay a punishment on our persons. If we fall from our first love . . . and do not use our talents to God’s glory, we may justly fear our persons. But as God first commanded Lot to go out of Sodom before he destroyed the city itself, so God will first take away the talent so that it will not perish; and afterward the person will be punished. "), _c('i', [_vm._v("Collection of Lectures.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-289-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-289",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Man of Sincerity.")]), _vm._v(" "), _c('i', [_vm._v("Daniel Dyke:")]), _vm._v(" The special hatred and antipathy that is in God against deceitfulness should be a strong motive for us to show sincerity. There can be no union between God and the hypocrites in regard to the great dissimilitude of disposition. God is single; he is not double. We are to be as David, a person according to God’s heart. The hypocrite is crooked, and God is straight. And how will you connect these "), _c('a', {
    attrs: {
      "id": "_idTextAnchor2862"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2863"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2864"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2865"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2866"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2867"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2868"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2869"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2870"
    }
  }), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page58",
      "title": "58"
    }
  }), _vm._v("together, and make something straight and crooked? How can there be friendship between those who are every way of contrary dispositions? But where there is likeness of manners, there easily will be hearts that are glued and riveted together. "), _c('i', [_vm._v("The Mystery of Self-Deceiving.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-288-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-288",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Cold Religion.")]), _vm._v(" "), _c('i', [_vm._v("John Calvin:")]), _vm._v(" Saul took the priest with him when he went to battle. . . . Although there was an outward appearance of religion, it was very coldly and grudgingly performed. We must realize that it takes far more than making a formal profession and merely declaring that we are God’s people and want to serve him. When we hear what was pronounced by the Spirit of God, it should encourage us to seek him voluntarily, and not in such a cold manner. If someone had asked all the people in the time of Saul, “Do you not want to seek God?” each one would have replied, “Yes, this is my intention.” But so what? God disdained their talk, and declared that they were despising and rejecting him, and in fact denying him. Why? Because they had no zeal and no pure and true affection for him. Let us therefore be careful not to seek God halfway. On the contrary, let us earnestly seek his face, driving ourselves forward as we realize that he is the mainspring of our whole life, on whom we must concentrate all our thoughts and study in order to be pleasing to him. "), _c('i', [_vm._v("Sermons on 2 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-287-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-287",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Fickle Faith.")]), _vm._v(" "), _c('i', [_vm._v("Johannes Bugenhagen:")]), _vm._v(" Seeing the Philistines routed, the rest of the Hebrews went to join up with the army. This is a sign of those people who come to the gospel while it is in full bloom but who leave under the cross. It is a sign of those who believe for a time but then fall away in the time of trial. "), _c('i', [_vm._v("Commentary on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-286-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-286",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Glorious Victories.")]), _vm._v(" "), _c('i', [_vm._v("Charles Drelincourt:")]), _vm._v(" And just as the servant of Jonathan, who was Saul’s son, dispatched and killed those whom his master had cast down, in the same way we need only pursue the glorious victories of the son of the King of kings, or rather, we need only gather up the pleasant fruits of his conquests. For this prince of life that has overcome death for us offers to overcome it also in us with the weapons with which he arms us. In short, to speak properly, there can be no death for those who are incorporated in Jesus Christ by a true and lively faith. For the one who lives and believes in him shall never die; and the one who believes in him, though he were dead, yet he shall live. "), _c('i', [_vm._v("Christian Defense Against the Fears of Death.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-285-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-285",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Of Jonathan’s Creeping up the Hill.")]), _vm._v(" "), _c('i', [_vm._v("Andrew Willet:")]), _vm._v(" Some believe that where it is said that Jonathan went up on his hands and feet, the meaning is that he went up with all his strength. However, this passage merely shows the manner of his climbing up: Because the place was steep, he was said to creep up it on all fours and to take hold with his hands and feet. He went up the hill with much patience rather than in haste. For he could not make great haste when going up so steep a rock. But it is further to be considered [that Jonathan and his armor-bearer climbed right up the Philistine garrison in plain sight]. This rare adventure and hard enterprise shows that God was with them and that he assisted them far beyond their own strength. Foreign histories highly commend Alexander’s taking of Aornos when he sent up his soldiers onto those steep rocks on their hands and feet. But more worthy is the memory of Jonathan who, with much less power than Alexander had, succeeded in a harder work and achieved a greater victory—since he had such confidence in his God, who intended nothing but victory from and praise for him. "), _c('i', [_vm._v("Harmony on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-284-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-284",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")])])])])]), _vm._v(" "), _c('h5', {
    attrs: {
      "id": "sigil_toc_id_70"
    }
  }, [_c('span', {
    staticClass: "com-rorohiko-pagestaker-style"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor2871"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2872"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2873"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2874"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2875"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2876"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2877"
    }
  })]), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page59",
      "title": "59"
    }
  }), _c('b', [_vm._v("14:1-52")]), _vm._v(" "), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("Saul’s Offense")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Saul Is Like Jephthah.")]), _vm._v(" "), _c('i', [_vm._v("Johannes Bugenhagen:")]), _vm._v(" Here you see hypocrisy even among those who reign and judge and who otherwise are supposed to be near to God and seek nothing but God’s glory. As proof, you have this example of a rash vow or oath, which was just like that of Jephthah. I wonder what good this vow was supposed to do, not only in itself but also inasmuch as it endangered all the people? Jonathan, full of faith, wondered the same thing when he reproved his father’s actions, saying, “My father has troubled the land,” etc. Because of this rashness, God immediately reproved Saul for this vow to strike down even his own innocent and holy child, in order to show that it was just as impious and destructive as that of rash Jephthah, who did not know that he was so painfully obligating himself to the Lord to sacrifice his daughter. The people were right to identify as an injustice the king’s rash vow to condemn the innocent. The same is true of all of our rash vows made without faith and in hypocrisy, when we (if such a thing were possible) offer our own souls to the devil in the name of God’s glory. "), _c('i', [_vm._v("Commentary on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-283-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-283",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Concerning Oaths.")]), _vm._v(" "), _c('i', [_vm._v("Andrew Willet:")]), _vm._v(" Jonathan is not to be considered the special offender at whom God should here shoot, as God, on a similar occasion, brought Achan’s sin to light (Judg 7). So neither is he to be altogether excused: For although it is a sin to make a rash oath and vow to begin with, it is also a fault to break such a rash oath. Yet it is a greater sin to keep it with greater inconvenience and hurt. And ignorance, though it qualifies the offense, does not altogether justify it. Ignorance excuses from so great a fault, but not from the entire fault. As the Preacher says, “It is better that you should not vow than that you should vow and not pay.”")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("We must therefore consent that Jonathan was somewhat faulty in breaking the oath, though ignorantly, because the lots fell out justly. Yet Saul was faultier in making it in the first place. For the Lord does not by this lot show who was most at fault, but only who it was that had broken the oath—which was the thing Saul earnestly requested. But though Jonathan was somewhat touched in this action, as his own heart misgives him—which the disposing of the lots and his own confession reveal—yet it was not God’s principal intention to uncover the offense of Jonathan as it was to lay open Saul’s hypocrisy, which damaged his own son, troubled the soldiers and hindered the victory. Yet it was also by this means that God would humble Jonathan, lest he become too puffed up with the joy of his victory. Finally, it must be considered that, as God by lot brought Jonathan to light and so into this danger, yet God also provided a means whereby Jonathan should escape it, namely, by the mediation of the people. "), _c('i', [_vm._v("Harmony on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-282-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-282",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Innocent and Faultless.")]), _vm._v(" "), _c('i', [_vm._v("The English Annotations:")]), _vm._v(" Jonathan really and truly was innocent and faultless, but not in Saul’s sense. But why is Jonathan taken by lot since he was innocent? First, some think that God acted in this way to show how severe he is in allowing any show of disobedience to princes. Second, to make children fear and avoid even the rash and causeless curses of parents, which out of God’s secret judgment are sometimes inflicted. Third, to punish Saul’s rash oath by bringing his dearest son into extreme danger. And finally, to discover Saul’s great hypocrisy, who scrupulously kept a rash and wicked oath but was not reluctant to kill his innocent son. "), _c('i', [_vm._v("Annotations on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-281-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-281",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")])])])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "_idContainer027"
    }
  }, [_c('p', {
    staticClass: "PER_Top-extra-space"
  }, [_c('span', {
    staticClass: "com-rorohiko-pagestaker-style"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor2878"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2879"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2880"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2881"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2882"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2883"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2884"
    }
  })]), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page60",
      "title": "60"
    }
  })]), _vm._v(" "), _c('h2', {
    staticClass: "PER_ScriptureCenter",
    attrs: {
      "id": "sigil_toc_id_71"
    }
  }, [_c('span', {
    staticClass: "RH-marker"
  }, [_vm._v("15:1-35")]), _vm._v(" THE REJECTION OF SAUL BY THE LORD")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("1")]), _c('i', [_vm._v("And Samuel said to Saul, “The")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("sent me to anoint you king over his people Israel; now therefore listen to the words of the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _c('i', [_vm._v(".")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("2")]), _c('i', [_vm._v("Thus says the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("of hosts, ‘I have noted what Amalek did to Israel in opposing them on the way when they came up out of Egypt.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("3")]), _c('i', [_vm._v("Now go and strike Amalek and devote to destruction")]), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("a")]), _vm._v(" "), _c('i', [_vm._v("all that they have. Do not spare them, but kill both man and woman, child and infant, ox and sheep, camel and donkey.’”")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("4")]), _c('i', [_vm._v("So Saul summoned the people and numbered them in Telaim, two hundred thousand men on foot, and ten thousand men of Judah.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("5")]), _c('i', [_vm._v("And Saul came to the city of Amalek and lay in wait in the valley.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("6")]), _c('i', [_vm._v("Then Saul said to the Kenites, “Go, depart; go down from among the Amalekites, lest I destroy you with them. For you showed kindness to all the people of Israel when they came up out of Egypt.” So the Kenites departed from among the Amalekites.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("7")]), _c('i', [_vm._v("And Saul defeated the Amalekites from Havilah as far as Shur, which is east of Egypt.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("8")]), _c('i', [_vm._v("And he took Agag the king of the Amalekites alive and devoted to destruction all the people with the edge of the sword.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("9")]), _c('i', [_vm._v("But Saul and the people spared Agag and the best of the sheep and of the oxen and of the fattened calves")]), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("b")]), _vm._v(" "), _c('i', [_vm._v("and the lambs, and all that was good, and would not utterly destroy them. All that was despised and worthless they devoted to destruction.")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("10")]), _c('i', [_vm._v("The word of the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("came to Samuel:")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("11")]), _c('i', [_vm._v("“I regret")]), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("c")]), _vm._v(" "), _c('i', [_vm._v("that I have made Saul king, for he has turned back from following me and has not performed my commandments.” And Samuel was angry, and he cried to the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("all night.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("12")]), _c('i', [_vm._v("And Samuel rose early to meet Saul in the morning. And it was told Samuel, “Saul came to Carmel, and behold, he set up a monument for himself and turned and passed on and went down to Gilgal.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("13")]), _c('i', [_vm._v("And Samuel came to Saul, and Saul said to him, “Blessed be you to the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _c('i', [_vm._v(". I have performed the commandment of the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _c('i', [_vm._v(".”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("14")]), _c('i', [_vm._v("And Samuel said, “What then is this bleating of the sheep in my ears and the lowing of the oxen that I hear?”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("15")]), _c('i', [_vm._v("Saul said, “They have brought them from the Amalekites, for the people spared the best of the sheep and of the oxen to sacrifice to the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("your God, and the rest we have devoted to destruction.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("16")]), _c('i', [_vm._v("Then Samuel said to Saul, “Stop! I will tell you what the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("said to me this night.” And he said to him, “Speak.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("17")]), _c('i', [_vm._v("And Samuel said, “Though you are little in your own eyes, are you not the head of the tribes of Israel? The")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("anointed you king over Israel.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("18")]), _c('i', [_vm._v("And the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("sent you on a mission and said, ‘Go, devote to destruction the sinners, the Amalekites, and fight against them until they are consumed.’")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("19")]), _c('i', [_vm._v("Why then did you not obey the voice of the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _c('i', [_vm._v("? Why did you pounce on the spoil and do what was evil in the sight of the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _c('i', [_vm._v("?”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("20")]), _c('i', [_vm._v("And Saul said to Samuel, “I have obeyed the voice of the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _c('i', [_vm._v(". I have gone on the mission on which the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("sent me. I have brought Agag the king of Amalek, and I have devoted the Amalekites to destruction.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("21")]), _c('i', [_vm._v("But the people took of the spoil, sheep and oxen, the best of the things devoted to destruction, to sacrifice to the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("your God in Gilgal.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("22")]), _c('i', [_vm._v("And Samuel said,")])]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "verse"
  }, [_c('i', [_vm._v("“Has the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("as great delight in burnt offerings and sacrifices,")])]), _vm._v(" "), _c('p', {
    staticClass: "verseindent"
  }, [_c('i', [_vm._v("as in obeying the voice of the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")]), _vm._v("?")])]), _vm._v(" "), _c('p', {
    staticClass: "verse"
  }, [_c('i', [_vm._v("Behold, to obey is better than sacrifice,")])]), _vm._v(" "), _c('p', {
    staticClass: "verseindent"
  }, [_c('i', [_vm._v("and to listen than the fat of rams.")])]), _vm._v(" "), _c('p', {
    staticClass: "verse"
  }, [_c('i', [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("23")])]), _c('i', [_vm._v("For rebellion is as the sin of divination,")])]), _vm._v(" "), _c('p', {
    staticClass: "verseindent"
  }, [_c('i', [_vm._v("and presumption is as iniquity and idolatry.")])]), _vm._v(" "), _c('p', {
    staticClass: "verse"
  }, [_c('i', [_vm._v("Because you have rejected the word of the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")]), _vm._v(",")])]), _vm._v(" "), _c('p', {
    staticClass: "verseindent"
  }, [_c('i', [_vm._v("he has also rejected you from being king.”")])])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("24")]), _c('i', [_vm._v("Saul said to Samuel, “I have sinned, for I have transgressed the commandment of the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("and your words, because I feared the people and obeyed their voice.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("25")]), _c('i', [_vm._v("Now therefore, please pardon my sin and return with me that I may bow before the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _c('i', [_vm._v(".”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("26")]), _c('i', [_vm._v("And Samuel said to Saul, “I will not return with you. For you have rejected the word of the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _c('i', [_vm._v(", and the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("has rejected you from being king over Israel.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("27")]), _c('i', [_vm._v("As Samuel turned to go away, Saul seized the skirt of his robe, and it tore.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("28")]), _c('i', [_vm._v("And Samuel said to him, “The")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("has torn the kingdom of Israel from you "), _c('a', {
    attrs: {
      "id": "_idTextAnchor2885"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2886"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2887"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2888"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2889"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2890"
    }
  })]), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page61",
      "title": "61"
    }
  }), _c('i', [_vm._v("this day and has given it to a neighbor of yours, who is better than you.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("29")]), _c('i', [_vm._v("And also the Glory of Israel will not lie or have regret, for he is not a man, that he should have regret.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("30")]), _c('i', [_vm._v("Then he said, “I have sinned; yet honor me now before the elders of my people and before Israel, and return with me, that I may bow before the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("your God.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("31")]), _c('i', [_vm._v("So Samuel turned back after Saul, and Saul bowed before the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _c('i', [_vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("32")]), _c('i', [_vm._v("Then Samuel said, “Bring here to me Agag the king of the Amalekites.” And Agag came to him cheerfully.")]), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("d")]), _vm._v(" "), _c('i', [_vm._v("Agag said, “Surely the bitterness of death is past.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("33")]), _c('i', [_vm._v("And Samuel said, “As your sword has made women childless, so shall your mother be childless among women.” And Samuel hacked Agag to pieces before the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("in Gilgal.")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("34")]), _c('i', [_vm._v("Then Samuel went to Ramah, and Saul went up to his house in Gibeah of Saul.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("35")]), _c('i', [_vm._v("And Samuel did not see Saul again until the day of his death, but Samuel grieved over Saul. And the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("regretted that he had made Saul king over Israel.")])]), _vm._v(" "), _c('p', {
    staticClass: "small"
  }, [_c('b', [_vm._v("a")]), _vm._v(" That is, set apart (devote) as an offering to the Lord (for destruction); also verses 8, 9, 15, 18, 20, 21 "), _c('b', [_vm._v("b")]), _vm._v(" The meaning of the Hebrew term is uncertain "), _c('b', [_vm._v("c")]), _vm._v(" See also verses 29, 35 "), _c('b', [_vm._v("d")]), _vm._v(" Or "), _c('i', [_vm._v("haltingly")]), _vm._v(" (compare Septuagint); the Hebrew is uncertain"), _c('br'), _vm._v(" "), _c('br')]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Overview:")]), _vm._v(" Focusing on Samuel’s rebuke of Saul, the reformers remind us that human reason can easily deceive us. Even though Saul thought he was acting mercifully toward Agag, the interpreters understand his actions differently. Divine obedience, they assert, takes precedence over everything else. Drawing a point of application from Saul’s lack of obedience, some of the reformers warn readers about the dangerous consequences of not mortifying the flesh, that is, of not constantly pruning the evil that lies hidden within all of us. They also applaud the pastoral spirit of Samuel toward Saul despite the latter’s wickedness. Finally, the commentators take great pains to clarify what it means for God to repent or regret an action.")]), _vm._v(" "), _c('h5', {
    attrs: {
      "id": "sigil_toc_id_72"
    }
  }, [_c('b', [_vm._v("15:1-8")]), _vm._v(" "), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("Saul’s Feigned Obedience")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Saul’s Would-Be Mercy.")]), _vm._v(" "), _c('i', [_vm._v("Menno Simons:")]), _vm._v(" How little the Word of the Lord is regarded which says, “You shall not do after that which is right in your own eyes, but observe whatsoever I command you.” Did not the Father testify from heaven and declare, “This is my beloved Son in whom I am well pleased; listen to him?” Does not the whole Scripture direct us to Christ? Are we not baptized in his name that we should hear his voice, and be obedient to his Word? Do you not boast to be the apostolic church? Why then do you go from Christ and antichrist and from the apostolic doctrine and practice to that of the learned ones? Observe how severely and frequently God has punished human inventions they considered holy transactions and religion! . . . Saul had mercy on Agag, the king of the Amalekites, and prompted by his invention he spared the best and fattest sheep and oxen to sacrifice to the Lord, contrary to the word of the prophet. That act of would-be mercy and illustrious zeal was punished as a sin of witchcraft and idolatry because he acted according to his own invention and not according to the word of the prophet. He was reproved by the prophet, smitten with pestilence, and his kingdom was taken from him and given to a more faithful man. "), _c('i', [_vm._v("Foundation of Christian Doctrine.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-280-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-280",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Rejecting Blind Reason and Good Intentions.")]), _vm._v(" "), _c('i', [_vm._v("Johannes Bugenhagen:")]), _vm._v(" Saul’s otherwise most generous-looking actions reveal his impiety. It is nothing but blind human reason, which sees nothing here but piety and is therefore deceived by the appearance of holiness. According to God’s Word, Saul struck down the impious and led his people to victory through God, whom he appeared to serve as king among the people. If, as everyone knew, he was going to use the cattle piously for sacrifice and for worshiping God, then what can be condemned about this? Who would not commend "), _c('a', {
    attrs: {
      "id": "_idTextAnchor2891"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2892"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2893"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2894"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2895"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2896"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2897"
    }
  }), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page62",
      "title": "62"
    }
  }), _vm._v("him as a great king in the sight of the people and pious in the sight of God? But this has been written so that we learn not to follow blind reason but truly fear God’s judgment, so that we do not forsake God’s Word on account of our good intentions and our contrived worship of God. "), _c('i', [_vm._v("Commentary on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-279-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-279",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("More Merciful Than God.")]), _vm._v(" "), _c('i', [_vm._v("John Calvin:")]), _vm._v(" Saul committed his first transgression when God sent him to destroy the Amalekites. . . . He was not supposed to spare anything, yet he preserved the king in order to show him off. . . . He was not content merely with sparing the people but . . . also wanted the keep the cattle—either out of avarice or ambition, or for some other reason. He had been told that if he had disobeyed God’s command, evil would rebound on him, and that condemnation would fall on his head. . . . Then he was shown by the prophet Samuel that obedience is better than all the sacrifices in the world; and to obey God’s voice is far better than the fat of sheep. . . . Here, then, was Saul’s sin. He wished to be more merciful than God. "), _c('i', [_vm._v("Sermons on 2 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-278-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-278",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])])])])]), _vm._v(" "), _c('h5', {
    attrs: {
      "id": "sigil_toc_id_73"
    }
  }, [_c('b', [_vm._v("15:9")]), _vm._v(" "), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("Killing Sin")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Turning Against All Sin.")]), _vm._v(" "), _c('i', [_vm._v("Edward Reynolds:")]), _vm._v(" This, then, we must first and principally remember—to set ourselves against all sin. In confession, we are not to lie; in supplication, we are not to stop; in conversion, we are not to forget anyone. Never give up so long as any remains. . . . When people kill snakes or vipers, they do not stop striking them until certain they are dead. Sin, like the thief on the cross when it is fast nailed and kept from its old tyranny, will, as much as it can, revile and spit out venom on Christ. Therefore do not give in; break its legs; crucify it clean through till it is quite dead. None can pray or turn to God in truth or hope to be delivered from judgment in mercy so long as he holds fast any known sin. Can any person look to receive benefit by the blood of Christ who hugs the enemy that shed it? Is it not treason to knowingly harbor and entertain a traitor? Whoever loves and holds fast to sin lies to God in every prayer that he makes. This proves and humbles us for our hypocrisy and halving with God in our conversions from sin and confessions of it. We are willing to pray for the pardon of them all; we would have none hurt us. But when it comes to parting and taking all away, this we cannot get away. Some are fat and delicate golden sins. We must not spare these, as Saul did Agag. "), _c('i', [_vm._v("Seven Sermons on the Fourteenth Chapter of Hosea.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-277-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-277",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Killing Secret Desires.")]), _vm._v(" "), _c('i', [_vm._v("Johann Arndt:")]), _vm._v(" Saul cast Agag . . . into prison, although according to God’s commandment he was to have killed him. In the same way, many people secretly conceal their desires that they should kill. It is not enough that you hide away your lusts; you must kill them or you will be cast out of the kingdom as Saul was, that is, out of eternal life.” "), _c('i', [_vm._v("True Christianity.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-276-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-276",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Destroying Our Flesh.")]), _vm._v(" "), _c('i', [_vm._v("Daniel Dyke:")]), _vm._v(" Though your feelings, desires and motions are good, and do not always come from devilish illusion—but from the spirit of God—they are not sufficient. It is good and well that you have spiritually surpassed those who do not know what these kinds of feelings mean. It is good that you are not treading on thorny or stony ground but are nearer to the good ground. But so what? Because you have come thus far in the way, will you go no further? Do you therefore think yourself well enough? No, as our Savior said to the young man, so I say to you: “One thing you still lack”: There lies in you some leaven of hypocrisy that must be purged out; some root of bitterness that must be weeded up; some thorn of covetousness, pride and vainglory that must be cut down. . . . You have many wonderful graces, and they make you to shine as a wonderful and beautiful temple of the Holy Spirit. Only one thing is lacking: There is "), _c('a', {
    attrs: {
      "id": "_idTextAnchor2898"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2899"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2900"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2901"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2902"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2903"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2904"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2905"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2906"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2907"
    }
  }), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page63",
      "title": "63"
    }
  }), _vm._v("some error in the foundation. It is sandy, and you must dig a little deeper. You need to get a little more humility of spirit and truth and purity of heart; or else, when a storm comes, all your other labor about the building will be lost. I am the more earnest in this exhortation because of those fearful shipwrecks that many ships, richly laden with many precious jewels of grace, have suffered in all ages on this rock of an evil and unrenewed heart. Take heed of it, then, as the very bane and poison of all grace, and so the only cause of those many deceits of temporary believers. Enter, therefore, into those dark parts of your heart, take the light of the world in the one hand and the sword of the spirit in the other: and whatever Agagite or Amalekite that light discovers, kill, spare none, with Saul, make havoc of all a universal destruction. Save only one thing: yourself. "), _c('i', [_vm._v("The Mystery of Self-Deceiving.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-275-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-275",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Level and Random Shots.")]), _vm._v(" "), _c('i', [_vm._v("Edward Reynolds:")]), _vm._v(" The natural conscience shoots only by aim and level against some sins and spares the rest, as Saul in the slaughter of the Amalekites. But the spiritual conscience shoots by level against not only particular notorious sins but collectively as well, against the whole army of sin. And it is by this means that our lusts are wounded and weakened, which it did not distinctly observe in itself by complaining to God against the body of sin by watching over the course and frame of the heart by acquainting itself out of the Word with the armor and devices of Satan. The opposition, then, between the natural conscience and sin is like the opposition between fire and hardness in some subjects, while the conflict between the spiritual conscience and sin is like the opposition between fire and coldness. Put metal into the fire and the heat will dissolve and melt it: but put a brick into the fire and it will neither melt nor soften. . . . However, if you put either one or the other into the fire, the coldness of it will be removed. "), _c('i', [_vm._v("The Sinfulness of Sin.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-274-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-274",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])])])])]), _vm._v(" "), _c('h5', {
    attrs: {
      "id": "sigil_toc_id_74"
    }
  }, [_c('b', [_vm._v("15:10-11")]), _vm._v(" "), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("The Lord’s Repentance")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Saul Not a Christian.")]), _vm._v(" "), _c('i', [_vm._v("John Knox:")]), _vm._v(" Where God says, “I regret that I have made Saul king,” he does not mean that Saul at any time was a member of Christ’s body; he means only that he was a temporal officer, promoted of God and yet most disobedient to his commandment. Therefore God would provide another to occupy his office. And where God says, “I regret,” we must understand him to speak after the manner of mortals, accommodating himself to our understanding. God did not repent, because his majesty knew the disobedience and rebellion of the wicked king beforehand. And so . . . God the Father cannot regret that he has engrafted us as members of Christ’s body. Otherwise God would regret the honor of his own Son and thereby his own good work in us. "), _c('i', [_vm._v("Letters.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-273-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-273",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("How the Lord Is Said to Repent.")]), _vm._v(" "), _c('i', [_vm._v("Andrew Willet:")]), _vm._v(" God is properly not said to repent as a person repents (1 Sam 15:29). And although the passage says that God repented, this is a literary phrase spoken in a way that humans can understand. From our perspective, God is said to repent when anything goes contrary to his temporal election. That is, God is said to repent not in respect of his counsel—which is constant and immutable, even in things that are mutable—but in respect of the thing that is altered and changed, which God himself decreed should be changed. As Augustine says, “The repentance of God is an unchangeable course of changeable things.” This is the case here. God did not change in regard to Saul, for God had decreed that the kingdom should not continue in his posterity. Rather, it was Saul who changed in forgetting his duty and obedience toward God. So God’s decree concerning Saul was unchangeable: He foresaw that Saul would fall away and decreed the change of the kingdom. But though Saul was changeable—and the kingdom did change—God’s decree remained unchangeable. Here repentance is joined with grief. By this is signified the Lord’s grief, "), _c('a', {
    attrs: {
      "id": "_idTextAnchor2908"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2909"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2910"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2911"
    }
  }), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page64",
      "title": "64"
    }
  }), _vm._v("as it were, for Saul, for Saul’s disobedience made himself unworthy of the kingdom. Indeed, human beings often change. For as they are mutable creatures, so they have changeable minds. What’s more, things occur otherwise than what people sometimes think. But God is of an immutable nature. His foreknowledge cannot be frustrated or deceived. Nor can anything occur other than what he has decreed. "), _c('i', [_vm._v("Harmony on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-272-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-272",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("God’s Accommodation to Humankind.")]), _vm._v(" "), _c('i', [_vm._v("John Knox:")]), _vm._v(" The Spirit of God must accommodate and submit himself oftentimes to our weakness and speak to us who, by corruption, are made ignorant and vulgar, so that we may understand what he works by his incomprehensible wisdom and inscrutable providence. For instance, there is no such thing as our God having a mouth to speak vocal words as the first sense appears in David’s statement: “O Lord, rebuke me not in your anger.” Indeed, many other places of Scripture attribute to God not only such body parts as human beings possess but also such affections and unstable passions that nevertheless are not in God, who always in himself remains stable, constant, holy and just. And of that sort is that manner of speech, “I regret that I have made Saul king.” That is to say, “My justice is compelled to reject and throw down the rebellious king from that estate and dignity in which I have placed him; and so I shall "), _c('i', [_vm._v("appear")]), _vm._v(" to repent of my former work.” The Scripture attributes to God such conditions, qualities and affections as his majesty "), _c('i', [_vm._v("appears")]), _vm._v(" to show in his works on his creatures. As when he plagues the world, Scripture says, “God did it in his anger.” When he delivers those who have long suffered trouble, the Scripture states, “God stretched out his hand” or “God lifted up his eyes, his face or countenance.” Yet no such thing can be in the Godhead. And therefore . . . do not think that God is changeable and repents or regrets, although it appears thus; for the Scripture speaks this way to instruct our weakness. For before God appointed Saul to be king, his majesty knew his disobedience and how he was to be subjected. Nor did Saul please God in Jesus his Son, but Saul was always reprobate and never embraced the promise of remission of sins and reconciliation in such promises, although the Lord did promote him to worldly dignity. However, this is no sure sign of God’s everlasting love and favor, given that the ungodly are oftentimes placed alongside the godly. "), _c('i', [_vm._v("Letters.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-271-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-271",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])])])])]), _vm._v(" "), _c('h5', {
    attrs: {
      "id": "sigil_toc_id_75"
    }
  }, [_c('b', [_vm._v("15:12-21")]), _vm._v(" "), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("Saul’s Pride in Saving Part of the Spoil")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Love of Self.")]), _vm._v(" "), _c('i', [_vm._v("Johann Gerhard:")]), _vm._v(" Sacrifice was an acceptable work to God in the Old Testament. Nevertheless, God was not pleased that Saul set apart the spoils of the Amalekites to offer sacrifice to God. Why? Because this did not proceed from the love of God. For if Saul had truly loved God, he would not have held in contempt the commandment of God to burn the spoils. Rather than loving God, Saul loved himself and his own devotion. "), _c('i', [_vm._v("Sacred Meditations.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-270-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-270",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Of Saul’s Excuse and Defense.")]), _vm._v(" "), _c('i', [_vm._v("Andrew Willet:")]), _vm._v(" Saul’s hypocrisy is discovered. He boasts that he had fulfilled God’s commandment, whereas he had really transgressed it. This is the manner of hypocrites: They say they have fulfilled the commandment of the Lord when in reality they have not. Saul excuses himself by laying the fault on the people and putting it away from himself. He cloaks and colors his covetousness with a pretense of zeal and religion, as though he had spared the best things for sacrifice. He afterward justifies his sin, as though he had for all this done well and obeyed the voice of God. Ultimately he does make a semblance of sorrow and repentance, but it was far from true submission. Saul does this on a vain ostentation, only desiring that Samuel would honor him before the people. "), _c('i', [_vm._v("Harmony on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-269-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-269",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])])])])]), _vm._v(" "), _c('h5', {
    attrs: {
      "id": "sigil_toc_id_76"
    }
  }, [_c('span', {
    staticClass: "com-rorohiko-pagestaker-style"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor2912"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2913"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2914"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2915"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2916"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2917"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2918"
    }
  })]), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page65",
      "title": "65"
    }
  }), _c('b', [_vm._v("15:22")]), _vm._v(" "), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("God Desires Obedience")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Nothing Without God’s Word.")]), _vm._v(" "), _c('i', [_vm._v("William Tyndale:")]), _vm._v(" Do nothing without God’s word. And to his word add nothing, nor pull anything from it. . . . Serve God in the Spirit, and serve your neighbor with all outward service. Serve God as he has appointed you, and not with your good intent and good zeal. Remember that Saul was cast away of God forever for his good intent. God requires obedience to his word, and he abhors all good intents and good zeal that are without God’s word, for they are nothing else than plain idolatry and the worshiping of false gods. "), _c('i', [_vm._v("Doctrinal Treatises and Introductions to Other Portions of Holy Scriptures.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-268-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-268",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Don’t Ask Why.")]), _vm._v(" "), _c('i', [_vm._v("Martin Luther:")]), _vm._v(" Therefore let no one add this detestable and fatal little word "), _c('i', [_vm._v("why")]), _vm._v(" to God’s commands. But when the command is certain, let us obey at once without any argument, and let us conclude that God is wiser than we are. He who argues about why God gives a particular command actually doubts that God is wise, just and good. What sin can be more hideous and more intolerable to God? Therefore we must believe—this is part of our duty—and not argue, for these matters are too lofty for us to be able to argue about them. "), _c('i', [_vm._v("Lectures on Genesis.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-267-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-267",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")])])])])]), _vm._v(" "), _c('h5', {
    attrs: {
      "id": "sigil_toc_id_77"
    }
  }, [_c('b', [_vm._v("15:23")]), _vm._v(" "), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("Idolatry Is Divination")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("On True Obedience.")]), _vm._v(" "), _c('i', [_vm._v("Martin Luther:")]), _vm._v(" At this point there arises an opportunity to discuss obedience, which is extolled to such an extent in the monasteries that no monk has been too unlearned not to leave some writing about it. And in his decretals the pope puts greater stress on obedience to his laws than on anything else. As a result, the statement of Samuel has been heard from every pulpit: “To obey is better than sacrifice. Rebellion is as a sin of divination.” To this true statement they appended the inference: “Hence no kind of life is better than that of the monks.” Surely a fine conclusion, which, as used to be said in the schools, has the force of the argument from the staff to the corner. . . . True obedience is not to do what you yourself choose or what you impose on yourself, but what the Lord has commanded you through his Word. "), _c('i', [_vm._v("Lectures on Genesis.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-266-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-266",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Sin of Divination.")]), _vm._v(" "), _c('i', [_vm._v("Giovanni Diodati:")]), _vm._v(" Idolatry is a sin against God’s majesty. It’s not the case that all sins are equal or alike. The meaning of the passage is that idolatry is a sin against God, which is also repugnant and contrary to his will, to the truth and to the glory of his nature and essence. In fact, magic arts and idolatry are alike, and therefore deserve the same punishment that is due to all sin: namely, death. At the same time there are degrees of severity to God’s justice. "), _c('i', [_vm._v("Annotations on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-265-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-265",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Rebellion Is the Sin of Witchcraft.")]), _vm._v(" "), _c('i', [_vm._v("Andrew Willet:")]), _vm._v(" In order to amplify Saul’s sin, Samuel compares it with two great transgressions: soothsaying and divining by magical predictions and committing idolatry. Samuel touches on two kinds of idolatry: the first one being inward in the superstition of the mind, which signifies a lie or a falsehood. The Septuagint refers to this as injustice or unrighteousness, but it is properly applied to false worship. The other kind of idolatry is the outward adoration of idols, here called "), _c('i', [_vm._v("teraphim")]), _vm._v(". Some think a comparison is made here not of the sins but of the punishment: that rebellion deserves capital punishment as much as either idolatry or soothsaying. But the prophet speaks directly of the sin itself, as before of the virtue of obedience: “to obey is better than sacrifice.” Samuel must be understood not to speak of transgressions—either of ignorance or infirmity—but of the sin of obstinacy, contumacy and rebellion. Such are the sins of those who know the "), _c('a', {
    attrs: {
      "id": "_idTextAnchor2919"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2920"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2921"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2922"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2923"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2924"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2925"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2926"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2927"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2928"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2929"
    }
  }), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page66",
      "title": "66"
    }
  }), _vm._v("will of God but willfully resist it. For this proceeds from the same cause, namely, infidelity—which is the corollary sin of witchcraft and idolatry. The one who does not fear to break God’s commandments does not acknowledge the Lord to be God. Further, such people actually make themselves wiser than God, as though they could discover a better way than the Lord had prescribed. "), _c('i', [_vm._v("Harmony on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-264-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-264",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17")])])])])]), _vm._v(" "), _c('h5', {
    attrs: {
      "id": "sigil_toc_id_78"
    }
  }, [_c('b', [_vm._v("15:24-26")]), _vm._v(" "), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("The Difference Between Saul and David’s Repentance")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Same Words but Different Hearts.")]), _vm._v(" "), _c('i', [_vm._v("Martin Luther:")]), _vm._v(" David’s word to Nathan (2 Sam 12:13), “I have sinned,” must be understood altogether differently from the word of Saul, who likewise said to Samuel: “I have sinned.” It is indeed the same word, the same voice and face of compunction or repentance, but the hearts are very different. "), _c('i', [_vm._v("Lectures on Genesis.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-263-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-263",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Smelling of Pride.")]), _vm._v(" "), _c('i', [_vm._v("Lancelot Andrewes:")]), _vm._v(" To cover and conceal sin is a double sin; and not to confess it plainly is partly pride and presumption, or else servile fear and despair. The sinners fear, lest they should have to confess all to God. This assumes that God has no goodness or mercy, and that it is not enough to forgive them. Or else these sinners conceal their sins out of pride, presuming that God cannot see and find out that which they do and hide from the eyes of people. . . . In short, pride makes people ashamed to confess their sins, or else so to confess that one may see a plain difference between the confession of a proud sinner and a poor, humble sinner; the difference between the confession of the good and faithful, and confession of evil and unfaithful. This is the difference between Saul’s and David’s confessions. Saul’s confession smells of pride. . . . “I have sinned,” he says, “yet honor me.” That is, he would so confess his sin that he might keep his credit and have his reputation, and not to lose one jot of either. "), _c('i', [_vm._v("Collection of Lectures.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-262-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-262",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Failure to Acknowledge Sin.")]), _vm._v(" "), _c('i', [_vm._v("Andrew Willet:")]), _vm._v(" There was great difference between Saul’s repentance here and David’s, who forthwith confesses: “I have sinned.” David, as soon as his sin was shown to him, confessed it. But Saul is hardly brought to acknowledge his sin. Indeed, he is an example of slow and late repentance. He does not make a simple and plain confession, but minces and extenuates his sin, because he feared the people, and so at their instigation did as he did. It is very hard for hypocrites to be brought to make a true confession of their sin. Instead, they prefer to lay the fault on others. Saul only confesses his sin out of the fear of losing the kingdom rather than for the grief that he had offended God: For till such time as Samuel had said that the Lord had rejected and cast him off, Saul would not confess himself as guilty. "), _c('i', [_vm._v("Harmony on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-261-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-261",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20")])])])])]), _vm._v(" "), _c('h5', {
    attrs: {
      "id": "sigil_toc_id_79"
    }
  }, [_c('b', [_vm._v("15:27-29")]), _vm._v(" "), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("The Kingdom Torn")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("No Doubt About God’s Constancy.")]), _vm._v(" "), _c('i', [_vm._v("John Calvin:")]), _vm._v(" We should have said enough concerning God’s providence to achieve the perfect instruction and comfort of believers (for nothing whatsoever can be sufficient to satisfy the curiosity of vain people, nor ought we want to satisfy it) if certain passages did not stand in the way. These seem to suggest, contrary to the above exposition, that the plan of God does not stand firm and sure, but is subject to change in response to the disposition of things below. . . . Hence many contend that God has not determined the affairs of humans by an eternal decree, but that, according to each person’s deserts or according as he deems fair and just, he decreed this or that each year, each day and each hour. Concerning repentance, we ought so to hold that it is no more chargeable against God than is ignorance, or error, or powerlessness. For if no one "), _c('a', {
    attrs: {
      "id": "_idTextAnchor2930"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2931"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2932"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2933"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2934"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2935"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2936"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2937"
    }
  }), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page67",
      "title": "67"
    }
  }), _vm._v("willingly and wittingly puts themselves under the necessity of repentance, we shall not attribute repentance to God without saying that he is ignorant of what is going to happen, or cannot escape it, or hastily and rashly rushes into a decision of which he immediately has to repent. But this is far removed from the intention of the Holy Spirit, who in the very reference to repentance says that God is not moved by compunction because he is not a man so that he can repent. And we must note that in the same chapter both are so joined together that the comparison well harmonizes the apparent disagreement. When God repents of having made Saul king, the change of mind is to be taken figuratively. A little later it is added: “The strength of Israel will not lie, nor be turned aside by repentance; for he is not a man, that he may repent.” By these words openly and unfiguratively God’s unchangeableness is declared. Therefore it is certain that God’s ordinance in the managing of human affairs is both everlasting and above all repentance. And lest there be doubt as to his constancy, even his adversaries are compelled to render testimony to this. "), _c('i', [_vm._v("Institutes 1.17.12.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-260-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-260",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("How the Kingdom Is Torn from Saul.")]), _vm._v(" "), _c('i', [_vm._v("Andrew Willet:")]), _vm._v(" By this present occasion of tearing the piece of Samuel’s garment, Samuel confirms God’s former sentence in the rejection of Saul. It’s not that he was immediately deposed, for he continued being king until his dying day. Rather, he was deprived of the right of the kingdom, which was given to David. Accordingly, although the kingdom was not immediately taken from his own person, it was taken from his posterity and succession. And this is how we can insinuate the violent death of Saul, who should by force be pulled from the kingdom and taken from it. And whereas David is said to be better than Saul, it is not understood of any difference in their nature—for we are all by nature the children of wrath. Nor is their difference so much in respect of outward works, which—in some of them—David offended more than Saul. But this difference is to be taken, first, in respect of God, of whom David was better accepted and more favored and his sins pardoned; and, second, in respect of David, who had a more obedient heart wrought in him by grace to do the will of God and to seek and set forth God’s glory. However, Saul’s heart was not like this, but was rather averse and estranged from God. "), _c('i', [_vm._v("Harmony on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-259-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-259",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Not Using God’s Things.")]), _vm._v(" "), _c('i', [_vm._v("Thomas Adams:")]), _vm._v(" When God threatened . . . Saul, he did not intend for there to be no more kings or turn back the kingdom to the former state of judges: no, only the kingdom would lose Saul, but Israel would not lose the kingdom. It is a clear testimony in nature that things dedicated to God should not be used by people. "), _c('i', [_vm._v("The Temple.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-258-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-258",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23")])])])])]), _vm._v(" "), _c('h5', {
    attrs: {
      "id": "sigil_toc_id_80"
    }
  }, [_c('b', [_vm._v("15:30-33")]), _vm._v(" "), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("Saul Seeks Honor Before the People")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Panting After Air.")]), _vm._v(" "), _c('i', [_vm._v("Lancelot Andrewes:")]), _vm._v(" Mark it when you will: There is no animal so ambitious, no chameleon that so pants after air, as does the hypocrite after popular praise. For it he fasts, and so hungry and thirsty is he after it that you shall even hear him beg for it. “Honor me now before the elders of my people,” says one of them—it is Saul. "), _c('i', [_vm._v("On Repentance and Fasting")]), _c('i', [_c('b', [_vm._v(":")])]), _vm._v(" "), _c('i', [_vm._v("Sermon 6.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-257-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-257",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Why Samuel Returned with Saul.")]), _vm._v(" "), _c('i', [_vm._v("Andrew Willet:")]), _vm._v(" Initially Samuel refused to return with Saul, lest he give the appearance of approving Saul’s sins. Accordingly, Samuel did not simply deny Saul but said, in effect, that he would not go with him yet or at that time. As Christ said, “You go up to the feast. I am not going up to this feast, for my time has not yet fully come”; and yet afterward, Jesus went. Some think that because Saul only required Samuel to honor him in a civil "), _c('a', {
    attrs: {
      "id": "_idTextAnchor2938"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2939"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2940"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2941"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2942"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2943"
    }
  }), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page68",
      "title": "68"
    }
  }), _vm._v("ceremony in the presence of the people, Samuel did not refuse. But seeing that Saul worshiped God—with Samuel being present—it is probable that Samuel also worshiped God with Saul, as Josephus well observes. But though Samuel vouchsafed his presence to Saul in prayer, he did not pray for the restoring of the kingdom to Saul or for the reversing of God’s sentence. Had Samuel done so, he would have prayed against the will of God. However, Samuel only assisted Saul in his prophetic office according to the will of God. One reason also of Samuel’s returning might be to see just execution done on Agag the king of Amalek, whom Samuel hewed in pieces before the Lord. This reverent and respective behavior of Samuel toward Saul demonstrates that ministers of God should yield outward honor even to evil magistrates. "), _c('i', [_vm._v("Harmony on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-256-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-256",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25")])])])])]), _vm._v(" "), _c('h5', {
    attrs: {
      "id": "sigil_toc_id_81"
    }
  }, [_c('b', [_vm._v("15:34-35")]), _vm._v(" "), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("Samuel Mourns over Saul")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Mourning for a Time.")]), _vm._v(" "), _c('i', [_vm._v("Dutch Annotations:")]), _vm._v(" Samuel saw Saul no more. Or, alternatively interpreted, Samuel visited Saul no more to instruct him concerning the government of the kingdom or to ask counsel of God for him. At the same time, Samuel did see Saul unawares at Naioth in Rama . . . and in other places until the day of his death. But these later encounters are not reckoned as proper seeing, thus implying that Samuel never visited Saul again after this time. Nevertheless, Samuel did mourn for Saul. Samuel did so not for the rest of his life but so long until he was forbidden by God to mourn. Thereafter he was commanded by God to anoint David king over Israel. "), _c('i', [_vm._v("Annotations on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-255-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-255",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Ministering Affectionately.")]), _vm._v(" "), _c('i', [_vm._v("Henry Airay:")]), _vm._v(" Great and godly affection . . . ought to be in the pastor toward his people. In fact the pastor’s affection ought to be so great that it should grieve him and even cause him to shed tears to see the enemies of the truth trouble his people or to see his people drawn into any sin or error by anyone or anything. For this is how we testify to our affection for the church of God—if we are grieved to see Satan assault God’s people or attempt to prevail against them. For so we see how Samuel mourned for Saul when he had provoked the Lord to anger by means of his disobedience against him. "), _c('i', [_vm._v("Lectures on Philippians.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-254-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-254",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Why Samuel Mourned for Saul.")]), _vm._v(" "), _c('i', [_vm._v("Andrew Willet:")]), _vm._v(" Though he mourned, Samuel did not so much mourn for Saul as he did for the fact that Saul had been rejected and deposed from the kingdom. For Samuel knew that the sentence of God was irrevocable, and that it was not good to be discontented with the Lord’s will. Yet Samuel lamented the hardness of Saul’s impenitent heart, seeing that Saul continued in his sin without any remorse—as was evident in the persecution of David. What’s more, Samuel also foresaw the misery in which Saul was likely to fall—relative to the loss not only of the kingdom but of his life as well. Indeed, though Samuel knew that God’s rejection of Saul from the kingdom could not be reversed, yet he grieved and tried to entreat the Lord for the forgiveness of Saul’s sin. Here Samuel shows his tender and loving affection, in addition his complete lack of envy: he felt sorry for the misery of Saul, even though Saul had succeeded him in the government. "), _c('i', [_vm._v("Harmony on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-253-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-253",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28")])])])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "_idContainer028"
    }
  }, [_c('p', {
    staticClass: "PER_Top-extra-space"
  }, [_c('span', {
    staticClass: "com-rorohiko-pagestaker-style"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor2944"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2945"
    }
  })]), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page69",
      "title": "69"
    }
  })]), _vm._v(" "), _c('h2', {
    staticClass: "PER_ScriptureCenter",
    attrs: {
      "id": "sigil_toc_id_82"
    }
  }, [_c('span', {
    staticClass: "RH-marker"
  }, [_vm._v("16:1-23")]), _vm._v(" DAVID IS ANOINTED AND ENTERS SAUL’S SERVICE")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("1")]), _c('i', [_vm._v("The")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("said to Samuel, “How long will you grieve over Saul, since I have rejected him from being king over Israel? Fill your horn with oil, and go. I will send you to Jesse the Bethlehemite, for I have provided for myself a king among his sons.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("2")]), _c('i', [_vm._v("And Samuel said, “How can I go? If Saul hears it, he will kill me.” And the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("said, “Take a heifer with you and say, ‘I have come to sacrifice to the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _c('i', [_vm._v(".’")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("3")]), _c('i', [_vm._v("And invite Jesse to the sacrifice, and I will show you what you shall do. And you shall anoint for me him whom I declare to you.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("4")]), _c('i', [_vm._v("Samuel did what the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("commanded and came to Bethlehem. The elders of the city came to meet him trembling and said, “Do you come peaceably?”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("5")]), _c('i', [_vm._v("And he said, “Peaceably; I have come to sacrifice to the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _c('i', [_vm._v(". Consecrate yourselves, and come with me to the sacrifice.” And he consecrated Jesse and his sons and invited them to the sacrifice.")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("6")]), _c('i', [_vm._v("When they came, he looked on Eliab and thought, “Surely the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _c('i', [_vm._v("’s anointed is before him.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("7")]), _c('i', [_vm._v("But the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("said to Samuel, “Do not look on his appearance or on the height of his stature, because I have rejected him. For the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("sees not as man sees: man looks on the outward appearance, but the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("looks on the heart.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("8")]), _c('i', [_vm._v("Then Jesse called Abinadab and made him pass before Samuel. And he said, “Neither has the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("chosen this one.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("9")]), _c('i', [_vm._v("Then Jesse made Shammah pass by. And he said, “Neither has the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("chosen this one.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("10")]), _c('i', [_vm._v("And Jesse made seven of his sons pass before Samuel. And Samuel said to Jesse, “The")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("has not chosen these.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("11")]), _c('i', [_vm._v("Then Samuel said to Jesse, “Are all your sons here?” And he said, “There remains yet the youngest,")]), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("a")]), _vm._v(" "), _c('i', [_vm._v("but behold, he is keeping the sheep.” And Samuel said to Jesse, “Send and get him, for we will not sit down till he comes here.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("12")]), _c('i', [_vm._v("And he sent and brought him in. Now he was ruddy and had beautiful eyes and was handsome. And the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("said, “Arise, anoint him, for this is he.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("13")]), _c('i', [_vm._v("Then Samuel took the horn of oil and anointed him in the midst of his brothers. And the Spirit of the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("rushed upon David from that day forward. And Samuel rose up and went to Ramah.")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("14")]), _c('i', [_vm._v("Now the Spirit of the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("departed from Saul, and a harmful spirit from the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("tormented him.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("15")]), _c('i', [_vm._v("And Saul’s servants said to him, “Behold now, a harmful spirit from God is tormenting you.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("16")]), _c('i', [_vm._v("Let our lord now command your servants who are before you to seek out a man who is skillful in playing the lyre, and when the harmful spirit from God is upon you, he will play it, and you will be well.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("17")]), _c('i', [_vm._v("So Saul said to his servants, “Provide for me a man who can play well and bring him to me.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("18")]), _c('i', [_vm._v("One of the young men answered, “Behold, I have seen a son of Jesse the Bethlehemite, who is skillful in playing, a man of valor, a man of war, prudent in speech, and a man of good presence, and the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("is with him.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("19")]), _c('i', [_vm._v("Therefore Saul sent messengers to Jesse and said, “Send me David your son, who is with the sheep.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("20")]), _c('i', [_vm._v("And Jesse took a donkey laden with bread and a skin of wine and a young goat and sent them by David his son to Saul.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("21")]), _c('i', [_vm._v("And David came to Saul and entered his service. And Saul loved him greatly, and he became his armor-bearer.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("22")]), _c('i', [_vm._v("And Saul sent to Jesse, saying, “Let David remain in my service, for he has found favor in my sight.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("23")]), _c('i', [_vm._v("And whenever the harmful spirit from God was upon Saul, David took the lyre and played it with his hand. So Saul was refreshed and was well, and the harmful spirit departed from him.")])]), _vm._v(" "), _c('p', {
    staticClass: "small"
  }, [_c('b', [_vm._v("a")]), _vm._v(" Or "), _c('i', [_vm._v("smallest"), _c('br'), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Overview:")]), _vm._v(" God cannot lie. So when God commands Samuel to conceal a truth, the reformers clarify how to interpret this passage. They also humanize the prophet Samuel—they do not confuse saintliness with sinlessness. The interpreters use the occasion of Samuel’s confusion about "), _c('a', {
    attrs: {
      "id": "_idTextAnchor2946"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2947"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2948"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2949"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2950"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2951"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2952"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2953"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2954"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2955"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2956"
    }
  }), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page70",
      "title": "70"
    }
  }), _vm._v("which of Jesse’s sons to anoint to reflect on the differences between the outward and the inward, the ungodly and the godly. Indeed, they ponder the well-known passage that “the Lord sees not as man sees.” This truth is not always convenient for God’s people—for example, despite his royal anointing, David endures years of persecution before undisputedly claiming the throne of Israel. The reformers also dwell on the spirit that tormented Saul, struggling to understand the relationship between the devil and God when it comes to working in the life of unbelievers, and how David’s delightful music was able to expel the evil spirit inflicting Saul.")]), _vm._v(" "), _c('h5', {
    attrs: {
      "id": "sigil_toc_id_83"
    }
  }, [_c('b', [_vm._v("16:1-5")]), _vm._v(" "), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("Samuel Questions God")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Samuel Was a Sinner Like Us.")]), _vm._v(" "), _c('i', [_vm._v("Johannes Bugenhagen:")]), _vm._v(" Samuel said, “How can I go? If Saul hears it, he will kill me.” You see that Samuel was a sinner the same as us. It is impossible to have this kind of fear without sin, without letting go of what God commands. So this fear is a great impurity when it comes near you. Faith swallows this sin so that it is not imputed to us. I freely offer this example from the holy ones. Otherwise what consolation could I have from their miracles? "), _c('i', [_vm._v("Commentary on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-252-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-252",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Whether Samuel Lied.")]), _vm._v(" "), _c('i', [_vm._v("Andrew Willet:")]), _vm._v(" Three things excuse, or rather, justify Samuel’s act here. First, he is excused because the author of this command was God, who does not command sin to be performed. Nor is God the author of any evil. Samuel, therefore, being bid to say what he did by the Lord, would not even have sinned had he killed someone—given that it was the Lord who commanded him to do so. Second, it is the "), _c('i', [_vm._v("end")]), _vm._v(" that always has to be considered. It is unlawful to lie or evade, for instance, if it is done in malice or in order hurt someone. But this evasion here by Samuel brought no such inconvenience with it. None received any hurt by it. Finally, the "), _c('i', [_vm._v("manner")]), _vm._v(" of this action makes Samuel’s excuse lawful: For he told no untruth, but only concealed part of the truth. Although he sacrificed, that was not the chief or only purpose of his coming. In this way, to conceal a great or weighty affair, and to reveal nothing at all, is providence—not hypocrisy. In the same way, the prophet Jeremiah—upon being asked by the princes what communication he had with King Zedekiah—only told them that he had entreated him to not return to Jonathan’s house to die there. But concerning the rest of the conversation, he did not utter anything. "), _c('i', [_vm._v("Harmony on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-251-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-251",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])])])])]), _vm._v(" "), _c('h5', {
    attrs: {
      "id": "sigil_toc_id_84"
    }
  }, [_c('b', [_vm._v("16:6-9")]), _vm._v(" "), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("Appearances Can Deceive")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("The Lord Looks on the Heart.")]), _vm._v(" "), _c('i', [_vm._v("Johannes Bugenhagen:")]), _vm._v(" Samuel looked on Eliab. In this example to us, the Lord commands Samuel not to judge Eliab by appearances, since indeed they were all already falling because of Saul. If they have to follow their eyes, they will be deceived, whether they are hypocrites or even good kinds of saints. I know this from 1 John regarding the “desires of the eyes.” But in the psalm, the Lord promises us his eyes: “I will instruct you and teach you in the way you should go; I will counsel you with my eye upon you.” The boy is given the kingdom, which neither his father or brothers or Samuel himself recognize. The kingdom of God is not seen by observation. The Lord knows who belongs to him, and all of Isaiah 53 shows that Christ is not known by people because of the form of the cross. But hypocrites follow Eliab because of his stature, speaking hatefully about David, “Why have you come down?” "), _c('i', [_vm._v("Commentary on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-250-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-250",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Prefiguring of Jesus’ Baptism by John.")]), _vm._v(" "), _c('i', [_vm._v("Thomas Jackson:")]), _vm._v(" Although John the Baptist no more knew our Savior by face from other men than Samuel did the sons of Jesse—one of which he was appointed to anoint as king in Saul’s place "), _c('a', {
    attrs: {
      "id": "_idTextAnchor2957"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2958"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2959"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2960"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2961"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2962"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2963"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2964"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2965"
    }
  }), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page71",
      "title": "71"
    }
  }), _vm._v("over Israel—yet when our Savior came to be baptized, he knew him to be the Messiah by some divine instinct or revelation as Samuel knew David (whose face he had never seen before) to be the man whom God had appointed him to anoint. . . . For it is evident . . . that although Samuel knew none of Jesse’s sons by face, yet he had received a distinct revelation from God. . . . “Do not look on his appearance or on the height of his stature, because I have rejected him.” But when David was brought before him, the Lord said, “Arise, anoint him, for this is he.” Samuel had no visible sign given from God by which to know the man whom he was to anoint from among his brothers; rather, he was merely to rely on the revelation or instruction that God had promised to give him in the very act or situation. God said, “invite Jesse to the sacrifice, and I will show you what you shall do. And you shall anoint for me him whom I declare to you.” "), _c('i', [_vm._v("Christ’s Answer to John’s Question.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-249-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-249",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Of Samuel’s Error.")]), _vm._v(" "), _c('i', [_vm._v("Andrew Willet:")]), _vm._v(" Samuel, in saying that the Lord’s anointed was before him, meant he believed that Eliab was chosen and approved of God to be anointed king. It is as if a person casts his eye on that which he loves and turns his eyes away from that which he hates. But here Samuel speaks unadvisedly of himself, without God’s warrant, as Nathan did to David when he encouraged him to build God a house (2 Sam 7:3). Samuel looked to the outward stature, lineaments and proportion of Eliab’s body, which indeed are attractive qualities in magistrates and governors, but the inward parts and gifts of the mind are more to be respected. These are the things on which the Lord looks. God does not look to the outward person. What’s more, Samuel already had experience of a king in the outward comeliness and stature of the body who exceeded all others. Indeed, none in Israel compared with Saul. Yet God was not pleased with Saul, nor were the inwards parts of his mind answerable to the outward ones any more than were Eliab’s—as may appear by his unkind and discourteous conversation toward David. "), _c('i', [_vm._v("Harmony on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-248-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-248",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Inside Versus Outside.")]), _vm._v(" "), _c('i', [_vm._v("Thomas Adams:")]), _vm._v(" Jesse could find nothing in David worthy of honor in relation to his brothers, but God found something in him that honored David before them all. David’s father thought him fit to keep sheep, and his brothers fit to rule over people. God thought David fit to rule, and for his brothers to serve. . . . Here was all the difference. . . . Jesse saw things based on the outside, God by the inside: Jesse saw the composition of the body, God saw the disposition of the mind. "), _c('i', [_vm._v("The Holy Choice.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-247-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-247",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])])])])]), _vm._v(" "), _c('h5', {
    attrs: {
      "id": "sigil_toc_id_85"
    }
  }, [_c('b', [_vm._v("16:10")]), _vm._v(" "), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("Jesse’s Other Sons")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("God’s Kindness.")]), _vm._v(" "), _c('i', [_vm._v("John Fisher:")]), _vm._v(" Jesse, the father of David, had seven sons. David was the youngest of them all, the least in appearance, the least established, and he kept his father’s sheep. Nevertheless, the goodness of Almighty God not only elected and chose him, but all his brothers were rejected and set aside. Then God commanded Samuel, the bishop and prophet, to anoint him king of Israel. Was not this a great kindness that Almighty God showed to such a, so to speak, vile person who was used to the habit of keeping beasts? God, out of his goodness, called David from so vile an office and set him by his commandment as king and head of all his people. "), _c('i', [_vm._v("Commentary on the Seven Penitential Psalms.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-246-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-246",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Of the Number of Jesse’s Sons.")]), _vm._v(" "), _c('i', [_vm._v("Andrew Willet:")]), _vm._v(" Josephus thinks Jesse only had seven sons—six in addition to David—and that David was the seventh. Josephus names all seven sons according to the names set down in 1 Chronicles 2:13-15, which are these: Eliab, also called Elihu, Abinadab . . . , Shimea, also called Shammah, Nethanel, Raddai, whom Josephus calls Rael, and "), _c('a', {
    attrs: {
      "id": "_idTextAnchor2966"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2967"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2968"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2969"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2970"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2971"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2972"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2973"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2974"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2975"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2976"
    }
  }), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page72",
      "title": "72"
    }
  }), _vm._v("Ozem. . . . These six are said to be Jesse’s sons, and David the seventh. However, in this present passage six sons were brought before Samuel before David came. And it is stated explicitly that Jesse had eight sons. To reconcile this discrepancy, we may conjecture that the “eighth son” was one of the elder brother’s sons. Most likely it was Jonadab, son of Shimea, about whom mention is made in 2 Samuel 13:3, for in the Hebrew the word “nephew” is also translated as “son.” "), _c('i', [_vm._v("Harmony on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-245-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-245",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Undivided Heart.")]), _vm._v(" "), _c('i', [_vm._v("Edward Reynolds:")]), _vm._v(" Samuel said to Jesse “Are all your children here? If any remain, we will not sit down till he comes here.” We must be the same way in our confessions and renunciation of sin. Christ asks us, “Are any still here? If any are remaining, I will not take possession till they are cast out.” . . . God’s law, as well as humankind’s, disallows inmates in the same house; he will not endure a divided heart; he is heir of all things; there lies no writ of partition in his inheritance; his title is so good that he will never yield to a composition; he will have all the heart or none. "), _c('i', [_vm._v("Seven Sermons on the Fourteenth Chapter of Hosea.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-244-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-244",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])])])])]), _vm._v(" "), _c('h5', {
    attrs: {
      "id": "sigil_toc_id_86"
    }
  }, [_c('b', [_vm._v("16:11-13")]), _vm._v(" "), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("David’s Anointing")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Whether David Was Anointed.")]), _vm._v(" "), _c('i', [_vm._v("Andrew Willet:")]), _vm._v(" Some think David was not anointed. Accordingly, when it is said in the text that Samuel “anointed him in the midst of his brothers,” these commentators interpret this passage in this way: Samuel merely anointed one of the brothers, in this case, the youngest of all the brothers. . . . It is also to be gathered out of this passage that all the brothers sat down together at the feast. As Samuel said after Jesse informed the prophet that David was not yet present at the meal: “Send and get him, for we will not sit down till he comes here.” Josephus thinks Samuel, having placed David next to him at the table, whispered in his ear that God had appointed him to be king, and only then poured the anointed oil on him. However, seeing that he was anointed “in the midst of his brothers,” so that David’s brothers perceived what the prophet intended, to what end should Samuel have concealed the words? And I should also mention that the people of Israel, when they later anointed David king, repeated the words Samuel had used at David’s first anointing: “You shall be shepherd of my people Israel, and you shall be prince over Israel.” It is likely that these words were not whispered in David’s ear, for how then should they come to the notice of all Israel? Therefore some think it more probable that Samuel both spoke to David in the audience of his brothers and anointed him in their sight. Yet David’s brothers did not greatly regard David’s anointing, nor think the prophet did it seriously. On the contrary, they condemned it, as appears from Eliab’s unkind reception of David in the camp after this (1 Sam 17:28). This mirrors Joseph’s brothers disregard of his dreams—only Jacob taking them to heart—and the Pharisee’s and Jewish leaders’ refusal to acknowledge Christ—of whom David was a type—as their Messiah and King.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Now, then, whereas some think David was not anointed in front of his brothers before they sat down and some think he was anointed in their presence but they did not realize the significance, I take a middle position. Though his brothers saw him being anointed in their presence, they understood nothing concerning the kingdom. For if they had understood this, then Eliab would not have spoken to David so insolently afterward. However, when they heard David sing prophetic psalms, they might have thought he was anointed to be a prophet. Yet there is no evidence that David was unaware of the significance of his anointing in relation to the kingdom, for the word of promise was annexed to the outward sign of his anointing. Those words Samuel spoke to David were afterward published by Samuel or David himself. And if all David’s brothers had been acquainted with this secret, it could not have been kept from Saul, "), _c('a', {
    attrs: {
      "id": "_idTextAnchor2977"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2978"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2979"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2980"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2981"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2982"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2983"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2984"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2985"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2986"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2987"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2988"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2989"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2990"
    }
  }), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page73",
      "title": "73"
    }
  }), _vm._v("who just like his brother Eliab was envious of David. "), _c('i', [_vm._v("Harmony on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-243-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-243",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Anointed but Not Enthroned.")]), _vm._v(" "), _c('i', [_vm._v("Geneva Bible:")]), _vm._v(" Though David was now anointed king by the prophet, God would exercise him in many ways before he had the command of his kingdom. "), _c('i', [_vm._v("Annotations on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-242-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-242",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Suffering Before Glory.")]), _vm._v(" "), _c('i', [_vm._v("Martin Luther:")]), _vm._v(" David, after being anointed to be king, lives in exile for ten years, is a servant of servants and is king only in name and in accordance with the empty words he heard from Samuel. Yet he holds out, and he perseveres in faith and expectation, until the outcome corresponds in richest abundance to the promise. This is the constant course of the church at all times, namely, that promises are made and that then those who believe the promises are treated in such a way that they are compelled to wait for things that are invisible, to believe what they do not see and to hope for what does not appear. He who does not do this is not a Christian. For Christ himself entered into his glory only by first descending into hell. When he is about to reign, he is crucified. When he is to be glorified, he is spit on. For he must suffer first and then at length be glorified. "), _c('i', [_vm._v("Lectures on Genesis.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-241-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-241",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("An Allegory on the Two Kings.")]), _vm._v(" "), _c('i', [_vm._v("Johannes Bugenhagen:")]), _vm._v(" The people of God are described by two kingdoms, that of Saul and that of David. One is a kingdom of hypocrisy; the other, a kingdom of the elect. The one group blossoms and is judged to be wise, powerful and righteous until the cross comes. But the other group is led through the cross and death into glory and life. In the meantime, however, you see nothing in them other than contempt, folly, sin and condemnation. They see nothing good in themselves whatsoever either, just as you see in many psalms. This is the hidden way of God in the flesh, which has been revealed to little children. It is said of Saul’s reign in the last chapter of Isaiah, “Before she was in labor, she gave birth.” That is not of God. But David’s reign is of God, which is from eternity in Christ. At first, David truly represents Christ, our head. Ever after, he represents all who are in Christ. "), _c('i', [_vm._v("Commentary on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-240-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-240",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Of the Spirit of God That Came on David.")]), _vm._v(" "), _c('i', [_vm._v("Andrew Willet:")]), _vm._v(" By the spirit we understand the excellent graces and gifts of the spirit with which David was now endued and made fit for the kingdom—Saul being deprived, since he was rejected from the kingdom. An example of the gift of the Spirit was fortitude and magnanimity, through which David did not fear to fight with a lion and a bear. David was also given a gift of prophecy, through which he began to craft and sing divine psalms and hymns to the praise of God. The blessing of God was with David, and his spirit assisted him through which he did all things happily, providentially and prosperously. . . . Besides, the spirit of God came in a further degree on David than it had on Saul, for it framed David’s heart to obedience to the will of God and it wrought in him true sanctification, which Saul did not have since he only received the Spirit for a certain time to perform temporary heroic acts. "), _c('i', [_vm._v("Harmony on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-239-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-239",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")])])])])]), _vm._v(" "), _c('h5', {
    attrs: {
      "id": "sigil_toc_id_87"
    }
  }, [_c('b', [_vm._v("16:14a")]), _vm._v(" "), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("God’s Spirit Departs from Saul")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Temporary Spirit.")]), _vm._v(" "), _c('i', [_vm._v("Johannes Bugenhagen:")]), _vm._v(" It says that “the Spirit departed from Saul.” I ask: what is this? Has not enough of Saul’s impiety been described above? Why is this the first time that it is written that the Spirit of the Lord departed from him? I answer: Thus is the Spirit of the Lord to sinners who have fallen away from God. It argues against the unbelief of their conscience, just as Christ says: the Spirit “will "), _c('a', {
    attrs: {
      "id": "_idTextAnchor2991"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2992"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2993"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2994"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2995"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2996"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2997"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2998"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2999"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3000"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3001"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3002"
    }
  }), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page74",
      "title": "74"
    }
  }), _vm._v("convict the world concerning sin and righteousness and judgment: concerning sin, because they do not believe in him.” But it withdraws at that time when those who are despairing surrender to a depraved mind, when a chiding spirit can no longer strengthen them. They are despisers, and they rush into wicked deeds. This is what the Lord said in Genesis: “My Spirit shall not abide in humans forever.” Therefore, before this time Saul could be conscious of his sins; after this, he despises everything and wants to establish himself as king, even when he sees the kingdom going to David, as you will see below. You can be sure that this is the highest impiety, to want to fight openly against God. "), _c('i', [_vm._v("Commentary on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-238-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-238",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("God Can Revoke His Gifts.")]), _vm._v(" "), _c('i', [_vm._v("Hans Denck:")]), _vm._v(" Now, since God does not will sin but still knows that it happens, we should not in this case trouble ourselves about him. God will not become desperate in himself, as we do. His foreknowledge, which is unknown to us, will surely accord with his will (of which even the perverse know something) apart from our inquisitiveness. But thus the clever must become fools who yearn to know God’s mysteriousness and to despise the acknowledged intention of his commandments.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("You say: We do not need foreknowledge, as you say, except for a consolation to all the elect that they may know that all their help and salvation lie in the hand of God and that no power is so mighty that it will or could wrest it from him. Response: This consolation you can give no one and also none can take from you, for he who has committed himself to the chastisement of the Father and who has tasted partially the sweetness of the bitter cross, to him the Father reveals himself through his Spirit in defiance before all his enemies, but, nonetheless, he must fear God and despise no one. For those whom God has received in faith he can and will reject again if he does not remain in faith, since he did not even spare the angels because they were so secure that they thereby developed satisfaction in themselves and forgot God. Therefore also Paul, the elect instrument of God, says now in vain: Let him who stands take heed lest he fall! If God gave his Spirit to Saul the king and took it again, and if it is nevertheless true that he never regrets his gifts, what should be wrong if he were to take from us the talent he gave us so that we have nothing—that is, would the one for whom grace means nothing nevertheless remain true and just? Speak out, whoever will, is it not a misuse of foreknowledge to want to be certain of the Lord’s reward (God help us!) regardless of how well we serve him? "), _c('i', [_vm._v("Whether God Is the Cause of Evil.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-237-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-237",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")])])])])]), _vm._v(" "), _c('h5', {
    attrs: {
      "id": "sigil_toc_id_88"
    }
  }, [_c('b', [_vm._v("16:14b-15")]), _vm._v(" "), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("A Harmful Spirit")]), _vm._v(" "), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("Sent from the Lord")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("All God’s Doing.")]), _vm._v(" "), _c('i', [_vm._v("John Calvin:")]), _vm._v(" I confess indeed that it is often by means of Satan’s intervention that God acts in the wicked, but in such a way that Satan performs his part by God’s impulsion and advances as far as he is allowed. An evil spirit troubles Saul; but it is said to have come from God, that we may know that Saul’s madness proceeds from God’s just vengeance. . . . To sum up, since God’s will is said to be the cause of all things, I have made his providence the determinative principle for all human plans and works, not only in order to display its force in the elect, who are ruled by the Holy Spirit, but also to compel the reprobate to obedience. "), _c('i', [_vm._v("Institutes 1.18.2.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-236-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-236",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Evil Spirits Sent by God Alone.")]), _vm._v(" "), _c('i', [_vm._v("George Gifford:")]), _vm._v(" I hold it no small folly for any person to think that the Lord does not now scourge his children, at least some of them, for their good, by the devil. There is no doubt that the devil has power given him to afflict, uses all the craft he can and will seem to be sent by a witch. The devil will make it appear that he is not sent from God but from the anger of a poor woman. And now, "), _c('a', {
    attrs: {
      "id": "_idTextAnchor3003"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3004"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3005"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3006"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3007"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3008"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3009"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3010"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3011"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3012"
    }
  }), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page75",
      "title": "75"
    }
  }), _vm._v("touching the wicked, who provoke God by their wicked sins and unbelief, may we not read in the Scriptures that an evil spirit was sent from God to King Saul, which haunted and vexed him? Was this spirit sent by a witch? . . . As I said before, here is the deep craft of Satan: that he will appear to be sent by witches whereas, in truth, God sent him, seeing none can send him but God. "), _c('i', [_vm._v("A Dialogue Concerning Witches and Witchcraft.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-235-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-235",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Working by Emission and Permission.")]), _vm._v(" "), _c('i', [_vm._v("Andrew Willet:")]), _vm._v(" Satan’s service and ministry is not absolutely accepted and pleasing to God. Further, there is a double work to be considered in the evil ministering spirits. For either they are ministers of outward punishments only—as in vexing and afflicting the body—in which case they work by "), _c('i', [_vm._v("emission")]), _vm._v(", that is, sending from God; or they also urge on and tempt to evil, in which case they work only by the "), _c('i', [_vm._v("permission")]), _vm._v(" or sufferance of God. Satan assaulted Saul in both of these ways, for both his body was vexed and his mind was tempted. "), _c('i', [_vm._v("Harmony on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-234-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-234",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19")])])])])]), _vm._v(" "), _c('h5', {
    attrs: {
      "id": "sigil_toc_id_89"
    }
  }, [_c('b', [_vm._v("16:16-23")]), _vm._v(" "), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("David’s Music Soothes Saul’s Bad Spirit")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Restraining Saul’s Evil Spirit.")]), _vm._v(" "), _c('i', [_vm._v("Martin Luther:")]), _vm._v(" David . . . often banished the evil spirit of Saul or restrained and subdued it with his lyre. . . . For the evil spirit is ill at ease wherever God’s Word is sung or preached in true faith. He is a spirit of gloom and cannot abide where he finds a spiritually happy heart, that is, where the heart rejoices in God and in his Word. "), _c('i', [_vm._v("Treatise on the Last Words of David.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-233-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-233",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("The Godly Are Like David’s Harp.")]), _vm._v(" "), _c('i', [_vm._v("Thomas Adams:")]), _vm._v(" One good person can do much good for many. They not only act as chains to the hands of God by holding them back from judgment, but they are also a happy prevention of sin. They keep God from being angry; and when God is angry, they calm God. Godly people are like David’s harp; they chase away evil spirits from people’s company. . . . For in his presence . . . insolence grows ashamed, course jokes appear foolish, drunkards become sober, blasphemers have their lips sealed up and the mouth of all wickedness is stopped. This good comes by the good. "), _c('i', [_vm._v("The Spiritual Navigator.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-232-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-232",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Music, the Joy on the Earth.")]), _vm._v(" "), _c('i', [_vm._v("Martin Luther:")])]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "verse"
  }, [_vm._v("Of all the joys upon this earth")]), _vm._v(" "), _c('p', {
    staticClass: "verse"
  }, [_vm._v("None has for men a greater worth")]), _vm._v(" "), _c('p', {
    staticClass: "verse"
  }, [_vm._v("Than what I give with my ringing")]), _vm._v(" "), _c('p', {
    staticClass: "verse"
  }, [_vm._v("And with voices sweetly singing.")]), _vm._v(" "), _c('p', {
    staticClass: "verse"
  }, [_vm._v("There cannot be an evil mood")]), _vm._v(" "), _c('p', {
    staticClass: "verse"
  }, [_vm._v("Where there are singing fellows good,")]), _vm._v(" "), _c('p', {
    staticClass: "verse"
  }, [_vm._v("There is no envy, hate nor ire,")]), _vm._v(" "), _c('p', {
    staticClass: "verse"
  }, [_vm._v("Gone are through me all sorrows dire;")]), _vm._v(" "), _c('p', {
    staticClass: "verse"
  }, [_vm._v("Greed, care and lonely heaviness")]), _vm._v(" "), _c('p', {
    staticClass: "verse"
  }, [_vm._v("No more do they the heart oppress.")]), _vm._v(" "), _c('p', {
    staticClass: "verse"
  }, [_vm._v("Each man can in his mirth be free")]), _vm._v(" "), _c('p', {
    staticClass: "verse"
  }, [_vm._v("Since such a joy no sin can be.")]), _vm._v(" "), _c('p', {
    staticClass: "verse"
  }, [_vm._v("But God in me more pleasure finds")]), _vm._v(" "), _c('p', {
    staticClass: "verse"
  }, [_vm._v("Than in all joys of earthly minds.")]), _vm._v(" "), _c('p', {
    staticClass: "verse"
  }, [_vm._v("Through my bright power the devil shirks")]), _vm._v(" "), _c('p', {
    staticClass: "verse"
  }, [_vm._v("His sinful, murderous, evil works.")]), _vm._v(" "), _c('p', {
    staticClass: "verse"
  }, [_vm._v("Of this King David’s deeds do tell")]), _vm._v(" "), _c('p', {
    staticClass: "verse"
  }, [_vm._v("Who pacified King Saul so well")]), _vm._v(" "), _c('p', {
    staticClass: "verse"
  }, [_vm._v("By sweetly playing on the lyre")]), _vm._v(" "), _c('p', {
    staticClass: "verse"
  }, [_vm._v("And thus escaped his murderous ire.")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('i', [_vm._v("A Preface for All Good Hymnals.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-231-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-231",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("The Remedy of David’s Harp.")]), _vm._v(" "), _c('i', [_vm._v("Charles Drelincourt:")]), _vm._v(" Take pleasure to meditate often on God’s wonderful works and sing forth his praises. The spiritual songs inspired by the Holy Spirit commonly appease all the evil motions of our mind and they also produce in us a holy joy and celestial peace. Just like when Saul was tormented with a "), _c('a', {
    attrs: {
      "id": "_idTextAnchor3013"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3014"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3015"
    }
  }), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page76",
      "title": "76"
    }
  }), _vm._v("wicked spirit, David was appointed with his harp to play before him and by that means quieted his troubled mind. Likewise, when hatred, anger, revenge, covetousness, ambition, lust or any other of the unruly passions—which are like evil spirits—disturb and torture our souls within us, we must seek a remedy from David’s harp and sing to the Lord in spiritual songs and hymns. "), _c('i', [_vm._v("Christian Defense Against the Fears of Death.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-230-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-230",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Good Music Drives Out Bad Habits.")]), _vm._v(" "), _c('i', [_vm._v("Thomas Adams:")]), _vm._v(" A gambler will hold so long as his money lasts, an adulterer so long as his loins last, but a drunkard so long as his lungs and life last. A philosopher, once finding himself in the company of drunkards where a musician ruled the disorderly gathering, charged the musician to change his music into a better tune. By doing so he brought the drunkards to sobriety; and casting away their drinks, they were ashamed of all they had done. But our drunkards have not the patience to hear such music. Saul was vexed with an evil spirit, but David’s harp expelled him. O that we knew that instrument or lesson, which could work such a reformation! We would double and triple that note, which might bring about such a cure. "), _c('i', [_vm._v("Commentary on 2 Peter.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-229-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-229",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Playing Music with David.")]), _vm._v(" "), _c('i', [_vm._v("Johannes Bugenhagen:")]), _vm._v(" The art of instrumental music back then was delightful in itself, just as it is now. But unlike we who rejoice in dirty songs, they only sang to God about praise and mercy, composing psalms and hymns that the devil could not bear and in which faith was played and sung. This was no doubt true of David’s songs too. Therefore, as often as you sing from a spirit of instruction to the Lord, you understand how to play the harp with David, especially when those songs restore the senses from the snare of the devil through God’s Word. But, as in David’s case, it is also important that the Lord is sought. Otherwise, “We played the flute for you, and you did not dance; we sang a dirge, and you did not weep.” "), _c('i', [_vm._v("Commentary on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-228-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-228",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Music and Madness.")]), _vm._v(" "), _c('i', [_vm._v("Giovanni Diodati:")]), _vm._v(" The musician was only sought for when Saul had fits of rage or melancholy, for he had some respites and spaces between these fits. . . . It’s not that musical sounds or any other corporal and sensible means have any power over the devil, who is only let loose, it should be noted, by God’s permission. The situation was this: With the supernatural madness or rage, there was a bodily defect in the mind and an exasperation of the spirits, which are the organs of diabolical operation in such cases. And music, by reducing the spirits of human beings for a time to some sweet concordance and harmony, makes the corporal or bodily instrument less subject to the devil’s operation. That is, unless this sound was accompanied with some divine word or subject whose power and respect repressed and quelled the devil’s action for the present. It’s also possible that some motion of God’s Spirit was awakened in Saul at times by prophetic music, as when he later prophesied. . . . Or finally, it’s possible that God of his free will determined to cooperate with David’s playing of music to lead Saul to need David to remain in the king’s court. "), _c('i', [_vm._v("Annotations on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-227-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-227",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26")])])])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "_idContainer029"
    }
  }, [_c('p', {
    staticClass: "PER_Top-extra-space"
  }, [_c('span', {
    staticClass: "com-rorohiko-pagestaker-style"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor3016"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3017"
    }
  })]), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page77",
      "title": "77"
    }
  })]), _vm._v(" "), _c('h2', {
    staticClass: "PER_ScriptureCenter",
    attrs: {
      "id": "sigil_toc_id_90"
    }
  }, [_c('span', {
    staticClass: "RH-marker"
  }, [_vm._v("17:1-58")]), _vm._v(" DAVID AND GOLIATH")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("1")]), _c('i', [_vm._v("Now the Philistines gathered their armies for battle. And they were gathered at Socoh, which belongs to Judah, and encamped between Socoh and Azekah, in Ephes-dammim.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("2")]), _c('i', [_vm._v("And Saul and the men of Israel were gathered, and encamped in the Valley of Elah, and drew up in line of battle against the Philistines.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("3")]), _c('i', [_vm._v("And the Philistines stood on the mountain on the one side, and Israel stood on the mountain on the other side, with a valley between them.")]), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("4")]), _c('i', [_vm._v("And there came out from the camp of the Philistines a champion named Goliath of Gath, whose height was six")]), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("a")]), _vm._v(" "), _c('i', [_vm._v("cubits")]), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("b")]), _vm._v(" "), _c('i', [_vm._v("and a span.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("5")]), _c('i', [_vm._v("He had a helmet of bronze on his head, and he was armed with a coat of mail, and the weight of the coat was five thousand shekels")]), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("c")]), _vm._v(" "), _c('i', [_vm._v("of bronze.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("6")]), _c('i', [_vm._v("And he had bronze armor on his legs, and a javelin of bronze slung between his shoulders.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("7")]), _c('i', [_vm._v("The shaft of his spear was like a weaver’s beam, and his spear’s head weighed six hundred shekels of iron. And his shield-bearer went before him.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("8")]), _c('i', [_vm._v("He stood and shouted to the ranks of Israel, “Why have you come out to draw up for battle? Am I not a Philistine, and are you not servants of Saul? Choose a man for yourselves, and let him come down to me.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("9")]), _c('i', [_vm._v("If he is able to fight with me and kill me, then we will be your servants. But if I prevail against him and kill him, then you shall be our servants and serve us.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("10")]), _c('i', [_vm._v("And the Philistine said, “I defy the ranks of Israel this day. Give me a man, that we may fight together.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("11")]), _c('i', [_vm._v("When Saul and all Israel heard these words of the Philistine, they were dismayed and greatly afraid.")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("12")]), _c('i', [_vm._v("Now David was the son of an Ephrathite of Bethlehem in Judah, named Jesse, who had eight sons. In the days of Saul the man was already old and advanced in years.")]), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("d")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("13")]), _c('i', [_vm._v("The three oldest sons of Jesse had followed Saul to the battle. And the names of his three sons who went to the battle were Eliab the firstborn, and next to him Abinadab, and the third Shammah.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("14")]), _c('i', [_vm._v("David was the youngest. The three eldest followed Saul,")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("15")]), _c('i', [_vm._v("but David went back and forth from Saul to feed his father’s sheep at Bethlehem.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("16")]), _c('i', [_vm._v("For forty days the Philistine came forward and took his stand, morning and evening.")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("17")]), _c('i', [_vm._v("And Jesse said to David his son, “Take for your brothers an ephah")]), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("e")]), _vm._v(" "), _c('i', [_vm._v("of this parched grain, and these ten loaves, and carry them quickly to the camp to your brothers.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("18")]), _c('i', [_vm._v("Also take these ten cheeses to the commander of their thousand. See if your brothers are well, and bring some token from them.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("19")]), _c('i', [_vm._v("Now Saul and they and all the men of Israel were in the Valley of Elah, fighting with the Philistines.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("20")]), _c('i', [_vm._v("And David rose early in the morning and left the sheep with a keeper and took the provisions and went, as Jesse had commanded him. And he came to the encampment as the host was going out to the battle line, shouting the war cry.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("21")]), _c('i', [_vm._v("And Israel and the Philistines drew up for battle, army against army.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("22")]), _c('i', [_vm._v("And David left the things in charge of the keeper of the baggage and ran to the ranks and went and greeted his brothers.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("23")]), _c('i', [_vm._v("As he talked with them, behold, the champion, the Philistine of Gath, Goliath by name, came up out of the ranks of the Philistines and spoke the same words as before. And David heard him.")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("24")]), _c('i', [_vm._v("All the men of Israel, when they saw the man, fled from him and were much afraid.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("25")]), _c('i', [_vm._v("And the men of Israel said, “Have you seen this man who has come up? Surely he has come up to defy Israel. And the king will enrich the man who kills him with great riches and will give him his daughter and make his father’s house free in Israel.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("26")]), _c('i', [_vm._v("And David said to the men who stood by him, “What shall be done for the man who kills this Philistine and takes away the reproach from Israel? For who is this uncircumcised Philistine, that he should defy the armies of the living God?”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("27")]), _c('i', [_vm._v("And the people answered him in the same way, “So shall it be done to the man who kills him.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("28")]), _c('i', [_vm._v("Now Eliab his eldest brother heard when he spoke to the men. And Eliab’s anger was kindled against David, and he said, “Why have you come down? And with whom have you left those few sheep in the wilderness? I know your presumption and the evil of your heart, for you have come down to see the battle.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("29")]), _c('i', [_vm._v("And David said, “What have I done now? Was it not but a word?”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("30")]), _c('i', [_vm._v("And he turned away from "), _c('a', {
    attrs: {
      "id": "_idTextAnchor3018"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3019"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3020"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3021"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3022"
    }
  })]), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page78",
      "title": "78"
    }
  }), _c('i', [_vm._v("him toward another, and spoke in the same way, and the people answered him again as before.")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("31")]), _c('i', [_vm._v("When the words that David spoke were heard, they repeated them before Saul, and he sent for him.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("32")]), _c('i', [_vm._v("And David said to Saul, “Let no man’s heart fail because of him. Your servant will go and fight with this Philistine.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("33")]), _c('i', [_vm._v("And Saul said to David, “You are not able to go against this Philistine to fight with him, for you are but a youth, and he has been a man of war from his youth.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("34")]), _c('i', [_vm._v("But David said to Saul, “Your servant used to keep sheep for his father. And when there came a lion, or a bear, and took a lamb from the flock,")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("35")]), _c('i', [_vm._v("I went after him and struck him and delivered it out of his mouth. And if he arose against me, I caught him by his beard and struck him and killed him.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("36")]), _c('i', [_vm._v("Your servant has struck down both lions and bears, and this uncircumcised Philistine shall be like one of them, for he has defied the armies of the living God.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("37")]), _c('i', [_vm._v("And David said, “The")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("who delivered me from the paw of the lion and from the paw of the bear will deliver me from the hand of this Philistine.” And Saul said to David, “Go, and the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("be with you!”")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("38")]), _c('i', [_vm._v("Then Saul clothed David with his armor. He put a helmet of bronze on his head and clothed him with a coat of mail,")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("39")]), _c('i', [_vm._v("and David strapped his sword over his armor. And he tried in vain to go, for he had not tested them. Then David said to Saul, “I cannot go with these, for I have not tested them.” So David put them off.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("40")]), _c('i', [_vm._v("Then he took his staff in his hand and chose five smooth stones from the brook and put them in his shepherd’s pouch. His sling was in his hand, and he approached the Philistine.")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("41")]), _c('i', [_vm._v("And the Philistine moved forward and came near to David, with his shield-bearer in front of him.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("42")]), _c('i', [_vm._v("And when the Philistine looked and saw David, he disdained him, for he was but a youth, ruddy and handsome in appearance.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("43")]), _c('i', [_vm._v("And the Philistine said to David, “Am I a dog, that you come to me with sticks?” And the Philistine cursed David by his gods.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("44")]), _c('i', [_vm._v("The Philistine said to David, “Come to me, and I will give your flesh to the birds of the air and to the beasts of the field.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("45")]), _c('i', [_vm._v("Then David said to the Philistine, “You come to me with a sword and with a spear and with a javelin, but I come to you in the name of the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("of hosts, the God of the armies of Israel, whom you have defied.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("46")]), _c('i', [_vm._v("This day the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("will deliver you into my hand, and I will strike you down and cut off your head. And I will give the dead bodies of the host of the Philistines this day to the birds of the air and to the wild beasts of the earth, that all the earth may know that there is a God in Israel,")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("47")]), _c('i', [_vm._v("and that all this assembly may know that the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("saves not with sword and spear. For the battle is the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _c('i', [_vm._v("’s, and he will give you into our hand.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("48")]), _c('i', [_vm._v("When the Philistine arose and came and drew near to meet David, David ran quickly toward the battle line to meet the Philistine.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("49")]), _c('i', [_vm._v("And David put his hand in his bag and took out a stone and slung it and struck the Philistine on his forehead. The stone sank into his forehead, and he fell on his face to the ground.")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("50")]), _c('i', [_vm._v("So David prevailed over the Philistine with a sling and with a stone, and struck the Philistine and killed him. There was no sword in the hand of David.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("51")]), _c('i', [_vm._v("Then David ran and stood over the Philistine and took his sword and drew it out of its sheath and killed him and cut off his head with it. When the Philistines saw that their champion was dead, they fled.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("52")]), _c('i', [_vm._v("And the men of Israel and Judah rose with a shout and pursued the Philistines as far as Gath")]), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("f")]), _vm._v(" "), _c('i', [_vm._v("and the gates of Ekron, so that the wounded Philistines fell on the way from Shaaraim as far as Gath and Ekron.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("53")]), _c('i', [_vm._v("And the people of Israel came back from chasing the Philistines, and they plundered their camp.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("54")]), _c('i', [_vm._v("And David took the head of the Philistine and brought it to Jerusalem, but he put his armor in his tent.")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("55")]), _c('i', [_vm._v("As soon as Saul saw David go out against the Philistine, he said to Abner, the commander of the army, “Abner, whose son is this youth?” And Abner said, “As your soul lives, O king, I do not know.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("56")]), _c('i', [_vm._v("And the king said, “Inquire whose son the boy is.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("57")]), _c('i', [_vm._v("And as soon as David returned from the striking down of the Philistine, Abner took him, and brought him before Saul with the head of the Philistine in his hand.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("58")]), _c('i', [_vm._v("And Saul said to him, “Whose son are you, young man?” And David answered, “I am the son of your servant Jesse the Bethlehemite.”")])]), _vm._v(" "), _c('p', {
    staticClass: "small"
  }, [_c('b', [_vm._v("a")]), _vm._v(" Hebrew; Septuagint, Dead Sea Scroll and Josephus "), _c('i', [_vm._v("four")]), _vm._v(" "), _c('b', [_vm._v("b")]), _vm._v(" A "), _c('i', [_vm._v("cubit")]), _vm._v(" was about 18 inches or 45 centimeters "), _c('b', [_vm._v("c")]), _vm._v(" A "), _c('i', [_vm._v("shekel")]), _vm._v(" was about 2/5 ounce or 11 grams "), _c('b', [_vm._v("d")]), _vm._v(" Septuagint, Syriac; Hebrew "), _c('i', [_vm._v("advanced among men")]), _vm._v(" "), _c('b', [_vm._v("e")]), _vm._v(" An "), _c('i', [_vm._v("ephah")]), _vm._v(" was about 3/5 bushel or 22 liters "), _c('b', [_vm._v("f")]), _vm._v(" Septuagint; Hebrew "), _c('i', [_vm._v("Gai"), _c('br'), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('span', {
    staticClass: "com-rorohiko-pagestaker-style"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor3023"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3024"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3025"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3026"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3027"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3028"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3029"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3030"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3031"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3032"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3033"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3034"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3035"
    }
  })]), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page79",
      "title": "79"
    }
  }), _c('b', [_vm._v("Overview:")]), _vm._v(" For some of the reformers, the famous battle between David and Goliath serves as an allegory, which symbolizes the battle of Christ against Satan and that of belief against disbelief. Due to his strong faith in God, David, often regarded by the reformers as a type of Christ, proves victorious over a visibly more terrifying foe. Unarmed but for a few stones, David overpowers the giant Goliath by God’s providence. Fighting in the name of the Lord against the giant, David cannot lose the battle, inciting these interpreters to apply the battle between the humble David and the arrogant Goliath to our spiritual lives.")]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("An Allegory on David and Goliath.")]), _vm._v(" "), _c('i', [_vm._v("Johannes Bugenhagen:")]), _vm._v(" Goliath, lord of the Philistines, is the ruler of the world. Saul is a shepherd without faith. David is Christ and anyone who has a firm spirit in Christ. The Israelites are the common people, as yet unsure about the gospel, which goes forth from Christ and the good shepherd, that is, the inspired preacher of the gospel who stands above all enemies. Saul is in the habit of delaying, which makes all Israel fear the one Philistine. For this is what the kingdom of hypocrisy is like against Satan. God’s righteousness cannot endure this, for this is not the spirit of victory. But David alone (that is, Christ) saves the people. For this reason, it is among the most esteemed stories you will ever read in human history. Here you see David’s marvelous faith and zeal for his people against the blasphemy of their enemies, as he blazed—carried by the Spirit—for the glory of God. These are Christ’s benefits, presented to us so that from the beginning of his anointing David might show through God what the kingdom itself will produce through Christ, David’s son. This is also the result of all faith fighting against Satan’s cunning and against worldly wisdom and power. These are not the weapons of the flesh but the armor of God. "), _c('i', [_vm._v("Commentary on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-226-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-226",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("The Perennial Duel.")]), _vm._v(" "), _c('i', [_vm._v("Viktorin Strigel:")]), _vm._v(" The story of the duel between David and Goliath provides an eminent and wonderful example of faith. For David, full of faith and hope, requests and awaits the help of God. David undertakes this dangerous task, which God guides for the fortune and advantage of the church. This story reminds us of the victory of Christ and the church. This story admonishes us [to keep in mind] the victory of Christ and the church. For Christ repels the devil, opposing him with the word and prayer, just as the church, through the Word of God and through prayer, repels the same enemy and his heretical and tyrannical instruments. "), _c('i', [_vm._v("Commentary on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-225-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-225",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])])])])]), _vm._v(" "), _c('h5', {
    attrs: {
      "id": "sigil_toc_id_91"
    }
  }, [_c('b', [_vm._v("17:1-11")]), _vm._v(" "), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("The Giant Goliath Frightens the Israelites")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Diabolical Goliath.")]), _vm._v(" "), _c('i', [_vm._v("Lucas Osiander:")]), _vm._v(" Goliath’s tremendous size suggests that he might have come from the huge race of the giants, or Anakim, of whom some remained in the city of Gath (around Gaza and Ashdod) as recorded in Joshua 11. . . . From the weight of his armor, we can imagine what a monster of a man this Goliath was. This Goliath signifies the devil, who is terrifying and powerful and whose strength surpasses that of humans. "), _c('i', [_vm._v("Annotations on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-224-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-224",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Protection from the Vile and Powerful Creature.")]), _vm._v(" "), _c('i', [_vm._v("Viktorin Strigel:")]), _vm._v(" This splendid description of Goliath and his armor illustrates the faith of David. Even though he was an unadorned and unarmed novice, David nevertheless dared to go against an experienced and noble enemy in hand-to-hand combat. Meanwhile, the stature and weaponry of this dreaded and monstrous giant brought fear on Saul and the whole of Israel. Now, Goliath is a picture of the devil, whose power is described in the following words from Job 41: “He counts iron as straw, and bronze as rotten wood. On earth he has no equal, a creature without fear.” "), _c('a', {
    attrs: {
      "id": "_idTextAnchor3036"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3037"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3038"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3039"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3040"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3041"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3042"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3043"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3044"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3045"
    }
  }), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page80",
      "title": "80"
    }
  }), _vm._v("To which defense should we seek refuge so that we are protected from this very powerful spirit? God strengthens us and is our refuge and defense! "), _c('i', [_vm._v("Commentary on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-223-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-223",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Parallel Fear and Faith.")]), _vm._v(" "), _c('i', [_vm._v("Johannes Brenz:")]), _vm._v(" The more Goliath’s ferocity grew, the more the timidity and cowardice of the Israelites increased. The more abject the Israelites’ fear became, the more Goliath’s fearsome majesty increased, until the people’s souls fell to their feet and they became the most shameful sort of deserters. Those who notice this relationship between Goliath’s increasing ferocity and the Israelites increasing fearfulness will notice the parallel way in which the Lord gloriously restored David, who had been despised and turned away by the people. For we should learn that in the same way as God would exalt the one person David by his grace, so would God allow Saul and all his people who first scorned David to fall into a disgraceful ruin. "), _c('i', [_vm._v("Sermons on Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-222-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-222",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])])])])]), _vm._v(" "), _c('h5', {
    attrs: {
      "id": "sigil_toc_id_92"
    }
  }, [_c('b', [_vm._v("17:12-30")]), _vm._v(" "), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("David Cares for God’s Flock")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Over the Course of Forty Days.")]), _vm._v(" "), _c('i', [_vm._v("Andrew Willet:")]), _vm._v(" God ordained that forty days should be spent this way, thereby serving as the occasion through which David was sent to the camp to visit his brothers. This is the means by which the Lord appointed the conquest of Goliath. Likewise, the more the Israelites were in fear and the greater their perplexity, the more famous their victory and deliverance was, which they did not expect. This further evidences the great change and alteration that took place in Saul, namely, how the Spirit of God had forsaken him. From a valiant and courageous man with a heroic spirit, he grew to be a despicable coward. Whereas before in one day he had killed almost forty thousand of the Philistines, now, over the course of forty days, he was afraid to fight just one man. "), _c('i', [_vm._v("Harmony on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-221-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-221",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Obeying His Father.")]), _vm._v(" "), _c('i', [_vm._v("Lucas Osiander:")]), _vm._v(" David had been anointed king by Samuel in the previous chapter. Even so, he was not carrying himself around as if he were king. Instead, he was humbly obeying his father and providing for his absent brothers. For though Christ (the true David) was in the form of God, he emptied himself for our sake, taking the form of a servant and obeying the Father, even to death on a cross. And though he was sent first to his brothers (the Jewish people), it became known that he had in fact come to free all of humankind from Satan’s tyranny. Therefore children ought to imitate David’s obedience and remember that he rose to glory and dignity through obedience. "), _c('i', [_vm._v("Annotations on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-220-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-220",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("God Makes an Example of David.")]), _vm._v(" "), _c('i', [_vm._v("Johannes Brenz:")]), _vm._v(" When Goliath insulted the armies of Israel, there were many pious men in the army. However, they did not sin by not engaging Goliath in single combat because God had inspired for them to do so by means of a spiritual gift. Only David received this gift because God wanted to make him illustrious. "), _c('i', [_vm._v("Commentary on Genesis.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-219-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-219",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Of the Rewards.")]), _vm._v(" "), _c('i', [_vm._v("Andrew Willet:")]), _vm._v(" It is fit and proper that, as in the case with David, rewards should be given to those who offer their service in the defense of the commonwealth. For although we do not deserve an everlasting reward from the hands of God, yet a temporary reward may be deserved from the hands of people. And such rewards may be respected and aimed for, though chiefly the glory of God and the good of his church ought to move everyone to perform his duty. Now the rewards that Saul gave to David were three: (1) to join him in affinity in making him his son-in-law; (2) in endowing him with riches and enlarging his house—as in setting it free from taxes and other impositions—and (3) in advancing David to the state of nobility. But here Saul’s inconstancy "), _c('a', {
    attrs: {
      "id": "_idTextAnchor3046"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3047"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3048"
    }
  }), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page81",
      "title": "81"
    }
  }), _vm._v("and fickleness appeared: he was liberal in promising but slow in performing, which was evident in his unkind attitude toward David afterward. "), _c('i', [_vm._v("Harmony on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-218-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-218",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Whether David Was Overly Ambitious.")]), _vm._v(" "), _c('i', [_vm._v("Andrew Willet:")]), _vm._v(" David was not incited or stirred up by the hope of any kind of reward. . . . Rather, David was incited by the honor of God and the love of the people of God. Therefore, when David says: “What shall be done for the man who kills this Philistine and takes away the reproach from Israel?” he says in effect: “Who cares about receiving a promise? The indignity of the insult to the people of God, and the reproach they bear at the hand of this Philistine, is sufficient to provoke any man to action.” David offers two reasons for his decision. The first was taken from the person of the Philistine, who was an uncircumcised foreigner. The other was taken from one of the Israelites, who served the living God. In short, the Philistine’s insult was not to be endured. In this way, it was the honor of God and the reproach of the people of God that moved David to act. It was not the consideration of the reward. No, David was not won with these promises. In fact, when David appeared before Saul, he made no mention of any reward nor did he require any provision or promise from the king. "), _c('i', [_vm._v("Harmony on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-217-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-217",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("When the Shepherd Is Away, the Wolves Will Slay.")]), _vm._v(" "), _c('i', [_vm._v("Andrew Willet:")]), _vm._v(" The care and charge David had of his flock (being morally applied) shows what duty is required of the spiritual pastor toward his people. It also shows what causes of absence are allowable and when the shepherd ought not to be absent. Pastors ought not to be absent from their charges for long. And when their necessary occasions of being absent are completed, they are bound in conscience to return to their places. That these reasons are grounded on the Word of God and agreeable to the continual practice of the church of Christ we may demonstrate as follows.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("First, there is a great danger that accrues and grows to the pastors themselves if any of those souls that are committed to their charge perish in their absence through their negligence. As the prophet Ezekiel says, “If I say to the wicked, ‘O wicked one, you shall surely die,’ and you do not speak to warn the wicked to turn from his way, that wicked person shall die in his iniquity, but his blood I will require at your hand.”")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("I do wonder how negligent pastors, when they read this passage, can pass it over without trembling—seeing what danger they incur in omitting to admonish the people committed to them. As Jerome well says, “The loss of the flock is the shame of the shepherd.” In fact, such loss even leads to the shepherd’s everlasting shame and confusion—without God’s great mercy.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Second, the absence and negligence of the pastor proceeds from lack of love toward the flock. The one who does not love the flock does not love the one who owns the flock. Therefore our Savior says to Peter after he asked if he loved him, “Feed my sheep.” Therefore Pope Damasus I warns that anyone who is negligent in feeding the Lord’s flock, despite clear commendation, is found not to love the chief shepherd. And how can the one who does not love Christ be assured of Christ’s love toward him?")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Third, let the inconveniences be considered that grow when pastors are absent. To begin with, the people will soon fall away from zeal to coldness and from virtue to vice. Where good seed is not sown, thistles and weeds will spring up instead. The apostle found this to be true by experience in the church of the Galatians when he was absent from them. As he says, “It is always good to be made much of for a good purpose, and not only when I am present with you, my little children, for whom I am again in the anguish of childbirth until Christ is formed in you! I wish I could be present with you now and change my tone, for I am perplexed about you.” It seems that while the apostle was present, the Galatians were very enthusiastic and zealous, but in his absence their "), _c('a', {
    attrs: {
      "id": "_idTextAnchor3049"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3050"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3051"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3052"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3053"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3054"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3055"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3056"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3057"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3058"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3059"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3060"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3061"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3062"
    }
  }), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page82",
      "title": "82"
    }
  }), _vm._v("zeal and first love abated. Therefore the apostle Paul wished he was among them, so that he might change and apply his voice to admonition or exhortation, as each person’s case required. This is the same thing Ambrose feared. Being on some necessary occasion absent from his church, he wrote: “I was mindful of you, fearing, lest in my absence any might fall through negligence and succumb to the ways of Satan.” And Augustine complains that while he was absent from Hippo, the citizens lost a certain godly custom among them of clothing and coating the poor. Therefore it is evident that good things will soon be discontinued and grow out of use where the pastor is not present to call on the people.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Fourth, the more diligent the spiritual adversary is to harm the flock, the more vigilant the pastor should be to watch over it. Now the devil, as Saint Peter says, “prowls around like a roaring lion, seeking someone to devour.” And the wolf is most likely to invade the flock when the pastor is not near at hand to defend them. Therefore Saint Paul says, “I know that after my departure fierce wolves will come in among you, not sparing the flock.” So Ambrose says well that the wolves watch for the pastor’s absence, because while the pastors are present they cannot invade the sheep of Christ.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Fifth, how necessary the presence and residence of pastors and ministers in their churches is appears by the excellence and price of that object where their cure and charge lies. For indeed, they are watchmen not of people’s bodies, but of their souls; and they must give account for them. If a steward, a dispenser of temporal things, must be faithful, as Jacob watched his flock by day and night and whatever perished he made it good (Gen 31:39), how much more careful, circumspect and vigilant ought the dispenser of spiritual things be? The imperial laws have provided that advocates should stay out of the cities and places where they practiced. They should not busy themselves with other people’s affairs but attend to their own calling and charge. If those who merely fight for people’s bodies and their goods give such diligent attendance, how much more so is the same requisite for those who are charged with people’s souls? But nowadays it is counted so ordinary and easy a thing to be the pastor of souls that a person will require more diligence at his servant’s hands about his cattle than many will perform in the feeding of souls! God, in his good time, opens the eyes of some so they may see the great danger in which they, by their negligence and carelessness, cast themselves. God also makes them aware, so they may feel the heavy weight of the burden of souls.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Finally, not to heap up more arguments in so evident a matter, but pastors give great offense when they are absent unnecessarily. It is as if they were seeking to feed on their church rather than feeding their church. As the prophet Ezekiel complains of such idle shepherds, “You eat the fat, you clothe yourselves with the wool, you slaughter the fat ones, but you do not feed the sheep.” Saint Paul says to the Corinthians, “I seek not what is yours but you.” But those who do not care for Christ’s flock evidently proclaim that they do not seek them, but theirs. Of this kind of scandal and offense Augustine had experience in his people of Hippo. Of his flock he writes, “The people of Hippo, whose servant the Lord has made me, are so altogether weak that a little trouble is able to make them very sick: I found them at my return dangerously scandalized with my absence.” If the people took offense at Augustine’s necessary absence—for we know that such a holy man would not be absent without just cause—how much more grievous is the offense given by a pastor’s unnecessary absence? "), _c('i', [_vm._v("Harmony of 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-216-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-216",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("David’s Eldest Brother.")]), _vm._v(" "), _c('i', [_vm._v("Andrew Willet:")]), _vm._v(" Some think Eliab was speaking sternly to David out of the love and protection of an older brother for a younger one. Yet by means of the rough words he used and the untrue surmises he made, it is evident that Eliab spoke out of envy. Indeed, he spoke with great indignation. And this might be "), _c('a', {
    attrs: {
      "id": "_idTextAnchor3063"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3064"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3065"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3066"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3067"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3068"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3069"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3070"
    }
  }), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page83",
      "title": "83"
    }
  }), _vm._v("the reason why Eliab envied David, namely, because David was advanced to the king’s service and court, while Eliab, the firstborn brother, was neglected. It was for this reason that Eliab blamed David when he should have commended him—for by leaving his flock, David was merely obeying his father’s command to visit his brothers. In fact, Eliab took it on himself to judge David’s heart and affection, reckoning David’s goodness to pride and malice, whereas such virtues actually came forth from the Spirit of God in him. In this way David was envied by his brothers to serve as a type of Christ, who was rejected by his brothers the Jews. "), _c('i', [_vm._v("Harmony on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-215-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-215",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])])])])]), _vm._v(" "), _c('h5', {
    attrs: {
      "id": "sigil_toc_id_93"
    }
  }, [_c('b', [_vm._v("17:31-37")]), _vm._v(" "), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("David Prepares for Battle")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Serving Under a Prince.")]), _vm._v(" "), _c('i', [_vm._v("Edward Reynolds:")]), _vm._v(" Nothing makes a person more fearful of wars than the dangers and hazards that accompany them. But if a person can serve under such a prince whose employments are not only honorable but also safe; if he, who is able and faithful to make good his promise to us that none of the strategies or forces of the enemy will hurt us, but that they shall fly before us while we resist them; who would not volunteer in such services as are not liable to the casualties and vicissitudes, which usually attend other wars, where he might fight with safety, and come off with honor? David had experience of God’s power in delivering him from the lion and the bear. He was well assured that God, who was careful of sheep, would be more caring to his people Israel. This gave him greater willingness to encounter Goliath, whose assurance was only in himself and not in God. "), _c('i', [_vm._v("The Sinfulness of Sin.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-214-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-214",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Circumcision of the Heart.")]), _vm._v(" "), _c('i', [_vm._v("Andrew Willet:")]), _vm._v(" As David holds the Philistine to be without defense—since he is uncircumcised—so he encourages himself because he was circumcised and so within God’s covenant. But David does not look to mere circumcision. Instead, he looks at it in relation to the covenant. Otherwise there were many who were bodily circumcised who did not belong to the covenant and many bodily uncircumcised who were the servants of God. (This appears, for instance, in the book of Job.) As circumcision, then, was a mark and outward recognition of God’s people, so baptism is now. As David’s circumcision defended him from Goliath, so baptism now shields us from Satan—but not merely the washing of the flesh, but as it is a seal of the covenant of grace in Christ. "), _c('i', [_vm._v("Harmony on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-213-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-213",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("No Fear.")]), _vm._v(" "), _c('i', [_vm._v("Henry Airay:")]), _vm._v(" We read that David—after having experienced God’s help in his deliverance out of the paw of the lion and out of the paw of the bear—did not fear to encounter Goliath, but assured himself that “the Lord who delivered him out of the paw of the lion and the paw of the bear will deliver him from the hand of this Philistine.” In the same way, the children of God—after having felt the love of God in Christ Jesus in their souls and the testimony of the Spirit witnessing to their spirits that they are the sons of God—should not fear to encounter sin or Satan, but should assure themselves that nothing is able to separate them from the love of God in Christ Jesus. "), _c('i', [_vm._v("Lectures on Philippians.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-212-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-212",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")])])])])]), _vm._v(" "), _c('h5', {
    attrs: {
      "id": "sigil_toc_id_94"
    }
  }, [_c('b', [_vm._v("17:38-40")]), _vm._v(" "), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("Saul Outfits David but David Finds His Own Weapon")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Why David Put Off Saul’s Armor.")]), _vm._v(" "), _c('i', [_vm._v("Andrew Willet:")]), _vm._v(" David would have used the armor if it had been helpful for him. But perceiving that they would rather be an impediment to him than a help, he laid them aside. This also brought about God’s providence, in the sense that God would not have David use any external defense, so that the glory of the victory might only be given to God. Furthermore, as there was a difference between the spirits of David and of Saul in the way in which they were "), _c('a', {
    attrs: {
      "id": "_idTextAnchor3071"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3072"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3073"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3074"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3075"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3076"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3077"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3078"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3079"
    }
  }), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page84",
      "title": "84"
    }
  }), _vm._v("led, so also their armor was different. Saul trusted in his helmet and breastplate, but David put his confidence in God. In this way David was a figure of Christ, who conquered Satan not by outward pomp and worldly power but by spiritual weapons. "), _c('i', [_vm._v("Harmony on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-211-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-211",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Of David’s Weapons.")]), _vm._v(" "), _c('i', [_vm._v("Andrew Willet:")]), _vm._v(" David takes only his sling and certain smooth stones, for by such means the Lord brings to pass mighty things. Indeed, so that the glory and power of God might more fully be made manifest in the blessing of so simple a means—just as Moses brought waters out of the rock with his rod, Elisha healed the waters with salt and Christ cured the blind with spittle—David used this simple weapons because Israelites were formerly forbidden by the Philistines to use any iron weapons. David takes more than one stone—five all together—so that if at the first throw he fails, he might cast the others as needed. The typical application of these five stones to the five books of Moses, in which Satan is vanquished, is somewhat far-fetched, and therefore I will not stand on it. "), _c('i', [_vm._v("Harmony on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-210-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-210",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Leaving Room for the Captain.")]), _vm._v(" "), _c('i', [_vm._v("Edward Reynolds:")]), _vm._v(" When David went forth against Goliath, he did not grapple with him by his own strength, but with his sling and his stone overthrew him at a distance. It is not good to let Satan come too close to the soul, to let in his temptation, or to enter into any private and intimate combat with him. This was only for our captain to do who, we know, entered into the field with him as being certain of his own strength. But our only way to prevail against him is to take faith as a sling and Christ as a stone. "), _c('i', [_vm._v("The Sinfulness of Sin.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-209-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-209",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Walking in God’s Ways.")]), _vm._v(" "), _c('i', [_vm._v("Johannes Brenz:")]), _vm._v(" David approached Goliath, walking in the calling of God. Therefore God established his portion against Goliath. Why, if you wished, God would establish your portion "), _c('i', [_vm._v("if")]), _vm._v(" you walked by faith. "), _c('i', [_vm._v("Commentary on Romans.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-208-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-208",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19")])])])])]), _vm._v(" "), _c('h5', {
    attrs: {
      "id": "sigil_toc_id_95"
    }
  }, [_c('b', [_vm._v("17:41-58")]), _vm._v(" "), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("Fighting in the Name of the Lord")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Overcoming Death.")]), _vm._v(" "), _c('i', [_vm._v("Charles Drelincourt:")]), _vm._v(" When David showed himself with a purpose to fight with Goliath, he spoke to this dreadful Philistine in this manner: “I come to you in the name of the Lord of hosts, the God of the armies of Israel.” But you, Christian souls, when you are encountering death, you may say to it, “Not only do I come to you in the name of he who commands legions of angels and all the armies of immortal spirits, but I also come to you clothed with his armor, strengthened by his Holy Spirit and assisted by him in person.” For Jesus Christ, who has overcome death "), _c('i', [_vm._v("for us")]), _vm._v(", intends to overcome death "), _c('i', [_vm._v("by us")]), _vm._v(". We are the living stones that he has chosen of his wonderful grace and mercy to bring down that proud insulting enemy, who causes all creatures to tremble and cover their faces with shame and confusion. "), _c('i', [_vm._v("Christian Defense Against the Fears of Death.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-207-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-207",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("The Gospel of David’s Victory.")]), _vm._v(" "), _c('i', [_vm._v("William Tyndale:")]), _vm._v(" When David had killed Goliath the giant, glad tidings came to the Israelites that their fearful and cruel enemy was dead and that they were delivered out of all danger. For this gladness, they sang, danced and were joyful. In like manner, the good news or “gospel” of God is joyful tidings; and, as some say, it is a good hearing proclaimed by the apostles throughout all the world of Christ as the real heir of David. It is good news of how he has fought with sin, death and the devil and overcome them. The result of this is that all people who were in bondage to sin, wounded with death and overcome of the devil are— without their own merits or deserving—freed, justified, restored to life and saved. They are brought to liberty and "), _c('a', {
    attrs: {
      "id": "_idTextAnchor3080"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3081"
    }
  }), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page85",
      "title": "85"
    }
  }), _vm._v("reconciled to the favor of God and set at one with him again. These are tidings to as many as believe, laud, praise and thank God; and who are glad, sing and dance for joy. "), _c('i', [_vm._v("Doctrinal Treatises and Introductions to Other Portions of Holy Scriptures.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-206-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-206",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("All Christians Are Strong.")]), _vm._v(" "), _c('i', [_vm._v("Martin Luther:")]), _vm._v(" For though David was insignificant in person and weak compared with others, he nevertheless became a greater hero than Goliath and slew him. Therefore, because Christians all have the same Christ and his Spirit, every one of them, when they are most insignificant and weak, can do as much as the very strongest. For they shall, all of them, conquer sin, death and the world. They all gain the same victory, however different they may be. For there is one Spirit and one Christ in all of them, who protects them and helps them. To the world they may therefore appear to be nothing but falling and all be heroes and victors in that world. "), _c('i', [_vm._v("Lectures on Zechariah.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-205-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-205",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Little Person, Big Results.")]), _vm._v(" "), _c('i', [_vm._v("John Fisher:")]), _vm._v(" No man among all the great multitude of Israelites had the audacity or boldness to make battle with this monstrous creature, this Philistine, save only this little person David. It was Almighty God who gave him so great a boldness, although he was but little in appearance and stature. Nevertheless, he in no way feared to fight and make battle with this great and mighty giant. "), _c('i', [_vm._v("Commentary on the Seven Penitential Psalms.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-204-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-204",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("The Love of God.")]), _vm._v(" "), _c('i', [_vm._v("Edward Reynolds:")]), _vm._v(" Our very actions are wrought in us and carried to their end by the power of Christ, who has enough mercy, wisdom and strength to rescue us from the power of hell and death and from the danger of our own sick and proud hearts. To see a person—half a mile from his enemy—draw a sword to encounter him or take up a stone to hit him would be a ridiculous spectacle. For what could he do with such weapons by his own strength at such a distance? But if he mounted a cannon and pointed his target against the enemy, we would not wonder at this even though the distance would be great between them because the effect of it proceeds from the force of the materials and instruments he uses, namely, the powder, the bullet, the fire and the cannon. It seemed absurd in the eyes of the enemy for little David—with a shepherd’s bag and a sling—to go against an armed giant like Goliath. This produced in the giant’s proud heart much disdain and offense. But when we hear David mention the name of God, in the strength and confidence where he came against so proud an enemy, this makes us conclude that weak David was strong enough to battle against great Goliath. It was not our own strength but the love of God that is the foundation of our triumph over all enemies. "), _c('i', [_vm._v("Seven Sermons on Fourteenth Chapter of Hosea.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-203-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-203",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24")])])])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "_idContainer030"
    }
  }, [_c('p', {
    staticClass: "PER_Top-extra-space"
  }, [_c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page86",
      "title": "86"
    }
  })]), _vm._v(" "), _c('h2', {
    staticClass: "PER_ScriptureCenter",
    attrs: {
      "id": "sigil_toc_id_96"
    }
  }, [_c('span', {
    staticClass: "RH-marker"
  }, [_vm._v("18:1-30")]), _vm._v(" DAVID CONTINUES TO PREVAIL")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("1")]), _c('i', [_vm._v("As soon as he had finished speaking to Saul, the soul of Jonathan was knit to the soul of David, and Jonathan loved him as his own soul.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("2")]), _c('i', [_vm._v("And Saul took him that day and would not let him return to his father’s house.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("3")]), _c('i', [_vm._v("Then Jonathan made a covenant with David, because he loved him as his own soul.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("4")]), _c('i', [_vm._v("And Jonathan stripped himself of the robe that was on him and gave it to David, and his armor, and even his sword and his bow and his belt.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("5")]), _c('i', [_vm._v("And David went out and was successful wherever Saul sent him, so that Saul set him over the men of war. And this was good in the sight of all the people and also in the sight of Saul’s servants.")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("6")]), _c('i', [_vm._v("As they were coming home, when David returned from striking down the Philistine, the women came out of all the cities of Israel, singing and dancing, to meet King Saul, with tambourines, with songs of joy, and with musical instruments.")]), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("a")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("7")]), _c('i', [_vm._v("And the women sang to one another as they celebrated,")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('i', [_vm._v("“Saul has struck down his thousands,")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('i', [_vm._v("and David his ten thousands.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("8")]), _c('i', [_vm._v("And Saul was very angry, and this saying displeased him. He said, “They have ascribed to David ten thousands, and to me they have ascribed thousands, and what more can he have but the kingdom?”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("9")]), _c('i', [_vm._v("And Saul eyed David from that day on.")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("10")]), _c('i', [_vm._v("The next day a harmful spirit from God rushed upon Saul, and he raved within his house while David was playing the lyre, as he did day by day. Saul had his spear in his hand.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("11")]), _c('i', [_vm._v("And Saul hurled the spear, for he thought, “I will pin David to the wall.” But David evaded him twice.")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("12")]), _c('i', [_vm._v("Saul was afraid of David because the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("was with him but had departed from Saul.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("13")]), _c('i', [_vm._v("So Saul removed him from his presence and made him a commander of a thousand. And he went out and came in before the people.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("14")]), _c('i', [_vm._v("And David had success in all his undertakings, for the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("was with him.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("15")]), _c('i', [_vm._v("And when Saul saw that he had great success, he stood in fearful awe of him.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("16")]), _c('i', [_vm._v("But all Israel and Judah loved David, for he went out and came in before them.")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("17")]), _c('i', [_vm._v("Then Saul said to David, “Here is my elder daughter Merab. I will give her to you for a wife. Only be valiant for me and fight the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _c('i', [_vm._v("’s battles.” For Saul thought, “Let not my hand be against him, but let the hand of the Philistines be against him.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("18")]), _c('i', [_vm._v("And David said to Saul, “Who am I, and who are my relatives, my father’s clan in Israel, that I should be son-in-law to the king?”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("19")]), _c('i', [_vm._v("But at the time when Merab, Saul’s daughter, should have been given to David, she was given to Adriel the Meholathite for a wife.")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("20")]), _c('i', [_vm._v("Now Saul’s daughter Michal loved David. And they told Saul, and the thing pleased him.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("21")]), _c('i', [_vm._v("Saul thought, “Let me give her to him, that she may be a snare for him and that the hand of the Philistines may be against him.” Therefore Saul said to David a second time,")]), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("b")]), _vm._v(" "), _c('i', [_vm._v("“You shall now be my son-in-law.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("22")]), _c('i', [_vm._v("And Saul commanded his servants, “Speak to David in private and say, ‘Behold, the king has delight in you, and all his servants love you. Now then become the king’s son-in-law.’”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("23")]), _c('i', [_vm._v("And Saul’s servants spoke those words in the ears of David. And David said, “Does it seem to you a little thing to become the king’s son-in-law, since I am a poor man and have no reputation?”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("24")]), _c('i', [_vm._v("And the servants of Saul told him, “Thus and so did David speak.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("25")]), _c('i', [_vm._v("Then Saul said, “Thus shall you say to David, ‘The king desires no bride-price except a hundred foreskins of the Philistines, that he may be avenged of the king’s enemies.’ ” Now Saul thought to make David fall by the hand of the Philistines.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("26")]), _c('i', [_vm._v("And when his servants told David these words, it pleased David well to be the king’s son-in-law. Before the time had expired,")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("27")]), _c('i', [_vm._v("David arose and went, along with his men, and killed two hundred of the Philistines. And David brought their foreskins, which were given in full number to the king, that he might become the king’s son-in-law. And Saul gave him his daughter Michal for a wife.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("28")]), _c('i', [_vm._v("But when Saul saw and knew that the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("was with David, and that Michal, Saul’s daughter, loved him,")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("29")]), _c('i', [_vm._v("Saul was even more afraid of David. So Saul was David’s enemy continually.")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "com-rorohiko-pagestaker-style"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor3082"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3083"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3084"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3085"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3086"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3087"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3088"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3089"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3090"
    }
  })]), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page87",
      "title": "87"
    }
  }), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("30")]), _c('i', [_vm._v("Then the commanders of the Philistines came out to battle, and as often as they came out David had more success than all the servants of Saul, so that his name was highly esteemed.")])]), _vm._v(" "), _c('p', {
    staticClass: "small"
  }, [_c('b', [_vm._v("a")]), _vm._v(" Or "), _c('i', [_vm._v("triangles")]), _vm._v(", or "), _c('i', [_vm._v("three-stringed instruments")]), _vm._v(" "), _c('b', [_vm._v("b")]), _vm._v(" Hebrew "), _c('i', [_vm._v("by two"), _c('br'), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Overview:")]), _vm._v(" The reformers consistently view David as a messianic figure whose righteousness incites criticism and attacks from the unrighteous. In this case, Saul serves as the instrument of attack on account of his jealous and ungodly motives. Saul’s behavior toward David is malicious and, according to some of the commentators, demonic. Saul slyly offers his daughter to David, according to the interpreters, as a snare (and later marries her to another man). David’s friendship with Jonathan, by contrast, is the paradigm of godly and virtuous friendship, the likes of which set the ideal for relationships on earth.")]), _vm._v(" "), _c('h5', {
    attrs: {
      "id": "sigil_toc_id_97"
    }
  }, [_c('b', [_vm._v("18:1-5")]), _vm._v(" "), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("David and Jonathan’s Friendship")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("The Difference Between Jonathan and Saul.")]), _vm._v(" "), _c('i', [_vm._v("Johannes Bugenhagen:")]), _vm._v(" We see the faith of David, which is necessary when following the cross and when faith gets tested. His victory over Goliath is itself the occasion of persecutions, for Saul could not bear someone else to be liked more. We see from this that the saints bear punishment just as sinners do, but not on account of sins but on account of righteousness. For what honor would not have been worthy of David for such a holy deed? But it happens just as Christ says in the psalm, “In return for my love they accuse me, but I give myself to prayer. So they reward me evil for good, and hatred for my love.” Scripture truly describes the difference between Jonathan and Saul with respect to David. Jonathan’s character was shown earlier in his love of virtue and piety, according to these words, “Those who fear you will see me and rejoice, because I have hoped in your word.” But it is impossible for the ungodly to do anything but hate and persecute the godly. But Jonathan is not afraid of losing glory and majesty, even though his father’s kingdom would have belonged to him, because he does not look on his own concerns but those of God. But it would be with him like it is with us when some look kindly on us, while others despise or hate us. The one group is more hidden and appears weaker before the world than the majority and the powerful who are able to be secure. Still, God cares for us, so that we see God’s work in every desperate situation, believing in God’s mercy and protecting hand even in the midst of death and hell, and not (as Paul says in 2 Cor 1) trusting in ourselves. "), _c('i', [_vm._v("Commentary on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-202-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-202",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("True Friendship.")]), _vm._v(" "), _c('i', [_vm._v("Lambert Daneau:")]), _vm._v(" The ground and foundation of true Christian friendship is the admiration of virtue or of some special gift of God that resides in another—the praise or use of which respects either God himself or a person. This moved Jonathan to knit himself in most firm friendship with David, whom for his valiant heart and noble courage in vanquishing proud Goliath he highly esteemed, honored and entirely loved. Such persons—as either some singular gift of true godliness or some special praise of some moral virtue (whether justice, fortitude, liberality, etc.)—excel others, and are therefore worthily invested with the title of deserved commendation, whom we thoroughly love, entirely reverence and heartily favor. And this latter is the secret or the next cause that we commonly use to respect and to regard. But the former of the two is that which is occasioned, bred and brought forth by a secret instinct of the Spirit from God: namely, the mutual knitting together of minds and a like inclination and conformity of wills. For all true and holy friendship has its ground from God, in whom it is firmly established "), _c('a', {
    attrs: {
      "id": "_idTextAnchor3091"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3092"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3093"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3094"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3095"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3096"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3097"
    }
  }), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page88",
      "title": "88"
    }
  }), _vm._v("and by whom alone it continues sure, steadfast and permanent. "), _c('i', [_vm._v("True and Christian Friendship.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-201-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-201",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Religion and Friendship.")]), _vm._v(" "), _c('i', [_vm._v("Henry Airay:")]), _vm._v(" Sincerity in religion and true fear of the Lord are the best bands of Christian friendship. We read in secular stories of some individuals who were renowned for their rare friendships. But what are these but shadows in respect to the Christian body? What friendship of theirs came ever near that of Jonathan and David? . . . Indeed, generally where religion and fear of the Lord knits the knot, there the friendship is most sure and the duties thereof are best performed. If, therefore, you will have such a friend . . . when need requires it . . . join yourself to someone who is religious and who fears the Lord; and let your love be in the Lord and for the Lord. For what is the cause that friendship is so rare, and why is there such slackness in all sorts of people to help one another and to comfort one another in any time of need? Surely this is the reason: because our love is only a cold love, grounded on this or that worldly respect, instead of our love for one another being in the Lord and for the Lord. "), _c('i', [_vm._v("Lectures on Philippians.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-200-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-200",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Keeping One’s Promise.")]), _vm._v(" "), _c('i', [_vm._v("Lambert Daneau:")]), _vm._v(" It is written of Jonathan that he gave to David as a pledge, bond or pawn of their newly begotten friendship not only the solemn citing of the name of God but also other visible gifts and outward testimonies—namely, his robe, girdle, sword, bow and such other garments and furniture he had at that time. For such hearty courtesies make people not only the more mindful but also the more religious in the keeping and observing of their promises and covenants. "), _c('i', [_vm._v("True and Christian Friendship.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-199-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-199",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Disarming Death.")]), _vm._v(" "), _c('i', [_vm._v("Charles Drelincourt:")]), _vm._v(" Just as our Savior has once overcome death for us, he continues to subdue it in and by us. He does us not let us encounter our enemies alone, nor leave us in our agonies. In a day of battle a wise and provident general has an eye to every place and encourages his soldiers by his action and with his voice when he perceives they are at blows with the enemy: some he loads with praises, others with promises. By that means he encourages those who act bravely and rescue the weak and feeble, and those who are overwhelmed he furnishes with fresh supplies. This is the same way our Lord and Savior Jesus Christ, the great Lord of hosts, who sits above in the heavens in triumph and beholds all our combats and encounters, deals with us. When he perceives that we are too weak, in order that we might not be overcome by our dreadful enemies he furnishes us with his Holy Spirit, and his own armor, as Jonathan did David, when he delivered to him his cloak, his bow, his belt and his sword. Besides, this merciful Savior disarms death of its most hurtful weapons and takes away all its arrows and darts. "), _c('i', [_vm._v("Christian Defense Against the Fears of Death.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-198-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-198",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])])])])]), _vm._v(" "), _c('h5', {
    attrs: {
      "id": "sigil_toc_id_98"
    }
  }, [_c('b', [_vm._v("18:6-16")]), _vm._v(" "), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("Saul’s Jealousy of David")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Rules for Dancing.")]), _vm._v(" "), _c('i', [_vm._v("Martin Bucer:")]), _vm._v(" Because human nature has that feebleness by which it cannot always concentrate on grave and serious things but demands other rest besides sleep, there must also be provision made for certain rest from work and useful studies and a certain recreation of the strength of the spirit and of the body in play and games. This is especially the case when grave and serious things have been satisfied in wise moderation and prudence, insomuch that the kind of game is prescribed and exhibited for adults and youth in such a way that they do not have to fear any lessening of morals or delight in wicked idleness, and in a way that there can also be gained a certain strengthening of health as well as some addition in the cultivation of the mind. . . . These "), _c('a', {
    attrs: {
      "id": "_idTextAnchor3098"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3099"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3100"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3101"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3102"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3103"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3104"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3105"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3106"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3107"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3108"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3109"
    }
  }), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page89",
      "title": "89"
    }
  }), _vm._v("games should come from musical and gymnastic art. From this music should come poems and songs that present nothing futile, nothing inappropriate to the Christian profession and nothing obscene and wicked, but only sounds that set forth the praises of God and of his servants from all his works and judgments as these are set forth in holy Scripture. . . . To these may be added dances, but the dances of godly girls should be separate from the dances of young men, which may be danced to pure, wholesome and holy songs, with chaste and modest motion that befits those who profess godliness. . . . Such was the dance of holy girls who celebrated a song of victory for David and Saul when they returned from the killing of the Philistines. "), _c('i', [_vm._v("Reign of Christ.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-197-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-197",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Saul’s Sin Against the Holy Spirit.")]), _vm._v(" "), _c('i', [_vm._v("Johannes Bugenhagen:")]), _vm._v(" As you know, we do not carelessly regard the words of Scripture to be the simple legends they seem to be. For this chapter clearly shows us Saul’s envy, which is the sin against the Holy Spirit. Scripture insists more than once that Saul knew the Lord had departed from him to be with David, along with all the counsel and favor that went with him, so that Saul has fallen. He is clearly fighting against knowledge of the truth, and therefore against God, as you see shortly. This is not a mistake or ignorance; rather it is pure folly and desperate ungodliness. "), _c('i', [_vm._v("Commentary on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-196-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-196",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Vindictiveness Is a Great Anger.")]), _vm._v(" "), _c('i', [_vm._v("Philipp Melanchthon:")]), _vm._v(" Vindictiveness is a great anger, stemming from pride, one’s own wantonness to overwhelm or to blot out others without the orderly office of authority; such pride is often great, even though the perpetrator has no reason, as Cain, for imagining that God honors only the other and wishes to do nothing for him. This is very common, and all rational beings can understand that this vice is repugnant to many divine commandments. Pride, through which anger is kindled like a fire in the heart, is against the first commandment. Saul wishes to drive David out of the way in order that he alone may have authority. This unrighteous anger, this jealousy and hate and thirst for blood are against the commandment, “You shall not kill.” "), _c('i', [_vm._v("Theological Commonplaces (1555).")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-195-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-195",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Advantages of Adversity.")]), _vm._v(" "), _c('i', [_vm._v("Roger Hutchinson:")]), _vm._v(" Our nature is such that prosperity depraves us. Prosperity brings many people to destruction and fills them with pride and covetousness; it makes them negligent, dissolute, forgetful and unthankful. . . . Therefore the wise person admonishes . . . “When you have refreshed yourself and are full of food and drink and other things, then take heed to yourself; you stand on a slippery ground.” Adversity, on the other hand, makes us lowly, gentle, diligent, circumspect and pitied. It garnishes us with all flowers of virtue and expels all sin. David, as long as he was in trouble and vexation under Saul, was in favor with God and famous among the people; but after he reigned and governed Israel prosperously, did he not fall into sin? . . . The devil is crafty. Those he cannot supplant by adversity he overthrows with prosperity. "), _c('i', [_vm._v("Two Sermons of Oppression, Affliction and Patience.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-194-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-194",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("David’s Triumph.")]), _vm._v(" "), _c('i', [_vm._v("Johannes Brenz:")]), _vm._v(" Saul knew that David would succeed him as king. And so, considering himself to be in great danger, he planned to kill David. But all of his spirited attempts were in vain. And another event eventually showed this. For Joseph became the leader of his older brothers at the right time. And David became king, not as a normal family member of Saul’s. For Saul sinned to such an extent that not even David could preserve his family since it would all soon fall. But to David’s credit, the line of Saul was not damned. For although God removed a gift from someone and conferred it on another, he did "), _c('a', {
    attrs: {
      "id": "_idTextAnchor3110"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3111"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3112"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3113"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3114"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3115"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3116"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3117"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3118"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3119"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3120"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3121"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3122"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3123"
    }
  }), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page90",
      "title": "90"
    }
  }), _vm._v("not do it here for this reason, so that it would affect him inconveniently, but he would take counsel to his advantage by removal. "), _c('i', [_vm._v("Commentary on Romans.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-193-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-193",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Leering Eye.")]), _vm._v(" "), _c('i', [_vm._v("Lancelot Andrewes:")]), _vm._v(" There are two ways to convey sin to us: by the ear and by the eye. And there are two ways to discover sin: by the mouth and by the eye. This is because the eye is a way both in the conveyance and discovery of the sin. . . . When Saul saw how David was esteemed, it is there said that he “eyed David from that day on,” as if he looked asquint, in that he looked on David with a leering eye. This is because he envied and hated David. "), _c('i', [_vm._v("Collection of Lectures.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-192-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-192",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Lack of True Obedience.")]), _vm._v(" "), _c('i', [_vm._v("Daniel Dyke:")]), _vm._v(" Note that constancy accompanies true obedience. For instance, the Scripture says that when we walk in the commandments of the Lord, we walk in peace. Conversely, the wicked are said to be involved in covetousness in that they constantly follow it as the thief does his trade. However, the “temporary” wicked person does not walk in these ways as does the honest traveler in the broad highway. . . . His obedience is like the true Christian’s disobedience, which is not settled and constant but is only for a time. The good Christian quickly remembers himself and returns to his course of godliness when, through a temporary lapse, he has begun to stray. In the same way, the “temporary” Christian quickly returns to his intermittent wickedness even though he occasionally stumbles on piety. His obedience is a moody and passionate obedience; it is soon forgotten. It is like Saul’s affection for David. When the evil spirit came on Saul, the piety about which he before seemed to make much of departed along with the spear in his hand. He did not, nor could he, cleave to the Lord with a full purpose of heart as the true believer can. "), _c('i', [_vm._v("The Mystery of Self-Deceiving.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-191-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-191",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])])])])]), _vm._v(" "), _c('h5', {
    attrs: {
      "id": "sigil_toc_id_99"
    }
  }, [_c('b', [_vm._v("18:17-30")]), _vm._v(" "), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("Saul Offers Michal to David as a Wife at a Price")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("On Hypocrisy.")]), _vm._v(" "), _c('i', [_vm._v("Martin Luther:")]), _vm._v(" King Saul did not like David and would have liked to kill him; but since he wanted to be holy, he decided not to kill him himself, but to send him among the Philistines to be killed there, so that his hand would remain innocent. Look at this beautiful Pharisaic holiness! It can purify itself and stay pious as long as it does not kill with its own hand, though its heart may be crammed full of anger, hate and envy, of hidden and evil schemes of murder, and though its tongue may be loaded with curses and blasphemies. "), _c('i', [_vm._v("The Sermon on the Mount.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-190-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-190",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Saul’s Deceitful Plan.")]), _vm._v(" "), _c('i', [_vm._v("Johannes Bugenhagen:")]), _vm._v(" Saul said to David, “Behold, my daughter.” This is an example of the greatest men being seen as hypocrites. They see themselves as good men. They handle themselves in such a way as to excuse their sins. They say to us, “It is not lawful for us to put anyone to death” and they did not enter Pilate’s quarters so that they would not be defiled and could eat the Passover. Scripture calls them men of blood, of deceit, of lies and of works of iniquity, as in Psalms 5, 58, 140 and Isaiah 59, etc. This reveals Saul’s hypocrisy, which continues to the end of the chapter. "), _c('i', [_vm._v("Commentary on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-189-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-189",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("God’s Three-Knot Chain.")]), _vm._v(" "), _c('i', [_vm._v("Lancelot Andrewes:")]), _vm._v(" With people it oftentimes happens that saying is without doing. That is, too often people promise and say much, but do nothing; and many times we see a person’s doing to be without completing. . . . Saul said he would give Michal to David, but he did not do it. However, it is not so with God; for he is not “yes” in saying, and “no” in doing and performing. Rather, as certain as he says a thing, so surely it is done—for his word is truth, and his deeds declare it. . . . If God begins a good work, he will surely finish it thoroughly. . . . If he is the beginner "), _c('a', {
    attrs: {
      "id": "_idTextAnchor3124"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3125"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3126"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3127"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3128"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3129"
    }
  }), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page91",
      "title": "91"
    }
  }), _vm._v("and author of anything, he will also perfect it. . . . This is the first consideration when it comes to God: that these three things—saying, doing and perfecting—are inseparable in him, joined and linked together as a chain, where all proceed after the other and all follow the first. "), _c('i', [_vm._v("Collection of Lectures.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-188-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-188",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Hidden Agenda.")]), _vm._v(" "), _c('i', [_vm._v("Thomas Adams:")]), _vm._v(" David had grown so gracious with the people that the king could not harm him. Therefore he lured him into the jaws of death by no less a price than his eldest daughter. What could be spoken more honorably, more graciously? A king could not offer a more noble gift than his own daughter nor desire a more gracious reward than to fight the Lord’s battles. What a saint, what a friend was Saul! Yet he never meant so much mischief to David and so much unfaithfulness to God as in this offer! A good man is never safe from the false-hearted: For when they make the fairest weather, that’s when the greatest danger is. Whatever the appearance was, Saul meant nothing to David but death. Yet this falsehood did discover itself, for Merab was not given to David but to Adriel. Seeing that all these dangers could not bring about what Saul desired, he himself would not bring about what he promised. Yet still he would be a friend and he had another daughter for David; even though she was younger, she was the more affectionate one. She was as sick in love as her father was of hate toward David. Saul was glad of this, as his daughter could never live to do him better service. If she could betray David, David would have his goodwill to marry her. Thus this false-hearted king sacrificed his own child to his envy, hoping that her honest and sincere love would betray her worthy and innocent husband. There is a story of an emperor in Turkey who married his own daughter to a man on the one day and then after a night’s pleasure sent for his head the next morning. Are there none who care not to cast away a daughter on their friend for their own ends? Such is the rage of desperate malice; rather than not ruin those they hate, they will do it through the means of their own children. “Faithful are the wounds of a friend, but the kisses of an enemy are deceitful.” . . . We pray, from the hands of all our enemies, and (of all our enemies) from the hands of our deceitful friends, good Lord deliver us. "), _c('i', [_vm._v("Commentary on 2 Peter.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-187-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-187",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Giftless Gift.")]), _vm._v(" "), _c('i', [_vm._v("Daniel Dyke:")]), _vm._v(" The devil sometimes gives the truth. In fact, he sometimes sets a snare to catch the truth. He does so as Saul, a good student in Satan’s school, did for David in giving him Michal as a wife. “I will give him her,” Saul reasons, “so that she may be a snare to him and so that the hand of the Philistines may be upon him.” What a splendid show of favor and goodwill! Yet David was so ravished by the offer, thinking about his lowness of birth, that he was honored with the prospect of so great a marriage. But it is but bait—a phony poison is covering up the hook. . . . It is just as the proverb says: Saul’s gift to David was a “giftless gift.” It was bread in one hand and a stone in the other. "), _c('i', [_vm._v("The Mystery of Self-Deceiving.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-186-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-186",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("The Benefit of an Enemy.")]), _vm._v(" "), _c('i', [_vm._v("Edward Reynolds:")]), _vm._v(" We may not deny but that a person may have gain by an enemy, as poison to some creatures affords nourishment. . . . They say the sweetest roses are the ones that grow near garlic. In the same way, the nearness of an enemy makes a good person even better. . . . When Saul, David’s enemy, eyed and persecuted him, this made him walk more circumspectly, pray more and trust in God more: He thought, “I will guard my ways, that I may not sin with my tongue; I will guard my mouth with a muzzle, so long as the wicked are in my presence.” . . . A malicious enemy that watches for our halting will make us look the better to our ways. "), _c('i', [_vm._v("Seven Sermons on the Fourteenth Chapter of Hosea.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-185-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-185",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18")])])])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "_idContainer031"
    }
  }, [_c('p', {
    staticClass: "PER_Top-extra-space"
  }, [_c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page92",
      "title": "92"
    }
  })]), _vm._v(" "), _c('h2', {
    staticClass: "PER_ScriptureCenter",
    attrs: {
      "id": "sigil_toc_id_100"
    }
  }, [_c('span', {
    staticClass: "RH-marker"
  }, [_vm._v("19:1–20:42")]), _vm._v(" SAUL MAKES AN ATTEMPT ON DAVID’S LIFE")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("1")]), _c('i', [_vm._v("And Saul spoke to Jonathan his son and to all his servants, that they should kill David. But Jonathan, Saul’s son, delighted much in David.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("2")]), _c('i', [_vm._v("And Jonathan told David, “Saul my father seeks to kill you. Therefore be on your guard in the morning. Stay in a secret place and hide yourself.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("3")]), _c('i', [_vm._v("And I will go out and stand beside my father in the field where you are, and I will speak to my father about you. And if I learn anything I will tell you.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("4")]), _c('i', [_vm._v("And Jonathan spoke well of David to Saul his father and said to him, “Let not the king sin against his servant David, because he has not sinned against you, and because his deeds have brought good to you.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("5")]), _c('i', [_vm._v("For he took his life in his hand and he struck down the Philistine, and the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("worked a great salvation for all Israel. You saw it, and rejoiced. Why then will you sin against innocent blood by killing David without cause?”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("6")]), _c('i', [_vm._v("And Saul listened to the voice of Jonathan. Saul swore, “As the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("lives, he shall not be put to death.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("7")]), _c('i', [_vm._v("And Jonathan called David, and Jonathan reported to him all these things. And Jonathan brought David to Saul, and he was in his presence as before.")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("8")]), _c('i', [_vm._v("And there was war again. And David went out and fought with the Philistines and struck them with a great blow, so that they fled before him.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("9")]), _c('i', [_vm._v("Then a harmful spirit from the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("came upon Saul, as he sat in his house with his spear in his hand. And David was playing the lyre.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("10")]), _c('i', [_vm._v("And Saul sought to pin David to the wall with the spear, but he eluded Saul, so that he struck the spear into the wall. And David fled and escaped that night.")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("11")]), _c('i', [_vm._v("Saul sent messengers to David’s house to watch him, that he might kill him in the morning. But Michal, David’s wife, told him, “If you do not escape with your life tonight, tomorrow you will be killed.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("12")]), _c('i', [_vm._v("So Michal let David down through the window, and he fled away and escaped.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("13")]), _c('i', [_vm._v("Michal took an image")]), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("a")]), _vm._v(" "), _c('i', [_vm._v("and laid it on the bed and put a pillow of goats’ hair at its head and covered it with the clothes.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("14")]), _c('i', [_vm._v("And when Saul sent messengers to take David, she said, “He is sick.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("15")]), _c('i', [_vm._v("Then Saul sent the messengers to see David, saying, “Bring him up to me in the bed, that I may kill him.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("16")]), _c('i', [_vm._v("And when the messengers came in, behold, the image was in the bed, with the pillow of goats’ hair at its head.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("17")]), _c('i', [_vm._v("Saul said to Michal, “Why have you deceived me thus and let my enemy go, so that he has escaped?” And Michal answered Saul, “He said to me, ‘Let me go. Why should I kill you?’”")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("18")]), _c('i', [_vm._v("Now David fled and escaped, and he came to Samuel at Ramah and told him all that Saul had done to him. And he and Samuel went and lived at Naioth.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("19")]), _c('i', [_vm._v("And it was told Saul, “Behold, David is at Naioth in Ramah.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("20")]), _c('i', [_vm._v("Then Saul sent messengers to take David, and when they saw the company of the prophets prophesying, and Samuel standing as head over them, the Spirit of God came upon the messengers of Saul, and they also prophesied.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("21")]), _c('i', [_vm._v("When it was told Saul, he sent other messengers, and they also prophesied. And Saul sent messengers again the third time, and they also prophesied.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("22")]), _c('i', [_vm._v("Then he himself went to Ramah and came to the great well that is in Secu. And he asked, “Where are Samuel and David?” And one said, “Behold, they are at Naioth in Ramah.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("23")]), _c('i', [_vm._v("And he went there to Naioth in Ramah. And the Spirit of God came upon him also, and as he went he prophesied until he came to Naioth in Ramah.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("24")]), _c('i', [_vm._v("And he too stripped off his clothes, and he too prophesied before Samuel and lay naked all that day and all that night. Thus it is said, “Is Saul also among the prophets?”")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    staticClass: "drop-cap"
  }, [_vm._v("20")]), _vm._v(" "), _c('i', [_vm._v("Then David fled from Naioth in Ramah and came and said before Jonathan, “What have I done? What is my guilt? And what is my sin before your father, that he seeks my life?”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("2")]), _c('i', [_vm._v("And he said to him, “Far from it! You shall not die. Behold, my father does nothing either great or small without disclosing it to me. And why should my father hide this from me? It is not so.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("3")]), _c('i', [_vm._v("But David vowed again, saying, “Your father knows well that I have found favor in your eyes, and he thinks, ‘Do not let Jonathan know this, lest he be grieved.’ But truly, as "), _c('a', {
    attrs: {
      "id": "_idTextAnchor3130"
    }
  })]), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page93",
      "title": "93"
    }
  }), _c('i', [_vm._v("the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("lives and as your soul lives, there is but a step between me and death.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("4")]), _c('i', [_vm._v("Then Jonathan said to David, “Whatever you say, I will do for you.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("5")]), _c('i', [_vm._v("David said to Jonathan, “Behold, tomorrow is the new moon, and I should not fail to sit at table with the king. But let me go, that I may hide myself in the field till the third day at evening.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("6")]), _c('i', [_vm._v("If your father misses me at all, then say, ‘David earnestly asked leave of me to run to Bethlehem his city, for there is a yearly sacrifice there for all the clan.’")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("7")]), _c('i', [_vm._v("If he says, ‘Good!’ it will be well with your servant, but if he is angry, then know that harm is determined by him.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("8")]), _c('i', [_vm._v("Therefore deal kindly with your servant, for you have brought your servant into a covenant of the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("with you. But if there is guilt in me, kill me yourself, for why should you bring me to your father?”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("9")]), _c('i', [_vm._v("And Jonathan said, “Far be it from you! If I knew that it was determined by my father that harm should come to you, would I not tell you?”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("10")]), _c('i', [_vm._v("Then David said to Jonathan, “Who will tell me if your father answers you roughly?”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("11")]), _c('i', [_vm._v("And Jonathan said to David, “Come, let us go out into the field.” So they both went out into the field.")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("12")]), _c('i', [_vm._v("And Jonathan said to David, “The")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _c('i', [_vm._v(", the God of Israel, be witness!")]), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("b")]), _vm._v(" "), _c('i', [_vm._v("When I have sounded out my father, about this time tomorrow, or the third day, behold, if he is well disposed toward David, shall I not then send and disclose it to you?")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("13")]), _c('i', [_vm._v("But should it please my father to do you harm, the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("do so to Jonathan and more also if I do not disclose it to you and send you away, that you may go in safety. May the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("be with you, as he has been with my father.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("14")]), _c('i', [_vm._v("If I am still alive, show me the steadfast love of the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _c('i', [_vm._v(", that I may not die;")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("15")]), _c('i', [_vm._v("and do not cut off")]), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("c")]), _vm._v(" "), _c('i', [_vm._v("your steadfast love from my house forever, when the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("cuts off every one of the enemies of David from the face of the earth.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("16")]), _c('i', [_vm._v("And Jonathan made a covenant with the house of David, saying, “May")]), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("d")]), _vm._v(" "), _c('i', [_vm._v("the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("take vengeance on David’s enemies.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("17")]), _c('i', [_vm._v("And Jonathan made David swear again by his love for him, for he loved him as he loved his own soul.")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("18")]), _c('i', [_vm._v("Then Jonathan said to him, “Tomorrow is the new moon, and you will be missed, because your seat will be empty.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("19")]), _c('i', [_vm._v("On the third day go down quickly to the place where you hid yourself when the matter was in hand, and remain beside the stone heap.")]), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("e")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("20")]), _c('i', [_vm._v("And I will shoot three arrows to the side of it, as though I shot at a mark.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("21")]), _c('i', [_vm._v("And behold, I will send the boy, saying, ‘Go, find the arrows.’ If I say to the boy, ‘Look, the arrows are on this side of you, take them,’ then you are to come, for, as the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("lives, it is safe for you and there is no danger.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("22")]), _c('i', [_vm._v("But if I say to the youth, ‘Look, the arrows are beyond you,’ then go, for the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("has sent you away.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("23")]), _c('i', [_vm._v("And as for the matter of which you and I have spoken, behold, the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("is between you and me forever.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("24")]), _c('i', [_vm._v("So David hid himself in the field. And when the new moon came, the king sat down to eat food.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("25")]), _c('i', [_vm._v("The king sat on his seat, as at other times, on the seat by the wall. Jonathan sat opposite,")]), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("f")]), _vm._v(" "), _c('i', [_vm._v("and Abner sat by Saul’s side, but David’s place was empty.")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("26")]), _c('i', [_vm._v("Yet Saul did not say anything that day, for he thought, “Something has happened to him. He is not clean; surely he is not clean.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("27")]), _c('i', [_vm._v("But on the second day, the day after the new moon, David’s place was empty. And Saul said to Jonathan his son, “Why has not the son of Jesse come to the meal, either yesterday or today?”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("28")]), _c('i', [_vm._v("Jonathan answered Saul, “David earnestly asked leave of me to go to Bethlehem.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("29")]), _c('i', [_vm._v("He said, ‘Let me go, for our clan holds a sacrifice in the city, and my brother has commanded me to be there. So now, if I have found favor in your eyes, let me get away and see my brothers.’ For this reason he has not come to the king’s table.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("30")]), _c('i', [_vm._v("Then Saul’s anger was kindled against Jonathan, and he said to him, “You son of a perverse, rebellious woman, do I not know that you have chosen the son of Jesse to your own shame, and to the shame of your mother’s nakedness?")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("31")]), _c('i', [_vm._v("For as long as the son of Jesse lives on the earth, neither you nor your kingdom shall be established. Therefore send and bring him to me, for he shall surely die.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("32")]), _c('i', [_vm._v("Then Jonathan answered Saul his father, “Why should he be put to death? What has he done?”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("33")]), _c('i', [_vm._v("But Saul hurled his spear at him to strike him. So Jonathan knew that his father was determined to put David to death.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("34")]), _c('i', [_vm._v("And Jonathan rose from the table in fierce anger and ate no food the second day of the month, for he was grieved for David, because his father had disgraced him.")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("35")]), _c('i', [_vm._v("In the morning Jonathan went out into the field to the appointment with David, and with him a little boy.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("36")]), _c('i', [_vm._v("And he said to his boy, “Run and find the arrows that I shoot.” As the boy ran, he shot an arrow beyond him. "), _c('a', {
    attrs: {
      "id": "_idTextAnchor3131"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3132"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3133"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3134"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3135"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3136"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3137"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3138"
    }
  })]), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page94",
      "title": "94"
    }
  }), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("37")]), _c('i', [_vm._v("And when the boy came to the place of the arrow that Jonathan had shot, Jonathan called after the boy and said, “Is not the arrow beyond you?”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("38")]), _c('i', [_vm._v("And Jonathan called after the boy, “Hurry! Be quick! Do not stay!” So Jonathan’s boy gathered up the arrows and came to his master.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("39")]), _c('i', [_vm._v("But the boy knew nothing. Only Jonathan and David knew the matter.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("40")]), _c('i', [_vm._v("And Jonathan gave his weapons to his boy and said to him, “Go and carry them to the city.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("41")]), _c('i', [_vm._v("And as soon as the boy had gone, David rose from beside the stone heap")]), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("g")]), _vm._v(" "), _c('i', [_vm._v("and fell on his face to the ground and bowed three times. And they kissed one another and wept with one another, David weeping the most.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("42")]), _c('i', [_vm._v("Then Jonathan said to David, “Go in peace, because we have sworn both of us in the name of the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _c('i', [_vm._v(", saying, ‘The")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("shall be between me and you, and between my offspring and your offspring, forever.’” And he rose and departed, and Jonathan went into the city.")]), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("h")])]), _vm._v(" "), _c('p', {
    staticClass: "small"
  }, [_c('b', [_vm._v("a")]), _vm._v(" Or "), _c('i', [_vm._v("a household god")]), _vm._v(" "), _c('b', [_vm._v("b")]), _vm._v(" Hebrew lacks "), _c('i', [_vm._v("be witness")]), _vm._v(" "), _c('b', [_vm._v("c")]), _vm._v(" Or "), _c('i', [_vm._v("but if I die, do not cut off")]), _vm._v(" "), _c('b', [_vm._v("d")]), _vm._v(" Septuagint "), _c('i', [_vm._v("earth,")]), _vm._v(" "), _c('i', [_vm._v("16")]), _c('i', [_vm._v("let not the name of Jonathan be cut off from the house of David. And may")]), _vm._v(" "), _c('b', [_vm._v("e")]), _vm._v(" Septuagint; Hebrew "), _c('i', [_vm._v("the stone Ezel")]), _vm._v(" "), _c('b', [_vm._v("f")]), _vm._v(" Compare Septuagint; Hebrew "), _c('i', [_vm._v("stood up")]), _vm._v(" "), _c('b', [_vm._v("g")]), _vm._v(" Septuagint; Hebrew "), _c('i', [_vm._v("from beside the south")]), _vm._v(" "), _c('b', [_vm._v("h")]), _vm._v(" This sentence is 21:1 in Hebrew"), _c('br'), _vm._v(" "), _c('br')]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Overview:")]), _vm._v(" The interpreters here find comfort in David’s protection from Saul. For example, Knox deduces that God protects the godly from evil snares. Some regard Jonathan as driven by God’s Spirit and Saul as driven by an evil spirit. The reformers weigh Michal’s actions—did she lie to her father Saul? Luther uses this instance to cite Augustine’s threefold definition of lies. The combined actions of Saul’s children Michal and Jonathan, both of whom come to the aid and support of David over against Saul, are indications of God’s providence and goodness.")]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Saul Is Driven by a Hidden Hatred.")]), _vm._v(" "), _c('i', [_vm._v("Johannes Bugenhagen:")]), _vm._v(" These chapters set before our eyes the fact that the Spirit of God drove Jonathan and an evil spirit drove Saul. The one loves and defends the innocent and godly; the other hates and persecutes it. This hatred fills him with such rage that his son Jonathan is not spared from it. No wonder, when he rages and is indignant against the divine judgment that God begins to prefer David, as we clearly saw in chapter 18. This state of being lives most horribly in the hearts of the ungodly, so that they are not able to see it hidden in themselves. But immediately and clearly through the revealed Spirit, the godly sense to come to pray, acknowledging that they do not follow God’s will in all things and saying, “your will be done.” "), _c('i', [_vm._v("Commentary on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-184-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-184",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])])])])]), _vm._v(" "), _c('h5', {
    attrs: {
      "id": "sigil_toc_id_101"
    }
  }, [_c('b', [_vm._v("19:1-7")]), _vm._v(" "), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("Saul Announces His Plan to Kill David")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Saul’s False Words.")]), _vm._v(" "), _c('i', [_vm._v("Johannes Bugenhagen:")]), _vm._v(" By speaking the truth, Jonathan convinces Saul, who then swears falsely to God that he will not kill David, even though he cannot bear his hatred for him. By this you see how a person does not have free will. Some people are driven by evil spirits like Saul; others are led by the Spirit of God, like the godly in Romans 8. And this Spirit, even at those times when we cannot see, is given occasions to reveal itself. For the blessed one is like a good tree that yields fruit in its season, as Psalm 1 says. Similarly, the ungodly receive occasions to yield the fruits of their unbelief. You have this example in Saul, who—despite having made his oath—seeks to kill David, after David had fought bravely and saved the people’s life. Thus blindness and impiety lead to hatred. This sign is a figure for those who persecute the gospel, that is, the kingdom of Christ the true David. . . . Saul hoped that the Philistines would do away with David, just as Satan once led Christ to the cross. But this only made David’s glory increase, as he is cleansed wherever he goes, being driven by God, who delivers him even in death and leads him to the kingdom through the cross, against the will of Satan. You see this in those hypocrites who say with Saul, “I will not lay my hand on him.” "), _c('i', [_vm._v("Commentary on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-183-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-183",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_c('span', {
    staticClass: "com-rorohiko-pagestaker-style"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor3139"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3140"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3141"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3142"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3143"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3144"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3145"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3146"
    }
  })])]), _c('b', [_c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page95",
      "title": "95"
    }
  })]), _c('b', [_vm._v("God’s Deliverance.")]), _vm._v(" "), _c('i', [_vm._v("John Knox:")]), _vm._v(" The notion that God delivers his chosen from their enemies is not written for David only, but for all those who shall suffer tribulation, until the end of the world. For I, John Knox—let this be said to the acclaim and praise of God alone—in anguish of mind and vehement tribulation and affliction, called on the Lord when not only the ungodly but even my faithful brothers (even my own self, that is, my natural understanding) judged my case to be irremediable. And yet, in my greatest calamity, and when my pains were most cruel, God’s eternal wisdom willed that my hands should be a writer, far contrary to the judgment of carnal reason, which his mercy has proved true, blessed be his holy name. And therefore I dare to be bold in the truth of God’s Word to promise that—notwithstanding the vehemence of trouble, the long continuance of it, the despair of all people and the fearfulness, danger, pain and anguish of our own hearts—yet if we call constantly to God, even beyond all human expectation, he shall deliver. "), _c('i', [_vm._v("Treatise on Prayer.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-182-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-182",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Forgiving and Forgetting.")]), _vm._v(" "), _c('i', [_vm._v("Thomas Becon:")]), _vm._v(" King David was unjustly persecuted by Saul, and his life very narrowly sought. Yet the Spirit of God was so strong in David that he did not only not seek to avenge himself but also forgave his enemy Saul and never did or sought out any evil against him. Even when Saul was in his clutches he not only did not kill him but also did not even touch him. "), _c('i', [_vm._v("A New Catechism.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-181-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-181",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])])])])]), _vm._v(" "), _c('h5', {
    attrs: {
      "id": "sigil_toc_id_102"
    }
  }, [_c('b', [_vm._v("19:8-17")]), _vm._v(" "), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("Michal’s Ruse")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("On Lying.")]), _vm._v(" "), _c('i', [_vm._v("Martin Luther:")]), _vm._v(" Augustine says there are three kinds of lies. It is a harmful lie when a falsehood is spoken out of a desire to deceive one’s neighbor for the purpose of injuring them, their property, their reputation or their very life. And this is worst when lies and false doctrines are spread under the name of God. God forbids this in the eighth commandment when he says: “You shall not bear false witness.” The second kind is the obliging lie, that is, a lie of love or compassion, as when the government happened to be searching for a thief to punish him and I knew where he was yet said that I did not know. In that case I am lying, not to harm, but to help my neighbor. Or if I saw that someone had designs on the chastity of a virgin or matron, and I pretended not to know her, then I would be lying to help, and out of respect for, the girl. Thus Michal is lying to her father when she says that David went way away, but she is doing this to help David. Accordingly, where it can be done without harm to the government or to parents, one may protect and defend those whom they are seeking or are asking about. "), _c('i', [_vm._v("Lectures on Genesis.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-180-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-180",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Righteous Deceptions.")]), _vm._v(" "), _c('i', [_vm._v("Johannes Bugenhagen:")]), _vm._v(" Whether through Jonathan or through Michal, God’s providence keeps David unharmed wherever he goes. You ask: Is it allowed to deceive enemies in word or deed, both of which you see here? I reply: the law allows interest to be taken from Gentiles. Snares may be set for enemies to fall on, as they are even set by God sometimes. You see this in history, that it is allowed for the godly to do this against enemies but not allowed for others. You see many examples in the Scriptures, where the saints deceive the ungodly for the well-being of themselves and others. "), _c('i', [_vm._v("Commentary on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-179-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-179",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Two Bodies Cannot Be in the Same Place Simultaneously.")]), _vm._v(" "), _c('i', [_vm._v("Lambert Daneau:")]), _vm._v(" Do you not remember . . . what Michal, David’s wife, did and what device she practiced when she concealed the sight of her husband from her father Saul and his servants, who sought to slay him? Have you not read that which is written in this section, how she by craft and colorable means placed an image in place of David’s body—but not by any devilish art nor after the manner of sorcerers? She laid pillows "), _c('a', {
    attrs: {
      "id": "_idTextAnchor3147"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3148"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3149"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3150"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3151"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3152"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3153"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3154"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3155"
    }
  }), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page96",
      "title": "96"
    }
  }), _vm._v("under his head, trimming him with garments so finely and cunningly that Saul’s servants clearly thought David was there, as they beheld David’s counterfeit so lively set forth before their eyes. So likewise Satan, to the intent he may keep from us the absence of his adherents, in place of their true body—which is away—places there a false body when we chance to inquire. Whereby it comes to pass that many supposed that sorcerers are not bodily present at their secret assemblies, which they themselves contend that they were at, and because they perceive and find false and counterfeit bodies—instead of their own bodies—laid in their rooms and beds by Satan. But surely those who judge so are very much confused. "), _c('i', [_vm._v("Dialogue of Witches.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-178-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-178",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("On God’s Providence.")]), _vm._v(" "), _c('i', [_vm._v("Heinrich Bullinger:")]), _vm._v(" The prophet and king David said clearly: “But I trust in you, O Lord; I say, ‘You are my God.’ My times are in your hands.” Nevertheless, even he, who was one who totally joined himself to divine providence, carefully considered how he could diligently and industriously elude the deception of his father-in-law Saul. Nor did he despise the help and machinations of his beloved wife Michal. He did not reply to her: “All has occurred through the providence of God; therefore, there will be no need for scheming. God, who is all powerful, is able to rescue me from the hands of our father’s soldiers or to save me in another miraculous way. Let us be in peace and allow God to do something for us.” Rather, David understood that providence proceeds in a certain order through means of other things, so that it was his task to apply himself, in the fear of the Lord, to his own protection. "), _c('i', [_vm._v("Decades 4.4.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-177-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-177",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Persistent Idolatry.")]), _vm._v(" "), _c('i', [_vm._v("Martin Luther:")]), _vm._v(" The statue Michal placed in the bed in place of David, I think, was an image that had been preserved somewhere from among the relics of superstition and idolatry. Among us, too, many statues are left that are preserved in one place in memory of the old idolatry, in another place as exhibits and objects of amusement for children, not worship. In David’s time such idols lay hidden away in the corners of buildings. Now when Michal had nothing else at hand, she quickly pulled out the statue and put it in David’s place. Undoubtedly there remained even at that time many vestiges of superstitions and idolatries from the kingdom and religion of the Jebusites as well as shouts of protest that could not be completely dispelled. Of this the worried complaints of many of the psalms testify, in which David with great grief prays and fights against idolatry. "), _c('i', [_vm._v("Lectures on Genesis.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-176-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-176",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Christological Undertones.")]), _vm._v(" "), _c('i', [_vm._v("Nikolaus Selnecker:")]), _vm._v(" Such histories about David’s crossbearing, suffering and deliverance are figures and images that signify the Lord Christ and his church—how, as several scribes point out excellently, Michal therefore placed an image in David’s place in bed and a goatskin at the head of the bed, so that the true David signifies Christ and the true sacrifice. "), _c('i', [_vm._v("The Whole Psalter.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-175-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-175",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])])])])]), _vm._v(" "), _c('h5', {
    attrs: {
      "id": "sigil_toc_id_103"
    }
  }, [_c('b', [_vm._v("19:18-24")]), _vm._v(" "), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("The Spirit of God Co-opts Saul and His Attendants")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("On Prophecy: What It Is and Who Does It.")]), _vm._v(" "), _c('i', [_vm._v("Hieronymus Weller von Molsdorf:")]), _vm._v(" In this passage the word “to prophesy” means . . . to hear, interpret and discuss the Word of God. But because the passage seems to prompt a discussion, let us speak about prophecy. Prophecy is threefold. First, there is what we otherwise call “the gift of interpretation,” when we interpret the prophetic and apostolic writings, and rightly instruct, strengthen and exhort consciences in the Word of God. This prophecy holds the highest rank, for it preserves the ministry of the gospel (1 Cor 12). Second is the prediction of things to come. When Joseph in Egypt interpreted Pharaoh’s dream—that was this kind of prophecy. Also, when Daniel "), _c('a', {
    attrs: {
      "id": "_idTextAnchor3156"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3157"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3158"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3159"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3160"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3161"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3162"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3163"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3164"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3165"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3166"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3167"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3168"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3169"
    }
  }), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page97",
      "title": "97"
    }
  }), _vm._v("expounded Nebuchadnezzar’s dream as well as the image in his other dream. Also, when the prophets foretold the fall of kingdoms, the destruction of cities and the defeat of nations. These two particular kinds of prophecy are confirmed in Scripture. The third kind of prophecy is astrology, when either from the observation and orbit of the stars or by the inspiration of some particular angel they foretell wars, seditions, plagues and similar calamities. However, these divinations that happen from the observation of the stars are ambiguous and uncertain. Those that happen by the inspiration of angels are certain, and the events correspond to them.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("“The Spirit of God also came upon them.” That is, they too began to hear, cherish and meditate on the Word of God. For the same thing happened to them that happened to the servants of the Pharisees who were sent to arrest Christ (John 7). For in the same way that by hearing Christ’s preaching, those servants changed their minds and converted, so also the attendants of Saul as soon as they began to hear Samuel’s preaching, they immediately changed their mind about dragging David off for punishment, and instead they reverently cherished and contemplated the Word of God. For to prophesy in Scripture not only means to interpret the Word but also to hear and contemplate it, to glorify the name of God and give thanks to God. For “the Spirit of the Lord came upon them,” that is, the Holy Spirit touched their hearts by hearing the Word. This idea stands firm in Isaiah 55: “My Word does not return to me void, but effects whatever I will, and it will succeed in the matter for which I sent it.” We should gather this here from their example, who, even though they did not want to learn, because of the holy preaching they heard they were nevertheless converted.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("“And again Saul sent a third group of messengers.” Saul was not at all moved by this miracle: that the previous attendants whom he sent to seize David had been converted by hearing Samuel’s preaching. Instead he proceeds to send a third group. Thus hardened enemies of the gospel are not moved by any miracles, so that they come to their senses. . . .")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("“The Spirit of God came over him also, and as he walked, he prophesied until he came to Naioth in Ramah.” That is, the Holy Spirit stirred Saul up too, so that he prophesied. This agrees with Matthew 7, as well as the examples of Balaam, Caiaphas and Judas the traitor—sometimes even the impious are given the gift of prophecy from God. For there is absolutely no doubt that Judas, just like the other apostles, was able to prophesy; that is, he was able to teach the gospel and to perform miracles. But this is the difference between people like Judas and true prophets: true prophets teach the pure and unadulterated Word of God, and they reflect the true and genuine meaning of the Scripture. Accordingly those like Judas persevere in sound doctrine, but “they do not walk in step with the truth of the gospel.” However, they eventually introduce distortions to the Word of God—even as they teach the Word of God, pure and unadulterated, against their own will, or as they seem to be true teachers. Nevertheless, afterward they abandon sound doctrine and conspire with the enemies of true doctrine. "), _c('i', [_vm._v("Annotations on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-174-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-174",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])])])])]), _vm._v(" "), _c('h5', {
    attrs: {
      "id": "sigil_toc_id_104"
    }
  }, [_c('b', [_vm._v("20:1-23")]), _vm._v(" "), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("A Covenant Between Jonathan and David")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("The Saints’ Examples, Good and Bad, Are for Our Consolation and Instruction.")]), _vm._v(" "), _c('i', [_vm._v("Justus Menius:")]), _vm._v(" It cannot happen, whenever the human mind begins to waver concerning the truth of God’s promises, that it could entrust itself to any other protection no matter how great, firm and safe it may be. Accordingly, David begins to doubt even most faithful Jonathan’s friendship, loyalty and help. Truly nothing is safe enough, no indeed, nothing is not suspect for a conscience hesitating in faith. Now these words reveal David’s mistrustful mind, when he says, “If there is any iniquity in me, kill me yourself, and bring me to your father.”")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "com-rorohiko-pagestaker-style"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor3170"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3171"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3172"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3173"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3174"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3175"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3176"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3177"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3178"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3179"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3180"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3181"
    }
  })]), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page98",
      "title": "98"
    }
  }), _vm._v("There are two reasons why Scripture records the saints’ weakness and sin. Indeed the first is for our consolation, certainly, so that it might rouse our faith, lest we despair at the sight of our sin or some other weakness. Imagining that in the flesh the saints lived without sin, full of faith, full of the Spirit and full of righteousness, as if in complete and constant perfection, we focus on how plainly hopeless such perfection is; we will never be able to achieve it. Second, lest we slip into self-assured security and, unwisely abandoning all fear of God, we impiously place trust in our self-righteousness and hypocrisy, and we judge ourselves to be perfect, even in what we have not yet begun rightly. For who will dare to boast of their perfection when they see David’s weak faith and elsewhere that he falls into such stupid and shameful deeds? And not only when we regard this one man but also so great a host of God’s saints? So then, let us consider the saints’ weakness and sin, so that, firm in faith, even when we fall through our weakness, we would always fear, trust and pray to God; so that when we stand firm, God would guard us through his grace, not desert us, and when we fall, through his mercy he would lift us up and sustain us. "), _c('i', [_vm._v("Commentary on 1 Samuel 20.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-173-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-173",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Friend over Father.")]), _vm._v(" "), _c('i', [_vm._v("Lambert Daneau:")]), _vm._v(" When a person is faithfully professed in a league of sincere and true friendship, he prefers and more esteems his friend than he does any other person. He bears toward him a far greater affection and zeal than to all other people, for Jonathan did seem to prefer his dear friend David before his own natural father. This type of friendship is not displeasing to God, nor does it willfully transgress his holy will and commandment. For Jonathan revealed and opened his father’s secret counsel to David and discovered by devices what his father’s purpose, sayings and meanings were toward him. Indeed, Jonathan was not at all afraid to reveal and disclose to David the shameful thoughts of his father, King Saul. "), _c('i', [_vm._v("True and Christian Friendship.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-172-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-172",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")])])])])]), _vm._v(" "), _c('h5', {
    attrs: {
      "id": "sigil_toc_id_105"
    }
  }, [_c('b', [_vm._v("20:24-31")]), _vm._v(" "), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("Jonathan’s Excuse and Saul’s Response")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Lying for a Friend.")]), _vm._v(" "), _c('i', [_vm._v("Lambert Daneau:")]), _vm._v(" It is not lawful to lie for the sake of a friend, thereby to help his cause or to bring him out of a difficult situation. However, sometimes and in some cases it is not forbidden us to cause to evade a matter for a friend, or to give an impression and countenance some things as though they were true, which in deed are not so. I am referring to such things whereby God is neither dishonored nor our neighbor damned. "), _c('i', [_vm._v("True and Christian Friendship.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-171-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-171",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Of Jonathan’s Excuse.")]), _vm._v(" "), _c('i', [_vm._v("Andrew Willet:")]), _vm._v(" Because Jonathan charitably intended to do good to David and to do no harm to anyone in excusing David in this manner, he is freed from any great imputation of untruth. And besides, the sum and substance of the excuse—that there was a yearly feast at Bethlehem for David’s family—was likely true. It is also likely that David really asked leave to go there. Yet it seems that Jonathan added other details, namely, that David’s brother had commanded him to go there. However, David did not make mention of his brother sending for him; nor did he ask Jonathan to say so. On the contrary, David merely asked permission to go to Bethlehem. Josephus mentions that Jonathan’s addition to David’s words show duplicity to some degree. However, Jonathan was not accustomed to making such excuses, and he therefore speaks somewhat uncertainly and timorously. "), _c('i', [_vm._v("Harmony on 1 Samuel")]), _vm._v("."), _c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-170-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-170",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Exasperating One’s Children.")]), _vm._v(" "), _c('i', [_vm._v("John Davenant:")]), _vm._v(" Children are provoked if parents endeavor to load them with impious and unjust commands. It was impious of Saul when he commanded Jonathan to seize and bring David his friend, guiltless of any crime, that he might be put "), _c('a', {
    attrs: {
      "id": "_idTextAnchor3182"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3183"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3184"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3185"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3186"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3187"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3188"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3189"
    }
  }), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page99",
      "title": "99"
    }
  }), _vm._v("to death. Hence we read that Jonathan was inflamed with grief and anger. . . . It pertains to this provocation as well, when parents being seized with anger rashly revile and wound their children when they do not deserve it, with contemptuous and unbecoming language. For such scorn has a certain sting, which it is very difficult for even prudent persons to endure. Saul also provoked his son Jonathan with this kind of injury where he breaks forth in these words, “You son of a perverse and rebellious woman! Don’t I know that you have sided with the son of Jesse to your own shame and to the shame of the mother who bore you?” What could be said to be more bitter to provoke a son than that in order to reproach him he even reviles his own wife as a common prostitute? "), _c('i', [_vm._v("Exposition of Colossians.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-169-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-169",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")])])])])]), _vm._v(" "), _c('h5', {
    attrs: {
      "id": "sigil_toc_id_106"
    }
  }, [_c('b', [_vm._v("20:32-42")]), _vm._v(" "), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("Jonathan’s Goodness Versus His Father’s Evil")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Saul’s Madness over David.")]), _vm._v(" "), _c('i', [_vm._v("Menno Simons:")]), _vm._v(" Saul regarded neither the piety nor the kindness, the fidelity nor the good deeds of David toward him and all Israel, nor the grace, the works and the will of God. He became so insane and drunken in his wrath and envy that the enemies and betrayers of David . . . were highly regarded and honored by him. But the peacemakers and those who advised for good, such as his own son Jonathan, were hated by him and considered suspect. In short, David had to take to his heels . . . until Saul was vanquished on Mount Gilboa by the Philistines, and there through utter despair and gloom he plunged the sword, which he had drawn against the righteous and the innocent, into his own heart, taking his own life. "), _c('i', [_vm._v("Cross of the Saints.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-168-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-168",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Jonathan as a Good Son.")]), _vm._v(" "), _c('i', [_vm._v("Heinrich Bullinger:")]), _vm._v(" Jonathan the son of Saul is a very godly and pious example for us. His father’s fury against David as well as his father’s injuries against himself caused him great pain and anguish. Nevertheless he prudently tolerated and concealed it until he could speak of it to him at the appropriate time and place. He never helped his father in his wicked ways. Instead he always clung to righteous and good things, he deplored his father’s stubbornness, and he did not resist him in boldness when he was dealt with violently but simply fled. Through all this, nevertheless, he loved his father and prayed for his health, in all ways showing himself to be a son who shows great respect. This is truly the duty of a godly son. "), _c('i', [_vm._v("Decades 2.5.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-167-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-167",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Jonathan’s Humility.")]), _vm._v(" "), _c('i', [_vm._v("Philipp Melanchthon:")]), _vm._v(" Jonathan is humble; he knows that he is too weak for the kingdom; he knows that blissful rule is God’s work alone, and he has fear of God in the knowledge of his sins and unworthiness. He remains in his calling; he does not wish to make himself king; he does not wish to push David aside; he relies on God, who helps and gives him success in his station. Later he is obedient to God, even though God removes him entirely away. "), _c('i', [_vm._v("Theological Commonplaces (1555).")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-166-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-166",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Love as the Foundation.")]), _vm._v(" "), _c('i', [_vm._v("Edward Reynolds:")]), _vm._v(" The love of the church is the foundation of all our prayers and endeavors for the prosperity of the church. A person will not very hastily seek the good of those whom he does not love. Therefore when Christ requires that we should love our enemies, he adds as a fruit of it that we should pray for them. Love made Jonathan intercede with his father for David even when he knew his displeasure against him. How much more will it move us to intercede with God for his beloved people, the spouse of his own Son? "), _c('i', [_vm._v("Seven Sermons on Fourteenth Chapter of Hosea.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-165-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-165",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Saul Is Driven by a Hidden Hatred.")]), _vm._v(" "), _c('i', [_vm._v("Johannes Bugenhagen:")]), _vm._v(" Again this chapter sets "), _c('a', {
    attrs: {
      "id": "_idTextAnchor3190"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3191"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3192"
    }
  }), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page100",
      "title": "100"
    }
  }), _vm._v("before our eyes the fact that the Spirit of God drove Jonathan and an evil spirit drove Saul. The one loves and defends the innocent and godly; the other hates and persecutes it. This hatred fills him with such rage that his son Jonathan is not spared from it. No wonder, when he rages and is indignant against the divine judgment that God begins to prefer David, as we clearly saw in chapter 18. This state of being lives most horribly in the hearts of the ungodly, so that they are not able to see it hidden in themselves. But immediately and clearly through the revealed spirit, the godly sense to come to pray, acknowledging that they do not follow God’s will in all things and saying, “your will be done.” "), _c('i', [_vm._v("Commentary on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-164-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-164",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Increasing Friendship.")]), _vm._v(" "), _c('i', [_vm._v("Lambert Daneau:")]), _vm._v(" Friendship requires the company, the sight and the familiar conversation of friends together among themselves. Therefore it is only among those who are either daily conversant with another or have previously spent much time together. For familiar conversation and frequent keeping in company increases (as the proverb says) this friendship, and sews people together in this indissoluble agreement of minds. No friendship has so much love and affection that there cannot possibly be any greater increase, or to which nothing can be either added or put into it. It requires therefore a mutual meeting and familiar conversation, because it is by this that our goodwill, liking and affection is increased, strengthened and made greater. It was this sort of friendship David and Jonathan shared, not only at the first occasion of their friendship . . . when they spoke in Saul’s house, but also as it continued to increase and grow. For . . . this frequent meeting and being together feeds (as it were) this new-kindled fire or flame or ardent affection, which burns alike in the breasts of either party. "), _c('i', [_vm._v("True and Christian Friendship.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-163-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-163",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22")])])])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "_idContainer032"
    }
  }, [_c('p', {
    staticClass: "PER_Top-extra-space"
  }, [_c('span', {
    staticClass: "com-rorohiko-pagestaker-style"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor3193"
    }
  })]), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page101",
      "title": "101"
    }
  })]), _vm._v(" "), _c('h2', {
    staticClass: "PER_ScriptureCenter",
    attrs: {
      "id": "sigil_toc_id_107"
    }
  }, [_c('span', {
    staticClass: "RH-marker"
  }, [_vm._v("21:1–22:23")]), _vm._v(" DAVID FLEES")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("1 a")]), _vm._v(" "), _c('i', [_vm._v("Then David came to Nob to Ahimelech the priest. And Ahimelech came to meet David trembling and said to him, “Why are you alone, and no one with you?”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("2")]), _c('i', [_vm._v("And David said to Ahimelech the priest, “The king has charged me with a matter and said to me, ‘Let no one know anything of the matter about which I send you, and with which I have charged you.’ I have made an appointment with the young men for such and such a place.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("3")]), _c('i', [_vm._v("Now then, what do you have on hand? Give me five loaves of bread, or whatever is here.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("4")]), _c('i', [_vm._v("And the priest answered David, “I have no common bread on hand, but there is holy bread—if the young men have kept themselves from women.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("5")]), _c('i', [_vm._v("And David answered the priest, “Truly women have been kept from us as always when I go on an expedition. The vessels of the young men are holy even when it is an ordinary journey. How much more today will their vessels be holy?”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("6")]), _c('i', [_vm._v("So the priest gave him the holy bread, for there was no bread there but the bread of the Presence, which is removed from before the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _c('i', [_vm._v(", to be replaced by hot bread on the day it is taken away.")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("7")]), _c('i', [_vm._v("Now a certain man of the servants of Saul was there that day, detained before the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _c('i', [_vm._v(". His name was Doeg the Edomite, the chief of Saul’s herdsmen.")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("8")]), _c('i', [_vm._v("Then David said to Ahimelech, “Then have you not here a spear or a sword at hand? For I have brought neither my sword nor my weapons with me, because the king’s business required haste.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("9")]), _c('i', [_vm._v("And the priest said, “The sword of Goliath the Philistine, whom you struck down in the Valley of Elah, behold, it is here wrapped in a cloth behind the ephod. If you will take that, take it, for there is none but that here.” And David said, “There is none like that; give it to me.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("10")]), _c('i', [_vm._v("And David rose and fled that day from Saul and went to Achish the king of Gath.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("11")]), _c('i', [_vm._v("And the servants of Achish said to him, “Is not this David the king of the land? Did they not sing to one another of him in dances,")])]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "verse"
  }, [_c('i', [_vm._v("‘Saul has struck down his thousands,")])]), _vm._v(" "), _c('p', {
    staticClass: "verse"
  }, [_c('i', [_vm._v("and David his ten thousands’?”")])])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("12")]), _c('i', [_vm._v("And David took these words to heart and was much afraid of Achish the king of Gath.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("13")]), _c('i', [_vm._v("So he changed his behavior before them and pretended to be insane in their hands and made marks on the doors of the gate and let his spittle run down his beard.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("14")]), _c('i', [_vm._v("Then Achish said to his servants, “Behold, you see the man is mad. Why then have you brought him to me?")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("15")]), _c('i', [_vm._v("Do I lack madmen, that you have brought this fellow to behave as a madman in my presence? Shall this fellow come into my house?”")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    staticClass: "drop-cap"
  }, [_vm._v("22")]), _vm._v(" "), _c('i', [_vm._v("David departed from there and escaped to the cave of Adullam. And when his brothers and all his father’s house heard it, they went down there to him.")]), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("2")]), _c('i', [_vm._v("And everyone who was in distress, and everyone who was in debt, and everyone who was bitter in soul,")]), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("b")]), _vm._v(" "), _c('i', [_vm._v("gathered to him. And he became commander over them. And there were with him about four hundred men.")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("3")]), _c('i', [_vm._v("And David went from there to Mizpeh of Moab. And he said to the king of Moab, “Please let my father and my mother stay")]), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("c")]), _vm._v(" "), _c('i', [_vm._v("with you, till I know what God will do for me.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("4")]), _c('i', [_vm._v("And he left them with the king of Moab, and they stayed with him all the time that David was in the stronghold.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("5")]), _c('i', [_vm._v("Then the prophet Gad said to David, “Do not remain in the stronghold; depart, and go into the land of Judah.” So David departed and went into the forest of Hereth.")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("6")]), _c('i', [_vm._v("Now Saul heard that David was discovered, and the men who were with him. Saul was sitting at Gibeah under the tamarisk tree on the height with his spear in his hand, and all his servants were standing about him.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("7")]), _c('i', [_vm._v("And Saul said to his servants who stood about him, “Hear now, people of Benjamin; will the son of Jesse give every one of you fields and vineyards, will he make you all commanders of thousands and commanders of hundreds,")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("8")]), _c('i', [_vm._v("that all of you have conspired against me? No one discloses to me when my son makes a covenant with the son of Jesse. None of you is sorry for me or discloses to me that my son has stirred up my servant against me, to lie in wait, as at this day.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("9")]), _c('i', [_vm._v("Then answered Doeg the Edomite, who stood by the servants of Saul, “I saw the son of Jesse coming to Nob, to "), _c('a', {
    attrs: {
      "id": "_idTextAnchor3194"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3195"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3196"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3197"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3198"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3199"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3200"
    }
  })]), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page102",
      "title": "102"
    }
  }), _c('i', [_vm._v("Ahimelech the son of Ahitub,")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("10")]), _c('i', [_vm._v("and he inquired of the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("for him and gave him provisions and gave him the sword of Goliath the Philistine.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("11")]), _c('i', [_vm._v("Then the king sent to summon Ahimelech the priest, the son of Ahitub, and all his father’s house, the priests who were at Nob, and all of them came to the king.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("12")]), _c('i', [_vm._v("And Saul said, “Hear now, son of Ahitub.” And he answered, “Here I am, my lord.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("13")]), _c('i', [_vm._v("And Saul said to him, “Why have you conspired against me, you and the son of Jesse, in that you have given him bread and a sword and have inquired of God for him, so that he has risen against me, to lie in wait, as at this day?”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("14")]), _c('i', [_vm._v("Then Ahimelech answered the king, “And who among all your servants is so faithful as David, who is the king’s son-in-law, and captain over")]), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("d")]), _vm._v(" "), _c('i', [_vm._v("your bodyguard, and honored in your house?")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("15")]), _c('i', [_vm._v("Is today the first time that I have inquired of God for him? No! Let not the king impute anything to his servant or to all the house of my father, for your servant has known nothing of all this, much or little.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("16")]), _c('i', [_vm._v("And the king said, “You shall surely die, Ahimelech, you and all your father’s house.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("17")]), _c('i', [_vm._v("And the king said to the guard who stood about him, “Turn and kill the priests of the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _c('i', [_vm._v(", because their hand also is with David, and they knew that he fled and did not disclose it to me.” But the servants of the king would not put out their hand to strike the priests of the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _c('i', [_vm._v(".")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("18")]), _c('i', [_vm._v("Then the king said to Doeg, “You turn and strike the priests.” And Doeg the Edomite turned and struck down the priests, and he killed on that day eighty-five persons who wore the linen ephod.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("19")]), _c('i', [_vm._v("And Nob, the city of the priests, he put to the sword; both man and woman, child and infant, ox, donkey and sheep, he put to the sword.")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("20")]), _c('i', [_vm._v("But one of the sons of Ahimelech the son of Ahitub, named Abiathar, escaped and fled after David.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("21")]), _c('i', [_vm._v("And Abiathar told David that Saul had killed the priests of the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _c('i', [_vm._v(".")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("22")]), _c('i', [_vm._v("And David said to Abiathar, “I knew on that day, when Doeg the Edomite was there, that he would surely tell Saul. I have occasioned the death of all the persons of your father’s house.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("23")]), _c('i', [_vm._v("Stay with me; do not be afraid, for he who seeks my life seeks your life. With me you shall be in safekeeping.”")])]), _vm._v(" "), _c('p', {
    staticClass: "small"
  }, [_c('b', [_vm._v("a")]), _vm._v(" Ch 21:2 in Hebrew "), _c('b', [_vm._v("b")]), _vm._v(" Or "), _c('i', [_vm._v("discontented")]), _vm._v(" "), _c('b', [_vm._v("c")]), _vm._v(" Syriac, Vulgate; Hebrew "), _c('i', [_vm._v("go out")]), _vm._v(" "), _c('b', [_vm._v("d")]), _vm._v(" Septuagint, Targum; Hebrew "), _c('i', [_vm._v("and has turned aside to"), _c('br'), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Overview:")]), _vm._v(" The reformers concentrate on the story about David’s army eating the holy bread, which was reserved only for priests. Does this signify that David was destined to be a great priestly king? Do the holy loaves foreshadow the holy Eucharist representing Christ’s body? The reformers interpret the passage within the context of Jesus’ larger message of love taking precedence over stringent interpretations of the law (Mt 12:1-8; Mk 2:23-28; Lk 6:1-5). Some cite this incident as an example of David’s freedom through faith, a concept that would only gradually be revealed during the time of Christ. David’s hardships and persecutions allowed these commentators to continue to interpret David’s life messianically. They also suggest that perhaps God used Saul to tame David and make him fit for kingship. At the same time, Saul’s scandalous treatment of the priests and inhabitants of Nob leads these commentators to consider him not only unfit for ruling but also irreversibly evil.")]), _vm._v(" "), _c('h5', {
    attrs: {
      "id": "sigil_toc_id_108"
    }
  }, [_c('b', [_vm._v("21:1-6")]), _vm._v(" "), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("Common People Eating What Is Holy")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Holy Vessels.")]), _vm._v(" "), _c('i', [_vm._v("Johannes Bugenhagen:")]), _vm._v(" Here you elegantly read about matters that pertained to the sanctification of the outward person, which were not in conflict with godly desires. The Lord imposes a similar law about not going near a woman in Exodus 19. And Paul judges it good to abstain from marital relations for a time in order to grow in prayer, but only with mutual consent. Therefore it was a practice to keep the bodies of servants holy and clean by keeping away from women. Yes, truly, we say nothing against any uncleanness, whether nocturnal emissions or other unclean contact according to the law, but on the same day it will have been passed over, for the law "), _c('a', {
    attrs: {
      "id": "_idTextAnchor3201"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3202"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3203"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3204"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3205"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3206"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3207"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3208"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3209"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3210"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3211"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3212"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3213"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3214"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3215"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3216"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3217"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3218"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3219"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3220"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3221"
    }
  }), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page103",
      "title": "103"
    }
  }), _vm._v("speaks of common or regular daily impurities, which will be gone by evening. There is no danger here if there is no other hindrance than external impurity. Paul spoke of this use of vessels, “For this is the will of God, your sanctification: that you abstain from sexual immorality; that each one of you know how to control his own body in holiness and honor.” For in the Hebrew tradition, a vessel stands for all kinds of instruments, as in Ezekiel: “. . . each with his destroying weapon in his hand.” Our bodies are our instruments, with which we act. And the saints are said to be God’s instruments, through whom God’s Spirit itself is working, just as Christ called Paul “a chosen instrument of mine.”")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("This is a sign, as Christ interpreted it in Matthew 12 and Mark 2, as Moses wanted to be heard in Deuteronomy 18. Christ sees David and this priest and lets it happen under the umbrella of legal cleanliness: “To the pure, all things are pure,” and “everything created by God is good,” and “all things are yours, whether Paul or Apollos or Cephas or the world or life or death or the present or the future—all are yours, and you are Christ’s, and Christ is God’s.” As Psalm 8 says, “You have given him dominion over all the works of your hands. . . . O L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")]), _vm._v(", our Lord, how majestic is your name in all the earth.”")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("If, therefore, David was allowed to use this freedom through faith, not yet revealed by the light of the gospel and at a time when this was still prohibited by God’s law, then how much more are we turned away from the decrees and elements of this world? For it has been revealed that the kingdom of God is not of this world. Necessity and love oversee the divine law, just as Christ interpreted. We most stupidly mangle this use when we set up and bind ourselves to human laws and the doctrines of demons. "), _c('i', [_vm._v("Commentary on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-162-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-162",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Of the Holy Bread.")]), _vm._v(" "), _c('i', [_vm._v("Andrew Willet:")]), _vm._v(" The law here is set down in Leviticus 24:5-9, concerning the matter of how the bread should be made, of the type of flour used, how much should be in every loaf, how many loaves should be baked in all, where they should be placed, how long they should continue from sabbath to sabbath and in what manner they should be presented, namely, with incense. The Jews used four kinds of breads. The first was common bread; the second was the bread the people used in the sacred feasts; the third was the kind of bread the priests ate with their families; and the fourth was the most holy bread, which was lawful only for the priests to eat within the tabernacle. The holy bread was called the “showbread” because it was always in the presence of God, which was a type of the true bread Christ Jesus who came down from heaven. The holy bread also shadowed forth the Eucharist of the New Testament, which is celebrated with bread. And there was the same signification of their sacraments with ours, except that ours are clearer and more manifest as a memorial of Christ already exhibited, whereas theirs foreshadowed him as the one who was to come. "), _c('i', [_vm._v("Harmony on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-161-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-161",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Love Is the Only Excuse.")]), _vm._v(" "), _c('i', [_vm._v("Hieronymus Weller von Molsdorf:")]), _vm._v(" Even though it was not lawful for anyone to eat the sacred bread, which we usually call the bread of the Presence, nevertheless David demands it be given to him, and Ahimelech does not hesitate to submit to David’s demand. And Christ in Matthew 12 defends this event and shows that the entirety of the ceremonial law should yield to love. Now what was said concerning the ceremonial law should also be said about ecclesiastical rites, namely, that in matters of need or demand we faithfully and righteously act in love, if by disregard of ecclesiastical ceremonies or rites we take care of our neighbors in need or look out for them. Outside of this case it is not lawful for the pious to disregard ecclesiastical ceremonies. So then, how much more lawful is it to disregard those ceremonies and rites that draw consciences into a trap, or that produce scandals or cause rebellions and strengthen the raging of our opponents—that "), _c('a', {
    attrs: {
      "id": "_idTextAnchor3222"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3223"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3224"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3225"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3226"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3227"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3228"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3229"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3230"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3231"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3232"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3233"
    }
  }), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page104",
      "title": "104"
    }
  }), _vm._v("is, those which seem to be instituted to please enemies of the gospel, so that their wrath is placated. "), _c('i', [_vm._v("Annotations on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-160-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-160",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Love Trumps Customs.")]), _vm._v(" "), _c('i', [_vm._v("Hans Denck:")]), _vm._v(" Baptism, which is the sign of the covenant, should be given and not denied to any of those who by God’s power have been invited to it through knowledge of genuine love and who desire this love and agree to be its followers. However, they are not to be compelled to stay in this love by any other person within the covenant unless love itself compels them. This is as it is written in the Psalter: “Your people will be there willingly.”")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("However, disregarding the customs of the law is a freedom permitted by love; it is not a commandment. For although it occasionally happened that even the holy patriarchs had to break these commands but without harm to themselves, no one can say therefore that anything other than love excused them. For this reason Jesus, who is genuine love, was silent and did not command or forbid any of these, as if he wanted to demonstrate that someone may come to this love without any of these customs. . . . Thus love permits her friends to be exempt from customs. "), _c('i', [_vm._v("Concerning True Love.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-159-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-159",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])])])])]), _vm._v(" "), _c('h5', {
    attrs: {
      "id": "sigil_toc_id_109"
    }
  }, [_c('b', [_vm._v("21:7-9")]), _vm._v(" "), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("David Retakes Goliath’s Sword")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Whether David Sinned in Taking Goliath’s Sword.")]), _vm._v(" "), _c('i', [_vm._v("Andrew Willet:")]), _vm._v(" Some think David sinned by taking Goliath’s old sword, which had been consecrated to God as a monument of great victory against the Philistine, and then converting it back to profane use. This action also brought the priest into danger. Now, it is acknowledged that it was David’s oversight, in the presence of Doeg, whom he suspected of evil, to ask for and receive these things from the priest. . . . And beside, it might have placed David in danger among the Philistines, when they saw Goliath’s sword. Yet, simply in using the sword—no other sword was available—David is excused by his necessity, like before in taking the showbread. For just as the Jews gave the Babylonians vessels of silver and gold to redeem their peace and were not reproved by the prophets, so David is excused for using the vessel of the sword for profane use. And who doubts but that the church may and ought, where there is no other remedy, sell the church vessels in order to help the poor. Besides, David took this sword to remind him of God’s former deliverance, so that he might by the sight of it be stirred up to wait on him still. And further, it is not unlikely that David later restored this monument again after he became king. By this example of David it is gathered . . . that it is lawful for the servants of God, where their cause is good, to wear armor and use weapons. "), _c('i', [_vm._v("Harmony on 1 Samuel.")]), _vm._v(" "), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-158-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-158",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Remembering Experiences.")]), _vm._v(" "), _c('i', [_vm._v("John Arrowsmith:")]), _vm._v(" Reflect on former experiences and let them be encouragements from time to time. The psalmist did so when he said, “I consider the days of old, the years long ago.” “Then I said, ‘I will appeal to this: to the years of the right hand of the Most High. I will remember the deeds of the Lord; yes, I will remember your wonders of old.” Some inquire why David—when he asked for a sword and Ahimelech told him there was none at hand but that of Goliath—called for it, and said, “There is none like that.” It is probable that David might have found swords of better metal or just as good; perhaps he even found some more fit for his strength. Yet he prefers this above all because of his experience, for God had formerly blessed him in the use of that sword. "), _c('i', [_vm._v("Chain of Principles.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-157-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-157",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])])])])]), _vm._v(" "), _c('h5', {
    attrs: {
      "id": "sigil_toc_id_110"
    }
  }, [_c('b', [_vm._v("21:10-15")]), _vm._v(" "), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("Fools for the Lord")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("David’s Foolishness: An Allegory on the Cross.")]), _vm._v(" "), _c('i', [_vm._v("Johannes Bugenhagen:")]), _vm._v(" Christ and Christians appear to be insane before the powers of earth and the wisdom of the flesh. As Isaiah 53 says, "), _c('a', {
    attrs: {
      "id": "_idTextAnchor3234"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3235"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3236"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3237"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3238"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3239"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3240"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3241"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3242"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3243"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3244"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3245"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3246"
    }
  }), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page105",
      "title": "105"
    }
  }), _vm._v("they are worthy who have been despised and rejected. For nothing is seen except the cross and foolishness. And it shall be that the faithful themselves see nothing but their sins and how Christ bore them for us. Truly, in the meantime, Satan’s blindness and the world’s foolishness do not recognize the wisdom of his victory. "), _c('i', [_vm._v("Commentary on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-156-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-156",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("God Provides Counsel in Times of Need.")]), _vm._v(" "), _c('i', [_vm._v("Johannes Bugenhagen:")]), _vm._v(" Jonathan loved David, all Israel loved David, and so he lost favor with Saul and thought it better to flee to his enemies than to stay among friends. For who could hate David more than the people of Gath, from whom Goliath had come? You see from this that David acted from necessity. There is nothing easy described in David’s persecutions. As the following story will show, things are more clearly seen among enemy Gentiles than among the Israelites, whom the Lord often saved by intervening himself. We have spoken of such complications above. It is truly foolish when we dispute such things as whether or not the saints have sinned. The saints have sinned when they acted according to their own counsel, not seeking or requiring us to imitate them. We do not need to make their actions into a law. This applies to David, and something else applies to you through God. So therefore one course of action may appear to him, and maybe something else might arise if you had occasion today to evade prison and be delivered from your enemies without detriment to your salvation or without causing scandal to the gospel, which often comes during persecution. David’s liberation certainly did not come from his trickery but from God, who gave the counsel about trickery to the one whom he wanted to liberate. This is abundantly declared in the Hebrew heading of Psalm 34, where it shows that this story clearly teaches to trust God in all needs of body and mind. "), _c('i', [_vm._v("Commentary on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-155-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-155",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("God’s Mercies.")]), _vm._v(" "), _c('i', [_vm._v("David Dickson:")]), _vm._v(" Sometimes people in fear for their lives fly from one danger and fall into one that is worse, as David did when he fled into an unhallowed place among God’s enemies. For fear of Saul, he falls into the hands of Achish. However, God pities the infirmity of his children, and sometimes gives success to weak and unwise decisions. This is seen here, as David “pretended to be insane” to escape. God can and does dispose of people’s hearts as he has a mind to work by them: For he moved the heart of Achish to take no notice of David other than to regard him as an unstable man. "), _c('i', [_vm._v("Explication of the First Fifty Psalms.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-154-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-154",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])])])])]), _vm._v(" "), _c('h5', {
    attrs: {
      "id": "sigil_toc_id_111"
    }
  }, [_c('b', [_vm._v("22:1-5")]), _vm._v(" "), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("David at the Cave of Adullam")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Made to Serve.")]), _vm._v(" "), _c('i', [_vm._v("William Tyndale:")]), _vm._v(" God promised David a kingdom, but immediately stirred up King Saul against him to persecute him, to hunt him as hunters do hares with greyhounds and to ferret him out of every hole. And God did this for the space of many years to tame David, to make him meek, to kill his lusts, to make him feel other people’s infirmities, to make him merciful and to make him understand that he was made king to minister and serve his brothers. In short, he was persecuted so that he should not think his subjects were made to minister to his lusts, or that it was lawful for him to take away from them life and goods at his pleasure. "), _c('i', [_vm._v("Doctrinal Treatises and Introductions to Other Portions of Holy Scriptures.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-153-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-153",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Good Brings Good out of Bad.")]), _vm._v(" "), _c('i', [_vm._v("Johannes Brenz:")]), _vm._v(" David loved God and had God as his friend. Therefore, when he was forced to flee from Saul he ascended in his exile almost by degree to the majesty of king. . . . Christ, the son of God, loved God, and had him as his friend. Therefore, when he was afflicted at the crucifixion and died, he attained great glory through the cross and his death. "), _c('a', {
    attrs: {
      "id": "_idTextAnchor3247"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3248"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3249"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3250"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3251"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3252"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3253"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3254"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3255"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3256"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3257"
    }
  }), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page106",
      "title": "106"
    }
  }), _vm._v("“But,” you say, “I am neither Jacob nor Joseph nor David nor Christ. Therefore, none of these examples apply to me.” We rightly admit that we are not Christ ourselves; but we know that Christ came in our place so that all adverse things that come our way, even by way of our enemies, are used by God for our good. "), _c('i', [_vm._v("Commentary on")]), _vm._v(" "), _c('i', [_vm._v("Genesis.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-152-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-152",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Saul and the House of Eli.")]), _vm._v(" "), _c('i', [_vm._v("Johannes Bugenhagen:")]), _vm._v(" Look with astonishment at the plans of God. The Lord had spoken against the house of Eli in the second chapter, which Saul fulfilled here through his most grave and manifest sin. For he not only sought the death of the Lord’s anointed king but also—because of David—did not spare the priesthood, which had been ordained and instituted by God. "), _c('i', [_vm._v("Commentary on 1 Samuel.")]), _c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-151-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-151",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])])])]), _vm._v(" "), _c('h5', {
    attrs: {
      "id": "sigil_toc_id_112"
    }
  }, [_c('b', [_vm._v("22:6-17")]), _vm._v(" "), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("Saul’s Murderous Rage Against the Priests at Nob")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("We Must Disobey Unjust Rulers.")]), _vm._v(" "), _c('i', [_vm._v("Philipp Melanchthon:")]), _vm._v(" Here an unalterable rule applies: “We should obey God rather than men.” For this reason, if an authority commands us to act against God, we should not obey, but should act like the three men in Babylon who refused to worship the idols or countenance idolatry, even though King Nebuchadnezzar had proclaimed a frightful command regarding it. As the worthy soldiers connected with the tyranny of Saul would not murder the innocent priest Ahimelech, the other priests, and their pious wives and children, even though Saul had commanded them to do it, so are we to act now. If the great lords command us to keep untrue doctrine and idolatry, we should not obey such commands. We should not assist in the murdering of the innocent or of Christians on account of their confession of the gospel, as many of the learned do by remaining silent because of fear. Such murder, along with such hypocrisy, will receive the terrible punishment of which Christ speaks in Matthew 23:35, “That on you may come all the righteous bloodshed on earth, from the blood of innocent Abel on . . . ,” for the Son of God will judge, and will hurl all the godless into eternal punishment. "), _c('i', [_vm._v("Theological Commonplaces (1555).")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-150-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-150",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Do Not Defend a Tyrant.")]), _vm._v(" "), _c('i', [_vm._v("Johannes Bugenhagen:")]), _vm._v(" This chapter shows all of David’s descendants not to defend the kingdom of Saul for David’s sake, because of his striking down of the priests of the Lord. Who could fully describe this tyrant’s insanity? Neither God nor humans owe respect when a soul gets enslaved by a godless malady that is visible to all who look for it. For the best men do not act to suit an occasion; instead, they are known by their demeanor. At the same time, all who want to stand forever go to ruin. And yet wherever these atrocities are judged, some have tried to defend the good aspects of King Saul, especially those that are shown by his speech. For he was pursuing David, whom everyone favored, which made everyone guilty of conspiracy against the king. “Thus iniquity has betrayed itself.” And so a just and righteous confessor bears not only persecutions and hatred, but everyone wishes the persecutor well, according to the verse, “If you were of the world, the world would love you as its own.” "), _c('i', [_vm._v("Commentary on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-149-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-149",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Saul as Antichrist.")]), _vm._v(" "), _c('i', [_vm._v("Andrew Willet:")]), _vm._v(" Saul’s speech to his servants is full of dissimulation and hypocrisy. Here he shows, first, his cruelty by charging his servants with negligence and unfaithfulness toward him because they were not more eager to pursue David, even though they were more removed from David and closer to Saul. Thus the wicked dislike all those who do not run together with them step by step, as Saint Peter says: “The sinful Gentiles are surprised when you "), _c('a', {
    attrs: {
      "id": "_idTextAnchor3258"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3259"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3260"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3261"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3262"
    }
  }), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page107",
      "title": "107"
    }
  }), _vm._v("do not join them in the same flood of debauchery, and they malign you.” "), _c('i', [_vm._v("Harmony on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-148-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-148",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")])])])])]), _vm._v(" "), _c('h5', {
    attrs: {
      "id": "sigil_toc_id_113"
    }
  }, [_c('b', [_vm._v("22:18-23")]), _vm._v(" "), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("Doeg Murders for Saul")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("The Ungodly Edomite.")]), _vm._v(" "), _c('i', [_vm._v("Johannes Bugenhagen:")]), _vm._v(" This ungodly Edomite, looking for honor and seeking the favor of his lord, betrays innocent people. He is a figure of all who only think about their own advancement and opportunity; they thereby help to trample on God’s truth and those who profess it. The heading of Psalm 52 shows this, where the impious ones—like Saul—are scolded, because they love and hope in their own ideas and things. But the righteous ones are like David, saying, “But I am like a green olive tree in the house of God. I trust in the steadfast love of God forever and ever.” "), _c('i', [_vm._v("Commentary on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-147-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-147",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("The People Pleaser.")]), _vm._v(" "), _c('i', [_vm._v("Robert Sanderson:")]), _vm._v(" Sometimes we apply ourselves to the wills of others with an eye to our own benefit or satisfaction in some other carnal or worldly respect. This is our fleshliness, and the fault is in the heart. This sin is one of the worst kinds, and therefore in the first place to be avoided. It is the worst and most unconscionable people who often transgress this way. They do this for a variety of reasons: for fear of a frown or worse displeasure; to curry favor with those they may have use of in hope either of raising themselves to some advancement or of raising to themselves some advantage; or for some other like respects. As they do this, they become officious instruments to others for the accomplishing of their lusts in such services as are evidently, even to their own apprehensions, sinful and wicked. So Doeg did King Saul service in shedding the blood of eighty-five innocent priests. "), _c('i', [_vm._v("To the People.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-146-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-146",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17")])])])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "_idContainer033"
    }
  }, [_c('p', {
    staticClass: "PER_Top-extra-space"
  }, [_c('span', {
    staticClass: "com-rorohiko-pagestaker-style"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor3263"
    }
  })]), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page108",
      "title": "108"
    }
  })]), _vm._v(" "), _c('h2', {
    staticClass: "PER_ScriptureCenter",
    attrs: {
      "id": "sigil_toc_id_114"
    }
  }, [_c('span', {
    staticClass: "RH-marker"
  }, [_vm._v("23:1–24:22")]), _vm._v(" DAVID SAVES KEILAH AND SPARES SAUL")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("1")]), _c('i', [_vm._v("Now they told David, “Behold, the Philistines are fighting against Keilah and are robbing the threshing floors.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("2")]), _c('i', [_vm._v("Therefore David inquired of the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _c('i', [_vm._v(", “Shall I go and attack these Philistines?” And the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("said to David, “Go and attack the Philistines and save Keilah.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("3")]), _c('i', [_vm._v("But David’s men said to him, “Behold, we are afraid here in Judah; how much more then if we go to Keilah against the armies of the Philistines?”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("4")]), _c('i', [_vm._v("Then David inquired of the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("again. And the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("answered him, “Arise, go down to Keilah, for I will give the Philistines into your hand.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("5")]), _c('i', [_vm._v("And David and his men went to Keilah and fought with the Philistines and brought away their livestock and struck them with a great blow. So David saved the inhabitants of Keilah.")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("6")]), _c('i', [_vm._v("When Abiathar the son of Ahimelech had fled to David to Keilah, he had come down with an ephod in his hand.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("7")]), _c('i', [_vm._v("Now it was told Saul that David had come to Keilah. And Saul said, “God has given him into my hand, for he has shut himself in by entering a town that has gates and bars.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("8")]), _c('i', [_vm._v("And Saul summoned all the people to war, to go down to Keilah, to besiege David and his men.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("9")]), _c('i', [_vm._v("David knew that Saul was plotting harm against him. And he said to Abiathar the priest, “Bring the ephod here.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("10")]), _c('i', [_vm._v("Then David said, “O")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _c('i', [_vm._v(", the God of Israel, your servant has surely heard that Saul seeks to come to Keilah, to destroy the city on my account.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("11")]), _c('i', [_vm._v("Will the men of Keilah surrender me into his hand? Will Saul come down, as your servant has heard? O")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _c('i', [_vm._v(", the God of Israel, please tell your servant.” And the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("said, “He will come down.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("12")]), _c('i', [_vm._v("Then David said, “Will the men of Keilah surrender me and my men into the hand of Saul?” And the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("said, “They will surrender you.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("13")]), _c('i', [_vm._v("Then David and his men, who were about six hundred, arose and departed from Keilah, and they went wherever they could go. When Saul was told that David had escaped from Keilah, he gave up the expedition.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("14")]), _c('i', [_vm._v("And David remained in the strongholds in the wilderness, in the hill country of the wilderness of Ziph. And Saul sought him every day, but God did not give him into his hand.")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("15")]), _c('i', [_vm._v("David saw that Saul had come out to seek his life. David was in the wilderness of Ziph at Horesh.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("16")]), _c('i', [_vm._v("And Jonathan, Saul’s son, rose and went to David at Horesh, and strengthened his hand in God.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("17")]), _c('i', [_vm._v("And he said to him, “Do not fear, for the hand of Saul my father shall not find you. You shall be king over Israel, and I shall be next to you. Saul my father also knows this.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("18")]), _c('i', [_vm._v("And the two of them made a covenant before the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _c('i', [_vm._v(". David remained at Horesh, and Jonathan went home.")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("19")]), _c('i', [_vm._v("Then the Ziphites went up to Saul at Gibeah, saying, “Is not David hiding among us in the strongholds at Horesh, on the hill of Hachilah, which is south of Jeshimon?")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("20")]), _c('i', [_vm._v("Now come down, O king, according to all your heart’s desire to come down, and our part shall be to surrender him into the king’s hand.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("21")]), _c('i', [_vm._v("And Saul said, “May you be blessed by the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _c('i', [_vm._v(", for you have had compassion on me.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("22")]), _c('i', [_vm._v("Go, make yet more sure. Know and see the place where his foot is, and who has seen him there, for it is told me that he is very cunning.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("23")]), _c('i', [_vm._v("See therefore and take note of all the lurking places where he hides, and come back to me with sure information. Then I will go with you. And if he is in the land, I will search him out among all the thousands of Judah.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("24")]), _c('i', [_vm._v("And they arose and went to Ziph ahead of Saul.")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('i', [_vm._v("Now David and his men were in the wilderness of Maon, in the Arabah to the south of Jeshimon.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("25")]), _c('i', [_vm._v("And Saul and his men went to seek him. And David was told, so he went down to the rock and lived in the wilderness of Maon. And when Saul heard that, he pursued after David in the wilderness of Maon.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("26")]), _c('i', [_vm._v("Saul went on one side of the mountain, and David and his men on the other side of the mountain. And David was hurrying to get away from Saul. As Saul and his men were closing in on David and his men to capture them,")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("27")]), _c('i', [_vm._v("a messenger came to Saul, saying, “Hurry and come, for the Philistines have made a raid against the land.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("28")]), _c('i', [_vm._v("So Saul returned from pursuing after David and went against the Philistines. Therefore that place was called the Rock of Escape.")]), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("a 29b")]), _c('i', [_vm._v("And David went up from there and lived in the strongholds of Engedi.")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    staticClass: "com-rorohiko-pagestaker-style"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor3264"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3265"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3266"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3267"
    }
  })]), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page109",
      "title": "109"
    }
  }), _c('span', {
    staticClass: "drop-cap"
  }, [_vm._v("24")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("c")]), _vm._v(" "), _c('i', [_vm._v("When Saul returned from following the Philistines, he was told, “Behold, David is in the wilderness of Engedi.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("2")]), _c('i', [_vm._v("Then Saul took three thousand chosen men out of all Israel and went to seek David and his men in front of the Wildgoats’ Rocks.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("3")]), _c('i', [_vm._v("And he came to the sheepfolds by the way, where there was a cave, and Saul went in to relieve himself.")]), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("d")]), _vm._v(" "), _c('i', [_vm._v("Now David and his men were sitting in the innermost parts of the cave.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("4")]), _c('i', [_vm._v("And the men of David said to him, “Here is the day of which the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("said to you, ‘Behold, I will give your enemy into your hand, and you shall do to him as it shall seem good to you.’” Then David arose and stealthily cut off a corner of Saul’s robe.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("5")]), _c('i', [_vm._v("And afterward David’s heart struck him, because he had cut off a corner of Saul’s robe.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("6")]), _c('i', [_vm._v("He said to his men, “The")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("forbid that I should do this thing to my lord, the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _c('i', [_vm._v("’s anointed, to put out my hand against him, seeing he is the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _c('i', [_vm._v("’s anointed.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("7")]), _c('i', [_vm._v("So David persuaded his men with these words and did not permit them to attack Saul. And Saul rose up and left the cave and went on his way.")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("8")]), _c('i', [_vm._v("Afterward David also arose and went out of the cave, and called after Saul, “My lord the king!” And when Saul looked behind him, David bowed with his face to the earth and paid homage.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("9")]), _c('i', [_vm._v("And David said to Saul, “Why do you listen to the words of men who say, ‘Behold, David seeks your harm’?")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("10")]), _c('i', [_vm._v("Behold, this day your eyes have seen how the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("gave you today into my hand in the cave. And some told me to kill you, but I spared you.")]), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("e")]), _vm._v(" "), _c('i', [_vm._v("I said, ‘I will not put out my hand against my lord, for he is the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _c('i', [_vm._v("’s anointed.’")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("11")]), _c('i', [_vm._v("See, my father, see the corner of your robe in my hand. For by the fact that I cut off the corner of your robe and did not kill you, you may know and see that there is no wrong or treason in my hands. I have not sinned against you, though you hunt my life to take it.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("12")]), _c('i', [_vm._v("May the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("judge between me and you, may the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("avenge me against you, but my hand shall not be against you.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("13")]), _c('i', [_vm._v("As the proverb of the ancients says, ‘Out of the wicked comes wickedness.’ But my hand shall not be against you.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("14")]), _c('i', [_vm._v("After whom has the king of Israel come out? After whom do you pursue? After a dead dog! After a flea!")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("15")]), _c('i', [_vm._v("May the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("therefore be judge and give sentence between me and you, and see to it and plead my cause and deliver me from your hand.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("16")]), _c('i', [_vm._v("As soon as David had finished speaking these words to Saul, Saul said, “Is this your voice, my son David?” And Saul lifted up his voice and wept.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("17")]), _c('i', [_vm._v("He said to David, “You are more righteous than I, for you have repaid me good, whereas I have repaid you evil.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("18")]), _c('i', [_vm._v("And you have declared this day how you have dealt well with me, in that you did not kill me when the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("put me into your hands.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("19")]), _c('i', [_vm._v("For if a man finds his enemy, will he let him go away safe? So may the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("reward you with good for what you have done to me this day.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("20")]), _c('i', [_vm._v("And now, behold, I know that you shall surely be king, and that the kingdom of Israel shall be established in your hand.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("21")]), _c('i', [_vm._v("Swear to me therefore by the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("that you will not cut off my offspring after me, and that you will not destroy my name out of my father’s house.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("22")]), _c('i', [_vm._v("And David swore this to Saul. Then Saul went home, but David and his men went up to the stronghold.")])]), _vm._v(" "), _c('p', {
    staticClass: "small"
  }, [_c('b', [_vm._v("a")]), _vm._v(" Or "), _c('i', [_vm._v("Rock of Divisions")]), _vm._v(" "), _c('b', [_vm._v("b")]), _vm._v(" Ch 24:1 in Hebrew "), _c('b', [_vm._v("c")]), _vm._v(" Ch 24:2 in Hebrew "), _c('b', [_vm._v("d")]), _vm._v(" Hebrew "), _c('i', [_vm._v("cover his feet")]), _vm._v(" "), _c('b', [_vm._v("e")]), _vm._v(" Septuagint, Syriac, Targum; Hebrew "), _c('i', [_vm._v("it")]), _vm._v(" [my eye] "), _c('i', [_vm._v("spared you"), _c('br'), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Overview:")]), _vm._v(" The Lord’s favor rests with David, as he proves victorious in battle, prudent in character and respectful of the king’s authority. Bugenhagen, committed to interpreting the Bible through the lens of law and gospel, cites this story as another example of God humbling David through the law so that he could receive God’s grace. The interpreters also reflect on David’s deference to King Saul. Although Saul is eager to kill David in the face of all the good he has done for him, David refuses to lay even a finger on Saul out of respect for his position as king. The reformers believe David would have sinned had he made an attempt on Saul’s life. Saul’s momentary remorse, however, does not trick the reformers into changing their negative assessment of the king.")]), _vm._v(" "), _c('h5', {
    attrs: {
      "id": "sigil_toc_id_115"
    }
  }, [_c('span', {
    staticClass: "com-rorohiko-pagestaker-style"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor3268"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3269"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3270"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3271"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3272"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3273"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3274"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3275"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3276"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3277"
    }
  })]), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page110",
      "title": "110"
    }
  }), _c('b', [_vm._v("23:1-14")]), _vm._v(" "), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("Keilah and")]), _vm._v(" "), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("Possible Contingencies")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("God’s Knowledge.")]), _vm._v(" "), _c('i', [_vm._v("Jacobus Arminius:")]), _vm._v(" I am thoroughly persuaded that God’s knowledge is eternal, immutable and infinite, and that it extends to all things . . . which he himself does with or without mediation, and which he permits to be done by others. But the mode in which he knows future contingencies, and especially those that appertain to the free will of creatures, and which he has decreed to permit, but not to do of himself—this I do not comprehend, not even in that measure in which I think it is understood by others of greater skill than myself. I know there are some who say that all things are present to God from eternity; and that the mode in which God knows future contingencies certainly and infallibly is this: that those contingencies coexist with God in the Now of eternity, and so are in him indivisible and in the infinite Now of eternity, which embraces all time. If that is so, it is not difficult to know in what way God knows future contingencies certainly and infallibly. For contingencies are not opposed to the certainty of knowledge, except as they are future, but not as they are present. But that reasoning does not exhaust all the difficulties that may arise in the consideration of these matters. For God knows, also, those things that may happen, but never do happen, and consequently do not coexist with God in the Now of eternity, which would happen unless they be stopped. "), _c('i', [_vm._v("Friendly Discussion Concerning Predestination.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-145-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-145",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("David’s Lonely Escape.")]), _vm._v(" "), _c('i', [_vm._v("Johannes Bugenhagen:")]), _vm._v(" Who does not see that this revelation from God about David’s being surrendered to Saul should be understood with the clear condition: “unless you flee.” It is like Jonah’s “Yet forty days, and Nineveh shall be overthrown!” that is, implicitly, “unless you repent.” Here you see that David was not troubled about those people whom he had protected, just as we learn from Jeremiah 17:5 not to trust in humans. God did not want David to have that kind of trust. For now you have a well-fortified city, the citizens are indebted to you, all of Israel is favorably disposed to you because you have repelled the Philistines, and the king will not be able or permitted to hurt you. But God wanted David to despair of everyone and everything, being forsaken and exposed by his own forces, so that he would hope in God alone. "), _c('i', [_vm._v("Commentary on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-144-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-144",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Deceitfulness of the Heart.")]), _vm._v(" "), _c('i', [_vm._v("Daniel Dyke:")]), _vm._v(" One form of deceit is when in temptation our hearts betray us like Judas’s did into the devil’s hands. If a person is very close to you so that we trust him, should we not consider him a deceitful person if—when walking about and we are accosted by an enemy or a criminal—he runs away from you? How much more so if this friend should conspire with the enemy and take part in the violence against you? . . . But this is exactly how the half-hearted men of Keilah would have done with David. As David mistrusted them, so we should our deceitful hearts. We do not need to ask the question, as David did of the men of Keilah, “Will they deliver us?” We must assure ourselves that they certainly will. "), _c('i', [_vm._v("The Mystery of Self-Deceiving.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-143-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-143",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])])])])]), _vm._v(" "), _c('h5', {
    attrs: {
      "id": "sigil_toc_id_116"
    }
  }, [_c('b', [_vm._v("23:15-29")]), _vm._v(" "), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("Jonathan Renews His Covenant with David")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Jonathan Renews His Vow for the Sake of the Truth.")]), _vm._v(" "), _c('i', [_vm._v("Johannes Bugenhagen:")]), _vm._v(" Now Jonathan keeps and renews his faithful vow with David, so that—touched by the Spirit of God—he prophesied and comforted David. For all that, he did not come in order to be the second greatest himself, because the vow pertains not only to Jonathan and David but also to their descendants, as chapter 20 says. Then he most gravely condemns his father before God when he says, “Saul my father also knows this.” For he could not hide anymore from Saul now that the Lord had anointed David "), _c('a', {
    attrs: {
      "id": "_idTextAnchor3278"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3279"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3280"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3281"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3282"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3283"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3284"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3285"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3286"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3287"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3288"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3289"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3290"
    }
  }), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page111",
      "title": "111"
    }
  }), _vm._v("in Bethlehem through the prophet Samuel and now that Saul came to know the Lord had departed from him to be with David. On this point Scripture cannot keep silence, for it shows this hypocrisy fighting against conscience in order to fight against God, for it wants to be seen before people as fighting against the one who lies in wait for the king and disturbs the kingdom. In the same way, those who now want to suppress the gospel give the pretext that all things are being disturbed. "), _c('i', [_vm._v("Commentary on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-142-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-142",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("True Friendship Lasts.")]), _vm._v(" "), _c('i', [_vm._v("Lambert Daneau:")]), _vm._v(" Friendship does not cease or utterly perish even when absent because it grows on just and reasonable causes. As we may see in David and Jonathan, the whole friendship continued and lasted despite the one being absent from the other, for such deep-rooted goodwill and such ardent affection cannot be easily quenched. Therefore friendship—being strongly and surely grounded between persons present—continues still between them when they are absent. And the further they are separated, the greater is the longing desire of one for the other and the more vehemently their inflamed hearts increase. "), _c('i', [_vm._v("True and Christian Friendship.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-141-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-141",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])])])])]), _vm._v(" "), _c('h5', {
    attrs: {
      "id": "sigil_toc_id_117"
    }
  }, [_c('b', [_vm._v("24:1-5")]), _vm._v(" "), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("David Spares Saul’s Life")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("David’s Conscience.")]), _vm._v(" "), _c('i', [_vm._v("Johannes Bugenhagen:")]), _vm._v(" When David’s heart sunk, it shows the working of his conscience. Scripture writes this in order to show the fear of God in David, who—even though he was able to—did not want to act against Saul, one who was duly installed by God, just as it says in Romans 13 about submitting to God by submitting to authorities. At the same time, however, David perceives that God has departed from Saul, who will perish when God wants it. "), _c('i', [_vm._v("Commentary on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-140-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-140",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("The Heart of the Matter.")]), _vm._v(" "), _c('i', [_vm._v("Thomas Adams:")]), _vm._v(" Saul would kill David but could not. David could kill Saul but would not. "), _c('i', [_vm._v("Commentary on 2 Peter.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-139-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-139",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("David Overcomes His Flesh.")]), _vm._v(" "), _c('i', [_vm._v("Johannes Brenz:")]), _vm._v(" David was a truly pious man and did not take advantage of Saul, who was the greatest of his enemies, even when he was offered up to him in the cave. Naturally, David’s flesh suggested: “Take him, David. You now have your enemy in your hands. Kill him and you will have not only the king but also the kingdom!” But David not only crucified his fleshly thoughts but also mastered his earthly desires. "), _c('i', [_vm._v("Commentary on Galatians.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-138-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-138",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])])])])]), _vm._v(" "), _c('h5', {
    attrs: {
      "id": "sigil_toc_id_118"
    }
  }, [_c('b', [_vm._v("24:6-15")]), _vm._v(" "), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("Honoring the Lord’s Anointed One")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Unlawful.")]), _vm._v(" "), _c('i', [_vm._v("William Tyndale:")]), _vm._v(" Why did David not kill Saul given that he was so wicked, not only in persecuting David but also in disobeying God’s commandments? And not only that, but he had also murdered eighty-five of God’s priests wrongfully? Truly, because it was not lawful. For if David would have done it, he would have sinned against God. This is because God makes the king in every realm judge over all, and over him there is no judge. The one who judges the king judges God; and the one who lays hands on the king lays hands on God. And the one who resists the king resists God and damns God’s laws and ordinances. If the subject sins, he or she must be brought to the king’s judgment. But if the king sins, he must be reserved to the judgment, wrath and vengeance of God. And as it is to resist the king, so is it to resist his officer, who is set or sent to execute the king’s commandment. "), _c('i', [_vm._v("Doctrinal Treatises and Introductions to Other Portions of Holy Scriptures.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-137-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-137",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("David Extends Grace.")]), _vm._v(" "), _c('i', [_vm._v("John Calvin:")]), _vm._v(" When we become indignant against someone, we very "), _c('a', {
    attrs: {
      "id": "_idTextAnchor3291"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3292"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3293"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3294"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3295"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3296"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3297"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3298"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3299"
    }
  }), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page112",
      "title": "112"
    }
  }), _vm._v("often fail to take account of all the favors God has given to the one whom we hate, as though those favors were beneath contempt. Even when we must hate and detest a person’s evil side, we must not be so carried away with the violence of our feelings that we are utterly unable to accept the good, for then we have lost our perception and discernment. On the contrary, we must honor the Lord for everything that comes from him. This is what we are to remember from David. David certainly knew that Saul was a desperate man. Nonetheless, God had chosen him to reign over his people, and had anointed him for that purpose. What is more, David knew that he would offend the Lord, and would commit a sacrilege if he ignored this grace God had put in Saul. "), _c('i', [_vm._v("Sermons on 2 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-136-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-136",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Inviolable Majesty.")]), _vm._v(" "), _c('i', [_vm._v("John Calvin:")]), _vm._v(" We owe this attitude of reverence and therefore piety toward all our rulers in the highest degree, whatever they may be like. I therefore the more often repeat this: that we should learn not to examine the men themselves, but take it as enough that they bear, by the Lord’s will, a character on which he has imprinted and engraved an inviolable majesty. But (you will say) rulers owe responsibilities in turn to their subjects. This I have already admitted. But if you conclude from this that service ought to be rendered only to just governors, you are reasoning foolishly. "), _c('i', [_vm._v("Institutes 4.20.29.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-135-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-135",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("David’s Respect for God’s Messiah.")]), _vm._v(" "), _c('i', [_vm._v("Jeremias Bastingius:")]), _vm._v(" In the Old Testament prophets, priests and kings were anointed by the commandment and ordinance of God. . . . Such ceremonies served as a seal of their calling that God would teach and govern his people by them, whereupon they were called “the Christ” or “the Anointed” of the Lord; as in the psalm: “Do not touch my anointed ones; do my prophets no harm.” So David calls Saul “the Lord’s anointed,” and for this reason would not hurt him even though he could. "), _c('i', [_vm._v("An Exposition on the Catechism of the Low Countries.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-134-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-134",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Conquering by Forbearance.")]), _vm._v(" "), _c('i', [_vm._v("John Davenant:")]), _vm._v(" The one who forbears conquers the very malice of his enemy. For when two competitors are in contention and conflict, the one who draws the other into similarity with itself conquers; and the one who is drawn and changed by the other is conquered. Therefore, as we say water is overcome by fire when it becomes warm; and on the contrary to have overcome it if, retaining its own cold, it can subdue the fire. So we say a Christian is overcome by a wicked person as often as he, by the provocation of attack, is drawn into similar fury; on the contrary, we may pronounce him to have conquered when he retains his own disposition and, by bearing with the violence of the other, changes and mollifies his ferocity. We see a beautiful example of this here where David, by forbearing and refraining from revenge, so mollifies and changes Saul from breathing blood and slaughter that he melts into tears and entreaties, confesses his fault and is compelled to acknowledge and extol David’s innocence and meekness. Who does not here see the malice of Saul overcome, and the patience of David triumphant? "), _c('i', [_vm._v("Exposition of Colossians.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-133-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-133",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")])])])])]), _vm._v(" "), _c('h5', {
    attrs: {
      "id": "sigil_toc_id_119"
    }
  }, [_c('b', [_vm._v("24:16-22")]), _vm._v(" "), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("David’s Determining Whether Saul Was Sincere")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Hearts as Crafty as a Fox.")]), _vm._v(" "), _c('i', [_vm._v("Daniel Dyke:")]), _vm._v(" If a person had a reputation of being a common deceiver, we would never take his word for anything. However, if we had to deal with him for business, we would be sure to have everything done according to the law and with proper documentation. Indeed, we are to be wise and wary in matters of this life. Yet our hearts are far more cunning and deceitful than the craftiest fox. Do not be so simple as to believe every sigh, every wish and word, every motion and every inclination of your heart. Yet we "), _c('a', {
    attrs: {
      "id": "_idTextAnchor3300"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3301"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3302"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3303"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3304"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3305"
    }
  }), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page113",
      "title": "113"
    }
  }), _vm._v("too often allow our hearts to have sway over our lives. We think that when we feel some inordinate affection for something, we believe that we will prove victorious and that sin will never prevail against us. Saul, though seemingly moved by David’s apology, acknowledged both David’s innocence and his own injustice. In fact, it was in tears and kind words that he said, “Is this your voice, my son David?” He added, “I will no more do you harm.” Yet for all Saul said, David did not trust Saul at all. For what heed is to be taken to a false and fickle-hearted man’s words like Saul’s? Because our hearts are as fickle and unstable in their affections toward the Lord as Saul’s were toward David, we must not slavishly trust our hearts. "), _c('i', [_vm._v("The Mystery of Self-Deceiving.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-132-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-132",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Saul’s Brief Moment of Repentance.")]), _vm._v(" "), _c('i', [_vm._v("Johannes Bugenhagen:")]), _vm._v(" Now Saul wastes no time, being certain that he will capture David, but is handed over by God into David’s hands instead. Then he is reluctantly summoned. He tearfully acknowledges the hand of God, David’s innocence and his own iniquity against both of them. That is because he is used to judging David’s faith falsely, even though David had often protected him, as you see again in chapter 26. For a sudden brief stupor comes over him when he hears that he was in the hands of David, whom he knows will reign after him. He weeps, he confesses, he makes a vow. But the word he proclaims is the repentance of a hypocrite, as we have often said before. "), _c('i', [_vm._v("Commentary on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-131-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-131",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Acknowledging David’s Righteousness.")]), _vm._v(" "), _c('i', [_vm._v("Edward Reynolds:")]), _vm._v(" When Saul, out of the force of natural ingenuity, saw the evidence of David’s integrity—who refused to kill Saul even when the Lord had delivered him into his hands—he relented for the time and wept. He acknowledged David’s righteousness above his own and spoke in all earnestness. "), _c('i', [_vm._v("The Sinfulness of Sin.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-130-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-130",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Tears of Remorse.")]), _vm._v(" "), _c('i', [_vm._v("Andrew Willet:")]), _vm._v(" Some think these tears of Saul and this kind of confession of his fault were done in hypocrisy, which Saul counterfeited out of deference to others, who would have thought Saul to be too hardhearted if he would not have be mollified by David’s submission. It was also hoped that because of this David would be persuaded to return to the court. . . . But it seems by Saul’s accusation of himself, his acknowledgment that David should be king and his instance in making David swear to him that Saul was truly touched. For, although the wicked have no true feeling of their sins, they may sometimes be moved in conscience even if it does not continue long. Indeed, Pharaoh confessed to Moses that he had sinned, and Judas also knew that he had sinned by betraying the innocent blood: for by the instinct of nature, the conscience in some degree both excuses and accuses, as the apostle shows in Romans 2:14-15. As David’s music had before diverse times allayed Saul’s malady, so now his divine voice worked some remorse in Saul. "), _c('i', [_vm._v("Harmony on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-129-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-129",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17")])])])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "_idContainer034"
    }
  }, [_c('p', {
    staticClass: "PER_Top-extra-space"
  }, [_c('span', {
    staticClass: "com-rorohiko-pagestaker-style"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor3306"
    }
  })]), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page114",
      "title": "114"
    }
  })]), _vm._v(" "), _c('h2', {
    staticClass: "PER_ScriptureCenter",
    attrs: {
      "id": "sigil_toc_id_120"
    }
  }, [_c('span', {
    staticClass: "RH-marker"
  }, [_vm._v("25:1-44")]), _vm._v(" NABAL, ABIGAIL AND DAVID")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("1")]), _c('i', [_vm._v("Now Samuel died. And all Israel assembled and mourned for him, and they buried him in his house at Ramah.")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('i', [_vm._v("Then David rose and went down to the wilderness of Paran.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("2")]), _c('i', [_vm._v("And there was a man in Maon whose business was in Carmel. The man was very rich; he had three thousand sheep and a thousand goats. He was shearing his sheep in Carmel.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("3")]), _c('i', [_vm._v("Now the name of the man was Nabal, and the name of his wife Abigail. The woman was discerning and beautiful, but the man was harsh and badly behaved; he was a Calebite.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("4")]), _c('i', [_vm._v("David heard in the wilderness that Nabal was shearing his sheep.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("5")]), _c('i', [_vm._v("So David sent ten young men. And David said to the young men, “Go up to Carmel, and go to Nabal and greet him in my name.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("6")]), _c('i', [_vm._v("And thus you shall greet him: ‘Peace be to you, and peace be to your house, and peace be to all that you have.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("7")]), _vm._v(" "), _c('i', [_vm._v("I hear that you have shearers. Now your shepherds have been with us, and we did them no harm, and they missed nothing all the time they were in Carmel.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("8")]), _c('i', [_vm._v("Ask your young men, and they will tell you. Therefore let my young men find favor in your eyes, for we come on a feast day. Please give whatever you have at hand to your servants and to your son David.’”")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("9")]), _c('i', [_vm._v("When David’s young men came, they said all this to Nabal in the name of David, and then they waited.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("10")]), _c('i', [_vm._v("And Nabal answered David’s servants, “Who is David? Who is the son of Jesse? There are many servants these days who are breaking away from their masters.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("11")]), _c('i', [_vm._v("Shall I take my bread and my water and my meat that I have killed for my shearers and give it to men who come from I do not know where?”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("12")]), _c('i', [_vm._v("So David’s young men turned away and came back and told him all this.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("13")]), _c('i', [_vm._v("And David said to his men, “Every man strap on his sword!” And every man of them strapped on his sword. David also strapped on his sword. And about four hundred men went up after David, while two hundred remained with the baggage.")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("14")]), _c('i', [_vm._v("But one of the young men told Abigail, Nabal’s wife, “Behold, David sent messengers out of the wilderness to greet our master, and he railed at them.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("15")]), _c('i', [_vm._v("Yet the men were very good to us, and we suffered no harm, and we did not miss anything when we were in the fields, as long as we went with them.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("16")]), _c('i', [_vm._v("They were a wall to us both by night and by day, all the while we were with them keeping the sheep.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("17")]), _c('i', [_vm._v("Now therefore know this and consider what you should do, for harm is determined against our master and against all his house, and he is such a worthless man that one cannot speak to him.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("18")]), _c('i', [_vm._v("Then Abigail made haste and took two hundred loaves and two skins of wine and five sheep already prepared and five seahs")]), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("a")]), _vm._v(" "), _c('i', [_vm._v("of parched grain and a hundred clusters of raisins and two hundred cakes of figs, and laid them on donkeys.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("19")]), _c('i', [_vm._v("And she said to her young men, “Go on before me; behold, I come after you.” But she did not tell her husband Nabal.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("20")]), _c('i', [_vm._v("And as she rode on the donkey and came down under cover of the mountain, behold, David and his men came down toward her, and she met them.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("21")]), _c('i', [_vm._v("Now David had said, “Surely in vain have I guarded all that this fellow has in the wilderness, so that nothing was missed of all that belonged to him, and he has returned me evil for good.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("22")]), _c('i', [_vm._v("God do so to the enemies of David")]), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("b")]), _vm._v(" "), _c('i', [_vm._v("and more also, if by morning I leave so much as one male of all who belong to him.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("23")]), _c('i', [_vm._v("When Abigail saw David, she hurried and got down from the donkey and fell before David on her face and bowed to the ground.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("24")]), _c('i', [_vm._v("She fell at his feet and said, “On me alone, my lord, be the guilt. Please let your servant speak in your ears, and hear the words of your servant.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("25")]), _c('i', [_vm._v("Let not my lord regard this worthless fellow, Nabal, for as his name is, so is he. Nabal")]), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("c")]), _vm._v(" "), _c('i', [_vm._v("is his name, and folly is with him. But I your servant did not see the young men of my lord, whom you sent.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("26")]), _c('i', [_vm._v("Now then, my lord, as the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("lives, and as your soul lives, because the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("has restrained you from bloodguilt and from saving with your own hand, now then let your enemies and those who seek to do evil to my lord be as Nabal.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("27")]), _c('i', [_vm._v("And now let this present that your servant has brought to my lord be given to the young men who follow my lord.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("28")]), _c('i', [_vm._v("Please forgive the "), _c('a', {
    attrs: {
      "id": "_idTextAnchor3307"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3308"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3309"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3310"
    }
  })]), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page115",
      "title": "115"
    }
  }), _c('i', [_vm._v("trespass of your servant. For the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("will certainly make my lord a sure house, because my lord is fighting the battles of the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _c('i', [_vm._v(", and evil shall not be found in you so long as you live.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("29")]), _c('i', [_vm._v("If men rise up to pursue you and to seek your life, the life of my lord shall be bound in the bundle of the living in the care of the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("your God. And the lives of your enemies he shall sling out as from the hollow of a sling.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("30")]), _c('i', [_vm._v("And when the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("has done to my lord according to all the good that he has spoken concerning you and has appointed you prince")]), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("d")]), _vm._v(" "), _c('i', [_vm._v("over Israel,")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("31")]), _c('i', [_vm._v("my lord shall have no cause of grief or pangs of conscience for having shed blood without cause or for my lord working salvation himself. And when the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("has dealt well with my lord, then remember your servant.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("32")]), _c('i', [_vm._v("And David said to Abigail, “Blessed be the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _c('i', [_vm._v(", the God of Israel, who sent you this day to meet me!")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("33")]), _c('i', [_vm._v("Blessed be your discretion, and blessed be you, who have kept me this day from bloodguilt and from working salvation with my own hand!")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("34")]), _c('i', [_vm._v("For as surely as the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _c('i', [_vm._v(", the God of Israel, lives, who has restrained me from hurting you, unless you had hurried and come to meet me, truly by morning there had not been left to Nabal so much as one male.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("35")]), _c('i', [_vm._v("Then David received from her hand what she had brought him. And he said to her, “Go up in peace to your house. See, I have obeyed your voice, and I have granted your petition.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("36")]), _c('i', [_vm._v("And Abigail came to Nabal, and behold, he was holding a feast in his house, like the feast of a king. And Nabal’s heart was merry within him, for he was very drunk. So she told him nothing at all until the morning light.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("37")]), _c('i', [_vm._v("In the morning, when the wine had gone out of Nabal, his wife told him these things, and his heart died within him, and he became as a stone.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("38")]), _c('i', [_vm._v("And about ten days later the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("struck Nabal, and he died.")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("39")]), _c('i', [_vm._v("When David heard that Nabal was dead, he said, “Blessed be the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("who has avenged the insult I received at the hand of Nabal, and has kept back his servant from wrongdoing. The")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("has returned the evil of Nabal on his own head.” Then David sent and spoke to Abigail, to take her as his wife.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("40")]), _c('i', [_vm._v("When the servants of David came to Abigail at Carmel, they said to her, “David has sent us to you to take you to him as his wife.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("41")]), _c('i', [_vm._v("And she rose and bowed with her face to the ground and said, “Behold, your handmaid is a servant to wash the feet of the servants of my lord.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("42")]), _c('i', [_vm._v("And Abigail hurried and rose and mounted a donkey, and her five young women attended her. She followed the messengers of David and became his wife.")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("43")]), _c('i', [_vm._v("David also took Ahinoam of Jezreel, and both of them became his wives.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("44")]), _c('i', [_vm._v("Saul had given Michal his daughter, David’s wife, to Palti the son of Laish, who was of Gallim.")])]), _vm._v(" "), _c('p', {
    staticClass: "small"
  }, [_c('b', [_vm._v("a")]), _vm._v(" A "), _c('i', [_vm._v("seah")]), _vm._v(" was about 7 quarts or 7.3 liters "), _c('b', [_vm._v("b")]), _vm._v(" Septuagint "), _c('i', [_vm._v("to David")]), _vm._v(" "), _c('b', [_vm._v("c")]), _vm._v(" "), _c('i', [_vm._v("Nabal")]), _vm._v(" means "), _c('i', [_vm._v("fool")]), _vm._v(" "), _c('b', [_vm._v("d")]), _vm._v(" Or "), _c('i', [_vm._v("leader"), _c('br'), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Overview:")]), _vm._v(" The reformers remark that on account of his godly leadership, Samuel, Israel’s last judge, is buried properly in Ramah. The story of foolish Nabal leads these interpreters to apply the lessons from Nabal’s dealings with David to our own lives: we should prefer others over ourselves, show thankfulness and not waste our time casting pearls before swine. But the story about Nabal also warns us of the excesses of anger. Despite the patience David bears when wronged by others, these interpreters believe that David acts too rashly when he vows to harm Nabal for being rude and refusing to acknowledge social norms.")]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("David Avoids Shedding Blood.")]), _vm._v(" "), _c('i', [_vm._v("Johannes Bugenhagen:")]), _vm._v(" In this story of David against Nabal, let us first say that David could have used the law of the sword to fight impiety and blasphemy because he was a king ordained by God over Nabal, who was a big man in and around Judah and a descendant of the excellent man Caleb. But while we thus excuse David’s situation, we fall into danger of speaking against Scripture, which says that David sought protection from human zeal. In this matter, he could have had a good conscience, for this impious man deserved to die and be slain; he could have made a vow against "), _c('a', {
    attrs: {
      "id": "_idTextAnchor3311"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3312"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3313"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3314"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3315"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3316"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3317"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3318"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3319"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3320"
    }
  }), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page116",
      "title": "116"
    }
  }), _vm._v("Nabal through the God of Israel. But see the words of Abigail. See David’s words of thanksgiving that he had been kept from shedding blood. Accordingly, you also will see this to be as clear as day. David sought relief from the unlawfulness being introduced to him, which Scripture prohibits. And, as a person, it would certainly be a sin to fall on him without consulting the Lord (as he usually did) instead of deciding about the righteousness of the matter based on what the Lord wants. For God establishes nothing more than this desire even in the saints, that we unite God’s word and will to our good intentions (as they call them). For indeed, it appears as if David’s cause is just, so that even his vow in verse 22 looks to him as something about to be accomplished, striking down the impious and blasphemous one, as if it were not against God’s law but in accordance with law and right. His conscience was certainly good. But while conscience is at its highest, it is impiously not being guided by the Word of God. This is indeed just as Paul says, he who was converted to a good conscience before God as his ancestors were (2 Tim 1), from having been a blasphemer and persecutor of the church (1 Tim 1). Therefore David gives thanks to God, who turned him away from his plans through Abigail. "), _c('i', [_vm._v("Commentary on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-128-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-128",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Abigail as Allegory of the Church.")]), _vm._v(" "), _c('i', [_vm._v("Andrew Willet:")]), _vm._v(" Nabal is described by his place of dwelling in Maon, though he kept his cattle in Carmel, where his business lay. According to Joshua 15:55, Maon, Ziph and Carmel were not far from each other. Carmel generally signifies any place tilled or planted. It was the proper name of two places, one in Issachar, where Baal’s priests were killed, and another in Judah, where this story takes place. Moreover, Nabal is set forth by his name, which means “fool.” By his riches and qualities, he was churlish and evil-conditioned. Indeed, riches, where God’s grace is not bestowed, make people proud and insolent. By his kindred, Nabal was of the posterity of Caleb. However, good men do not always have good issue. Parents may leave to their children riches and possessions, but they cannot bequeath them wisdom, understanding and piety; for these attributes only proceed from God. And if there might be a certain descent of these spiritual graces, as of temporal ones, they would be thought to be natural. As for Abigail, whose name is interpreted as “the joy of the father,” she was a virtuous woman who was unequally matched with a wicked husband. Ambrose makes this allegory concerning her: Abigail signifies the church, which first served under a foolish and unwise husband, the philosophers and other vain men among the heathen. But afterward she was joined in marriage to Christ, just as Abigail became David’s wife. But this figure does not hold water on every point. For Abigail was a beautiful and wise woman before she was married to David, while the church of God was deformed and without any spiritual attractiveness or beauty until she was espoused to Christ. "), _c('i', [_vm._v("Harmony on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-127-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-127",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])])])])]), _vm._v(" "), _c('h5', {
    attrs: {
      "id": "sigil_toc_id_121"
    }
  }, [_c('b', [_vm._v("25:1")]), _vm._v(" "), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("The Death of Samuel")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Israel’s Last Judge.")]), _vm._v(" "), _c('i', [_vm._v("Johannes Bugenhagen:")]), _vm._v(" You might wonder that Saul did not manifestly threaten Samuel with evil, for Samuel himself said, “If Saul hears it, he will kill me.” But it is clear that he was afraid of the people, with whom this admirable prophet had lived from his youth until he was a holy judge in Israel, so that even the king was afraid of Samuel, as the story above in chapter 15 declared. The same is true in chapter 28 below, where in anguish Saul wanted to raise him up from death himself, which he wanted not out of any sense of sorrow but because of his own failure. . . . Here dies the last judge of Israel, the one who established the kingdom. "), _c('i', [_vm._v("Commentary on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-126-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-126",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Burial with Reverence.")]), _vm._v(" "), _c('i', [_vm._v("Andrew Willet:")]), _vm._v(" The people had great cause to mourn for Samuel, the Lord’s prophet. He was an upright man. In "), _c('a', {
    attrs: {
      "id": "_idTextAnchor3321"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3322"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3323"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3324"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3325"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3326"
    }
  }), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page117",
      "title": "117"
    }
  }), _vm._v("fact, at this time two calamities happened together: first, the death of Samuel, so great a prophet, and the exile of David. And second, not long after Samuel’s death, the Philistines prevailed against Saul after he and his three sons died in battle. It is not likely that Saul publicly mourned for Samuel as Samuel had done for Saul. And he did not wait long after Samuel’s death before pursuing David. Therefore David took this opportunity to escape to the utmost parts of the land, while others were busy with the burial of Samuel. There was a very great assembly of all Israel to honor Samuel’s funeral, for the bodies of the saints are to be interred in a dignified way. They are to be brought to the ground with honorable solemnity according to their defects while they lived. . . . Indeed, the bodies of Christians should not be neglected and cast away as unclean. This is how the heathens act, who have no regard for the immortality of the soul. Accordingly, they make a small account of the dead. In fact, the pagan emperors of Rome let the bodies of Christians lie unburied. However, the bodies of Christians, in hope of the resurrection and as temples of the Holy Spirit, should be commended and committed to Christian burial with reverence. "), _c('i', [_vm._v("Harmony on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-125-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-125",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])])])])]), _vm._v(" "), _c('h5', {
    attrs: {
      "id": "sigil_toc_id_122"
    }
  }, [_c('b', [_vm._v("25:2-12")]), _vm._v(" "), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("Foolish Nabal")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Riches and Blessings Are Wasted on Fools.")]), _vm._v(" "), _c('i', [_vm._v("Johannes Bugenhagen:")]), _vm._v(" Proverbs says, “What good does it do a fool to have riches when he cannot buy wisdom?” Here you have an example. It is all for the worst whenever power and riches fall on foolish people, that is, among those ignorant of God’s Word. How much do you really value the cross carried by this wise, God-fearing woman Abigail? What impious company, which congregates in any and every place where you read of a good woman in Scripture! But God later makes her the queen and holiest wife of David, for God often leads the elect through hell and back again, and the impious are preserved until the day of evil. Moreover, hypocrites say yes presumptively to God’s love as long as the better gifts of God are visible: power, riches, eloquence, worldly wisdom, expertise in the law, righteousness of the flesh, a robust body and appearance, and so on. We use these examples to oppose the notion that Nabal was great or wealthy or that he deserved to be given the greatest wife, for there is nothing greater in this life than that. "), _c('i', [_vm._v("Commentary on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-124-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-124",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Tending to Christ’s Sheep.")]), _vm._v(" "), _c('i', [_vm._v("Thomas Adams:")]), _vm._v(" Nabal thinks only of his sheep and does not have any concern for David. If the truth were known, there are many Nabals today who love their own sheep better than Christ’s sheep. "), _c('i', [_vm._v("The White Devil.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-123-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-123",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Being Thankful Unlike Nabal.")]), _vm._v(" "), _c('i', [_vm._v("John Davenant:")]), _vm._v(" We ought to be thankful to God because without gratitude there can be no spiritual blessings within us. For since every spiritual blessing depends on a certain perpetual influx of divine grace, ingratitude is that infernal bar that interrupts the flow and the course of divine goodness. Therefore we ought to be thankful, lest we should be deprived of all our gifts.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("But gratitude toward people is also required so that peace may be kept inviolate, because troubles and enmities sometimes arise from kindnesses not duly repaid or from injuries inflicted. We perceive this in the example of Nabal, who by his ingratitude so exasperated the mind of David that unless the prudence and humanity of Abigail had relieved him, that ungrateful man and his whole family would have been ruined.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("There are two instructions we may gather from this: First, if we would have God remain kind to us, we ought to show ourselves thankful to him and grateful for the benefits conferred on us. Second, "), _c('a', {
    attrs: {
      "id": "_idTextAnchor3327"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3328"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3329"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3330"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3331"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3332"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3333"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3334"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3335"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3336"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3337"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3338"
    }
  }), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page118",
      "title": "118"
    }
  }), _vm._v("the best proof we can give of our gratitude is that we obey the divine will. . . . Those benefited by kindnesses are bound by the divine command (if occasion offers) to return thanks to their benefactors not in mere words, but in reality. "), _c('i', [_vm._v("Exposition on Colossians.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-122-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-122",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])])])])]), _vm._v(" "), _c('h5', {
    attrs: {
      "id": "sigil_toc_id_123"
    }
  }, [_c('b', [_vm._v("25:13-35")]), _vm._v(" "), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("David’s Rashness")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("By God’s Permission.")]), _vm._v(" "), _c('i', [_vm._v("Jacobus Arminius:")]), _vm._v(" God permitted David to resolve in his mind to destroy with the sword Nabal and all his domestics, and to go instantly to him; but he did not permit him to shed innocent blood, and to save himself by his own hand. "), _c('i', [_vm._v("Disputation 10: On the Righteousness and Efficacy of God’s Providence Concerning Evil")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-121-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-121",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("David’s Hasty and Sudden Rage.")]), _vm._v(" "), _c('i', [_vm._v("Andrew Willet:")]), _vm._v(" It may seem strange that David, who patiently bore both the wrongs Saul perpetrated against him as well as the ravings of Shimei later on when he was king, could not at this time hold himself back from Nabal’s insult. On the contrary, he quickly armed himself to take revenge. His first reason for doing so was due to the ingratitude of Nabal, who returned to him “evil for good,” as David says in verse 21. The other reason was due to the indignity and contempt with which Nabal spoke to David’s servants. Here it is clear that people can endure greater violence offered to their bodies than contempt and reproaches to their good name. "), _c('i', [_vm._v("Harmony on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-120-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-120",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("On David’s Lie.")]), _vm._v(" "), _c('i', [_vm._v("Benedict Aretius:")]), _vm._v(" David swore he would kill Nabal, but afterward he did not do so. We respond: He rashly swore, but he later more wisely changed his mind. In the thought was sin but in his change of heart is praise. Therefore, there is no profit for the one who lies. "), _c('i', [_vm._v("Common Places of the Christian Religion.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-119-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-119",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])])])])]), _vm._v(" "), _c('h5', {
    attrs: {
      "id": "sigil_toc_id_124"
    }
  }, [_c('b', [_vm._v("25:36-38")]), _vm._v(" "), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("Not Reasoning with a Drunken Person")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Taking the Wise Course.")]), _vm._v(" "), _c('i', [_vm._v("Lancelot Andrewes:")]), _vm._v(" That course Abigail took . . . is the course God uses, that is, in the spirit of discretion to deal with people when the fit of rage of sin is past and when their blood is cold. For there is no meddling with a person in their drunken fit or in their fury of heat and rage, because their judgment and senses are then taken away. "), _c('i', [_vm._v("Collection of Lectures.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-118-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-118",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Waiting till the Wine’s Gone Out.")]), _vm._v(" "), _c('i', [_vm._v("John Arrowsmith:")]), _vm._v(" You may see a drunk person reeling to and fro, today entertaining this odd conceit, tomorrow that . . . and unstable in all his ways. In fact, the drunk may be vomiting and casting out scornful reproaches on all who are of a contrary judgment. . . . You may perceive them full of slander, as drunkards commonly used to be, prating and venting their own apprehensions everywhere. . . . “One drunkard,” our proverb says, “is forty men strong.” Whoever attempts to reason with them will easily find them as incapable of conviction as Nabal was of Abigail’s narration till his wine was gone out of him. "), _c('i', [_vm._v("Chain of Principles.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-117-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-117",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])])])])]), _vm._v(" "), _c('h5', {
    attrs: {
      "id": "sigil_toc_id_125"
    }
  }, [_c('b', [_vm._v("25:39-44")]), _vm._v(" "), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("David’s Polygamy")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Example for Admonishing, Not Imitating.")]), _vm._v(" "), _c('i', [_vm._v("Johannes Piscator:")]), _vm._v(" This admission of polygamy in the holy figure of David is not given as an example to follow. Rather, it’s given as a way to admonish the weaknesses of the saints. "), _c('i', [_vm._v("Commentary on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-116-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-116",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Polygamy Among Cave Wandering.")]), _vm._v(" "), _c('i', [_vm._v("Cardinal Cajetan:")]), _vm._v(" See how great the Jewish inclination toward procreation was! The zeal of the Jews was so great for producing children that they "), _c('a', {
    attrs: {
      "id": "_idTextAnchor3339"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3340"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3341"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3342"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3343"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3344"
    }
  }), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page119",
      "title": "119"
    }
  }), _vm._v("managed to multiply wives while also wandering through caves. "), _c('i', [_vm._v("Commentary on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-115-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-115",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Multiple Wives and Singular Faith.")]), _vm._v(" "), _c('i', [_vm._v("Konrad Pellikan:")]), _vm._v(" David was allowed to have multiple wives, just as other saints similarly were welcomed amid great sins. Nevertheless, he knew that such temptations of the flesh were quite unbearable. We are not allowed to take many wives, as the saints were before us, without it causing trouble. Solomon did not handle having many wives well, nor did David, as we have seen. The Lord had advised them well, yet did not count their actions as a grave sin, as it would have been among others. On the contrary, Saul had few wives and yet displeased God; David had many and pleased the Lord. Wives did not cause this, rather faith. "), _c('i', [_vm._v("Commentary on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-114-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-114",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Many Wives Are Permissible.")]), _vm._v(" "), _c('i', [_vm._v("Andrew Willet:")]), _vm._v(" Because the law is given in Deuteronomy 17:17 that the king shall not multiply many wives lest his heart turn away, there is great doubt whether David did not offend against that law. That’s because this passage explicitly mentions that David had three wives (and many more afterward). Some answer that as in the same place the king is forbidden to have many horses, yet Solomon—before his fall, while his wisdom remained with him—had forty thousand stalls of horses, meaning that as it was lawful for the king to have a number of horses for the maintenance of the state, as long as they were necessary and not excessive. They were not to be kept only for ostentation and pleasure. According to such an interpretation, therefore, the king would be permitted to have two, three or more wives, so long as they were not multiplied out of measure. Such was Solomon’s sin and not David’s. But some do not find this interpretation satisfying. For although Solomon had hundreds more wives than David, David still had more than one wife; in fact, he had six. Nor does the comparison hold between the number of horses and wives: For one wife may suffice, where many thousands of horses are not sufficient for the state and service of a king. Some therefore think that the issue is not about having many wives but about not multiplying them such as would turn the king’s heart away from God. Again, in such a circumstance, Solomon’s wives did turn his heart away from God while David’s wives did not. But this answer is not sufficient either. That’s because this law is meant for all the kings of Israel, just as much as it is for all others. For anyone who has multiple wives will be put in peril, though some by God’s grace are kept from that danger.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Therefore the occasion of the danger is to be shunned completely, for no one knows their own strength. The same law is prescribed, namely, that they should not take the daughters of the foreign nations to their sons lest they make them “whore after their gods.” Yet was it simply forbidden to marry them even though no idolatry ensued? For example, although the people confessed that they had trespassed against God by taking foreign wives of the people of the land in Ezra 10:2, no mention is made that by them they fell into idolatry. Accordingly, some think the king was forbidden to violently take away other men’s wives, as they did before the flood. Such would have been David’s great offense by taking Uriah’s wife. If this was the meaning, however, then Solomon would not have transgressed against this law by taking many wives, for it does not appear that any of his queens and concubines were another’s wife. Nor yet can it be thought that such a holy man as David would transgress such a manifest law. Therefore, though it was a general infirmity in those days not only in kings but also in their people to have many wives . . . yet the meaning of this law does not appear to simply forbid many wives. This is apparent by the verse which indicates that the Lord gave power and liberty to David to take his master’s wives: “And I gave you your master’s house and your master’s wives into your arms and gave you the house of Israel and of Judah. And if this were too little, I would add to you as much more.” The Lord would "), _c('a', {
    attrs: {
      "id": "_idTextAnchor3345"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3346"
    }
  }), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page120",
      "title": "120"
    }
  }), _vm._v("not have gone against his own law. Therefore, in this passage, it is not the "), _c('i', [_vm._v("thing")]), _vm._v(" that is forbidden, but the "), _c('i', [_vm._v("manner")]), _vm._v(". In other words, the king was not to take many wives to give himself to lust and pleasure, and so neglect the office and duty of the kingdom. And just as the king was forbidden to multiply horses, gold and silver, so he was restrained from multiplying wives. But it was lawful in and of itself for the king to have many horses, silver and gold, as Solomon had. However, he was not to trust in them. To conclude, it was permitted in those times to have many wives. Yet the kings were not to use their wives for lust and concupiscence, but for procreation. The kings were not to be addicted to them. "), _c('i', [_vm._v("Harmony on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-113-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-113",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")])])])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "_idContainer035"
    }
  }, [_c('p', {
    staticClass: "PER_Top-extra-space"
  }, [_c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page121",
      "title": "121"
    }
  })]), _vm._v(" "), _c('h2', {
    staticClass: "PER_ScriptureCenter",
    attrs: {
      "id": "sigil_toc_id_126"
    }
  }, [_c('span', {
    staticClass: "RH-marker"
  }, [_vm._v("26:1–27:12")]), _vm._v(" DAVID SPARES SAUL AGAIN AND THEN FLEES")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("1")]), _c('i', [_vm._v("Then the Ziphites came to Saul at Gibeah, saying, “Is not David hiding himself on the hill of Hachilah, which is on the east of Jeshimon?”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("2")]), _c('i', [_vm._v("So Saul arose and went down to the wilderness of Ziph with three thousand chosen men of Israel to seek David in the wilderness of Ziph.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("3")]), _c('i', [_vm._v("And Saul encamped on the hill of Hachilah, which is beside the road on the east of Jeshimon. But David remained in the wilderness. When he saw that Saul came after him into the wilderness,")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("4")]), _c('i', [_vm._v("David sent out spies and learned that Saul had indeed come.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("5")]), _c('i', [_vm._v("Then David rose and came to the place where Saul had encamped. And David saw the place where Saul lay, with Abner the son of Ner, the commander of his army. Saul was lying within the encampment, while the army was encamped around him.")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("6")]), _c('i', [_vm._v("Then David said to Ahimelech the Hittite, and to Joab’s brother Abishai the son of Zeruiah, “Who will go down with me into the camp to Saul?” And Abishai said, “I will go down with you.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("7")]), _c('i', [_vm._v("So David and Abishai went to the army by night. And there lay Saul sleeping within the encampment, with his spear stuck in the ground at his head, and Abner and the army lay around him.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("8")]), _c('i', [_vm._v("Then Abishai said to David, “God has given your enemy into your hand this day. Now please let me pin him to the earth with one stroke of the spear, and I will not strike him twice.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("9")]), _c('i', [_vm._v("But David said to Abishai, “Do not destroy him, for who can put out his hand against the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _c('i', [_vm._v("’s anointed and be guiltless?”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("10")]), _c('i', [_vm._v("And David said, “As the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("lives, the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("will strike him, or his day will come to die, or he will go down into battle and perish.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("11")]), _c('i', [_vm._v("The")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("forbid that I should put out my hand against the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _c('i', [_vm._v("’s anointed. But take now the spear that is at his head and the jar of water, and let us go.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("12")]), _c('i', [_vm._v("So David took the spear and the jar of water from Saul’s head, and they went away. No man saw it or knew it, nor did any awake, for they were all asleep, because a deep sleep from the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("had fallen upon them.")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("13")]), _c('i', [_vm._v("Then David went over to the other side and stood far off on the top of the hill, with a great space between them.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("14")]), _c('i', [_vm._v("And David called to the army, and to Abner the son of Ner, saying, “Will you not answer, Abner?” Then Abner answered, “Who are you who calls to the king?”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("15")]), _c('i', [_vm._v("And David said to Abner, “Are you not a man? Who is like you in Israel? Why then have you not kept watch over your lord the king? For one of the people came in to destroy the king your lord.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("16")]), _c('i', [_vm._v("This thing that you have done is not good. As the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("lives, you deserve to die, because you have not kept watch over your lord, the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _c('i', [_vm._v("’s anointed. And now see where the king’s spear is and the jar of water that was at his head.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("17")]), _c('i', [_vm._v("Saul recognized David’s voice and said, “Is this your voice, my son David?” And David said, “It is my voice, my lord, O king.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("18")]), _c('i', [_vm._v("And he said, “Why does my lord pursue after his servant? For what have I done? What evil is on my hands?")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("19")]), _c('i', [_vm._v("Now therefore let my lord the king hear the words of his servant. If it is the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("who has stirred you up against me, may he accept an offering, but if it is men, may they be cursed before the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _c('i', [_vm._v(", for they have driven me out this day that I should have no share in the heritage of the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _c('i', [_vm._v(", saying, ‘Go, serve other gods.’")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("20")]), _c('i', [_vm._v("Now therefore, let not my blood fall to the earth away from the presence of the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _c('i', [_vm._v(", for the king of Israel has come out to seek a single flea like one who hunts a partridge in the mountains.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("21")]), _c('i', [_vm._v("Then Saul said, “I have sinned. Return, my son David, for I will no more do you harm, because my life was precious in your eyes this day. Behold, I have acted foolishly, and have made a great mistake.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("22")]), _c('i', [_vm._v("And David answered and said, “Here is the spear, O king! Let one of the young men come over and take it.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("23")]), _c('i', [_vm._v("The")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("rewards every man for his righteousness and his faithfulness, for the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("gave you into my hand today, and I would not put out my hand against the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _c('i', [_vm._v("’s anointed.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("24")]), _c('i', [_vm._v("Behold, as your life was precious this day in my sight, so may my life be precious in the sight of the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _c('i', [_vm._v(", and may he deliver me out of all tribulation.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("25")]), _c('i', [_vm._v("Then Saul said to David, "), _c('a', {
    attrs: {
      "id": "_idTextAnchor3347"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3348"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3349"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3350"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3351"
    }
  })]), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page122",
      "title": "122"
    }
  }), _c('i', [_vm._v("“Blessed be you, my son David! You will do many things and will succeed in them.” So David went his way, and Saul returned to his place.")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    staticClass: "drop-cap"
  }, [_vm._v("27")]), _vm._v(" "), _c('i', [_vm._v("Then David said in his heart, “Now I shall perish one day by the hand of Saul. There is nothing better for me than that I should escape to the land of the Philistines. Then Saul will despair of seeking me any longer within the borders of Israel, and I shall escape out of his hand.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("2")]), _c('i', [_vm._v("So David arose and went over, he and the six hundred men who were with him, to Achish the son of Maoch, king of Gath.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("3")]), _c('i', [_vm._v("And David lived with Achish at Gath, he and his men, every man with his household, and David with his two wives, Ahinoam of Jezreel, and Abigail of Carmel, Nabal’s widow.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("4")]), _c('i', [_vm._v("And when it was told Saul that David had fled to Gath, he no longer sought him.")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("5")]), _c('i', [_vm._v("Then David said to Achish, “If I have found favor in your eyes, let a place be given me in one of the country towns, that I may dwell there. For why should your servant dwell in the royal city with you?”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("6")]), _c('i', [_vm._v("So that day Achish gave him Ziklag. Therefore Ziklag has belonged to the kings of Judah to this day.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("7")]), _c('i', [_vm._v("And the number of the days that David lived in the country of the Philistines was a year and four months.")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("8")]), _c('i', [_vm._v("Now David and his men went up and made raids against the Geshurites, the Girzites, and the Amalekites, for these were the inhabitants of the land from of old, as far as Shur, to the land of Egypt.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("9")]), _c('i', [_vm._v("And David would strike the land and would leave neither man nor woman alive, but would take away the sheep, the oxen, the donkeys, the camels, and the garments, and come back to Achish.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("10")]), _c('i', [_vm._v("When Achish asked, “Where have you made a raid today?” David would say, “Against the Negeb of Judah,” or, “Against the Negeb of the Jerahmeelites,” or, “Against the Negeb of the Kenites.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("11")]), _c('i', [_vm._v("And David would leave neither man nor woman alive to bring news to Gath, thinking, “lest they should tell about us and say, ‘So David has done.’” Such was his custom all the while he lived in the country of the Philistines.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("12")]), _c('i', [_vm._v("And Achish trusted David, thinking, “He has made himself an utter stench to his people Israel; therefore he shall always be my servant.”"), _c('br'), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Overview:")]), _vm._v(" The theme of David as a messianic figure and Saul as an evil oppressor continues in these two chapters. One of the Anabaptist commentators, likely drawing on his own experience as a persecuted minority, draws direct connections between David and Christ’s persecutions. In addition, David’s deception of Achish, though used to protect the Judeans, is not to be an example for believers—the works and words of God, not human beings, are.")]), _vm._v(" "), _c('h5', {
    attrs: {
      "id": "sigil_toc_id_127"
    }
  }, [_c('b', [_vm._v("26:1-5")]), _vm._v(" "), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("The Hunt Continues")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("David’s Persecuted Then Enthroned Heir.")]), _vm._v(" "), _c('i', [_vm._v("Dirk Philips:")]), _vm._v(" Christ also was persecuted by unbelieving and godless people and often had to escape from Judea and hide himself in the wilderness. But after this he received his kingdom and was established and inaugurated by God his Father as the mighty king on Mount Zion. God gave him the throne of David to rule in the house of Jacob for eternity, a kingdom without end. "), _c('i', [_vm._v("Enchiridion: Concerning Spiritual Restitution.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-112-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-112",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("No Rest for the Wicked.")]), _vm._v(" "), _c('i', [_vm._v("Thomas Adams:")]), _vm._v(" The wicked cannot sleep until they have done mischief. Saul would not give over the chase of David, but hunts him savagely through every wilderness. The very desert is held too good a refuge for innocence; the hills and rocks are searched in an angry jealousy. The very wild goats of the mountains were not allowed to be companions for the one who had no other fault but his virtue. Still David’s success is Saul’s vexation. Where will that person rest who seeks rest in sin? They cannot find rest in this life, for they walk in circles, grind in the devil’s mill. Will they rest hereafter? No, then they will eat of their own grist, and labor in torment. Only there is some difference in the manner of their working, and of the time; here with pleasure, there with horror: for a while here, there forever. Still "), _c('a', {
    attrs: {
      "id": "_idTextAnchor3352"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3353"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3354"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3355"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3356"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3357"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3358"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3359"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3360"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3361"
    }
  }), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page123",
      "title": "123"
    }
  }), _vm._v("these obstinate seducers who are obsessed with mischief go on, from strength in sin, to strength of sinning, till every one appears before their master in hell. "), _c('i', [_vm._v("Commentary on 2 Peter.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-111-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-111",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("How the Lord Stirs Up.")]), _vm._v(" "), _c('i', [_vm._v("Andrew Willet:")]), _vm._v(" God stirs no one up nor tempts the person to evil, just as he himself is not tempted of any evil. Yet the Lord may be said here to stir Saul up to the action of pursuing of David in three kinds of ways. First, God acts instrumentally. He justly uses here the ministry of the evil spirits, which were the instruments and ministers of God in stirring up Saul. God justly sent them on Saul to do his will. Second, God, acting efficiently, may be said to stir up the magistrate to act justly. But here Saul acted unjustly. Finally, the Lord occasionally stirs up when the wicked take occasion by God’s mercies on others to fret and show their malice. Such is how Pharaoh hated the people of God because he saw that they increased plentifully. And so Saul was David’s enemy because the Lord had caused him to be anointed as king. "), _c('i', [_vm._v("Harmony on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-110-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-110",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])])])])]), _vm._v(" "), _c('h5', {
    attrs: {
      "id": "sigil_toc_id_128"
    }
  }, [_c('b', [_vm._v("26:6-25")]), _vm._v(" "), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("David’s Great Restraint")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Wickedness by Another.")]), _vm._v(" "), _c('i', [_vm._v("William Tyndale:")]), _vm._v(" If any person might have avenged himself on his superior, it would have justifiably been David’s actions done on King Saul, who so wrongfully persecuted David. And he did this for no other cause than that God had anointed David king and promised him the kingdom. Yet when God had delivered Saul into the hands of David, he could not do what he may have wanted to do with him. . . . As the old proverb says, “Out of the wicked shall wickedness proceed, but my hand will not be on you,” meaning that God always punishes one who is wicked by another. "), _c('i', [_vm._v("Doctrinal Treatises and Introductions to Other Portions of Holy Scriptures.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-109-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-109",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("On Being a Good Subject.")]), _vm._v(" "), _c('i', [_vm._v("Heinrich Bullinger:")]), _vm._v(" We learn partly through the example of David and partly through the teachings of Jeremiah and the apostles in what way subjects are to be influenced by their hard and cruel princes or tyrants. David was not ignorant of the type of person Saul was—an ungodly and cruel bandit; as such, he fled from him. But when the occasion arose for him once or twice to take him down, David did not kill Saul but spared the tyrant and honored him as if he were his own father. "), _c('i', [_vm._v("Decades 2.6.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-108-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-108",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Practice in Afflictions.")]), _vm._v(" "), _c('i', [_vm._v("Johannes Bugenhagen:")]), _vm._v(" As always, here goes Saul, except now with even more impiety since David overlooked his sins and false oaths above in chapter 24. Indeed, David does not turn away from his innocence this time either, as he still does not want to strike down the king until the Lord strikes him down. He trusts God’s vindication, perhaps having learned in the previous chapter that it might be harmful to follow our whims. And it clearly happens again as it did in chapter 4 that David has been well versed to this point in having a strong faith in his soul, so that by his own will he and his companions go down into Saul’s camp. For he has been protected so often that he knows himself to be in God’s care and that he cannot perish in Saul’s impiety. Only practice in afflictions can produce such faith in us. For God exalts through faith for faith, so that we might grow to full maturity. Moreover, this story has it that the wisdom of the flesh is mocked and the Spirit cares for the one to whom it has been given. A deep sleep from the Lord had come over David’s enemies. In this miracle, we see how much God cared for David, who entrusted himself to God with the highest faithfulness. "), _c('i', [_vm._v("Commentary on 1 Samuel.")]), _c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-107-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-107",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_c('span', {
    staticClass: "com-rorohiko-pagestaker-style"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor3362"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3363"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3364"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3365"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3366"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3367"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3368"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3369"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3370"
    }
  })])]), _c('b', [_c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page124",
      "title": "124"
    }
  })]), _c('b', [_vm._v("Confident Prayer While Being Hunted.")]), _vm._v(" "), _c('i', [_vm._v("John Knox:")]), _vm._v(" What is necessary to be followed in prayer is a sure hope to obtain what we ask for. For nothing more offends God than when we ask doubtfully whether he will grant our petitions. For in so doing we doubt if God is true and if he is mighty and good. Such, says James, obtain nothing, and therefore Jesus Christ commands that we firmly believe in order to obtain whatever we ask for. For all things are possible to the one who believes. And therefore, in our prayers, desperation is always to be expelled. I do not mean that any person in extremity of trouble can be without present pain and without a greater fear of trouble to follow. Rather, trouble and fear are the very spurs to prayer. For when a person, encircled with vehement calamities and vexed with continual anxiety—having, by human help, no hope of deliverance, with an oppressed and punished heart, fearing also greater punishment to follow from the deep pit of tribulation—calls to God for comfort and support, such prayer ascends to God’s presence, and does not return in vain.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("This is seen, for instance, in Saul’s vehement persecution of David, as the latter was hunted and chased from every hole, fearing that one day or other he should fall into the hands of his persecutors. After that he complained that no place of rest was left to him, vehemently praying, “O Lord my God, in you do I take refuge; save me from all my pursuers and deliver me, lest like a lion they tear my soul apart, rending it in pieces, with none to deliver. O Lord my God, if I have done this, if there is wrong in my hands, if I have repaid my friend with evil or plundered my enemy without cause, let the enemy pursue my soul and overtake it, and let him trample my life to the ground and lay my glory in the dust.” In the midst of these anguishes, the goodness of God sustained David, so that the present tribulation was tolerable. And the infallible promises of God so assured him of deliverance that fear was partly mitigated and gone, as plainly appears to those who diligently observe the process of his prayer. "), _c('i', [_vm._v("Treatise on Prayer.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-106-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-106",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("David’s Good Example.")]), _vm._v(" "), _c('i', [_vm._v("Thomas Becon:")]), _vm._v(" It is good to follow the example of David, who showed such honor and reverence to King Saul, both a wicked ruler and his mortal enemy, that he would not once hurt him, nor yet suffer any other to do it, although he had sufficient opportunity . . . and occasion at diverse times to have slain him, if he had been minded. "), _c('i', [_vm._v("A New Catechism.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-105-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-105",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Innocence Before God.")]), _vm._v(" "), _c('i', [_vm._v("David Dickson:")]), _vm._v(" Though innocence cannot exempt a person from being unjustly slandered, yet it will furnish him with a good conscience and much boldness in the specific things before God. . . . The more a person renders good for evil, the more confidence he will have when he comes to God. For innocence served David for this good use, namely, that he delivered Saul—who was his enemy for no good reason. . . . The one who is conscious of doing or intending injury to his neighbor will have his own conscience against him, and in that case will be forced to justify God’s righteousness against himself. "), _c('i', [_vm._v("Explication of the First Fifty Psalms.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-104-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-104",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])])])])]), _vm._v(" "), _c('h5', {
    attrs: {
      "id": "sigil_toc_id_129"
    }
  }, [_c('b', [_vm._v("27:1-12")]), _vm._v(" "), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("David Flees to the Philistines")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("The Enemy of Your Enemy.")]), _vm._v(" "), _c('i', [_vm._v("Johannes Bugenhagen:")]), _vm._v(" Here David in his anguish is driven away, deciding he will be better off among enemies than among his own people. And he flees to the one he was with before, Achish in Gath of the Philistines, the enemy of Israel. David receives the city of Ziklag from him to live in as a prince. But why does he flee to the one before whom he was so afraid that he pretended to be out of his mind? I reply: By this time it had become known that the life of this prince who had dispatched Goliath was being sought by the king of Israel. For this reason, the king of the Philistines was not afraid of any traps but warmly accepted this great man as a Philistine, of whom it might be expected that he would do great evil against Saul. "), _c('i', [_vm._v("Commentary on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-103-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-103",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_c('span', {
    staticClass: "com-rorohiko-pagestaker-style"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor3371"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3372"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3373"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3374"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3375"
    }
  })])]), _c('b', [_c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page125",
      "title": "125"
    }
  })]), _c('b', [_vm._v("David’s Unbelief and Belief.")]), _vm._v(" "), _c('i', [_vm._v("Justus Menius:")]), _vm._v(" Here David’s weakened faith is described. He feared that he would eventually fall into Saul’s hands; therefore he departed from the borders of Israel into the land of the Philistines. Now, as by this David’s faith had been weakened in part, so that he fled Saul; so also, again, in a different way his faith was strengthened in part, so that he dared to entrust himself to a most hostile people. For if you would consider what a wicked reputation he had earned for himself among the Philistines—because he killed Goliath and, in addition, he cut down two hundred of them and cut off their foreskin—you would easily recognize that there was nothing more dangerous than to dwell in this race’s country. Yes, although David was in the midst of an impious people, nevertheless he did not at the same time abandon faith, no indeed, he did nothing apart from faith. "), _c('i', [_vm._v("Commentary on 1 Samuel 27.")]), _c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-102-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-102",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("David’s Answers to King Achish.")]), _vm._v(" "), _c('i', [_vm._v("Johannes Bugenhagen:")]), _vm._v(" The king asked, “Where have you made a raid today?” David’s words were true, but through them he nevertheless deceived the king, who thought that David was bringing evil to the Judeans as an enemy. For the king greatly desired that David might sacrifice himself against the nations, and so he did not condemn those things, even though he did not know what was being plundered. Thus David deceived the king without being condemned by the king in order to defend himself and protect his own, which God was allowing to him to do. We spoke of this fraud earlier, that one may not make a rule of deception based on this. For it is the well-practiced hypocritical wisdom of the flesh that makes a law out of the works of the saints, as if the saints were not able to sin. We should follow the Word of God, not the works of the saints, unless we even want to imitate David in committing adultery and murder. "), _c('i', [_vm._v("Commentary on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-101-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-101",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])])])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "_idContainer036"
    }
  }, [_c('p', {
    staticClass: "PER_Top-extra-space"
  }, [_c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page126",
      "title": "126"
    }
  })]), _vm._v(" "), _c('h2', {
    staticClass: "PER_ScriptureCenter",
    attrs: {
      "id": "sigil_toc_id_130"
    }
  }, [_c('span', {
    staticClass: "RH-marker"
  }, [_vm._v("28:1-25")]), _vm._v(" SAUL AND THE MEDIUM AT EN-DOR")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("1")]), _c('i', [_vm._v("In those days the Philistines gathered their forces for war, to fight against Israel. And Achish said to David, “Understand that you and your men are to go out with me in the army.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("2")]), _c('i', [_vm._v("David said to Achish, “Very well, you shall know what your servant can do.” And Achish said to David, “Very well, I will make you my bodyguard for life.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("3")]), _c('i', [_vm._v("Now Samuel had died, and all Israel had mourned for him and buried him in Ramah, his own city. And Saul had put the mediums and the necromancers out of the land.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("4")]), _c('i', [_vm._v("The Philistines assembled and came and encamped at Shunem. And Saul gathered all Israel, and they encamped at Gilboa.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("5")]), _c('i', [_vm._v("When Saul saw the army of the Philistines, he was afraid, and his heart trembled greatly.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("6")]), _c('i', [_vm._v("And when Saul inquired of the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _c('i', [_vm._v(", the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("did not answer him, either by dreams, or by Urim, or by prophets.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("7")]), _c('i', [_vm._v("Then Saul said to his servants, “Seek out for me a woman who is a medium, that I may go to her and inquire of her.” And his servants said to him, “Behold, there is a medium at En-dor.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("8")]), _c('i', [_vm._v("So Saul disguised himself and put on other garments and went, he and two men with him. And they came to the woman by night. And he said, “Divine for me by a spirit and bring up for me whomever I shall name to you.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("9")]), _c('i', [_vm._v("The woman said to him, “Surely you know what Saul has done, how he has cut off the mediums and the necromancers from the land. Why then are you laying a trap for my life to bring about my death?”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("10")]), _c('i', [_vm._v("But Saul swore to her by the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _c('i', [_vm._v(", “As the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("lives, no punishment shall come upon you for this thing.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("11")]), _c('i', [_vm._v("Then the woman said, “Whom shall I bring up for you?” He said, “Bring up Samuel for me.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("12")]), _c('i', [_vm._v("When the woman saw Samuel, she cried out with a loud voice. And the woman said to Saul, “Why have you deceived me? You are Saul.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("13")]), _c('i', [_vm._v("The king said to her, “Do not be afraid. What do you see?” And the woman said to Saul, “I see a god coming up out of the earth.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("14")]), _c('i', [_vm._v("He said to her, “What is his appearance?” And she said, “An old man is coming up, and he is wrapped in a robe.” And Saul knew that it was Samuel, and he bowed with his face to the ground and paid homage.")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("15")]), _c('i', [_vm._v("Then Samuel said to Saul, “Why have you disturbed me by bringing me up?” Saul answered, “I am in great distress, for the Philistines are warring against me, and God has turned away from me and answers me no more, either by prophets or by dreams. Therefore I have summoned you to tell me what I shall do.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("16")]), _c('i', [_vm._v("And Samuel said, “Why then do you ask me, since the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("has turned from you and become your enemy?")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("17")]), _c('i', [_vm._v("The")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("has done to you as he spoke by me, for the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("has torn the kingdom out of your hand and given it to your neighbor, David.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("18")]), _c('i', [_vm._v("Because you did not obey the voice of the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("and did not carry out his fierce wrath against Amalek, therefore the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("has done this thing to you this day.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("19")]), _c('i', [_vm._v("Moreover, the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("will give Israel also with you into the hand of the Philistines, and tomorrow you and your sons shall be with me. The")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("will give the army of Israel also into the hand of the Philistines.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("20")]), _c('i', [_vm._v("Then Saul fell at once full length on the ground, filled with fear because of the words of Samuel. And there was no strength in him, for he had eaten nothing all day and all night.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("21")]), _c('i', [_vm._v("And the woman came to Saul, and when she saw that he was terrified, she said to him, “Behold, your servant has obeyed you. I have taken my life in my hand and have listened to what you have said to me.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("22")]), _c('i', [_vm._v("Now therefore, you also obey your servant. Let me set a morsel of bread before you; and eat, that you may have strength when you go on your way.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("23")]), _c('i', [_vm._v("He refused and said, “I will not eat.” But his servants, together with the woman, urged him, and he listened to their words. So he arose from the earth and sat on the bed.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("24")]), _c('i', [_vm._v("Now the woman had a fattened calf in the house, and she quickly killed it, and she took flour and kneaded it and baked unleavened bread of it,")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("25")]), _c('i', [_vm._v("and she put it before Saul and his servants, and they ate. Then they rose and went away that night."), _c('br'), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('span', {
    staticClass: "com-rorohiko-pagestaker-style"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor3376"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3377"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3378"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3379"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3380"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3381"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3382"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3383"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3384"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3385"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3386"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3387"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3388"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3389"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3390"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3391"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3392"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3393"
    }
  })]), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page127",
      "title": "127"
    }
  }), _c('b', [_vm._v("Overview:")]), _vm._v(" The scene between Saul and the witch at En-dor elicits more commentary from the interpreters than perhaps any other passage in First or Second Samuel. Indeed, this passage provides a rich diversity of interpretation from all the major confessions of the Reformation era. All agree that seeking out a witch is a desperate and depraved act. There are three principal interpretive options when it comes to identifying the spirit the witch calls forth: it is Samuel in person, an illusion or a demon (perhaps even Satan himself). The reformers carefully examine the words of the spirit—that Saul and his sons would die tomorrow on the battlefield. That this prophecy came to pass complicates the issue of identifying exactly what or who the spirit is.")]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("In Distress and Temptation, Saul Turns to Idolatry.")]), _vm._v(" "), _c('i', [_vm._v("Johannes Bugenhagen:")]), _vm._v(" First, Samuel’s death was described in chapter 25, so that you know what follows about his rising to be a demonic illusion. Next, it is shown what kind of righteous and pious king this desperate hypocrite pretended to be after Samuel’s death, sweeping away the magicians—soothsayers and mediums—as if following the law of Leviticus 20, Deuteronomy 18 and Isaiah 8. For hypocrites insist upon forcing the works of the law upon the people, while neglecting and despising faith in God. Therefore it is written of Saul in 1 Chronicles, “Saul died for his breach of faith. He broke faith with the L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")]), _vm._v(" in that he did not keep the command of the L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")]), _vm._v(", and also consulted a medium, seeking guidance. He did not seek guidance from the L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")]), _vm._v(". Therefore the L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")]), _vm._v(" put him to death and turned the kingdom over to David the son of Jesse.”")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("What good did it do Saul to have a name among men that soothsayers would not be suffered, as he had heard from Samuel earlier: “Rebellion is as the sin of divination, and presumption is as iniquity and idolatry.” All the righteous ones are idolaters when they cast off the Word of God, etc. Further, this story reveals Saul’s hypocrisy, for he sought in distress that which he had publicly condemned. Hypocrisy boasts of being beyond temptation through the works of the law and of being seen in worship of God, but then it despairs in times of real temptation, because it never had true faith in God. Thus it says, “When Saul saw the army of the Philistines, he was afraid, and his heart trembled greatly.” "), _c('i', [_vm._v("Commentary on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-100-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-100",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])])])])]), _vm._v(" "), _c('h5', {
    attrs: {
      "id": "sigil_toc_id_131"
    }
  }, [_c('b', [_vm._v("28:1-10")]), _vm._v(" "), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("Saul’s Desperate Act")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Saul’s Wicked Act.")]), _vm._v(" "), _c('i', [_vm._v("John Calvin:")]), _vm._v(" Saul was to the very end a rebel against God; he despised him like someone who is incorrigible. Not only did he persecute the innocent, but wishing to reverse the decree of God, he committed a most wicked act. He went like a wretched magician or enchanter to ask counsel of a witch. . . . That was the most desperate act of all. "), _c('i', [_vm._v("Sermons on 2 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-099-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-099",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Impatience Leads to Sin.")]), _vm._v(" "), _c('i', [_vm._v("Philipp Melanchthon:")]), _vm._v(" All those who allow the devil to embitter them with impatience, who give way to the flesh and who mumble and become angry against God allow faith and obedience to God to depart (which is frightful). Impatient, angry, embittered hearts think that God does not pay attention to them, that there is no point in praying, or in waiting and expecting comfort and help. In truly great temptations the heart will impatiently grasp at blasphemy, despondency and human comfort and assistance, against God’s commandment, just as King Saul sought out the witch. Such frightfully heavy sins against the first table of the Decalogue come from impatience. A little patience, however, often produces much good. "), _c('i', [_vm._v("Theological Commonplaces (1555).")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-098-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-098",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Appealing to God Too Late.")]), _vm._v(" "), _c('i', [_vm._v("Thomas Adams:")]), _vm._v(" The more hold a person takes of the world, the more they lose hold of the Lord. Covetous people cleave to the world so long as they can; but when that staff breaks, then they turn to the Lord. Extremity of distress will send the most profane to "), _c('a', {
    attrs: {
      "id": "_idTextAnchor3394"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3395"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3396"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3397"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3398"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3399"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3400"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3401"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3402"
    }
  }), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page128",
      "title": "128"
    }
  }), _vm._v("God: as the drowning person stretches out their hand to that lifejacket, which they condemned while safe on shore. So Saul retired himself to “inquire of the Lord, but the Lord did not answer him.” It is an unreasonable inequality to hope to find God at our command, when we would not be at his: to look that he should regard our voice in trouble, when we would not regard his voice in peace. Let your conversation be without covetousness. Why? Because God has said, “I will never leave you nor forsake you.” We credit the promise of a wealthy and trusty friend: yet a person may lie, a person may die and a person may be unable to help themselves. God is too constant to be changed, too powerful to be crossed, too wise to be deceived. “I will never leave you”: not in a year, not in age, not in sickness, not in death. Those who believe this cannot be covetous. The wealth you keep is not your own, but God’s. "), _c('i', [_vm._v("Commentary on 2 Peter.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-097-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-097",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("The Devil in God’s Place.")]), _vm._v(" "), _c('i', [_vm._v("George Gifford:")]), _vm._v(" No doubt many refuse to hear the voice of God and be instructed by him. They despise his word, and therefore they are given up to listen to devils. All those who have sought out the work of the devil and have now come to see their offense ought to show repentance for this, but not as for a light sin. It is no small abomination to go for help to the devil. It is to set him in God’s place and to honor him as God. It rises from infidelity to and distrust of help from God. We may see this in the example of King Saul who, finding neither answer nor comfort from God, whom he had so wickedly disobeyed, went to a witch. The heathen man said, “If I cannot entreat the gods, I will drown among the devils.” "), _c('i', [_vm._v("A Dialogue Concerning Witches and Witchcraft.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-096-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-096",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Truth Ministered by the Devil.")]), _vm._v(" "), _c('i', [_vm._v("Thomas Jackson:")]), _vm._v(" Saul, who had followed the customs of other nations and not the prescripts of God’s Word, “asked of the L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")]), _vm._v(", but the Lord did not answer him, either by dreams, or by Urim, or by prophets.” His sins had made a separation between him and the God of Israel, who for this cause would not allow his presence to his priests or prophets—who came as mediators between God and Saul—to be manifested. Much less would vouchsafe his Spirit to priests and prophets who were carnally minded themselves. . . . Yet it cannot be denied that the pagans were oftentimes, by God’s permission, truly spoken to through the means of dreams and oracles—though ultimately ministered by the devil—of events that should come to pass. But such resolutions were rarely for their good. For example, when Saul inquired after a witch . . . when God had cast him off, she did in fact procure Saul a true prediction of his fearful end. "), _c('i', [_vm._v("The Eternal Truth of Scriptures.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-095-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-095",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])])])])]), _vm._v(" "), _c('h5', {
    attrs: {
      "id": "sigil_toc_id_132"
    }
  }, [_c('b', [_vm._v("28:11-14")]), _vm._v(" "), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("Is It Samuel, an Overactive Imagination, a Demon or the Devil?")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("From Saul’s Perspective.")]), _vm._v(" "), _c('i', [_vm._v("Martin Luther:")]), _vm._v(" The Scriptures do not expressly state whether it was really Samuel; they only call him Samuel. This proves that the Scriptures put the matter as it was in the heart of Saul, who did not know but that it was Samuel; and the spirit skillfully spoke all the words of Samuel and added more to them. The Holy Spirit, however, intends that we should be warned and armed by this commandment . . . so that we might know that whatever happens contrary to it does not proceed from a good spirit or from the children of a good spirit. "), _c('i', [_vm._v("The Misuse of the Mass.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-094-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-094",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("On How People Live and Die Once.")]), _vm._v(" "), _c('i', [_vm._v("Heinrich Bullinger:")]), _vm._v(" Some people oppose Samuel’s appearance taken here from holy Scripture, which they contend to prove that souls return again after death and teach people about speculative matters. We answer briefly that this figure who seemed to be the prophet was called Samuel by a "), _c('a', {
    attrs: {
      "id": "_idTextAnchor3403"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3404"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3405"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3406"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3407"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3408"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3409"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3410"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3411"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3412"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3413"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3414"
    }
  }), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page129",
      "title": "129"
    }
  }), _vm._v("trope, but in fact it was not Samuel. In truth, it was a ghost—a delusion and illusion of Satan—for magic is strictly prohibited in the law of the Lord. Therefore blessed spirits do not submit to such prohibited things and unspeakable arts, which when they were still united with their flesh fought against and abhorred all of their ways. As for damned spirits, they do involve themselves in this. Now, who would believe their oracles? But Samuel predicts that which, they say, happened the next day. And then what? This was not difficult for the demon, given that the true and living Samuel had predicted many things a little while before. . . . Tertullian says in his book "), _c('i', [_vm._v("On the Soul")]), _vm._v(": “God forbid that we should believe that any soul, much less that of a prophet, could be called forth by a demon, since we are taught that ‘Satan disguises himself as an angel of light’—much less into a man of light—even asserting himself as God and presenting wonderful signs to overthrow, if possible, even the elect.” St. Augustine is of the same opinion about this appearance in his book "), _c('i', [_vm._v("To Simplician")]), _vm._v(" 2.3 and others. By these passages I hope that it is abundantly proved that souls of people separated from bodies do not wander or appear in these regions after death. For they remain until judgment in the destination appointed for them by the declaration of God. They are neither sent by the Lord nor are they able to enter into people; neither can they give warning of either present or future things. From this it follows that the appearances of souls, revelations and oracles are mere delusions of Satan, instituted contrary to the sincerity and purity of true religion. "), _c('i', [_vm._v("Decades 4.10.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-093-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-093",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Saul Deceived by a Demon.")]), _vm._v(" "), _c('i', [_vm._v("Johannes Bugenhagen:")]), _vm._v(" I wonder how could it have been possible to have this damnable power over death unless Satan had taken the appearance of Samuel? Since the law reveals that the ungodly consult the dead, as in Deuteronomy 18 and Isaiah 8, who does not see that this was a diabolical illusion? Scripture does not write that this was truly Samuel but that Saul and the woman believed it was him. In its simplicity here, Scripture does not withdraw the prohibition not to seek truth by means of the dead. Such images are truly not the dead but demons who are wrongly believed to have been raised up among the living. Moreover, it is no wonder that the devil reports and predicts accurately. For he sees what is already everywhere: for no one hid the fact that David would soon reign or that Saul would soon perish. For against the Philistine forces, Saul himself saw no defense, neither from people, nor from God, whom Saul was already fighting through his adversaries, nor from David, who alone God might use to save, because David was not there. Therefore the devil could easily make certain conjectures as prophecy, especially because he is eager to cause and inspire failure. God allowed all these things to be spoken truly by Satan, so that all those who have refused to love the truth might be more fully confirmed in their errors, as it says in 2 Thessalonians 2. And in Deuteronomy 13 the law prohibits believing those who come forth to prophesy, offering signs so that we defect to a foreign god, for it says that “the Lord your God is testing you, to know whether you love the Lord your God with all your heart and with all your soul.” "), _c('i', [_vm._v("Commentary on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-092-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-092",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Samuel’s Body but the Devil’s Spirit.")]), _vm._v(" "), _c('i', [_vm._v("Heinrich Bullinger:")]), _vm._v(" Devils are spiritual substances. But no one, I think, is able to say exactly in what way they assume bodies or how they appear to human beings. Indeed, the story of Samuel being brought up by a witch shows clearly that devils put on bodies and shapes that are different from their own. It was not Samuel who was brought up from the dead; rather, the chief architect of lies—the devil—deceived King Saul by pretending to be Samuel. For Paul testifies that “Satan disguises himself as an angel of light.” Other stories testify that the devil is an extraordinary "), _c('a', {
    attrs: {
      "id": "_idTextAnchor3415"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3416"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3417"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3418"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3419"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3420"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3421"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3422"
    }
  }), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page130",
      "title": "130"
    }
  }), _vm._v("deceiver who assumes various forms and shapes. "), _c('i', [_vm._v("Decades 4.9.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-091-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-091",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Counterfeit Samuel.")]), _vm._v(" "), _c('i', [_vm._v("Andrew Willet:")]), _vm._v(" It seems by Saul’s question to the soothsayer that he did not at first see the apparition. In fact, the rabbis think Saul only heard the voice, and that only the woman both saw and heard. But Saul’s servants neither heard nor saw. Now, the woman was in another room, since witches back then did not like to be seen when they worked their magic. And it is likely that afterward Saul was admitted to see the apparition. This is indicated by both the reverence he showed to it, in bowing himself, and by the communication he had with the apparition of Samuel. It may be gathered also by the text that the woman did not hear the communication. For it is said that she entered or “came to Saul,” implying that she had gone forth beforehand. Presumably, after raising the spirit she left Saul alone in the bedchamber, as it expressed in verse 23. Now, where the woman said, “I saw a god coming up out of the earth,” some believe she indicated an excellent person who was ascending. But it is likely that these gods were certain attractive, satanic apparitions (as Satan can transform himself into an angel of light). Thus Samuel appears wrapped about with a mantle, which was the custom of magistrates and prophets to wear to distinguish them from the common sort. Josephus thinks it was a priestly garment. But Samuel was no priest, though he was of the tribe of Levi. The witch recognized him as Samuel, having so learned of the devil who told her who it was. And this counterfeit Samuel yielded to Saul. "), _c('i', [_vm._v("Harmony of 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-090-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-090",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("The Devil Appears.")]), _vm._v(" "), _c('i', [_vm._v("Lambert Daneau:")]), _vm._v(" First, I agree with you that Satan can appear to people in the shape of a person. In fact, if we should say this cannot be done, then we must deny the meeting and talking together of Christ with the devil, about which the Scripture makes mention in Matthew 4, where it is written how Satan appeared visibly and in the shape of a man to Christ. Second, I will easily grant you that sorcerers can learn no good thing of Satan, but only such counsels and precepts as proceed from a vile and mischievous disposition, such as to revenge himself, to deceive strangers, to slay people at unawares and to do all these things secretly, none knowing about it or witnessing it. "), _c('i', [_vm._v("Dialogue of Witches.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-089-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-089",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])])])])]), _vm._v(" "), _c('h5', {
    attrs: {
      "id": "sigil_toc_id_133"
    }
  }, [_c('b', [_vm._v("28:15-25")]), _vm._v(" "), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("Concerning the Accuracy of “Samuel’s” Prophecy")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Judgment Left for God Alone.")]), _vm._v(" "), _c('i', [_vm._v("Andrew Willet:")]), _vm._v(" Some interpret this phrase—“tomorrow you and your sons shall be with me”—as though the devil, counterfeiting Samuel’s person, said that Saul would be with Samuel, that is, in the state of grace and in the favor of God, but that Satan here lied to him. However, as the rest of these words to Saul fell out to be true—that Saul would be delivered into the hands of the Philistines—so it is likely that the rest also should be true. Indeed, the event happened just as it was spoken. Both Saul and his sons were killed the next day. David Kimchi, along with other rabbis, thinks this is to be understood of the happy estate, where Saul should be. And that here nothing was uttered but truth. For these rabbis hold that Saul, dying for his country and not giving over the defense of Israel to pagans, died in the favor of God. Indeed, Josephus commends Saul as a worthy man who died for his country. But this resolution in Saul to die for his country was only a civil virtue. It was far from piety. Rather, it was like the fortitude of the heathen among the Romans who died for their country. And it was more a matter of God’s justice that forced him into this battle rather than his own will and resolution to defend his country. Besides, seeing that Saul killed himself and so died without repentance and ending his days in despair, how could he die in the favor and grace of God? But we will not hastily pronounce a verdict on his everlast"), _c('a', {
    attrs: {
      "id": "_idTextAnchor3423"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3424"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3425"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3426"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3427"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3428"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3429"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3430"
    }
  }), _vm._v("ing reprobation, though he was rejected from the kingdom. For that, we leave him to the judgment of the Lord. "), _c('i', [_vm._v("Harmony of 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-088-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-088",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Hiding Behind Words.")]), _vm._v(" "), _c('i', [_vm._v("Francois Perrault:")]), _vm._v(" We read here that the devil, speaking to King Saul under the figure of Samuel, makes himself into an ambiguous form, saying to him, “and tomorrow you and your sons shall be with me,” which is to say, you all will die, but he speaks confidently and deceptively, using this word "), _c('i', [_vm._v("tomorrow")]), _vm._v(", which signifies not only the day immediately following but also the time to come indefinitely and at large, as in that passage speaking of the Eternal One: “When your sons will inquire of you tomorrow, saying, ‘What is this here?’” This word "), _c('i', [_vm._v("tomorrow")]), _vm._v(" means hereafter and of the time to come. In this same sense must be understood that which our Lord Jesus Christ says in Saint Matthew, “Do not be anxious about tomorrow.” And in order to make it evident that Saul would not die the next day, or the day following the conference that he had with the devil under the figure of Samuel, but only a year or so afterward, it is necessary to diligently examine the story. But the devil will consider that it certainly appeared by the state and disposition of events that that which he was saying must happen, and nevertheless not being assured he limits nothing certainly, thus hiding in the ambiguity of this word "), _c('i', [_vm._v("tomorrow")]), _vm._v(", wanting to always preserve an avenue door behind for escape. It is thus that he has nearly always deceived the pagans by the ambiguity of his oracles, and not only has he spoken strongly among the pagans, but also he has deceived many Christians by this means, as we have an infinity of examples in the histories. "), _c('i', [_vm._v("Demonology.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-087-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-087",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Even the Devil Can Speak Truly.")]), _vm._v(" "), _c('i', [_vm._v("Thomas Adams:")]), _vm._v(" It is pleasing to the wisdom of God to express himself even by the tongues of faulty instruments. In fact, Satan himself sometimes receives notice from God of his future actions that otherwise that evil Spirit could neither foretell nor foresee. Such, in all likelihood, was his information concerning the end of Saul: “. . . tomorrow you and your sons shall be with me.” How could Satan tell this? Did the devil become a prophet? No. But as he was once a good angel, so he can still act what he was. Even lewd men may be good preachers when Satan himself plays the prophet. What prophet could speak better words than this foul spirit in Samuel’s mantle? “Why do you consult me, now that the Lord has turned away from you and become your enemy?” Samuel himself while he was alive could not have spoken more gravely, more severely, more divinely, than this hellish counterfeit. Good words are no rule to distinguish a prophet from a devil. This kind of knowledge is both rare and common: rare, in that it is seldom given to any; common, in that it is indifferently given to the good and bad. Prophecy does not always presuppose sanctification. Many have had visions from God who will never enjoy the vision of God. "), _c('i', [_vm._v("Commentary on 2 Peter.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-086-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-086",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("The Devil at Play.")]), _vm._v(" "), _c('i', [_vm._v("Daniel Dyke:")]), _vm._v(" The devil played with Saul by taking it on himself to foretell future events in the hands of God: “tomorrow you and your sons shall be with me,” that is, they shall die. Now how did the devil come to reveal God’s counsel? How is he able to determine with certainty the end of any person’s days given that they are numbered by God alone? However, if you look carefully, you will notice that the devil does not define Saul’s death in certain terms, but speaks darkly and deceitfully. For “tomorrow” does not only signify the day immediately following, but it also signifies the time to come indefinitely and at large. For instance, our Savior said, “Therefore do not be anxious about tomorrow”; that is, Jesus refers to the hereafter in the time to come. Moreover, the poet Horace said, “Do not seek what shall be tomorrow, for I care about only what is today. For who knows tomorrow?” In fact, Saul did not die the next day after this appearance—as the "), _c('a', {
    attrs: {
      "id": "_idTextAnchor3431"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3432"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3433"
    }
  }), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page131132",
      "title": "131132"
    }
  }), _vm._v("more diligent reader of the whole context of that history will detect. It was only that Satan discerned the likelihood of it, and ventured so to speak as if the next day Saul should have died. However, because he was not sure of it, the devil tempered his speech with the ambiguity of the word "), _c('i', [_vm._v("tomorrow")]), _vm._v(", so that his reputation might be preserved. "), _c('i', [_vm._v("The Mystery of Self-Deceiving.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-085-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-085",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")])])])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "_idContainer037"
    }
  }, [_c('p', {
    staticClass: "PER_Top-extra-space"
  }, [_c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page133",
      "title": "133"
    }
  })]), _vm._v(" "), _c('h2', {
    staticClass: "PER_ScriptureCenter",
    attrs: {
      "id": "sigil_toc_id_134"
    }
  }, [_c('span', {
    staticClass: "RH-marker"
  }, [_vm._v("29:1–31:13")]), _vm._v(" THE PHILISTINES REJECT DAVID AND SAUL DIES")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("1")]), _c('i', [_vm._v("Now the Philistines had gathered all their forces at Aphek. And the Israelites were encamped by the spring that is in Jezreel.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("2")]), _c('i', [_vm._v("As the lords of the Philistines were passing on by hundreds and by thousands, and David and his men were passing on in the rear with Achish,")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("3")]), _c('i', [_vm._v("the commanders of the Philistines said, “What are these Hebrews doing here?” And Achish said to the commanders of the Philistines, “Is this not David, the servant of Saul, king of Israel, who has been with me now for days and years, and since he deserted to me I have found no fault in him to this day.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("4")]), _c('i', [_vm._v("But the commanders of the Philistines were angry with him. And the commanders of the Philistines said to him, “Send the man back, that he may return to the place to which you have assigned him. He shall not go down with us to battle, lest in the battle he become an adversary to us. For how could this fellow reconcile himself to his lord? Would it not be with the heads of the men here?")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("5")]), _c('i', [_vm._v("Is not this David, of whom they sing to one another in dances,")])]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "verse"
  }, [_c('i', [_vm._v("‘Saul has struck down his thousands,")])]), _vm._v(" "), _c('p', {
    staticClass: "verse"
  }, [_c('i', [_vm._v("and David his ten thousands’?”")])])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("6")]), _c('i', [_vm._v("Then Achish called David and said to him, “As the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("lives, you have been honest, and to me it seems right that you should march out and in with me in the campaign. For I have found nothing wrong in you from the day of your coming to me to this day. Nevertheless, the lords do not approve of you.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("7")]), _c('i', [_vm._v("So go back now; and go peaceably, that you may not displease the lords of the Philistines.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("8")]), _c('i', [_vm._v("And David said to Achish, “But what have I done? What have you found in your servant from the day I entered your service until now, that I may not go and fight against the enemies of my lord the king?”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("9")]), _c('i', [_vm._v("And Achish answered David and said, “I know that you are as blameless in my sight as an angel of God. Nevertheless, the commanders of the Philistines have said, ‘He shall not go up with us to the battle.’")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("10")]), _c('i', [_vm._v("Now then rise early in the morning with the servants of your lord who came with you, and start early in the morning, and depart as soon as you have light.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("11")]), _c('i', [_vm._v("So David set out with his men early in the morning to return to the land of the Philistines. But the Philistines went up to Jezreel.")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    staticClass: "drop-cap"
  }, [_vm._v("30")]), _vm._v(" "), _c('i', [_vm._v("Now when David and his men came to Ziklag on the third day, the Amalekites had made a raid against the Negeb and against Ziklag. They had overcome Ziklag and burned it with fire")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("2")]), _c('i', [_vm._v("and taken captive the women and all")]), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("a")]), _vm._v(" "), _c('i', [_vm._v("who were in it, both small and great. They killed no one, but carried them off and went their way.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("3")]), _c('i', [_vm._v("And when David and his men came to the city, they found it burned with fire, and their wives and sons and daughters taken captive.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("4")]), _c('i', [_vm._v("Then David and the people who were with him raised their voices and wept until they had no more strength to weep.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("5")]), _c('i', [_vm._v("David’s two wives also had been taken captive, Ahinoam of Jezreel and Abigail the widow of Nabal of Carmel.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("6")]), _c('i', [_vm._v("And David was greatly distressed, for the people spoke of stoning him, because all the people were bitter in soul,")]), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("b")]), _vm._v(" "), _c('i', [_vm._v("each for his sons and daughters. But David strengthened himself in the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("his God.")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("7")]), _c('i', [_vm._v("And David said to Abiathar the priest, the son of Ahimelech, “Bring me the ephod.” So Abiathar brought the ephod to David.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("8")]), _c('i', [_vm._v("And David inquired of the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _c('i', [_vm._v(", “Shall I pursue after this band? Shall I overtake them?” He answered him, “Pursue, for you shall surely overtake and shall surely rescue.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("9")]), _c('i', [_vm._v("So David set out, and the six hundred men who were with him, and they came to the brook Besor, where those who were left behind stayed.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("10")]), _c('i', [_vm._v("But David pursued, he and four hundred men. Two hundred stayed behind, who were too exhausted to cross the brook Besor.")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("11")]), _c('i', [_vm._v("They found an Egyptian in the open country and brought him to David. And they gave him bread and he ate. They gave him water to drink,")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("12")]), _c('i', [_vm._v("and they gave him a piece of a cake of figs and two clusters of raisins. And when he had eaten, his spirit revived, for he had not eaten bread or drunk water for three days and three nights.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("13")]), _c('i', [_vm._v("And David said to him, “To whom do you belong? And where are you from?” He said, “I am a")]), _vm._v(" "), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page134",
      "title": "134"
    }
  }), _c('i', [_vm._v("young man of Egypt, servant to an Amalekite, and my master left me behind because I fell sick three days ago.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("14")]), _c('i', [_vm._v("We had made a raid against the Negeb of the Cherethites and against that which belongs to Judah and against the Negeb of Caleb, and we burned Ziklag with fire.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("15")]), _c('i', [_vm._v("And David said to him, “Will you take me down to this band?” And he said, “Swear to me by God that you will not kill me or deliver me into the hands of my master, and I will take you down to this band.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("16")]), _c('i', [_vm._v("And when he had taken him down, behold, they were spread abroad over all the land, eating and drinking and dancing, because of all the great spoil they had taken from the land of the Philistines and from the land of Judah.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("17")]), _c('i', [_vm._v("And David struck them down from twilight until the evening of the next day, and not a man of them escaped, except four hundred young men, who mounted camels and fled.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("18")]), _c('i', [_vm._v("David recovered all that the Amalekites had taken, and David rescued his two wives.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("19")]), _c('i', [_vm._v("Nothing was missing, whether small or great, sons or daughters, spoil or anything that had been taken. David brought back all.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("20")]), _c('i', [_vm._v("David also captured all the flocks and herds, and the people drove the livestock before him,")]), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("c")]), _vm._v(" "), _c('i', [_vm._v("and said, “This is David’s spoil.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("21")]), _c('i', [_vm._v("Then David came to the two hundred men who had been too exhausted to follow David, and who had been left at the brook Besor. And they went out to meet David and to meet the people who were with him. And when David came near to the people he greeted them.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("22")]), _c('i', [_vm._v("Then all the wicked and worthless fellows among the men who had gone with David said, “Because they did not go with us, we will not give them any of the spoil that we have recovered, except that each man may lead away his wife and children, and depart.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("23")]), _c('i', [_vm._v("But David said, “You shall not do so, my brothers, with what the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("has given us. He has preserved us and given into our hand the band that came against us.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("24")]), _c('i', [_vm._v("Who would listen to you in this matter? For as his share is who goes down into the battle, so shall his share be who stays by the baggage. They shall share alike.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("25")]), _c('i', [_vm._v("And he made it a statute and a rule for Israel from that day forward to this day.")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("26")]), _c('i', [_vm._v("When David came to Ziklag, he sent part of the spoil to his friends, the elders of Judah, saying, “Here is a present for you from the spoil of the enemies of the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _c('i', [_vm._v(".”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("27")]), _c('i', [_vm._v("It was for those in Bethel, in Ramoth of the Negeb, in Jattir,")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("28")]), _c('i', [_vm._v("in Aroer, in Siphmoth, in Eshtemoa,")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("29")]), _c('i', [_vm._v("in Racal, in the cities of the Jerahmeelites, in the cities of the Kenites,")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("30")]), _c('i', [_vm._v("in Hormah, in Bor-ashan, in Athach,")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("31")]), _c('i', [_vm._v("in Hebron, for all the places where David and his men had roamed.")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    staticClass: "drop-cap"
  }, [_vm._v("31")]), _vm._v(" "), _c('i', [_vm._v("Now the Philistines were fighting against Israel, and the men of Israel fled before the Philistines and fell slain on Mount Gilboa.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("2")]), _c('i', [_vm._v("And the Philistines overtook Saul and his sons, and the Philistines struck down Jonathan and Abinadab and Malchi-shua, the sons of Saul.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("3")]), _c('i', [_vm._v("The battle pressed hard against Saul, and the archers found him, and he was badly wounded by the archers.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("4")]), _c('i', [_vm._v("Then Saul said to his armor-bearer, “Draw your sword, and thrust me through with it, lest these uncircumcised come and thrust me through, and mistreat me.” But his armor-bearer would not, for he feared greatly. Therefore Saul took his own sword and fell upon it.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("5")]), _c('i', [_vm._v("And when his armor-bearer saw that Saul was dead, he also fell upon his sword and died with him.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("6")]), _c('i', [_vm._v("Thus Saul died, and his three sons, and his armor-bearer, and all his men, on the same day together.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("7")]), _c('i', [_vm._v("And when the men of Israel who were on the other side of the valley and those beyond the Jordan saw that the men of Israel had fled and that Saul and his sons were dead, they abandoned their cities and fled. And the Philistines came and lived in them.")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("8")]), _c('i', [_vm._v("The next day, when the Philistines came to strip the slain, they found Saul and his three sons fallen on Mount Gilboa.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("9")]), _c('i', [_vm._v("So they cut off his head and stripped off his armor and sent messengers throughout the land of the Philistines, to carry the good news to the house of their idols and to the people.")]), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("10")]), _c('i', [_vm._v("They put his armor in the temple of Ashtaroth, and they fastened his body to the wall of Beth-shan.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("11")]), _c('i', [_vm._v("But when the inhabitants of Jabesh-gilead heard what the Philistines had done to Saul,")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("12")]), _c('i', [_vm._v("all the valiant men arose and went all night and took the body of Saul and the bodies of his sons from the wall of Beth-shan, and they came to Jabesh and burned them there.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("13")]), _c('i', [_vm._v("And they took their bones and buried them under the tamarisk tree in Jabesh and fasted seven days.")])]), _vm._v(" "), _c('p', {
    staticClass: "small"
  }, [_c('b', [_vm._v("a")]), _vm._v(" Septuagint; Hebrew lacks "), _c('i', [_vm._v("and all")]), _vm._v(" "), _c('b', [_vm._v("b")]), _vm._v(" Compare 22:2 "), _c('b', [_vm._v("c")]), _vm._v(" The meaning of the Hebrew clause is uncertain"), _c('br'), _vm._v(" "), _c('br')]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('span', {
    staticClass: "com-rorohiko-pagestaker-style"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor3434"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3435"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3436"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3437"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3438"
    }
  })]), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page135",
      "title": "135"
    }
  }), _c('b', [_vm._v("Overview:")]), _vm._v(" David’s predicament about whether he should (or would be allowed to) fight with the Philistines against his fellow Israelites causes these interpreters to wonder about his motives. Was David waiting for the Lord to act? Would he have fought against Israel? Or would he have turned deceptively against the Philistines? At the same time, the reformers praise David’s shrewd leadership after Ziklag is captured and burned. Saul, by contrast, meets a lonely death on account of his poor leadership decisions.")]), _vm._v(" "), _c('h5', {
    attrs: {
      "id": "sigil_toc_id_135"
    }
  }, [_c('b', [_vm._v("29:1-11")]), _vm._v(" "), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("Rejection of David")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Living by God’s Word in Troubled Times.")]), _vm._v(" "), _c('i', [_vm._v("Johannes Bugenhagen:")]), _vm._v(" David is seen to have had some doubts. It is as if he were thinking, “The children of Israel are my people, yet I have sworn faithfulness to the king of the Philistines. At the same time, God wants to punish the impious children of Israel. God does not want to give his faithful servant over to God’s enemies, but I should also not make my faith into more than the will of God (just as they now do with their monastic vows). I understand neither the one option nor the other. But I know this: I can follow neither side with a good conscience. Therefore I wait for the will of God in whatever I am called to do, for God will not push me away in this time of need, nor will God cause me to do what is against his will. Either way the people will have passed judgment over me.” Faith in humans comes to nothing when faith in God requires something else. God presents the second table of the law so that we should excel in keeping faith, promises, oaths and the like with each other, but not at the expense of the first table. In fact, no oaths or vows are superior to the first table of the law, unless you want to stand before the devil rather than God. For your own thoughtlessness does not need to be so great that you do injury to divine truth. God is truth, you are given to lying, and you ought to be humble before God, who will cause you to fall by the vows and oaths on which it is impossible to stand without going against God’s Word. Therefore God liberates David here and gathers the advice of the Philistines about sending him back. For in this case, if you let God work, then God will give counsel, so that you will be liberated without a bad conscience. In the same way, God liberates those who had been devoted to human traditions, so that they can conscientiously violate those vows through the Word of God, which has been taught from God. This is like the time when David did not have anything against his conscience in chapter 25 above, but rather gave thanks to God that he did not proceed with his oath. On this subject, however, there are those today who without the Word of God (and therefore in bad conscience) heedlessly attack everything, doing so in the name of gospel freedom. This is the freedom of the flesh and a great scandal to the gospel. This is not, I say, the same thing I have just been describing. "), _c('i', [_vm._v("Commentary on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-084-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-084",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Fencing in the Heart.")]), _vm._v(" "), _c('i', [_vm._v("Daniel Dyke:")]), _vm._v(" When the Philistines were going out to war against the Israelites, they dared not allow David to go with them. They were jealous of him because of the love he bore to his own country. Therefore they put him out of the military. How happy would our spiritual war with Satan be if we could as easily rid ourselves of our deceitful hearts as they did themselves of David! Without doubt we have far greater cause to suspect our hearts than they did of David. The acquaintance of the flesh with Satan—and Satan’s interest in the flesh—is greater than the Israelites’ acquaintance of David. Besides that, the Philistines never had any experience of David’s deceitfulness and unfaithfulness as we have had of our flesh. Therefore I wish we could rid ourselves entirely of this treacherous and perfidious flesh! But since it sticks so close to us, and we cannot possibly remove it from ourselves, we must always have an eye over it just as we would over an untrustworthy and pilfering servant who—if not closely observed—would steal from us. For certainly such is the deceitfulness of our hearts that if we took our eyes off of them they would throw off the yoke of the "), _c('a', {
    attrs: {
      "id": "_idTextAnchor3439"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3440"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3441"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3442"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3443"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3444"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3445"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3446"
    }
  }), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page136",
      "title": "136"
    }
  }), _vm._v("Lord and make a run for it! Therefore we must keep our hearts as closely monitored as the jailor does his prisoner. "), _c('i', [_vm._v("The Mystery of Self-Deceiving.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-083-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-083",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Did David Lie?")]), _vm._v(" "), _c('i', [_vm._v("Andrew Willet:")]), _vm._v(" Some think David had no intention at all to fight against Israel. Rather, he would have only defended the king’s person, who said he would make David keeper of his head for ever. But this does not agree with David’s own words. David seemed to be discontented because he was sent back and not allowed to fight against the enemies of the king. It seems therefore that he was fully in support of the Philistine king and that he was willing to go and fight against Israel. Others think that the Philistines’ war against Saul at this time was just, because this was the way the Lord intended to punish Saul’s wickedness. And besides, the kingdom rightly belonged to David, and therefore he was merely seeking what was his own. But neither of these makes the war just. For regardless of how God intended to judge Saul here, the Philistines went to battle against the people of God in a malicious way. And though David was the anointed king, that is, the apparent heir of the kingdom, he had no such commandment to invade the kingdom of Israel. Instead, he was to wait his time. Some are of the opinion that David would have turned his force against Achish in the battle had he been allowed to fight. Yet in such a case David, rather than supporting the Philistine king, would have disrespected Achish, with whom he had found such kind hospitality. Therefore the best solution to this question is that David very astutely neither directly promised his help, as Josephus believed, nor directly affirmed it. Instead he waited on God for his direction. He prayed to God fervently in his heart that some impediment might occur so that he would not be forced to fight against the Israelites, and especially against his dear and beloved friend Jonathan. "), _c('i', [_vm._v("Harmony on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-082-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-082",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Faith Among the Gentiles.")]), _vm._v(" "), _c('i', [_vm._v("Johannes Bugenhagen:")]), _vm._v(" Because the Gentile king Achish swears by God and later invokes God’s angels, it is clear to see that an awareness of the true God had remained in the land from the time of the patriarchs, even though the false worship of God reigned there. Canaan—the son of Ham the son of Noah—first possessed the land, as you see illustrated later in the journeys of Abraham, Isaac and Jacob in Genesis. Many of them surely preached and taught the fear of God, as when Abraham, for instance, found Melchizedek that priest of God Most High in the land of Salem, among others. In Genesis 20 you also see how Abimelech, the king of the Palestinians in Gerar, had a holy conscience. But even though ideas about God survived to posterity, nothing remained of godliness except false worship where the preaching of God’s Word had ceased. "), _c('i', [_vm._v("Commentary on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-081-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-081",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])])])])]), _vm._v(" "), _c('h5', {
    attrs: {
      "id": "sigil_toc_id_136"
    }
  }, [_c('b', [_vm._v("30:1-20")]), _vm._v(" "), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("David Overcomes Adversity")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Always Expecting Trials.")]), _vm._v(" "), _c('i', [_vm._v("John Calvin:")]), _vm._v(" We must learn from the example given to us here. David had recovered his wives. After that, he won a great quantity of spoil from his enemies, and everyone who was in his company made themselves rich in one day. Well, two days had been spent in this business. But the third day brought them news of the defeat of the people of Israel (2 Sam 1:2). Thus when God has given us cause to rejoice—whether for a day or a month—let us learn to accept any trial with which he chooses to test us. . . . For we need to be continually tried, because our senses are too attached to this world; and we wish to make our own paradise on earth as though there were no blessedness greater than that! That is why God subjects us to so many changes, and causes us to be cast from one side to the other. "), _c('i', [_vm._v("Sermons on 2 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-080-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-080",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_c('span', {
    staticClass: "com-rorohiko-pagestaker-style"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor3447"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3448"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3449"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3450"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3451"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3452"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3453"
    }
  })])]), _c('b', [_c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page137",
      "title": "137"
    }
  })]), _c('b', [_vm._v("Persecuted and Weeping.")]), _vm._v(" "), _c('i', [_vm._v("Andrew Willet:")]), _vm._v(" David was a figure of our Savior Christ, who was hated by his own people. Moses, that faithful servant of God, was also a figure of Christ. Thus it pleased the Lord to test David’s patience; and now, being as it were plunged in the depth of sorrow, it was a sign to him that his deliverance was near at hand. David excessively wept together with the rest of the men for their present loss, since their wives and children had been carried away. But David further wept because he knew the Lord was chastising him for his sin. David’s grievous weeping and lamenting serves as an example to us and, as such, confutes the opinion of the Stoics that a wise person is one who shows no passion, affection or ever changes his countenance. "), _c('i', [_vm._v("Harmony of 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-079-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-079",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])])])])]), _vm._v(" "), _c('h5', {
    attrs: {
      "id": "sigil_toc_id_137"
    }
  }, [_c('b', [_vm._v("30:21-31")]), _vm._v(" "), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("The Men’s Selfishness and David’s Generosity")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Equal Sharing of Goods.")]), _vm._v(" "), _c('i', [_vm._v("Peter Walpot:")]), _vm._v(" Humanity will hold a great sabbath. Yes, they will have a continual sabbath and will lead a most holy life on earth, when they rid their nature of two words—“mine” and “yours.” These words have been and are today the cause of many wars. From where comes war and bloodshed, quarreling and fighting, envy and hatred, disunity and disruption, if not from private possessions and greed? For whoever deals in mine and yours, that is, with possessions, becomes a friend of avarice. . . . When the evil men of Belial said that the one hundred who remained behind during the raid on Ziklag should not share in the booty won there, David said, “Do not be like that, brothers, with what God has given us. Who will agree with you on this? The share of those who went shall be the share of those who remained behind. It should be divided equally.” And since that time to this day that has been the custom and law in Israel. . . . How much more should this be the custom and law among the children of the New Testament? What God has given us should be divided equally. "), _c('i', [_vm._v("True Yieldedness.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-078-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-078",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("David’s Shrewd Generosity.")]), _vm._v(" "), _c('i', [_vm._v("Andrew Willet:")]), _vm._v(" David had found hospitality among some in his tribe, where he was able to hide himself while Saul pursued him. Therefore David showed his thankfulness by sending them presents. Besides, these people were his kindred and brothers, and it was therefore reasonable for David to first show his kindness to them. Moreover, these cities of Judah also had been robbed and spoiled by the Amalekites, as the Egyptian told David in verse 14. And because the Amalekites had robbed on the coast of Judah, David thought it reasonable that some restitution should be made to them for their losses. Additionally, it is by this means that David prepared their hearts and ingratiated himself into their affections, who afterward faithfully took part with David against the house of Saul. "), _c('i', [_vm._v("Harmony on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-077-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-077",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])])])])]), _vm._v(" "), _c('h5', {
    attrs: {
      "id": "sigil_toc_id_138"
    }
  }, [_c('b', [_vm._v("31:1-13")]), _vm._v(" "), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("Saul and His Sons Die")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Saul Dies in His Unbelief.")]), _vm._v(" "), _c('i', [_vm._v("Johannes Bugenhagen:")]), _vm._v(" It is written in the Psalms: “Precious in the sight of the Lord is the death of his saints.” This is no less true for the righteous Jonathan, who died fighting for the Lord’s inheritance. For “the righteous, though they die early, will be at rest,” as you read of the deaths of the righteous whom the world has judged to be contemptible and evil. But against others, it says in the psalm, “The death of the wicked is very evil.” You read that here as it applies to Saul, who did not hope in the God of Israel and instead consulted the soothsayer, as it says in 1 Chronicles. Therefore, when pressed on by enemies while desperately leading in battle, Saul perished like the apostle Judas, who also perished as one who had earlier been greatly blessed by God. In the end, Saul was a blasphemer of the God of Israel among both the Gentiles and those who exalt God in the holy places. This is how "), _c('a', {
    attrs: {
      "id": "_idTextAnchor3454"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3455"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3456"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3457"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3458"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3459"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3460"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3461"
    }
  }), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page138",
      "title": "138"
    }
  }), _vm._v("hypocrites meet their end, as it says in all of Job: “Do you not know this from of old, since humans were placed on earth, that the exulting of the wicked is short, and the joy of the godless but for a moment?” They reign gloriously and appear to be wise, righteous and the saviors of others, but their end reveals them to be in disgrace and blasphemy of God. This point relates to what Christ says of salt that has lost its flavor and what Paul wrote to the Romans: “The name of God is blasphemed among the Gentiles because of you.” Then and now, God unmasks our hypocrites, who are covered in the most Christian skins before God begins to judge them by his word and expel them from the kingdom, as he turned the kingdom to David, that is, to Christ the son of David through faith in the holy gospel. "), _c('i', [_vm._v("Commentary on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-076-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-076",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("The Death of Saul’s Sons.")]), _vm._v(" "), _c('i', [_vm._v("Andrew Willet:")]), _vm._v(" Here only three of Saul’s sons are mentioned to have died in this battle. Ish-bosheth was not present, either because he was not a warrior or because he was left at home to be overseer of the families. All three of these sons died together with their father. None of them bore his father’s punishment or suffered for his sin. They had sins of their own. Indeed, God’s judgments worked in such a way that they coincided with the punishment of their father. This was so that evil parents might be warned that their wickedness may bring God’s judgment on themselves and their posterity. But concerning Jonathan, because he was a good man his lamentable end deserves more compassion. It must be considered this way: Because Jonathan was a good man, regardless of how he ended his days he could not die in evil. God no doubt turned this temporal death of Jonathan to his everlasting glory. In fact God might have foreseen that if Jonathan had remained alive, his heart may have changed toward David. Therefore the Lord took him away. In this way God’s judgments, though secret and hidden to us, are most just. "), _c('i', [_vm._v("Harmony on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-075-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-075",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Saul’s Multiple Deaths.")]), _vm._v(" "), _c('i', [_vm._v("John Calvin:")]), _vm._v(" Saul had to beg someone who was his enemy to kill him, since he was unable to do so himself (2 Sam 1:9). Saul, in desperation, had thrown himself on his sword in order to kill himself, but then he was not able to achieve it by himself and, as I have said, he had to beg his enemies to help him to do so. Since he had wickedly persecuted David, who was chosen and elected by God to succeed him, there was a very good reason why he should not simply die one death, but that he should actually die two or three times, as it were. "), _c('i', [_vm._v("Sermons on 2 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-074-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-074",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4da40a3e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/1samuel.vue
// module id = 90
// module chunks = 0